[
  {
    "NIP": "'198008012006042001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. Dewi Arum Widhiyanti Metra Putri, S.Psi., M.A., M.Psi., Psikolog",
    "JURUSAN": "Bimbingan Konseling (BK) (S1)",
    "FAKULTAS": "Fakultas Ilmu Pendidikan",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "STRUKTURAL": "Kepala UPA",
    "GRADE STRUKTURAL": 12,
    "UNIT KERJA": "Unit Penunjang Akademik Layanan Bimbingan konseling",
    "POINT POSITION": 2559.35,
    "POINT PERFORMANCE": 1230,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 3789.35,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 5684025,
    "PPh 100%": 284201.25,
    "JUMLAH KOTOR 30% (Rp)": 1938757.5,
    "JUMLAH KOTOR 70% (Rp)": 3745267.5,
    "PPh 21": 187263.375,
    "JUMLAH BERSIH 70% (Rp)": 3558004.125,
    "TANDA TANGAN": 1
  },
  {
    "NIP": "'198605192008122003",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. Luh Putu Sri Lestari, S.Pd., M.Pd.",
    "JURUSAN": "Bimbingan Konseling (BK) (S1)",
    "FAKULTAS": "Fakultas Ilmu Pendidikan",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "STRUKTURAL": "Sekretaris Jurusan S1",
    "GRADE STRUKTURAL": 11,
    "UNIT KERJA": "Jurusan Ilmu Pendidikan, Psikologi dan Bimbingan",
    "POINT POSITION": 1899,
    "POINT PERFORMANCE": 1176,
    "POINT KELEBIHAN": 36.2433,
    "POINT TOTAL": 3111.24,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 4666860,
    "PPh 100%": 233343,
    "JUMLAH KOTOR 30% (Rp)": 1641600,
    "JUMLAH KOTOR 70% (Rp)": 3025260,
    "PPh 21": 151263,
    "JUMLAH BERSIH 70% (Rp)": 2873997,
    "TANDA TANGAN": 2
  },
  {
    "NIP": "'198501232008122004",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. Putu Ari Dharmayanti, S.Pd., M.Pd.",
    "JURUSAN": "Bimbingan Konseling (BK) (S1)",
    "FAKULTAS": "Fakultas Ilmu Pendidikan",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "STRUKTURAL": "Sekretaris Program Studi S2",
    "GRADE STRUKTURAL": 11,
    "UNIT KERJA": "Bimbingan Konseling (S2)",
    "POINT POSITION": 2152.2,
    "POINT PERFORMANCE": 787,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 2939.2,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 4408800,
    "PPh 100%": 220440,
    "JUMLAH KOTOR 30% (Rp)": 1755540,
    "JUMLAH KOTOR 70% (Rp)": 2653260,
    "PPh 21": 132663,
    "JUMLAH BERSIH 70% (Rp)": 2520597,
    "TANDA TANGAN": 3
  },
  {
    "NIP": "'198904262019031006",
    "STATUS SEKARANG": "Tugas Belajar",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Gede Nugraha Sudarsana, S.Psi.,M.Pd.",
    "JURUSAN": "Bimbingan Konseling (BK) (S1)",
    "FAKULTAS": "Fakultas Ilmu Pendidikan",
    "GOLONGAN": "IIIB",
    "STATUS PENELITIAN": "TIDAK ADA",
    "STATUS PENGABDIAN": "TIDAK ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Asisten Ahli",
    "GRADE FUNGSIONAL": 8,
    "UNIT KERJA": "-",
    "POINT POSITION": 0,
    "POINT PERFORMANCE": 0,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 0,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 0,
    "PPh 100%": 0,
    "JUMLAH KOTOR 70% (Rp)": 0,
    "PPh 21": 0,
    "JUMLAH BERSIH 70% (Rp)": 0,
    "TANDA TANGAN": 4
  },
  {
    "NIP": "'199012042022031006",
    "STATUS SEKARANG": "Ijin Belajar",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Kade Sathya Gita Rismawan, M.Pd",
    "JURUSAN": "Bimbingan Konseling (BK) (S1)",
    "FAKULTAS": "Fakultas Ilmu Pendidikan",
    "GOLONGAN": "IIIB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Asisten Ahli",
    "GRADE FUNGSIONAL": 8,
    "STRUKTURAL": "[REN223] Sekretaris Pusat/ Ketua Divisi/ Asrama/ Koordinator Lab. Jurusan Kepala Unit BPU/ Sekretaris Gugus Kendali Mutu Fakultas/ Sekretaris Tim Pengelolaan dan Penerimaan Mahasiswa Asing/ Sekretaris Unit Pengembangan dan Peningkatan Kapasitas Kelembagaan",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "-",
    "POINT POSITION": 800,
    "POINT PERFORMANCE": 910.295,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 1710.3,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 2565450,
    "PPh 100%": 128272.5,
    "JUMLAH KOTOR 30% (Rp)": 1016550,
    "JUMLAH KOTOR 70% (Rp)": 1548900,
    "PPh 21": 77445,
    "JUMLAH BERSIH 70% (Rp)": 1471455,
    "TANDA TANGAN": 5
  },
  {
    "NIP": "'199202162019032021",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Kadek Ari Dwiarwati, S.Pd., M.Pd.",
    "JURUSAN": "Bimbingan Konseling (BK) (S1)",
    "FAKULTAS": "Fakultas Ilmu Pendidikan",
    "GOLONGAN": "IIIC",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "STRUKTURAL": "[REN126] Pengelola Gugus Kendali Mutu (Fakultas) sebagai Anggota",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Fakultas Ilmu Pendidikan",
    "POINT POSITION": 200,
    "POINT PERFORMANCE": 1131.33,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 1331.33,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 1996995,
    "PPh 100%": 99849.75,
    "JUMLAH KOTOR 30% (Rp)": 877050,
    "JUMLAH KOTOR 70% (Rp)": 1119945,
    "PPh 21": 55997.25,
    "JUMLAH BERSIH 70% (Rp)": 1063947.75,
    "TANDA TANGAN": 6
  },
  {
    "NIP": "'198208162008121002",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Prof. Dr. Kadek Suranata, S.Pd., M.Pd., Kons.",
    "JURUSAN": "Bimbingan Konseling (BK) (S1)",
    "FAKULTAS": "Fakultas Ilmu Pendidikan",
    "GOLONGAN": "IVB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Guru Besar",
    "GRADE FUNGSIONAL": 12,
    "STRUKTURAL": "Wakil Dekan I",
    "GRADE STRUKTURAL": 14,
    "UNIT KERJA": "Fakultas Ilmu Pendidikan",
    "POINT POSITION": 10800,
    "POINT PERFORMANCE": 2965.83,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 13765.8,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 20648700,
    "PPh 100%": 3097305,
    "JUMLAH KOTOR 30% (Rp)": 6214950,
    "JUMLAH KOTOR 70% (Rp)": 14433750,
    "PPh 21": 2165062.5,
    "JUMLAH BERSIH 70% (Rp)": 12268687.5,
    "TANDA TANGAN": 7
  },
  {
    "NIP": "'199709222024062002",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Septia Rahmawati, M.Pd.",
    "JURUSAN": "Bimbingan Konseling (BK) (S1)",
    "FAKULTAS": "Fakultas Ilmu Pendidikan",
    "GOLONGAN": "IIIB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Tenaga Pengajar",
    "GRADE FUNGSIONAL": 7,
    "UNIT KERJA": "-",
    "POINT PERFORMANCE": 865.5,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 865.5,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 1298250,
    "PPh 100%": 64912.5,
    "JUMLAH KOTOR 30% (Rp)": 545400,
    "JUMLAH KOTOR 70% (Rp)": 752850,
    "PPh 21": 37642.5,
    "JUMLAH BERSIH 70% (Rp)": 715207.5,
    "TANDA TANGAN": 8
  },
  {
    "NIP": "'199307012022031005",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Wayan Eka Paramartha, S.Pd.,M.Pd",
    "JURUSAN": "Bimbingan Konseling (BK) (S1)",
    "FAKULTAS": "Fakultas Ilmu Pendidikan",
    "GOLONGAN": "IIIB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Asisten Ahli",
    "GRADE FUNGSIONAL": 8,
    "STRUKTURAL": "Sekretaris UPA",
    "GRADE STRUKTURAL": 11,
    "UNIT KERJA": "Unit Penunjang Akademik Layanan Bimbingan konseling",
    "POINT POSITION": 2152.2,
    "POINT PERFORMANCE": 1058,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 3210.2,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 4815300,
    "PPh 100%": 240765,
    "JUMLAH KOTOR 30% (Rp)": 1625040,
    "JUMLAH KOTOR 70% (Rp)": 3190260,
    "PPh 21": 159513,
    "JUMLAH BERSIH 70% (Rp)": 3030747,
    "TANDA TANGAN": 9
  },
  {
    "NIP": "'198807082014041003",
    "STATUS SEKARANG": "Ijin Belajar",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Adrianus I Wayan Ilia Yuda Sukmana, S.Kom., M.Pd.",
    "JURUSAN": "Teknologi Pendidikan (TP) (S1)",
    "FAKULTAS": "Fakultas Ilmu Pendidikan",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "STRUKTURAL": "[REN126] Pengelola Gugus Kendali Mutu (Fakultas) sebagai Anggota",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Fakultas Ilmu Pendidikan",
    "POINT POSITION": 200,
    "POINT PERFORMANCE": 1148.08,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 1348.08,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 2022120,
    "PPh 100%": 101106,
    "JUMLAH KOTOR 30% (Rp)": 877050,
    "JUMLAH KOTOR 70% (Rp)": 1145070,
    "PPh 21": 57253.5,
    "JUMLAH BERSIH 70% (Rp)": 1087816.5,
    "TANDA TANGAN": 10
  },
  {
    "NIP": "'198807062015041001",
    "STATUS SEKARANG": "Ijin Belajar",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. Alexander Hamonangan Simamora, S.E., M.Pd.",
    "JURUSAN": "Teknologi Pendidikan (TP) (S1)",
    "FAKULTAS": "Fakultas Ilmu Pendidikan",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "UNIT KERJA": "-",
    "POINT PERFORMANCE": 1128.33,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 1128.33,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 1692495,
    "PPh 100%": 84624.75,
    "JUMLAH KOTOR 30% (Rp)": 787050,
    "JUMLAH KOTOR 70% (Rp)": 905445,
    "PPh 21": 45272.25,
    "JUMLAH BERSIH 70% (Rp)": 860172.75,
    "TANDA TANGAN": 11
  },
  {
    "NIP": "'198908082024211004",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PPPK",
    "NAMA DOSEN": "Dr. Dewa Gede Agus Putra Prabawa, S.Pd., M.Pd.",
    "JURUSAN": "Teknologi Pendidikan (TP) (S1)",
    "FAKULTAS": "Fakultas Ilmu Pendidikan",
    "GOLONGAN": "X",
    "STATUS PENELITIAN": "TIDAK ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Asisten Ahli",
    "GRADE FUNGSIONAL": 8,
    "STRUKTURAL": "[REN225] Anggota Divisi",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "-",
    "POINT POSITION": 0,
    "POINT PERFORMANCE": 0,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 0,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 0,
    "PPh 100%": 0,
    "JUMLAH KOTOR 30% (Rp)": 769050,
    "JUMLAH KOTOR 70% (Rp)": 0,
    "PPh 21": 0,
    "JUMLAH BERSIH 70% (Rp)": 0,
    "TANDA TANGAN": 12
  },
  {
    "NIP": "'198104142006041001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. I Kadek Suartama, S.Pd., M.Pd.",
    "JURUSAN": "Teknologi Pendidikan (TP) (S1)",
    "FAKULTAS": "Fakultas Ilmu Pendidikan",
    "GOLONGAN": "IVA",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor Kepala",
    "GRADE FUNGSIONAL": 11,
    "STRUKTURAL": "Koordinator Program Studi S1/D3",
    "GRADE STRUKTURAL": 11,
    "UNIT KERJA": "Teknologi Pendidikan (TP) (S1)",
    "POINT POSITION": 1645.8,
    "POINT PERFORMANCE": 2511.67,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 4157.47,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 6236205,
    "PPh 100%": 935430.75,
    "JUMLAH KOTOR 30% (Rp)": 1880010,
    "JUMLAH KOTOR 70% (Rp)": 4356195,
    "PPh 21": 653429.25,
    "JUMLAH BERSIH 70% (Rp)": 3702765.75,
    "TANDA TANGAN": 13
  },
  {
    "NIP": "'198209102005012001",
    "STATUS SEKARANG": "Tugas Belajar",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. Luh Putu Putrini Mahadewi, S.Pd., M.S.",
    "JURUSAN": "Teknologi Pendidikan (TP) (S1)",
    "FAKULTAS": "Fakultas Ilmu Pendidikan",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "UNIT KERJA": "-",
    "POINT PERFORMANCE": 0,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 0,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 0,
    "PPh 100%": 0,
    "JUMLAH KOTOR 70% (Rp)": 0,
    "PPh 21": 0,
    "JUMLAH BERSIH 70% (Rp)": 0,
    "TANDA TANGAN": 14
  },
  {
    "NIP": "'198202142008121004",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Prof. Dr. I Gde Wawan Sudatha, S.Pd., S.T., M.Pd.",
    "JURUSAN": "Teknologi Pendidikan (TP) (S1)",
    "FAKULTAS": "Fakultas Ilmu Pendidikan",
    "GOLONGAN": "IVB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Guru Besar",
    "GRADE FUNGSIONAL": 12,
    "STRUKTURAL": "Ketua Jurusan S1",
    "GRADE STRUKTURAL": 12,
    "UNIT KERJA": "Jurusan Ilmu Pendidikan, Psikologi dan Bimbingan",
    "POINT POSITION": 2258.25,
    "POINT PERFORMANCE": 2996.67,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 5254.92,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 7882380,
    "PPh 100%": 1182357,
    "JUMLAH KOTOR 30% (Rp)": 2371162.5,
    "JUMLAH KOTOR 70% (Rp)": 5511217.5,
    "PPh 21": 826682.625,
    "JUMLAH BERSIH 70% (Rp)": 4684534.875,
    "TANDA TANGAN": 15
  },
  {
    "NIP": "'199301272024212001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PPPK",
    "NAMA DOSEN": "Anak Agung Ayu Dewi Sutyaningsih, M.Pd.",
    "JURUSAN": "Pendidikan Guru Sekolah Dasar (PGSD) (S1)",
    "FAKULTAS": "Fakultas Ilmu Pendidikan",
    "GOLONGAN": "X",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Asisten Ahli",
    "GRADE FUNGSIONAL": 8,
    "UNIT KERJA": "-",
    "POINT PERFORMANCE": 1102.33,
    "POINT KELEBIHAN": 121.545,
    "POINT TOTAL": 1223.88,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 1835820,
    "PPh 100%": 91791,
    "JUMLAH KOTOR 30% (Rp)": 656550,
    "JUMLAH KOTOR 70% (Rp)": 1179270,
    "PPh 21": 58963.5,
    "JUMLAH BERSIH 70% (Rp)": 1120306.5,
    "TANDA TANGAN": 16
  },
  {
    "NIP": "'199106172024212002",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PPPK",
    "NAMA DOSEN": "Chindytia, M.Pd.",
    "JURUSAN": "Pendidikan Guru Sekolah Dasar (PGSD) (S1)",
    "FAKULTAS": "Fakultas Ilmu Pendidikan",
    "GOLONGAN": "X",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Asisten Ahli",
    "GRADE FUNGSIONAL": 8,
    "UNIT KERJA": "-",
    "POINT PERFORMANCE": 1096.67,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 1096.67,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 1645005,
    "PPh 100%": 82250.25,
    "JUMLAH KOTOR 30% (Rp)": 656550,
    "JUMLAH KOTOR 70% (Rp)": 988455,
    "PPh 21": 49422.75,
    "JUMLAH BERSIH 70% (Rp)": 939032.25,
    "TANDA TANGAN": 17
  },
  {
    "NIP": "'198808152023212046",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PPPK",
    "NAMA DOSEN": "Dewi Anzelina, M.Pd.",
    "JURUSAN": "Pendidikan Guru Sekolah Dasar (PGSD) (S1)",
    "FAKULTAS": "Fakultas Ilmu Pendidikan",
    "GOLONGAN": "X",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Asisten Ahli",
    "GRADE FUNGSIONAL": 8,
    "UNIT KERJA": "-",
    "POINT PERFORMANCE": 1158.83,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 1158.83,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 1738245,
    "PPh 100%": 86912.25,
    "JUMLAH KOTOR 30% (Rp)": 656550,
    "JUMLAH KOTOR 70% (Rp)": 1081695,
    "PPh 21": 54084.75,
    "JUMLAH BERSIH 70% (Rp)": 1027610.25,
    "TANDA TANGAN": 18
  },
  {
    "NIP": "'196606142003121002",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. Basilius Redan Werang, S.S., S.Sos., JCL.",
    "JURUSAN": "Pendidikan Guru Sekolah Dasar (PGSD) (S1)",
    "FAKULTAS": "Fakultas Ilmu Pendidikan",
    "GOLONGAN": "IVA",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor Kepala",
    "GRADE FUNGSIONAL": 11,
    "STRUKTURAL": "Sekretaris Program Studi S2",
    "GRADE STRUKTURAL": 11,
    "UNIT KERJA": "Administrasi Pendidikan (S2)",
    "POINT POSITION": 2152.2,
    "POINT PERFORMANCE": 2401.17,
    "POINT KELEBIHAN": 380,
    "POINT TOTAL": 4933.37,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 7400055,
    "PPh 100%": 1110008.25,
    "JUMLAH KOTOR 30% (Rp)": 2107890,
    "JUMLAH KOTOR 70% (Rp)": 5292165,
    "PPh 21": 793824.75,
    "JUMLAH BERSIH 70% (Rp)": 4498340.25,
    "TANDA TANGAN": 19
  },
  {
    "NIP": "'198403272015041001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. Gede Wira Bayu, S.Pd., M.Pd.",
    "JURUSAN": "Pendidikan Guru Sekolah Dasar (PGSD) (S1)",
    "FAKULTAS": "Fakultas Ilmu Pendidikan",
    "GOLONGAN": "IVA",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor Kepala",
    "GRADE FUNGSIONAL": 11,
    "STRUKTURAL": "Sekretaris Program Studi S2",
    "GRADE STRUKTURAL": 11,
    "UNIT KERJA": "Pendidikan Anak Usia Dini (S2)",
    "POINT POSITION": 2152.2,
    "POINT PERFORMANCE": 2123.17,
    "POINT KELEBIHAN": 63.3333,
    "POINT TOTAL": 4338.7,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 6508050,
    "PPh 100%": 976207.5,
    "JUMLAH KOTOR 30% (Rp)": 2107890,
    "JUMLAH KOTOR 70% (Rp)": 4400160,
    "PPh 21": 660024,
    "JUMLAH BERSIH 70% (Rp)": 3740136,
    "TANDA TANGAN": 20
  },
  {
    "NIP": "'198912232015042002",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. Gusti Ayu Putu Sukma Trisna, S.Pd., M.Pd.",
    "JURUSAN": "Pendidikan Guru Sekolah Dasar (PGSD) (S1)",
    "FAKULTAS": "Fakultas Ilmu Pendidikan",
    "GOLONGAN": "IIIC",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "UNIT KERJA": "-",
    "POINT PERFORMANCE": 1378.5,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 1378.5,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 2067750,
    "PPh 100%": 103387.5,
    "JUMLAH KOTOR 30% (Rp)": 787050,
    "JUMLAH KOTOR 70% (Rp)": 1280700,
    "PPh 21": 64035,
    "JUMLAH BERSIH 70% (Rp)": 1216665,
    "TANDA TANGAN": 21
  },
  {
    "NIP": "'198408202012121004",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. I Gede Astawan, S.Pd., M.Pd.",
    "JURUSAN": "Pendidikan Guru Sekolah Dasar (PGSD) (S1)",
    "FAKULTAS": "Fakultas Ilmu Pendidikan",
    "GOLONGAN": "IVA",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor Kepala",
    "GRADE FUNGSIONAL": 11,
    "STRUKTURAL": "Ketua Jurusan S1",
    "GRADE STRUKTURAL": 12,
    "UNIT KERJA": "Jurusan Pendidikan Dasar",
    "POINT POSITION": 3011,
    "POINT PERFORMANCE": 2258,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 5269,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 7903500,
    "PPh 100%": 1185525,
    "JUMLAH KOTOR 30% (Rp)": 2494350,
    "JUMLAH KOTOR 70% (Rp)": 5409150,
    "PPh 21": 811372.5,
    "JUMLAH BERSIH 70% (Rp)": 4597777.5,
    "TANDA TANGAN": 22
  },
  {
    "NIP": "'199008052015042001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. I Gusti Agung Ayu Wulandari, S.Pd., M.Pd.",
    "JURUSAN": "Pendidikan Guru Sekolah Dasar (PGSD) (S1)",
    "FAKULTAS": "Fakultas Ilmu Pendidikan",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "UNIT KERJA": "-",
    "POINT PERFORMANCE": 1362,
    "POINT KELEBIHAN": 210.91,
    "POINT TOTAL": 1572.91,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 2359365,
    "PPh 100%": 117968.25,
    "JUMLAH KOTOR 30% (Rp)": 787050,
    "JUMLAH KOTOR 70% (Rp)": 1572315,
    "PPh 21": 78615.75,
    "JUMLAH BERSIH 70% (Rp)": 1493699.25,
    "TANDA TANGAN": 23
  },
  {
    "NIP": "'198408282009122005",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. I Gusti Ayu Tri Agustiana, S.Pd., M.Pd.",
    "JURUSAN": "Pendidikan Guru Sekolah Dasar (PGSD) (S1)",
    "FAKULTAS": "Fakultas Ilmu Pendidikan",
    "GOLONGAN": "IVA",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor Kepala",
    "GRADE FUNGSIONAL": 11,
    "UNIT KERJA": "-",
    "POINT PERFORMANCE": 1822,
    "POINT KELEBIHAN": 20.9,
    "POINT TOTAL": 1842.9,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 2764350,
    "PPh 100%": 414652.5,
    "JUMLAH KOTOR 30% (Rp)": 1139400,
    "JUMLAH KOTOR 70% (Rp)": 1624950,
    "PPh 21": 243742.5,
    "JUMLAH BERSIH 70% (Rp)": 1381207.5,
    "TANDA TANGAN": 24
  },
  {
    "NIP": "'198307262009121004",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. I Made Citra Wibawa, S.Pd., M.Pd.",
    "JURUSAN": "Pendidikan Guru Sekolah Dasar (PGSD) (S1)",
    "FAKULTAS": "Fakultas Ilmu Pendidikan",
    "GOLONGAN": "IVA",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor Kepala",
    "GRADE FUNGSIONAL": 11,
    "STRUKTURAL": "Sekretaris Program Studi S2",
    "GRADE STRUKTURAL": 11,
    "UNIT KERJA": "Pendidikan Dasar (S2)",
    "POINT POSITION": 2152.2,
    "POINT PERFORMANCE": 2141.33,
    "POINT KELEBIHAN": 643.15,
    "POINT TOTAL": 4936.68,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 7405020,
    "PPh 100%": 1110753,
    "JUMLAH KOTOR 30% (Rp)": 2107890,
    "JUMLAH KOTOR 70% (Rp)": 5297130,
    "PPh 21": 794569.5,
    "JUMLAH BERSIH 70% (Rp)": 4502560.5,
    "TANDA TANGAN": 25
  },
  {
    "NIP": "'197202052024211001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PPPK",
    "NAMA DOSEN": "Dr. I Wayan Sujana, M.Fil.H",
    "JURUSAN": "Pendidikan Guru Sekolah Dasar (PGSD) (S1)",
    "FAKULTAS": "Fakultas Ilmu Pendidikan",
    "GOLONGAN": "X",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Asisten Ahli",
    "GRADE FUNGSIONAL": 8,
    "UNIT KERJA": "-",
    "POINT PERFORMANCE": 1029.17,
    "POINT KELEBIHAN": 416.1,
    "POINT TOTAL": 1445.27,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 2167905,
    "PPh 100%": 108395.25,
    "JUMLAH KOTOR 30% (Rp)": 656550,
    "JUMLAH KOTOR 70% (Rp)": 1511355,
    "PPh 21": 75567.75,
    "JUMLAH BERSIH 70% (Rp)": 1435787.25,
    "TANDA TANGAN": 26
  },
  {
    "NIP": "'197808312010121002",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. Ida Bagus Gede Surya Abadi, S.E., M.Pd.",
    "JURUSAN": "Pendidikan Guru Sekolah Dasar (PGSD) (S1)",
    "FAKULTAS": "Fakultas Ilmu Pendidikan",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "UNIT KERJA": "-",
    "POINT PERFORMANCE": 1133.17,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 1133.17,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 1699755,
    "PPh 100%": 84987.75,
    "JUMLAH KOTOR 30% (Rp)": 787050,
    "JUMLAH KOTOR 70% (Rp)": 912705,
    "PPh 21": 45635.25,
    "JUMLAH BERSIH 70% (Rp)": 867069.75,
    "TANDA TANGAN": 27
  },
  {
    "NIP": "'198909212024212001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PPPK",
    "NAMA DOSEN": "Dr. Ketut Susiani, M.Pd.",
    "JURUSAN": "Pendidikan Guru Sekolah Dasar (PGSD) (S1)",
    "FAKULTAS": "Fakultas Ilmu Pendidikan",
    "GOLONGAN": "X",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Asisten Ahli",
    "GRADE FUNGSIONAL": 8,
    "UNIT KERJA": "-",
    "POINT PERFORMANCE": 1201.33,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 1201.33,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 1801995,
    "PPh 100%": 90099.75,
    "JUMLAH KOTOR 30% (Rp)": 656550,
    "JUMLAH KOTOR 70% (Rp)": 1145445,
    "PPh 21": 57272.25,
    "JUMLAH BERSIH 70% (Rp)": 1088172.75,
    "TANDA TANGAN": 28
  },
  {
    "NIP": "'198802122014041002",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. Komang Sujendra Diputra, S.Pd., M.Pd.",
    "JURUSAN": "Pendidikan Guru Sekolah Dasar (PGSD) (S1)",
    "FAKULTAS": "Fakultas Ilmu Pendidikan",
    "GOLONGAN": "IIIC",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "STRUKTURAL": "Sekretaris Pusat Pengembangan Kurikulum dan Pelaksanaan Pembelajaran",
    "GRADE STRUKTURAL": 11,
    "UNIT KERJA": "-",
    "POINT POSITION": 1645.8,
    "POINT PERFORMANCE": 1346.17,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 2991.97,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 4487955,
    "PPh 100%": 224397.75,
    "JUMLAH KOTOR 30% (Rp)": 1527660,
    "JUMLAH KOTOR 70% (Rp)": 2960295,
    "PPh 21": 148014.75,
    "JUMLAH BERSIH 70% (Rp)": 2812280.25,
    "TANDA TANGAN": 29
  },
  {
    "NIP": "'198912132015042003",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. Ni Ketut Desia Tristiantari, S.Pd., M.Pd.",
    "JURUSAN": "Pendidikan Guru Sekolah Dasar (PGSD) (S1)",
    "FAKULTAS": "Fakultas Ilmu Pendidikan",
    "GOLONGAN": "IIIC",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "STRUKTURAL": "[REN222] Kepala Pusat /Kantor/Kepala Gugus Kendali Mutu Fakultas/Ketua Unit Pengelolaan dan Penerimaan Mahasiswa Asing/ Ketua Unit Pengembangan dan Peningkatan Kapasitas Kelembagaan",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "-",
    "POINT POSITION": 1150,
    "POINT PERFORMANCE": 1382.83,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 2532.83,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 3799245,
    "PPh 100%": 189962.25,
    "JUMLAH KOTOR 30% (Rp)": 1304550,
    "JUMLAH KOTOR 70% (Rp)": 2494695,
    "PPh 21": 124734.75,
    "JUMLAH BERSIH 70% (Rp)": 2369960.25,
    "TANDA TANGAN": 30
  },
  {
    "NIP": "'197612142009122002",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. Ni Wayan Rati, S.Pd., M.Pd.",
    "JURUSAN": "Pendidikan Guru Sekolah Dasar (PGSD) (S1)",
    "FAKULTAS": "Fakultas Ilmu Pendidikan",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "UNIT KERJA": "-",
    "POINT PERFORMANCE": 1427.67,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 1427.67,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 2141505,
    "PPh 100%": 107075.25,
    "JUMLAH KOTOR 30% (Rp)": 787050,
    "JUMLAH KOTOR 70% (Rp)": 1354455,
    "PPh 21": 67722.75,
    "JUMLAH BERSIH 70% (Rp)": 1286732.25,
    "TANDA TANGAN": 31
  },
  {
    "NIP": "'198604272009122003",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. Putu Nanci Riastini, S.Pd., M.Pd.",
    "JURUSAN": "Pendidikan Guru Sekolah Dasar (PGSD) (S1)",
    "FAKULTAS": "Fakultas Ilmu Pendidikan",
    "GOLONGAN": "IVA",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor Kepala",
    "GRADE FUNGSIONAL": 11,
    "STRUKTURAL": "Koordinator Program Studi S1/D3",
    "GRADE STRUKTURAL": 11,
    "UNIT KERJA": "Pendidikan Guru Sekolah Dasar (PGSD) (S1)",
    "POINT POSITION": 2532,
    "POINT PERFORMANCE": 2300,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 4832,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 7248000,
    "PPh 100%": 1087200,
    "JUMLAH KOTOR 30% (Rp)": 2278800,
    "JUMLAH KOTOR 70% (Rp)": 4969200,
    "PPh 21": 745380,
    "JUMLAH BERSIH 70% (Rp)": 4223820,
    "TANDA TANGAN": 32
  },
  {
    "NIP": "'196012311986031022",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Drs. I Made Suarjana, M.Pd.",
    "JURUSAN": "Pendidikan Guru Sekolah Dasar (PGSD) (S1)",
    "FAKULTAS": "Fakultas Ilmu Pendidikan",
    "GOLONGAN": "IVC",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor Kepala",
    "GRADE FUNGSIONAL": 11,
    "UNIT KERJA": "-",
    "POINT PERFORMANCE": 1920.67,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 1920.67,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 2881005,
    "PPh 100%": 432150.75,
    "JUMLAH KOTOR 30% (Rp)": 1139400,
    "JUMLAH KOTOR 70% (Rp)": 1741605,
    "PPh 21": 261240.75,
    "JUMLAH BERSIH 70% (Rp)": 1480364.25,
    "TANDA TANGAN": 33
  },
  {
    "NIP": "'196306161988031003",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Drs. I Wayan Wiarta, S.Pd., M.For.",
    "JURUSAN": "Pendidikan Guru Sekolah Dasar (PGSD) (S1)",
    "FAKULTAS": "Fakultas Ilmu Pendidikan",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor Kepala",
    "GRADE FUNGSIONAL": 11,
    "UNIT KERJA": "-",
    "POINT PERFORMANCE": 1894,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 1894,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 2841000,
    "PPh 100%": 142050,
    "JUMLAH KOTOR 30% (Rp)": 1139400,
    "JUMLAH KOTOR 70% (Rp)": 1701600,
    "PPh 21": 85080,
    "JUMLAH BERSIH 70% (Rp)": 1616520,
    "TANDA TANGAN": 34
  },
  {
    "NIP": "'198605172015041001",
    "STATUS SEKARANG": "Ijin Belajar",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Gusti Ngurah Sastra Agustika, S.Si., M.Pd.",
    "JURUSAN": "Pendidikan Guru Sekolah Dasar (PGSD) (S1)",
    "FAKULTAS": "Fakultas Ilmu Pendidikan",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "UNIT KERJA": "-",
    "POINT PERFORMANCE": 1322.83,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 1322.83,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 1984245,
    "PPh 100%": 99212.25,
    "JUMLAH KOTOR 30% (Rp)": 787050,
    "JUMLAH KOTOR 70% (Rp)": 1197195,
    "PPh 21": 59859.75,
    "JUMLAH BERSIH 70% (Rp)": 1137335.25,
    "TANDA TANGAN": 35
  },
  {
    "NIP": "'199809152024061001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "I Gede Wahyu Suwela Antara, M.Pd.",
    "JURUSAN": "Pendidikan Guru Sekolah Dasar (PGSD) (S1)",
    "FAKULTAS": "Fakultas Ilmu Pendidikan",
    "GOLONGAN": "IIIB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Tenaga Pengajar",
    "GRADE FUNGSIONAL": 7,
    "UNIT KERJA": "-",
    "POINT PERFORMANCE": 669.593,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 669.593,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 1004389.5,
    "PPh 100%": 50219.475,
    "JUMLAH KOTOR 30% (Rp)": 545400,
    "JUMLAH KOTOR 70% (Rp)": 458989.5,
    "PPh 21": 22949.475,
    "JUMLAH BERSIH 70% (Rp)": 436040.025,
    "TANDA TANGAN": 36
  },
  {
    "NIP": "'198410082024211001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PPPK",
    "NAMA DOSEN": "I Kadek Edi Yudiana, M.Pd.",
    "JURUSAN": "Pendidikan Guru Sekolah Dasar (PGSD) (S1)",
    "FAKULTAS": "Fakultas Ilmu Pendidikan",
    "GOLONGAN": "X",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Asisten Ahli",
    "GRADE FUNGSIONAL": 8,
    "UNIT KERJA": "-",
    "POINT PERFORMANCE": 1166.83,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 1166.83,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 1750245,
    "PPh 100%": 87512.25,
    "JUMLAH KOTOR 30% (Rp)": 656550,
    "JUMLAH KOTOR 70% (Rp)": 1093695,
    "PPh 21": 54684.75,
    "JUMLAH BERSIH 70% (Rp)": 1039010.25,
    "TANDA TANGAN": 37
  },
  {
    "NIP": "'198905282023211018",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PPPK",
    "NAMA DOSEN": "I Made Hendra Sukmayasa, M.Pd.",
    "JURUSAN": "Pendidikan Guru Sekolah Dasar (PGSD) (S1)",
    "FAKULTAS": "Fakultas Ilmu Pendidikan",
    "GOLONGAN": "X",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Asisten Ahli",
    "GRADE FUNGSIONAL": 8,
    "UNIT KERJA": "-",
    "POINT PERFORMANCE": 974.024,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 974.024,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 1461036,
    "PPh 100%": 73051.8,
    "JUMLAH KOTOR 30% (Rp)": 656550,
    "JUMLAH KOTOR 70% (Rp)": 804486,
    "PPh 21": 40224.3,
    "JUMLAH BERSIH 70% (Rp)": 764261.7,
    "TANDA TANGAN": 38
  },
  {
    "NIP": "'198601102015041001",
    "STATUS SEKARANG": "Ijin Belajar",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "I Nyoman Laba Jayanta, S.Pd., M.Pd.",
    "JURUSAN": "Pendidikan Guru Sekolah Dasar (PGSD) (S1)",
    "FAKULTAS": "Fakultas Ilmu Pendidikan",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor Kepala",
    "GRADE FUNGSIONAL": 11,
    "STRUKTURAL": "Ketua Laboratorium Fakultas",
    "GRADE STRUKTURAL": 12,
    "UNIT KERJA": "Fakultas Ilmu Pendidikan",
    "POINT POSITION": 3011,
    "POINT PERFORMANCE": 2028.17,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 5039.17,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 7558755,
    "PPh 100%": 377937.75,
    "JUMLAH KOTOR 30% (Rp)": 2494350,
    "JUMLAH KOTOR 70% (Rp)": 5064405,
    "PPh 21": 253220.25,
    "JUMLAH BERSIH 70% (Rp)": 4811184.75,
    "TANDA TANGAN": 39
  },
  {
    "NIP": "'199405182024061001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "I Nyoman Tri Esaputra, S.E., M.Pd.",
    "JURUSAN": "Pendidikan Guru Sekolah Dasar (PGSD) (S1)",
    "FAKULTAS": "Fakultas Ilmu Pendidikan",
    "GOLONGAN": "IIIB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Tenaga Pengajar",
    "GRADE FUNGSIONAL": 7,
    "STRUKTURAL": "[REN223] Sekretaris Pusat/ Ketua Divisi/ Asrama/ Koordinator Lab. Jurusan Kepala Unit BPU/ Sekretaris Gugus Kendali Mutu Fakultas/ Sekretaris Tim Pengelolaan dan Penerimaan Mahasiswa Asing/ Sekretaris Unit Pengembangan dan Peningkatan Kapasitas Kelembagaan",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "-",
    "POINT POSITION": 800,
    "POINT PERFORMANCE": 849.667,
    "POINT KELEBIHAN": 267.843,
    "POINT TOTAL": 1917.51,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 2876265,
    "PPh 100%": 143813.25,
    "JUMLAH KOTOR 30% (Rp)": 905400,
    "JUMLAH KOTOR 70% (Rp)": 1970865,
    "PPh 21": 98543.25,
    "JUMLAH BERSIH 70% (Rp)": 1872321.75,
    "TANDA TANGAN": 40
  },
  {
    "NIP": "'198706102024211001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PPPK",
    "NAMA DOSEN": "I Wayan Ardana, M.Pd.",
    "JURUSAN": "Pendidikan Guru Sekolah Dasar (PGSD) (S1)",
    "FAKULTAS": "Fakultas Ilmu Pendidikan",
    "GOLONGAN": "X",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Asisten Ahli",
    "GRADE FUNGSIONAL": 8,
    "UNIT KERJA": "-",
    "POINT PERFORMANCE": 795.212,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 795.212,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 1192818,
    "PPh 100%": 59640.9,
    "JUMLAH KOTOR 30% (Rp)": 656550,
    "JUMLAH KOTOR 70% (Rp)": 536268,
    "PPh 21": 26813.4,
    "JUMLAH BERSIH 70% (Rp)": 509454.6,
    "TANDA TANGAN": 41
  },
  {
    "NIP": "'199305152024061002",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "I Wayan Suantara, S.Pd., M.Pd.",
    "JURUSAN": "Pendidikan Guru Sekolah Dasar (PGSD) (S1)",
    "FAKULTAS": "Fakultas Ilmu Pendidikan",
    "GOLONGAN": "IIIB",
    "STATUS PENELITIAN": "TIDAK ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Tenaga Pengajar",
    "GRADE FUNGSIONAL": 7,
    "UNIT KERJA": "-",
    "POINT POSITION": 0,
    "POINT PERFORMANCE": 0,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 0,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 0,
    "PPh 100%": 0,
    "JUMLAH KOTOR 30% (Rp)": 545400,
    "JUMLAH KOTOR 70% (Rp)": 0,
    "PPh 21": 0,
    "JUMLAH BERSIH 70% (Rp)": 0,
    "TANDA TANGAN": 42
  },
  {
    "NIP": "'198605212015041001",
    "STATUS SEKARANG": "Ijin Belajar",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Kadek Yudiana, S.Pd., M.Pd.",
    "JURUSAN": "Pendidikan Guru Sekolah Dasar (PGSD) (S1)",
    "FAKULTAS": "Fakultas Ilmu Pendidikan",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor Kepala",
    "GRADE FUNGSIONAL": 11,
    "STRUKTURAL": "Sekretaris UPA",
    "GRADE STRUKTURAL": 11,
    "UNIT KERJA": "-",
    "POINT POSITION": 2152.2,
    "POINT PERFORMANCE": 1597.83,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 3750.03,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 5625045,
    "PPh 100%": 281252.25,
    "JUMLAH KOTOR 30% (Rp)": 2107890,
    "JUMLAH KOTOR 70% (Rp)": 3517155,
    "PPh 21": 175857.75,
    "JUMLAH BERSIH 70% (Rp)": 3341297.25,
    "TANDA TANGAN": 43
  },
  {
    "NIP": "'198706112023212058",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PPPK",
    "NAMA DOSEN": "Ketut Herya Darma Utami, S.Pd., M.Pd.",
    "JURUSAN": "Pendidikan Guru Sekolah Dasar (PGSD) (S1)",
    "FAKULTAS": "Fakultas Ilmu Pendidikan",
    "GOLONGAN": "X",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Asisten Ahli",
    "GRADE FUNGSIONAL": 8,
    "UNIT KERJA": "-",
    "POINT PERFORMANCE": 1111.83,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 1111.83,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 1667745,
    "PPh 100%": 83387.25,
    "JUMLAH KOTOR 30% (Rp)": 656550,
    "JUMLAH KOTOR 70% (Rp)": 1011195,
    "PPh 21": 50559.75,
    "JUMLAH BERSIH 70% (Rp)": 960635.25,
    "TANDA TANGAN": 44
  },
  {
    "NIP": "'198904232024212001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PPPK",
    "NAMA DOSEN": "Komang Alit Wahyuni, S.Pd., M.Pd.",
    "JURUSAN": "Pendidikan Guru Sekolah Dasar (PGSD) (S1)",
    "FAKULTAS": "Fakultas Ilmu Pendidikan",
    "GOLONGAN": "X",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Asisten Ahli",
    "GRADE FUNGSIONAL": 8,
    "UNIT KERJA": "-",
    "POINT PERFORMANCE": 1006.54,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 1006.54,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 1509810,
    "PPh 100%": 75490.5,
    "JUMLAH KOTOR 30% (Rp)": 656550,
    "JUMLAH KOTOR 70% (Rp)": 853260,
    "PPh 21": 42663,
    "JUMLAH BERSIH 70% (Rp)": 810597,
    "TANDA TANGAN": 45
  },
  {
    "NIP": "'198607032023212041",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PPPK",
    "NAMA DOSEN": "Luh Sri Surya Wisma Jayanti, S.Pd.,M.Pd",
    "JURUSAN": "Pendidikan Guru Sekolah Dasar (PGSD) (S1)",
    "FAKULTAS": "Fakultas Ilmu Pendidikan",
    "GOLONGAN": "X",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Asisten Ahli",
    "GRADE FUNGSIONAL": 8,
    "UNIT KERJA": "-",
    "POINT PERFORMANCE": 1015,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 1015,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 1522500,
    "PPh 100%": 76125,
    "JUMLAH KOTOR 30% (Rp)": 656550,
    "JUMLAH KOTOR 70% (Rp)": 865950,
    "PPh 21": 43297.5,
    "JUMLAH BERSIH 70% (Rp)": 822652.5,
    "TANDA TANGAN": 46
  },
  {
    "NIP": "'199004142023212054",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PPPK",
    "NAMA DOSEN": "Ni Luh Putu Agetania, S.Pd., M.Pd.",
    "JURUSAN": "Pendidikan Guru Sekolah Dasar (PGSD) (S1)",
    "FAKULTAS": "Fakultas Ilmu Pendidikan",
    "GOLONGAN": "X",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Asisten Ahli",
    "GRADE FUNGSIONAL": 8,
    "UNIT KERJA": "-",
    "POINT PERFORMANCE": 1091.33,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 1091.33,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 1636995,
    "PPh 100%": 81849.75,
    "JUMLAH KOTOR 30% (Rp)": 656550,
    "JUMLAH KOTOR 70% (Rp)": 980445,
    "PPh 21": 49022.25,
    "JUMLAH BERSIH 70% (Rp)": 931422.75,
    "TANDA TANGAN": 47
  },
  {
    "NIP": "'198411172024212001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PPPK",
    "NAMA DOSEN": "Ni Made Dainivitri Sinta Sari, M.Pd.",
    "JURUSAN": "Pendidikan Guru Sekolah Dasar (PGSD) (S1)",
    "FAKULTAS": "Fakultas Ilmu Pendidikan",
    "GOLONGAN": "X",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Asisten Ahli",
    "GRADE FUNGSIONAL": 8,
    "UNIT KERJA": "-",
    "POINT PERFORMANCE": 598.545,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 598.545,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 897817.5,
    "PPh 100%": 44890.875,
    "JUMLAH KOTOR 30% (Rp)": 656550,
    "JUMLAH KOTOR 70% (Rp)": 241267.5,
    "PPh 21": 12063.375,
    "JUMLAH BERSIH 70% (Rp)": 229204.125,
    "TANDA TANGAN": 48
  },
  {
    "NIP": "'198902152024212001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PPPK",
    "NAMA DOSEN": "Ni Putu Kusuma Widiastuti, M.Pd.",
    "JURUSAN": "Pendidikan Guru Sekolah Dasar (PGSD) (S1)",
    "FAKULTAS": "Fakultas Ilmu Pendidikan",
    "GOLONGAN": "X",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Asisten Ahli",
    "GRADE FUNGSIONAL": 8,
    "UNIT KERJA": "-",
    "POINT PERFORMANCE": 714.878,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 714.878,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 1072317,
    "PPh 100%": 53615.85,
    "JUMLAH KOTOR 30% (Rp)": 656550,
    "JUMLAH KOTOR 70% (Rp)": 415767,
    "PPh 21": 20788.35,
    "JUMLAH BERSIH 70% (Rp)": 394978.65,
    "TANDA TANGAN": 49
  },
  {
    "NIP": "'198211132024212001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PPPK",
    "NAMA DOSEN": "Ni Wayan Eka Widiastini, S.Pd., M.Pd.",
    "JURUSAN": "Pendidikan Guru Sekolah Dasar (PGSD) (S1)",
    "FAKULTAS": "Fakultas Ilmu Pendidikan",
    "GOLONGAN": "X",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Asisten Ahli",
    "GRADE FUNGSIONAL": 8,
    "UNIT KERJA": "-",
    "POINT PERFORMANCE": 1048.83,
    "POINT KELEBIHAN": 194.545,
    "POINT TOTAL": 1243.38,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 1865070,
    "PPh 100%": 93253.5,
    "JUMLAH KOTOR 30% (Rp)": 656550,
    "JUMLAH KOTOR 70% (Rp)": 1208520,
    "PPh 21": 60426,
    "JUMLAH BERSIH 70% (Rp)": 1148094,
    "TANDA TANGAN": 50
  },
  {
    "NIP": "'198504022009121009",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Prof. Dr. I Gede Margunayasa, S.Pd., M.Pd.",
    "JURUSAN": "Pendidikan Guru Sekolah Dasar (PGSD) (S1)",
    "FAKULTAS": "Fakultas Ilmu Pendidikan",
    "GOLONGAN": "IVB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Guru Besar",
    "GRADE FUNGSIONAL": 12,
    "STRUKTURAL": "Koordinator Program Studi S2",
    "GRADE STRUKTURAL": 12,
    "UNIT KERJA": "Pendidikan Dasar (S2)",
    "POINT POSITION": 2559.35,
    "POINT PERFORMANCE": 2978.33,
    "POINT KELEBIHAN": 541.8,
    "POINT TOTAL": 6079.48,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 9119220,
    "PPh 100%": 1367883,
    "JUMLAH KOTOR 30% (Rp)": 2506657.5,
    "JUMLAH KOTOR 70% (Rp)": 6612562.5,
    "PPh 21": 991884.375,
    "JUMLAH BERSIH 70% (Rp)": 5620678.125,
    "TANDA TANGAN": 51
  },
  {
    "NIP": "'195903211983032003",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Prof. Dr. Maria Goreti Rini Kristiantari, M.Pd.",
    "JURUSAN": "Pendidikan Guru Sekolah Dasar (PGSD) (S1)",
    "FAKULTAS": "Fakultas Ilmu Pendidikan",
    "GOLONGAN": "IVD",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Guru Besar",
    "GRADE FUNGSIONAL": 12,
    "STRUKTURAL": "[REN126] Pengelola Gugus Kendali Mutu (Fakultas) sebagai Anggota",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Pendidikan Anak Usia Dini (S2)",
    "POINT POSITION": 200,
    "POINT PERFORMANCE": 2465.17,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 2665.17,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 3997755,
    "PPh 100%": 599663.25,
    "JUMLAH KOTOR 30% (Rp)": 1444950,
    "JUMLAH KOTOR 70% (Rp)": 2552805,
    "PPh 21": 382920.75,
    "JUMLAH BERSIH 70% (Rp)": 2169884.25,
    "TANDA TANGAN": 52
  },
  {
    "NIP": "'199202122019032013",
    "STATUS SEKARANG": "Tugas Belajar",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dewa Ayu Puteri Handayani, S.Psi., M.Sc.",
    "JURUSAN": "Pendidikan Guru Pendidikan Anak Usia Dini (PGPAUD) (S1)",
    "FAKULTAS": "Fakultas Ilmu Pendidikan",
    "GOLONGAN": "IIIC",
    "STATUS PENELITIAN": "TIDAK ADA",
    "STATUS PENGABDIAN": "TIDAK ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "UNIT KERJA": "-",
    "POINT POSITION": 0,
    "POINT PERFORMANCE": 0,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 0,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 0,
    "PPh 100%": 0,
    "JUMLAH KOTOR 70% (Rp)": 0,
    "PPh 21": 0,
    "JUMLAH BERSIH 70% (Rp)": 0,
    "TANDA TANGAN": 53
  },
  {
    "NIP": "'199005082019031011",
    "STATUS SEKARANG": "Ijin Belajar",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dewa Gede Firstia Wirabrata, S.Psi., M.Psi., Psikolog.",
    "JURUSAN": "Pendidikan Guru Pendidikan Anak Usia Dini (PGPAUD) (S1)",
    "FAKULTAS": "Fakultas Ilmu Pendidikan",
    "GOLONGAN": "IIIC",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "STRUKTURAL": "Koordinator Program Studi S1/D3",
    "GRADE STRUKTURAL": 11,
    "UNIT KERJA": "Pendidikan Guru Pendidikan Anak Usia Dini (PGPAUD) (S1)",
    "POINT POSITION": 1645.8,
    "POINT PERFORMANCE": 1147.83,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 2793.63,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 4190445,
    "PPh 100%": 209522.25,
    "JUMLAH KOTOR 30% (Rp)": 1527660,
    "JUMLAH KOTOR 70% (Rp)": 2662785,
    "PPh 21": 133139.25,
    "JUMLAH BERSIH 70% (Rp)": 2529645.75,
    "TANDA TANGAN": 54
  },
  {
    "NIP": "'197405202008121003",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Didith Pramunditya Ambara, S.Psi., M.A.",
    "JURUSAN": "Pendidikan Guru Pendidikan Anak Usia Dini (PGPAUD) (S1)",
    "FAKULTAS": "Fakultas Ilmu Pendidikan",
    "GOLONGAN": "IIIB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Asisten Ahli",
    "GRADE FUNGSIONAL": 8,
    "UNIT KERJA": "-",
    "POINT PERFORMANCE": 1027,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 1027,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 1540500,
    "PPh 100%": 77025,
    "JUMLAH KOTOR 30% (Rp)": 656550,
    "JUMLAH KOTOR 70% (Rp)": 883950,
    "PPh 21": 44197.5,
    "JUMLAH BERSIH 70% (Rp)": 839752.5,
    "TANDA TANGAN": 55
  },
  {
    "NIP": "'198303022006041001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. Putu Aditya Antara, S.Pd., M.Pd.",
    "JURUSAN": "Pendidikan Guru Pendidikan Anak Usia Dini (PGPAUD) (S1)",
    "FAKULTAS": "Fakultas Ilmu Pendidikan",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor Kepala",
    "GRADE FUNGSIONAL": 11,
    "STRUKTURAL": "Wakil Dekan III",
    "GRADE STRUKTURAL": 14,
    "UNIT KERJA": "Fakultas Ilmu Pendidikan",
    "POINT POSITION": 10800,
    "POINT PERFORMANCE": 2125.67,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 12925.7,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 19388550,
    "PPh 100%": 969427.5,
    "JUMLAH KOTOR 30% (Rp)": 5999400,
    "JUMLAH KOTOR 70% (Rp)": 13389150,
    "PPh 21": 669457.5,
    "JUMLAH BERSIH 70% (Rp)": 12719692.5,
    "TANDA TANGAN": 56
  },
  {
    "NIP": "'199206042019032014",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Made Vina Arie Paramita, S.Pd., M.Pd.",
    "JURUSAN": "Pendidikan Guru Pendidikan Anak Usia Dini (PGPAUD) (S1)",
    "FAKULTAS": "Fakultas Ilmu Pendidikan",
    "GOLONGAN": "IIIC",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "UNIT KERJA": "-",
    "POINT PERFORMANCE": 1284.17,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 1284.17,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 1926255,
    "PPh 100%": 96312.75,
    "JUMLAH KOTOR 30% (Rp)": 787050,
    "JUMLAH KOTOR 70% (Rp)": 1139205,
    "PPh 21": 56960.25,
    "JUMLAH BERSIH 70% (Rp)": 1082244.75,
    "TANDA TANGAN": 57
  },
  {
    "NIP": "'199410232024062002",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Ni Putu Vivin Indrawati, M.Pd.",
    "JURUSAN": "Pendidikan Guru Pendidikan Anak Usia Dini (PGPAUD) (S1)",
    "FAKULTAS": "Fakultas Ilmu Pendidikan",
    "GOLONGAN": "IIIB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Tenaga Pengajar",
    "GRADE FUNGSIONAL": 7,
    "STRUKTURAL": "[REN126] Pengelola Gugus Kendali Mutu (Fakultas) sebagai Anggota",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Fakultas Ilmu Pendidikan",
    "POINT POSITION": 200,
    "POINT PERFORMANCE": 818.167,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 1018.17,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 1527255,
    "PPh 100%": 76362.75,
    "JUMLAH KOTOR 30% (Rp)": 635400,
    "JUMLAH KOTOR 70% (Rp)": 891855,
    "PPh 21": 44592.75,
    "JUMLAH BERSIH 70% (Rp)": 847262.25,
    "TANDA TANGAN": 58
  },
  {
    "NIP": "'198705082012122001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Nice Maylani Asril, S.Psi., M.Psi., Ph.D.",
    "JURUSAN": "Pendidikan Guru Pendidikan Anak Usia Dini (PGPAUD) (S1)",
    "FAKULTAS": "Fakultas Ilmu Pendidikan",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor Kepala",
    "GRADE FUNGSIONAL": 11,
    "STRUKTURAL": "Koordinator Program Studi S2",
    "GRADE STRUKTURAL": 12,
    "UNIT KERJA": "Pendidikan Anak Usia Dini (S2)",
    "POINT POSITION": 2559.35,
    "POINT PERFORMANCE": 2136.5,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 4695.85,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 7043775,
    "PPh 100%": 352188.75,
    "JUMLAH KOTOR 30% (Rp)": 2291107.5,
    "JUMLAH KOTOR 70% (Rp)": 4752667.5,
    "PPh 21": 237633.375,
    "JUMLAH BERSIH 70% (Rp)": 4515034.125,
    "TANDA TANGAN": 59
  },
  {
    "NIP": "'199401012022031013",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Rendy Setyowahyudi, M.Pd.",
    "JURUSAN": "Pendidikan Guru Pendidikan Anak Usia Dini (PGPAUD) (S1)",
    "FAKULTAS": "Fakultas Ilmu Pendidikan",
    "GOLONGAN": "IIIB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Asisten Ahli",
    "GRADE FUNGSIONAL": 8,
    "UNIT KERJA": "-",
    "POINT PERFORMANCE": 780.462,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 780.462,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 1170693,
    "PPh 100%": 58534.65,
    "JUMLAH KOTOR 30% (Rp)": 656550,
    "JUMLAH KOTOR 70% (Rp)": 514143,
    "PPh 21": 25707.15,
    "JUMLAH BERSIH 70% (Rp)": 488435.85,
    "TANDA TANGAN": 60
  },
  {
    "NIP": "'196312311989031021",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. Drs. I Ketut Supir, M.Hum.",
    "JURUSAN": "Desain Komunikasi Visual (D3)",
    "FAKULTAS": "Fakultas Bahasa dan Seni",
    "GOLONGAN": "IVB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor Kepala",
    "GRADE FUNGSIONAL": 11,
    "STRUKTURAL": "Ketua Jurusan S1",
    "GRADE STRUKTURAL": 12,
    "UNIT KERJA": "Jurusan Seni dan Desain",
    "POINT POSITION": 1957.15,
    "POINT PERFORMANCE": 1954.67,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 3911.82,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 5867730,
    "PPh 100%": 880159.5,
    "JUMLAH KOTOR 30% (Rp)": 2020117.5,
    "JUMLAH KOTOR 70% (Rp)": 3847612.5,
    "PPh 21": 577141.875,
    "JUMLAH BERSIH 70% (Rp)": 3270470.625,
    "TANDA TANGAN": 61
  },
  {
    "NIP": "'198006022010122003",
    "STATUS SEKARANG": "Ijin Belajar",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Elly Herliyani, S.Sn., M.Pd.",
    "JURUSAN": "Desain Komunikasi Visual (D3)",
    "FAKULTAS": "Fakultas Bahasa dan Seni",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "STRUKTURAL": "[REN126] Pengelola Gugus Kendali Mutu (Fakultas) sebagai Anggota",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Fakultas Bahasa dan Seni",
    "POINT POSITION": 200,
    "POINT PERFORMANCE": 971.167,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 1171.17,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 1756755,
    "PPh 100%": 87837.75,
    "JUMLAH KOTOR 30% (Rp)": 877050,
    "JUMLAH KOTOR 70% (Rp)": 879705,
    "PPh 21": 43985.25,
    "JUMLAH BERSIH 70% (Rp)": 835719.75,
    "TANDA TANGAN": 62
  },
  {
    "NIP": "'197406241999031001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Ketut Nala Hari Wardana, S.Sn., M.Pd.",
    "JURUSAN": "Desain Komunikasi Visual (D3)",
    "FAKULTAS": "Fakultas Bahasa dan Seni",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "STRUKTURAL": "[REN126] Pengelola Gugus Kendali Mutu (Fakultas) sebagai Anggota",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Fakultas Bahasa dan Seni",
    "POINT POSITION": 200,
    "POINT PERFORMANCE": 915.333,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 1115.33,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 1672995,
    "PPh 100%": 83649.75,
    "JUMLAH KOTOR 30% (Rp)": 877050,
    "JUMLAH KOTOR 70% (Rp)": 795945,
    "PPh 21": 39797.25,
    "JUMLAH BERSIH 70% (Rp)": 756147.75,
    "TANDA TANGAN": 63
  },
  {
    "NIP": "'197405042006042001",
    "STATUS SEKARANG": "Ijin Belajar",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Ni Nyoman Sri Witari, S.Sn., M.Ds.",
    "JURUSAN": "Desain Komunikasi Visual (D3)",
    "FAKULTAS": "Fakultas Bahasa dan Seni",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "STRUKTURAL": "Koordinator Program Studi S1/D3",
    "GRADE STRUKTURAL": 11,
    "UNIT KERJA": "Desain Komunikasi Visual (D3)",
    "POINT POSITION": 1645.8,
    "POINT PERFORMANCE": 1251,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 2896.8,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 4345200,
    "PPh 100%": 217260,
    "JUMLAH KOTOR 30% (Rp)": 1527660,
    "JUMLAH KOTOR 70% (Rp)": 2817540,
    "PPh 21": 140877,
    "JUMLAH BERSIH 70% (Rp)": 2676663,
    "TANDA TANGAN": 64
  },
  {
    "NIP": "'197806082001122005",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Anak Agung Sri Barustyawati, S.Pd., M.Hum.",
    "JURUSAN": "Bahasa Inggris Untuk Komunikasi Bisnis Dan Profesional (D4)",
    "FAKULTAS": "Fakultas Bahasa dan Seni",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "STRUKTURAL": "[REN126] Pengelola Gugus Kendali Mutu (Fakultas) sebagai Anggota",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Fakultas Bahasa dan Seni",
    "POINT POSITION": 200,
    "POINT PERFORMANCE": 992.167,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 1192.17,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 1788255,
    "PPh 100%": 89412.75,
    "JUMLAH KOTOR 30% (Rp)": 877050,
    "JUMLAH KOTOR 70% (Rp)": 911205,
    "PPh 21": 45560.25,
    "JUMLAH BERSIH 70% (Rp)": 865644.75,
    "TANDA TANGAN": 65
  },
  {
    "NIP": "'198505302023212029",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PPPK",
    "NAMA DOSEN": "Desak Ketut Meirawati, S.Pd., M.Pd.",
    "JURUSAN": "Bahasa Inggris Untuk Komunikasi Bisnis Dan Profesional (D4)",
    "FAKULTAS": "Fakultas Bahasa dan Seni",
    "GOLONGAN": "X",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Asisten Ahli",
    "GRADE FUNGSIONAL": 8,
    "UNIT KERJA": "-",
    "POINT PERFORMANCE": 630.167,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 630.167,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 945250.5,
    "PPh 100%": 47262.525,
    "JUMLAH KOTOR 30% (Rp)": 656550,
    "JUMLAH KOTOR 70% (Rp)": 288700.5,
    "PPh 21": 14435.025,
    "JUMLAH BERSIH 70% (Rp)": 274265.475,
    "TANDA TANGAN": 66
  },
  {
    "NIP": "'197807102002121002",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. I Made Suta Paramarta, S.Pd., M.Hum.",
    "JURUSAN": "Bahasa Inggris Untuk Komunikasi Bisnis Dan Profesional (D4)",
    "FAKULTAS": "Fakultas Bahasa dan Seni",
    "GOLONGAN": "IVA",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor Kepala",
    "GRADE FUNGSIONAL": 11,
    "STRUKTURAL": "Kepala UPA",
    "GRADE STRUKTURAL": 12,
    "UNIT KERJA": "Unit Penunjang Akademik layanan Uji Kompetensi",
    "POINT POSITION": 2559.35,
    "POINT PERFORMANCE": 1831.33,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 4390.68,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 6586020,
    "PPh 100%": 987903,
    "JUMLAH KOTOR 30% (Rp)": 2291107.5,
    "JUMLAH KOTOR 70% (Rp)": 4294912.5,
    "PPh 21": 644236.875,
    "JUMLAH BERSIH 70% (Rp)": 3650675.625,
    "TANDA TANGAN": 67
  },
  {
    "NIP": "'197607142008121002",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. Made Dharma Susena Suyasa, S.S., M.Hum.",
    "JURUSAN": "Bahasa Inggris Untuk Komunikasi Bisnis Dan Profesional (D4)",
    "FAKULTAS": "Fakultas Bahasa dan Seni",
    "GOLONGAN": "IIIC",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "STRUKTURAL": "[REN126] Pengelola Gugus Kendali Mutu (Fakultas) sebagai Anggota",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Pendidikan Bahasa Inggris (S2)",
    "POINT POSITION": 200,
    "POINT PERFORMANCE": 1067.67,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 1267.67,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 1901505,
    "PPh 100%": 95075.25,
    "JUMLAH KOTOR 30% (Rp)": 877050,
    "JUMLAH KOTOR 70% (Rp)": 1024455,
    "PPh 21": 51222.75,
    "JUMLAH BERSIH 70% (Rp)": 973232.25,
    "TANDA TANGAN": 68
  },
  {
    "NIP": "'198303142008122002",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. Ni Putu Era Marsakawati, S.Pd., M.Pd.",
    "JURUSAN": "Bahasa Inggris Untuk Komunikasi Bisnis Dan Profesional (D4)",
    "FAKULTAS": "Fakultas Bahasa dan Seni",
    "GOLONGAN": "IVA",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor Kepala",
    "GRADE FUNGSIONAL": 11,
    "STRUKTURAL": "Ketua Jurusan S1",
    "GRADE STRUKTURAL": 12,
    "UNIT KERJA": "Jurusan Bahasa Asing",
    "POINT POSITION": 2559.35,
    "POINT PERFORMANCE": 2165,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 4724.35,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 7086525,
    "PPh 100%": 1062978.75,
    "JUMLAH KOTOR 30% (Rp)": 2291107.5,
    "JUMLAH KOTOR 70% (Rp)": 4795417.5,
    "PPh 21": 719312.625,
    "JUMLAH BERSIH 70% (Rp)": 4076104.875,
    "TANDA TANGAN": 69
  },
  {
    "NIP": "'198401252008122003",
    "STATUS SEKARANG": "Ijin Belajar",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. Putu Ayu Prabawati Sudana, S.Pd., M.Hum.",
    "JURUSAN": "Bahasa Inggris Untuk Komunikasi Bisnis Dan Profesional (D4)",
    "FAKULTAS": "Fakultas Bahasa dan Seni",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "STRUKTURAL": "[REN220] Ketua Tim Ahli Rektor/ SP4/Kepala Balingkang Confucius Institute/Kepala Unit Kerjasama",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "-",
    "POINT POSITION": 1500,
    "POINT PERFORMANCE": 1052.17,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 2552.17,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 3828255,
    "PPh 100%": 191412.75,
    "JUMLAH KOTOR 30% (Rp)": 1462050,
    "JUMLAH KOTOR 70% (Rp)": 2366205,
    "PPh 21": 118310.25,
    "JUMLAH BERSIH 70% (Rp)": 2247894.75,
    "TANDA TANGAN": 70
  },
  {
    "NIP": "'197310032000121001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. Putu Suarcaya, S.Pd., M.Sc.",
    "JURUSAN": "Bahasa Inggris Untuk Komunikasi Bisnis Dan Profesional (D4)",
    "FAKULTAS": "Fakultas Bahasa dan Seni",
    "GOLONGAN": "IVC",
    "STATUS PENELITIAN": "TIDAK ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor Kepala",
    "GRADE FUNGSIONAL": 11,
    "STRUKTURAL": "[REN126] Pengelola Gugus Kendali Mutu (Fakultas) sebagai Anggota",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Fakultas Bahasa dan Seni",
    "POINT POSITION": 0,
    "POINT PERFORMANCE": 0,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 0,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 0,
    "PPh 100%": 0,
    "JUMLAH KOTOR 30% (Rp)": 1229400,
    "JUMLAH KOTOR 70% (Rp)": 0,
    "PPh 21": 0,
    "JUMLAH BERSIH 70% (Rp)": 0,
    "TANDA TANGAN": 71
  },
  {
    "NIP": "'197605292005012003",
    "STATUS SEKARANG": "Ijin Belajar",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. Rima Andriani Sari, S.Pd., M.Hum",
    "JURUSAN": "Bahasa Inggris Untuk Komunikasi Bisnis Dan Profesional (D4)",
    "FAKULTAS": "Fakultas Bahasa dan Seni",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "STRUKTURAL": "[REN126] Pengelola Gugus Kendali Mutu (Fakultas) sebagai Anggota",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Fakultas Bahasa dan Seni",
    "POINT POSITION": 200,
    "POINT PERFORMANCE": 1221.33,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 1421.33,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 2131995,
    "PPh 100%": 106599.75,
    "JUMLAH KOTOR 30% (Rp)": 877050,
    "JUMLAH KOTOR 70% (Rp)": 1254945,
    "PPh 21": 62747.25,
    "JUMLAH BERSIH 70% (Rp)": 1192197.75,
    "TANDA TANGAN": 72
  },
  {
    "NIP": "'197712162002121002",
    "STATUS SEKARANG": "Ijin Belajar",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Made Aryawan Adijaya, S.Pd., M.Pd.",
    "JURUSAN": "Bahasa Inggris Untuk Komunikasi Bisnis Dan Profesional (D4)",
    "FAKULTAS": "Fakultas Bahasa dan Seni",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor Kepala",
    "GRADE FUNGSIONAL": 11,
    "STRUKTURAL": "Koordinator Program Studi S1/D3",
    "GRADE STRUKTURAL": 11,
    "UNIT KERJA": "Bahasa Inggris Untuk Komunikasi Bisnis Dan Profesional (D4)",
    "POINT POSITION": 1645.8,
    "POINT PERFORMANCE": 1557.17,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 3202.97,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 4804455,
    "PPh 100%": 240222.75,
    "JUMLAH KOTOR 30% (Rp)": 1880010,
    "JUMLAH KOTOR 70% (Rp)": 2924445,
    "PPh 21": 146222.25,
    "JUMLAH BERSIH 70% (Rp)": 2778222.75,
    "TANDA TANGAN": 73
  },
  {
    "NIP": "'197506012001121001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Made Suardana, S.Pd., M.Hum.",
    "JURUSAN": "Bahasa Inggris Untuk Komunikasi Bisnis Dan Profesional (D4)",
    "FAKULTAS": "Fakultas Bahasa dan Seni",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "UNIT KERJA": "-",
    "POINT PERFORMANCE": 835.5,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 835.5,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 1253250,
    "PPh 100%": 62662.5,
    "JUMLAH KOTOR 30% (Rp)": 787050,
    "JUMLAH KOTOR 70% (Rp)": 466200,
    "PPh 21": 23310,
    "JUMLAH BERSIH 70% (Rp)": 442890,
    "TANDA TANGAN": 74
  },
  {
    "NIP": "'197803112003122001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Prof. Dr. Ni Luh Putu Sri Adnyani, S.Pd., M.Hum.",
    "JURUSAN": "Bahasa Inggris Untuk Komunikasi Bisnis Dan Profesional (D4)",
    "FAKULTAS": "Fakultas Bahasa dan Seni",
    "GOLONGAN": "IVB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Guru Besar",
    "GRADE FUNGSIONAL": 12,
    "STRUKTURAL": "Sekretaris Program Studi S3",
    "GRADE STRUKTURAL": 11,
    "UNIT KERJA": "Pendidikan Bahasa Inggris (S3)",
    "POINT POSITION": 2152.2,
    "POINT PERFORMANCE": 2914.5,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 5066.7,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 7600050,
    "PPh 100%": 1140007.5,
    "JUMLAH KOTOR 30% (Rp)": 2323440,
    "JUMLAH KOTOR 70% (Rp)": 5276610,
    "PPh 21": 791491.5,
    "JUMLAH BERSIH 70% (Rp)": 4485118.5,
    "TANDA TANGAN": 75
  },
  {
    "NIP": "'198709182015042001",
    "STATUS SEKARANG": "Ijin Belajar",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Ade Asih Susiari Tantri, S.Pd., M.Pd.",
    "JURUSAN": "Pendidikan Bahasa dan Sastra Indonesia (S1)",
    "FAKULTAS": "Fakultas Bahasa dan Seni",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "STRUKTURAL": "[REN126] Pengelola Gugus Kendali Mutu (Fakultas) sebagai Anggota",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Fakultas Bahasa dan Seni",
    "POINT POSITION": 200,
    "POINT PERFORMANCE": 1296.5,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 1496.5,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 2244750,
    "PPh 100%": 112237.5,
    "JUMLAH KOTOR 30% (Rp)": 877050,
    "JUMLAH KOTOR 70% (Rp)": 1367700,
    "PPh 21": 68385,
    "JUMLAH BERSIH 70% (Rp)": 1299315,
    "TANDA TANGAN": 76
  },
  {
    "NIP": "'198405032008121002",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. I Dewa Gede Budi Utama, S.Pd., M.Hum.",
    "JURUSAN": "Pendidikan Bahasa dan Sastra Indonesia (S1)",
    "FAKULTAS": "Fakultas Bahasa dan Seni",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "UNIT KERJA": "-",
    "POINT PERFORMANCE": 1184.17,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 1184.17,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 1776255,
    "PPh 100%": 88812.75,
    "JUMLAH KOTOR 30% (Rp)": 787050,
    "JUMLAH KOTOR 70% (Rp)": 989205,
    "PPh 21": 49460.25,
    "JUMLAH BERSIH 70% (Rp)": 939744.75,
    "TANDA TANGAN": 77
  },
  {
    "NIP": "'198301052006041001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. I Nyoman Yasa, S.Pd., M.A.",
    "JURUSAN": "Pendidikan Bahasa dan Sastra Indonesia (S1)",
    "FAKULTAS": "Fakultas Bahasa dan Seni",
    "GOLONGAN": "IVB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor Kepala",
    "GRADE FUNGSIONAL": 11,
    "STRUKTURAL": "[REN222] Kepala Pusat /Kantor/Kepala Gugus Kendali Mutu Fakultas/Ketua Unit Pengelolaan dan Penerimaan Mahasiswa Asing/ Ketua Unit Pengembangan dan Peningkatan Kapasitas Kelembagaan",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Pendidikan Bahasa (S2)",
    "POINT POSITION": 1150,
    "POINT PERFORMANCE": 1661.83,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 2811.83,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 4217745,
    "PPh 100%": 632661.75,
    "JUMLAH KOTOR 30% (Rp)": 1656900,
    "JUMLAH KOTOR 70% (Rp)": 2560845,
    "PPh 21": 384126.75,
    "JUMLAH BERSIH 70% (Rp)": 2176718.25,
    "TANDA TANGAN": 78
  },
  {
    "NIP": "'198702072015041001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. I Putu Mas Dewantara, S.Pd., M.Pd.",
    "JURUSAN": "Pendidikan Bahasa dan Sastra Indonesia (S1)",
    "FAKULTAS": "Fakultas Bahasa dan Seni",
    "GOLONGAN": "IVA",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor Kepala",
    "GRADE FUNGSIONAL": 11,
    "STRUKTURAL": "Wakil Dekan II",
    "GRADE STRUKTURAL": 14,
    "UNIT KERJA": "Fakultas Bahasa dan Seni",
    "POINT POSITION": 9720,
    "POINT PERFORMANCE": 1787.04,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 11507,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 17260500,
    "PPh 100%": 2589075,
    "JUMLAH KOTOR 30% (Rp)": 5513400,
    "JUMLAH KOTOR 70% (Rp)": 11747100,
    "PPh 21": 1762065,
    "JUMLAH BERSIH 70% (Rp)": 9985035,
    "TANDA TANGAN": 79
  },
  {
    "NIP": "'198402072008122004",
    "STATUS SEKARANG": "Ijin Belajar",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. Ida Ayu Made Darmayanti, S.Pd., M.Pd.",
    "JURUSAN": "Pendidikan Bahasa dan Sastra Indonesia (S1)",
    "FAKULTAS": "Fakultas Bahasa dan Seni",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "STRUKTURAL": "[REN126] Pengelola Gugus Kendali Mutu (Fakultas) sebagai Anggota",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Fakultas Bahasa dan Seni",
    "POINT POSITION": 200,
    "POINT PERFORMANCE": 1272.17,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 1472.17,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 2208255,
    "PPh 100%": 110412.75,
    "JUMLAH KOTOR 30% (Rp)": 877050,
    "JUMLAH KOTOR 70% (Rp)": 1331205,
    "PPh 21": 66560.25,
    "JUMLAH BERSIH 70% (Rp)": 1264644.75,
    "TANDA TANGAN": 80
  },
  {
    "NIP": "'198705272015042001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. Kadek Wirahyuni, S.Pd., M.Pd.",
    "JURUSAN": "Pendidikan Bahasa dan Sastra Indonesia (S1)",
    "FAKULTAS": "Fakultas Bahasa dan Seni",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor Kepala",
    "GRADE FUNGSIONAL": 11,
    "STRUKTURAL": "Sekretaris Program Studi S2",
    "GRADE STRUKTURAL": 11,
    "UNIT KERJA": "Pendidikan Bahasa (S2)",
    "POINT POSITION": 2152.2,
    "POINT PERFORMANCE": 2031.17,
    "POINT KELEBIHAN": 582.667,
    "POINT TOTAL": 4766.03,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 7149045,
    "PPh 100%": 357452.25,
    "JUMLAH KOTOR 30% (Rp)": 2107890,
    "JUMLAH KOTOR 70% (Rp)": 5041155,
    "PPh 21": 252057.75,
    "JUMLAH BERSIH 70% (Rp)": 4789097.25,
    "TANDA TANGAN": 81
  },
  {
    "NIP": "'198502202008122005",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. Ni Made Rai Wisudariani, S.Pd., M.Pd.",
    "JURUSAN": "Pendidikan Bahasa dan Sastra Indonesia (S1)",
    "FAKULTAS": "Fakultas Bahasa dan Seni",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor Kepala",
    "GRADE FUNGSIONAL": 11,
    "STRUKTURAL": "Koordinator Program Studi S1/D3",
    "GRADE STRUKTURAL": 11,
    "UNIT KERJA": "Pendidikan Bahasa dan Sastra Indonesia (S1)",
    "POINT POSITION": 1899,
    "POINT PERFORMANCE": 1983.83,
    "POINT KELEBIHAN": 274.233,
    "POINT TOTAL": 4157.07,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 6235605,
    "PPh 100%": 311780.25,
    "JUMLAH KOTOR 30% (Rp)": 1993950,
    "JUMLAH KOTOR 70% (Rp)": 4241655,
    "PPh 21": 212082.75,
    "JUMLAH BERSIH 70% (Rp)": 4029572.25,
    "TANDA TANGAN": 82
  },
  {
    "NIP": "'196104131986032001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dra. Made Sri Indriani, M.Hum.",
    "JURUSAN": "Pendidikan Bahasa dan Sastra Indonesia (S1)",
    "FAKULTAS": "Fakultas Bahasa dan Seni",
    "GOLONGAN": "IVC",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor Kepala",
    "GRADE FUNGSIONAL": 11,
    "STRUKTURAL": "[REN126] Pengelola Gugus Kendali Mutu (Fakultas) sebagai Anggota",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Fakultas Bahasa dan Seni",
    "POINT POSITION": 200,
    "POINT PERFORMANCE": 1684.67,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 1884.67,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 2827005,
    "PPh 100%": 424050.75,
    "JUMLAH KOTOR 30% (Rp)": 1229400,
    "JUMLAH KOTOR 70% (Rp)": 1597605,
    "PPh 21": 239640.75,
    "JUMLAH BERSIH 70% (Rp)": 1357964.25,
    "TANDA TANGAN": 83
  },
  {
    "NIP": "'196503201990031002",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Drs. I Gede Nurjaya, M.Pd.",
    "JURUSAN": "Pendidikan Bahasa dan Sastra Indonesia (S1)",
    "FAKULTAS": "Fakultas Bahasa dan Seni",
    "GOLONGAN": "IVB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor Kepala",
    "GRADE FUNGSIONAL": 11,
    "STRUKTURAL": "Dekan",
    "GRADE STRUKTURAL": 15,
    "UNIT KERJA": "Fakultas Bahasa dan Seni",
    "POINT POSITION": 11610,
    "POINT PERFORMANCE": 1876.23,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 13486.2,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 20229300,
    "PPh 100%": 3034395,
    "JUMLAH KOTOR 30% (Rp)": 6363900,
    "JUMLAH KOTOR 70% (Rp)": 13865400,
    "PPh 21": 2079810,
    "JUMLAH BERSIH 70% (Rp)": 11785590,
    "TANDA TANGAN": 84
  },
  {
    "NIP": "'199112132023211014",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PPPK",
    "NAMA DOSEN": "I Komang Sugi Partawan, M.Pd.",
    "JURUSAN": "Pendidikan Bahasa dan Sastra Indonesia (S1)",
    "FAKULTAS": "Fakultas Bahasa dan Seni",
    "GOLONGAN": "X",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Asisten Ahli",
    "GRADE FUNGSIONAL": 8,
    "STRUKTURAL": "[REN126] Pengelola Gugus Kendali Mutu (Fakultas) sebagai Anggota",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Fakultas Bahasa dan Seni",
    "POINT POSITION": 200,
    "POINT PERFORMANCE": 973.167,
    "POINT KELEBIHAN": 308.608,
    "POINT TOTAL": 1481.77,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 2222655,
    "PPh 100%": 111132.75,
    "JUMLAH KOTOR 30% (Rp)": 746550,
    "JUMLAH KOTOR 70% (Rp)": 1476105,
    "PPh 21": 73805.25,
    "JUMLAH BERSIH 70% (Rp)": 1402299.75,
    "TANDA TANGAN": 85
  },
  {
    "NIP": "'198305132008121001",
    "STATUS SEKARANG": "Tugas Belajar",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "I Made Astika, S.Pd., M.A.",
    "JURUSAN": "Pendidikan Bahasa dan Sastra Indonesia (S1)",
    "FAKULTAS": "Fakultas Bahasa dan Seni",
    "GOLONGAN": "IIIC",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "TIDAK ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "UNIT KERJA": "-",
    "POINT POSITION": 0,
    "POINT PERFORMANCE": 0,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 0,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 0,
    "PPh 100%": 0,
    "JUMLAH KOTOR 70% (Rp)": 0,
    "PPh 21": 0,
    "JUMLAH BERSIH 70% (Rp)": 0,
    "TANDA TANGAN": 86
  },
  {
    "NIP": "'198806222014041001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "A.A. Gede Yudha Paramartha, S.Pd., M.Pd.",
    "JURUSAN": "Pendidikan Bahasa Inggris (S1)",
    "FAKULTAS": "Fakultas Bahasa dan Seni",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "STRUKTURAL": "Sekretaris Jurusan S1",
    "GRADE STRUKTURAL": 11,
    "UNIT KERJA": "Jurusan Bahasa Asing",
    "POINT POSITION": 2152.2,
    "POINT PERFORMANCE": 999.243,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 3151.44,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 4727160,
    "PPh 100%": 236358,
    "JUMLAH KOTOR 30% (Rp)": 1755540,
    "JUMLAH KOTOR 70% (Rp)": 2971620,
    "PPh 21": 148581,
    "JUMLAH BERSIH 70% (Rp)": 2823039,
    "TANDA TANGAN": 87
  },
  {
    "NIP": "'198108142009122002",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dewa Ayu Eka Agustini, S.Pd., M.S.",
    "JURUSAN": "Pendidikan Bahasa Inggris (S1)",
    "FAKULTAS": "Fakultas Bahasa dan Seni",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "UNIT KERJA": "-",
    "POINT PERFORMANCE": 1099.5,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 1099.5,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 1649250,
    "PPh 100%": 82462.5,
    "JUMLAH KOTOR 30% (Rp)": 787050,
    "JUMLAH KOTOR 70% (Rp)": 862200,
    "PPh 21": 43110,
    "JUMLAH BERSIH 70% (Rp)": 819090,
    "TANDA TANGAN": 88
  },
  {
    "NIP": "'198411182015041002",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. I Wayan Swandana, S.S., M.Hum.",
    "JURUSAN": "Pendidikan Bahasa Inggris (S1)",
    "FAKULTAS": "Fakultas Bahasa dan Seni",
    "GOLONGAN": "IIIC",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "STRUKTURAL": "[REN126] Pengelola Gugus Kendali Mutu (Fakultas) sebagai Anggota",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Pendidikan Bahasa Inggris (S2)",
    "POINT POSITION": 200,
    "POINT PERFORMANCE": 1098.06,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 1298.06,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 1947090,
    "PPh 100%": 97354.5,
    "JUMLAH KOTOR 30% (Rp)": 877050,
    "JUMLAH KOTOR 70% (Rp)": 1070040,
    "PPh 21": 53502,
    "JUMLAH BERSIH 70% (Rp)": 1016538,
    "TANDA TANGAN": 89
  },
  {
    "NIP": "'198803232015042004",
    "STATUS SEKARANG": "Ijin Belajar",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. Kadek Sintya Dewi, S.Pd., M.Pd.",
    "JURUSAN": "Pendidikan Bahasa Inggris (S1)",
    "FAKULTAS": "Fakultas Bahasa dan Seni",
    "GOLONGAN": "IIIC",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "STRUKTURAL": "[REN223] Sekretaris Pusat/ Ketua Divisi/ Asrama/ Koordinator Lab. Jurusan Kepala Unit BPU/ Sekretaris Gugus Kendali Mutu Fakultas/ Sekretaris Tim Pengelolaan dan Penerimaan Mahasiswa Asing/ Sekretaris Unit Pengembangan dan Peningkatan Kapasitas Kelembagaan",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Fakultas Bahasa dan Seni",
    "POINT POSITION": 800,
    "POINT PERFORMANCE": 1109.91,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 1909.91,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 2864865,
    "PPh 100%": 143243.25,
    "JUMLAH KOTOR 30% (Rp)": 1147050,
    "JUMLAH KOTOR 70% (Rp)": 1717815,
    "PPh 21": 85890.75,
    "JUMLAH BERSIH 70% (Rp)": 1631924.25,
    "TANDA TANGAN": 90
  },
  {
    "NIP": "'198403042008122002",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. Kadek Sonia Piscayanti, S.Pd., M.Pd.",
    "JURUSAN": "Pendidikan Bahasa Inggris (S1)",
    "FAKULTAS": "Fakultas Bahasa dan Seni",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "UNIT KERJA": "-",
    "POINT PERFORMANCE": 1178,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 1178,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 1767000,
    "PPh 100%": 88350,
    "JUMLAH KOTOR 30% (Rp)": 787050,
    "JUMLAH KOTOR 70% (Rp)": 979950,
    "PPh 21": 48997.5,
    "JUMLAH BERSIH 70% (Rp)": 930952.5,
    "TANDA TANGAN": 91
  },
  {
    "NIP": "'198309232008122001",
    "STATUS SEKARANG": "Tugas Belajar",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. Luh Diah Surya Adnyani, S.Pd., M.Pd.",
    "JURUSAN": "Pendidikan Bahasa Inggris (S1)",
    "FAKULTAS": "Fakultas Bahasa dan Seni",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "UNIT KERJA": "-",
    "POINT PERFORMANCE": 0,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 0,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 0,
    "PPh 100%": 0,
    "JUMLAH KOTOR 70% (Rp)": 0,
    "PPh 21": 0,
    "JUMLAH BERSIH 70% (Rp)": 0,
    "TANDA TANGAN": 92
  },
  {
    "NIP": "'198104192006042002",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. Ni Luh Putu Eka Sulistia Dewi, S.Pd. M.Pd.",
    "JURUSAN": "Pendidikan Bahasa Inggris (S1)",
    "FAKULTAS": "Fakultas Bahasa dan Seni",
    "GOLONGAN": "IVA",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor Kepala",
    "GRADE FUNGSIONAL": 11,
    "STRUKTURAL": "Wakil Dekan I",
    "GRADE STRUKTURAL": 14,
    "UNIT KERJA": "Fakultas Bahasa dan Seni",
    "POINT POSITION": 9720,
    "POINT PERFORMANCE": 2013.46,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 11733.5,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 17600250,
    "PPh 100%": 2640037.5,
    "JUMLAH KOTOR 30% (Rp)": 5513400,
    "JUMLAH KOTOR 70% (Rp)": 12086850,
    "PPh 21": 1813027.5,
    "JUMLAH BERSIH 70% (Rp)": 10273822.5,
    "TANDA TANGAN": 93
  },
  {
    "NIP": "'198805172012122002",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. Ni Wayan Surya Mahayanti, S.Pd., M.Pd.",
    "JURUSAN": "Pendidikan Bahasa Inggris (S1)",
    "FAKULTAS": "Fakultas Bahasa dan Seni",
    "GOLONGAN": "IVA",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor Kepala",
    "GRADE FUNGSIONAL": 11,
    "STRUKTURAL": "[REN222] Kepala Pusat /Kantor/Kepala Gugus Kendali Mutu Fakultas/Ketua Unit Pengelolaan dan Penerimaan Mahasiswa Asing/ Ketua Unit Pengembangan dan Peningkatan Kapasitas Kelembagaan",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "-",
    "POINT POSITION": 1150,
    "POINT PERFORMANCE": 2335.83,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 3485.83,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 5228745,
    "PPh 100%": 784311.75,
    "JUMLAH KOTOR 30% (Rp)": 1656900,
    "JUMLAH KOTOR 70% (Rp)": 3571845,
    "PPh 21": 535776.75,
    "JUMLAH BERSIH 70% (Rp)": 3036068.25,
    "TANDA TANGAN": 94
  },
  {
    "NIP": "'198204212008122003",
    "STATUS SEKARANG": "Tugas Belajar",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. Nyoman Karina Wedhanti, S.Pd., M.Pd.",
    "JURUSAN": "Pendidikan Bahasa Inggris (S1)",
    "FAKULTAS": "Fakultas Bahasa dan Seni",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "TIDAK ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "UNIT KERJA": "-",
    "POINT POSITION": 0,
    "POINT PERFORMANCE": 0,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 0,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 0,
    "PPh 100%": 0,
    "JUMLAH KOTOR 70% (Rp)": 0,
    "PPh 21": 0,
    "JUMLAH BERSIH 70% (Rp)": 0,
    "TANDA TANGAN": 95
  },
  {
    "NIP": "'199002242014042001",
    "STATUS SEKARANG": "Tugas Belajar",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "G.A.P. Suprianti, S.Pd., M.Pd.",
    "JURUSAN": "Pendidikan Bahasa Inggris (S1)",
    "FAKULTAS": "Fakultas Bahasa dan Seni",
    "GOLONGAN": "IVA",
    "STATUS PENELITIAN": "TIDAK ADA",
    "STATUS PENGABDIAN": "TIDAK ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor Kepala",
    "GRADE FUNGSIONAL": 11,
    "UNIT KERJA": "-",
    "POINT POSITION": 0,
    "POINT PERFORMANCE": 0,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 0,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 0,
    "PPh 100%": 0,
    "JUMLAH KOTOR 70% (Rp)": 0,
    "PPh 21": 0,
    "JUMLAH BERSIH 70% (Rp)": 0,
    "TANDA TANGAN": 96
  },
  {
    "NIP": "'199007252015041002",
    "STATUS SEKARANG": "Ijin Belajar",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Gede Mahendrayana, S.Pd., M.Pd.",
    "JURUSAN": "Pendidikan Bahasa Inggris (S1)",
    "FAKULTAS": "Fakultas Bahasa dan Seni",
    "GOLONGAN": "IIIC",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "UNIT KERJA": "-",
    "POINT PERFORMANCE": 1129.74,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 1129.74,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 1694610,
    "PPh 100%": 84730.5,
    "JUMLAH KOTOR 30% (Rp)": 787050,
    "JUMLAH KOTOR 70% (Rp)": 907560,
    "PPh 21": 45378,
    "JUMLAH BERSIH 70% (Rp)": 862182,
    "TANDA TANGAN": 97
  },
  {
    "NIP": "'197510092001121001",
    "STATUS SEKARANG": "Ijin Belajar",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "I Ketut Armawan, S.Pd., M.Pd.",
    "JURUSAN": "Pendidikan Bahasa Inggris (S1)",
    "FAKULTAS": "Fakultas Bahasa dan Seni",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "UNIT KERJA": "-",
    "POINT PERFORMANCE": 765.667,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 765.667,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 1148500.5,
    "PPh 100%": 57425.025,
    "JUMLAH KOTOR 30% (Rp)": 787050,
    "JUMLAH KOTOR 70% (Rp)": 361450.5,
    "PPh 21": 18072.525,
    "JUMLAH BERSIH 70% (Rp)": 343377.975,
    "TANDA TANGAN": 98
  },
  {
    "NIP": "'198508022023211012",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PPPK",
    "NAMA DOSEN": "I Ketut Trika Adi Ana, S.Pd., M.Pd.",
    "JURUSAN": "Pendidikan Bahasa Inggris (S1)",
    "FAKULTAS": "Fakultas Bahasa dan Seni",
    "GOLONGAN": "X",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Asisten Ahli",
    "GRADE FUNGSIONAL": 8,
    "STRUKTURAL": "[REN126] Pengelola Gugus Kendali Mutu (Fakultas) sebagai Anggota",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Fakultas Bahasa dan Seni",
    "POINT POSITION": 200,
    "POINT PERFORMANCE": 1011.83,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 1211.83,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 1817745,
    "PPh 100%": 90887.25,
    "JUMLAH KOTOR 30% (Rp)": 746550,
    "JUMLAH KOTOR 70% (Rp)": 1071195,
    "PPh 21": 53559.75,
    "JUMLAH BERSIH 70% (Rp)": 1017635.25,
    "TANDA TANGAN": 99
  },
  {
    "NIP": "'197809182006041001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "I Nyoman Pasek Hadisaputra, S.Pd., M.Pd.",
    "JURUSAN": "Pendidikan Bahasa Inggris (S1)",
    "FAKULTAS": "Fakultas Bahasa dan Seni",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "UNIT KERJA": "-",
    "POINT PERFORMANCE": 882.077,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 882.077,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 1323115.5,
    "PPh 100%": 66155.775,
    "JUMLAH KOTOR 30% (Rp)": 787050,
    "JUMLAH KOTOR 70% (Rp)": 536065.5,
    "PPh 21": 26803.275,
    "JUMLAH BERSIH 70% (Rp)": 509262.225,
    "TANDA TANGAN": 100
  },
  {
    "NIP": "'198701172014041001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "I Putu Indra Kusuma, S.Pd., M.Pd. Ph.D.",
    "JURUSAN": "Pendidikan Bahasa Inggris (S1)",
    "FAKULTAS": "Fakultas Bahasa dan Seni",
    "GOLONGAN": "IIIC",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor Kepala",
    "GRADE FUNGSIONAL": 11,
    "STRUKTURAL": "[REN223] Sekretaris Pusat/ Ketua Divisi/ Asrama/ Koordinator Lab. Jurusan Kepala Unit BPU/ Sekretaris Gugus Kendali Mutu Fakultas/ Sekretaris Tim Pengelolaan dan Penerimaan Mahasiswa Asing/ Sekretaris Unit Pengembangan dan Peningkatan Kapasitas Kelembagaan",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "-",
    "POINT POSITION": 800,
    "POINT PERFORMANCE": 2432,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 3232,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 4848000,
    "PPh 100%": 242400,
    "JUMLAH KOTOR 30% (Rp)": 1499400,
    "JUMLAH KOTOR 70% (Rp)": 3348600,
    "PPh 21": 167430,
    "JUMLAH BERSIH 70% (Rp)": 3181170,
    "TANDA TANGAN": 101
  },
  {
    "NIP": "'198210052006041005",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "I Putu Ngurah Wage Myartawan, S.Pd., M.Pd.",
    "JURUSAN": "Pendidikan Bahasa Inggris (S1)",
    "FAKULTAS": "Fakultas Bahasa dan Seni",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "UNIT KERJA": "-",
    "POINT PERFORMANCE": 765.077,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 765.077,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 1147615.5,
    "PPh 100%": 57380.775,
    "JUMLAH KOTOR 30% (Rp)": 787050,
    "JUMLAH KOTOR 70% (Rp)": 360565.5,
    "PPh 21": 18028.275,
    "JUMLAH BERSIH 70% (Rp)": 342537.225,
    "TANDA TANGAN": 102
  },
  {
    "NIP": "'198709172015042002",
    "STATUS SEKARANG": "Ijin Belajar",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Ida Ayu Made Istri Utami, S.Pd., M.Pd.",
    "JURUSAN": "Pendidikan Bahasa Inggris (S1)",
    "FAKULTAS": "Fakultas Bahasa dan Seni",
    "GOLONGAN": "IIIC",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "STRUKTURAL": "Kepala UPA",
    "GRADE STRUKTURAL": 12,
    "UNIT KERJA": "Unit Penunjang Akademik Bahasa",
    "POINT POSITION": 2559.35,
    "POINT PERFORMANCE": 807.577,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 3366.93,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 5050395,
    "PPh 100%": 252519.75,
    "JUMLAH KOTOR 30% (Rp)": 1938757.5,
    "JUMLAH KOTOR 70% (Rp)": 3111637.5,
    "PPh 21": 155581.875,
    "JUMLAH BERSIH 70% (Rp)": 2956055.625,
    "TANDA TANGAN": 103
  },
  {
    "NIP": "'199309192018032001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Luh Gd Rahayu Budiarta, S.Pd., M.Pd.",
    "JURUSAN": "Pendidikan Bahasa Inggris (S1)",
    "FAKULTAS": "Fakultas Bahasa dan Seni",
    "GOLONGAN": "IIIC",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "STRUKTURAL": "[REN126] Pengelola Gugus Kendali Mutu (Fakultas) sebagai Anggota",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Fakultas Bahasa dan Seni",
    "POINT POSITION": 200,
    "POINT PERFORMANCE": 1312.33,
    "POINT KELEBIHAN": 145.41,
    "POINT TOTAL": 1657.74,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 2486610,
    "PPh 100%": 124330.5,
    "JUMLAH KOTOR 30% (Rp)": 877050,
    "JUMLAH KOTOR 70% (Rp)": 1609560,
    "PPh 21": 80478,
    "JUMLAH BERSIH 70% (Rp)": 1529082,
    "TANDA TANGAN": 104
  },
  {
    "NIP": "'198812012015042003",
    "STATUS SEKARANG": "Ijin Belajar",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Luh Gede Eka Wahyuni, S.Pd., M.Pd.",
    "JURUSAN": "Pendidikan Bahasa Inggris (S1)",
    "FAKULTAS": "Fakultas Bahasa dan Seni",
    "GOLONGAN": "IIIC",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "STRUKTURAL": "[REN223] Sekretaris Pusat/ Ketua Divisi/ Asrama/ Koordinator Lab. Jurusan Kepala Unit BPU/ Sekretaris Gugus Kendali Mutu Fakultas/ Sekretaris Tim Pengelolaan dan Penerimaan Mahasiswa Asing/ Sekretaris Unit Pengembangan dan Peningkatan Kapasitas Kelembagaan",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "-",
    "POINT POSITION": 800,
    "POINT PERFORMANCE": 1300.24,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 2100.24,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 3150360,
    "PPh 100%": 157518,
    "JUMLAH KOTOR 30% (Rp)": 1147050,
    "JUMLAH KOTOR 70% (Rp)": 2003310,
    "PPh 21": 100165.5,
    "JUMLAH BERSIH 70% (Rp)": 1903144.5,
    "TANDA TANGAN": 105
  },
  {
    "NIP": "'199305162023212040",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PPPK",
    "NAMA DOSEN": "Luh Indrayani, S.Pd., M.Pd",
    "JURUSAN": "Pendidikan Bahasa Inggris (S1)",
    "FAKULTAS": "Fakultas Bahasa dan Seni",
    "GOLONGAN": "X",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Asisten Ahli",
    "GRADE FUNGSIONAL": 8,
    "STRUKTURAL": "[REN126] Pengelola Gugus Kendali Mutu (Fakultas) sebagai Anggota",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Fakultas Bahasa dan Seni",
    "POINT POSITION": 200,
    "POINT PERFORMANCE": 1115,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 1315,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 1972500,
    "PPh 100%": 98625,
    "JUMLAH KOTOR 30% (Rp)": 746550,
    "JUMLAH KOTOR 70% (Rp)": 1225950,
    "PPh 21": 61297.5,
    "JUMLAH BERSIH 70% (Rp)": 1164652.5,
    "TANDA TANGAN": 106
  },
  {
    "NIP": "'198503262023212023",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PPPK",
    "NAMA DOSEN": "Luh Putu Dian Kresnawati, S.Pd., M.Pd.",
    "JURUSAN": "Pendidikan Bahasa Inggris (S1)",
    "FAKULTAS": "Fakultas Bahasa dan Seni",
    "GOLONGAN": "X",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Asisten Ahli",
    "GRADE FUNGSIONAL": 8,
    "STRUKTURAL": "[REN126] Pengelola Gugus Kendali Mutu (Fakultas) sebagai Anggota",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Fakultas Bahasa dan Seni",
    "POINT POSITION": 200,
    "POINT PERFORMANCE": 884.667,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 1084.67,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 1627005,
    "PPh 100%": 81350.25,
    "JUMLAH KOTOR 30% (Rp)": 746550,
    "JUMLAH KOTOR 70% (Rp)": 880455,
    "PPh 21": 44022.75,
    "JUMLAH BERSIH 70% (Rp)": 836432.25,
    "TANDA TANGAN": 107
  },
  {
    "NIP": "'198904082023212043",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PPPK",
    "NAMA DOSEN": "Ni Luh Putu Era Adnyayanti, S.Pd.,M.Pd.",
    "JURUSAN": "Pendidikan Bahasa Inggris (S1)",
    "FAKULTAS": "Fakultas Bahasa dan Seni",
    "GOLONGAN": "X",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Asisten Ahli",
    "GRADE FUNGSIONAL": 8,
    "STRUKTURAL": "[REN223] Sekretaris Pusat/ Ketua Divisi/ Asrama/ Koordinator Lab. Jurusan Kepala Unit BPU/ Sekretaris Gugus Kendali Mutu Fakultas/ Sekretaris Tim Pengelolaan dan Penerimaan Mahasiswa Asing/ Sekretaris Unit Pengembangan dan Peningkatan Kapasitas Kelembagaan",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "-",
    "POINT POSITION": 800,
    "POINT PERFORMANCE": 949.212,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 1749.21,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 2623815,
    "PPh 100%": 131190.75,
    "JUMLAH KOTOR 30% (Rp)": 1016550,
    "JUMLAH KOTOR 70% (Rp)": 1607265,
    "PPh 21": 80363.25,
    "JUMLAH BERSIH 70% (Rp)": 1526901.75,
    "TANDA TANGAN": 108
  },
  {
    "NIP": "'199611132024062002",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Ni Nyoman Artini, M.Pd.",
    "JURUSAN": "Pendidikan Bahasa Inggris (S1)",
    "FAKULTAS": "Fakultas Bahasa dan Seni",
    "GOLONGAN": "IIIB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Tenaga Pengajar",
    "GRADE FUNGSIONAL": 7,
    "UNIT KERJA": "-",
    "POINT PERFORMANCE": 700.5,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 700.5,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 1050750,
    "PPh 100%": 52537.5,
    "JUMLAH KOTOR 30% (Rp)": 545400,
    "JUMLAH KOTOR 70% (Rp)": 505350,
    "PPh 21": 25267.5,
    "JUMLAH BERSIH 70% (Rp)": 480082.5,
    "TANDA TANGAN": 109
  },
  {
    "NIP": "'198808252015042002",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Ni Putu Astiti Pratiwi, S.Pd., M.Pd.",
    "JURUSAN": "Pendidikan Bahasa Inggris (S1)",
    "FAKULTAS": "Fakultas Bahasa dan Seni",
    "GOLONGAN": "IIIC",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "STRUKTURAL": "[REN221] Anggota Tim Ahli Rektor/SP4/ Sekretaris Balingkang Confucius Institute/ Sekretaris Unit Kerjasama",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "-",
    "POINT POSITION": 1300,
    "POINT PERFORMANCE": 1075.74,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 2375.74,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 3563610,
    "PPh 100%": 178180.5,
    "JUMLAH KOTOR 30% (Rp)": 1372050,
    "JUMLAH KOTOR 70% (Rp)": 2191560,
    "PPh 21": 109578,
    "JUMLAH BERSIH 70% (Rp)": 2081982,
    "TANDA TANGAN": 110
  },
  {
    "NIP": "'198810242023212030",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PPPK",
    "NAMA DOSEN": "Ni Wayan Monik Rismadewi, S.Pd., M.Pd.",
    "JURUSAN": "Pendidikan Bahasa Inggris (S1)",
    "FAKULTAS": "Fakultas Bahasa dan Seni",
    "GOLONGAN": "X",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Asisten Ahli",
    "GRADE FUNGSIONAL": 8,
    "STRUKTURAL": "[REN126] Pengelola Gugus Kendali Mutu (Fakultas) sebagai Anggota",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Fakultas Bahasa dan Seni",
    "POINT POSITION": 200,
    "POINT PERFORMANCE": 966.5,
    "POINT KELEBIHAN": 48.545,
    "POINT TOTAL": 1215.05,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 1822575,
    "PPh 100%": 91128.75,
    "JUMLAH KOTOR 30% (Rp)": 746550,
    "JUMLAH KOTOR 70% (Rp)": 1076025,
    "PPh 21": 53801.25,
    "JUMLAH BERSIH 70% (Rp)": 1022223.75,
    "TANDA TANGAN": 111
  },
  {
    "NIP": "'198304022006042001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Prof. Dr. I G A Lokita Purnamika Utami, S.Pd., M.Pd.",
    "JURUSAN": "Pendidikan Bahasa Inggris (S1)",
    "FAKULTAS": "Fakultas Bahasa dan Seni",
    "GOLONGAN": "IVB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Guru Besar",
    "GRADE FUNGSIONAL": 12,
    "STRUKTURAL": "Koordinator Program Studi S1/D3",
    "GRADE STRUKTURAL": 11,
    "UNIT KERJA": "Pendidikan Bahasa Inggris (S1)",
    "POINT POSITION": 1899,
    "POINT PERFORMANCE": 2909.83,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 4808.83,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 7213245,
    "PPh 100%": 1081986.75,
    "JUMLAH KOTOR 30% (Rp)": 2323440,
    "JUMLAH KOTOR 70% (Rp)": 4889805,
    "PPh 21": 733470.75,
    "JUMLAH BERSIH 70% (Rp)": 4156334.25,
    "TANDA TANGAN": 112
  },
  {
    "NIP": "'198706122015041006",
    "STATUS SEKARANG": "Ijin Belajar",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Putu Adi Krisna Juniarta, S.Pd., M.Pd.",
    "JURUSAN": "Pendidikan Bahasa Inggris (S1)",
    "FAKULTAS": "Fakultas Bahasa dan Seni",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "STRUKTURAL": "[REN223] Sekretaris Pusat/ Ketua Divisi/ Asrama/ Koordinator Lab. Jurusan Kepala Unit BPU/ Sekretaris Gugus Kendali Mutu Fakultas/ Sekretaris Tim Pengelolaan dan Penerimaan Mahasiswa Asing/ Sekretaris Unit Pengembangan dan Peningkatan Kapasitas Kelembagaan",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Fakultas Bahasa dan Seni",
    "POINT POSITION": 800,
    "POINT PERFORMANCE": 1166.67,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 1966.67,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 2950005,
    "PPh 100%": 147500.25,
    "JUMLAH KOTOR 30% (Rp)": 1147050,
    "JUMLAH KOTOR 70% (Rp)": 1802955,
    "PPh 21": 90147.75,
    "JUMLAH BERSIH 70% (Rp)": 1712807.25,
    "TANDA TANGAN": 113
  },
  {
    "NIP": "'197811142008121002",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Putu Eka Dambayana S., S.Pd., M.Pd.",
    "JURUSAN": "Pendidikan Bahasa Inggris (S1)",
    "FAKULTAS": "Fakultas Bahasa dan Seni",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "TIDAK ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "STRUKTURAL": "[REN126] Pengelola Gugus Kendali Mutu (Fakultas) sebagai Anggota",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Fakultas Bahasa dan Seni",
    "POINT POSITION": 0,
    "POINT PERFORMANCE": 0,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 0,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 0,
    "PPh 100%": 0,
    "JUMLAH KOTOR 30% (Rp)": 877050,
    "JUMLAH KOTOR 70% (Rp)": 0,
    "PPh 21": 0,
    "JUMLAH BERSIH 70% (Rp)": 0,
    "TANDA TANGAN": 114
  },
  {
    "NIP": "'196012311990031017",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. I Ketut Sudita, M.Si.",
    "JURUSAN": "Pendidikan Seni Rupa (S1)",
    "FAKULTAS": "Fakultas Bahasa dan Seni",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "UNIT KERJA": "-",
    "POINT PERFORMANCE": 212.667,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 212.667,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 319000.5,
    "PPh 100%": 15950.025,
    "JUMLAH KOTOR 30% (Rp)": 787050,
    "JUMLAH KOTOR 70% (Rp)": 0,
    "PPh 21": 0,
    "JUMLAH BERSIH 70% (Rp)": 0,
    "TANDA TANGAN": 115
  },
  {
    "NIP": "'197904272010121002",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. I Nyoman Rediasa, S.Sn., M,.Si.",
    "JURUSAN": "Pendidikan Seni Rupa (S1)",
    "FAKULTAS": "Fakultas Bahasa dan Seni",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "STRUKTURAL": "Koordinator Program Studi S1/D3",
    "GRADE STRUKTURAL": 11,
    "UNIT KERJA": "Pendidikan Seni Rupa (S1)",
    "POINT POSITION": 1645.8,
    "POINT PERFORMANCE": 892.743,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 2538.54,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 3807810,
    "PPh 100%": 190390.5,
    "JUMLAH KOTOR 30% (Rp)": 1527660,
    "JUMLAH KOTOR 70% (Rp)": 2280150,
    "PPh 21": 114007.5,
    "JUMLAH BERSIH 70% (Rp)": 2166142.5,
    "TANDA TANGAN": 116
  },
  {
    "NIP": "'196412311989031022",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. I Nyoman Sila, M.Hum.",
    "JURUSAN": "Pendidikan Seni Rupa (S1)",
    "FAKULTAS": "Fakultas Bahasa dan Seni",
    "GOLONGAN": "IVC",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor Kepala",
    "GRADE FUNGSIONAL": 11,
    "STRUKTURAL": "Wakil Dekan III",
    "GRADE STRUKTURAL": 14,
    "UNIT KERJA": "Fakultas Bahasa dan Seni",
    "POINT POSITION": 9720,
    "POINT PERFORMANCE": 1449.9,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 11169.9,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 16754850,
    "PPh 100%": 2513227.5,
    "JUMLAH KOTOR 30% (Rp)": 5513400,
    "JUMLAH KOTOR 70% (Rp)": 11241450,
    "PPh 21": 1686217.5,
    "JUMLAH BERSIH 70% (Rp)": 9555232.5,
    "TANDA TANGAN": 117
  },
  {
    "NIP": "'198202062010122003",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. Langen Bronto Sutrisno, S.Sn., M.A.",
    "JURUSAN": "Pendidikan Seni Rupa (S1)",
    "FAKULTAS": "Fakultas Bahasa dan Seni",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "STRUKTURAL": "[REN126] Pengelola Gugus Kendali Mutu (Fakultas) sebagai Anggota",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Fakultas Bahasa dan Seni",
    "POINT POSITION": 200,
    "POINT PERFORMANCE": 511.5,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 711.5,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 1067250,
    "PPh 100%": 53362.5,
    "JUMLAH KOTOR 30% (Rp)": 877050,
    "JUMLAH KOTOR 70% (Rp)": 190200,
    "PPh 21": 9510,
    "JUMLAH BERSIH 70% (Rp)": 180690,
    "TANDA TANGAN": 118
  },
  {
    "NIP": "'196410031990032001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dra. Luh Suartini, M.Pd.",
    "JURUSAN": "Pendidikan Seni Rupa (S1)",
    "FAKULTAS": "Fakultas Bahasa dan Seni",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "STRUKTURAL": "Sekretaris Jurusan S1",
    "GRADE STRUKTURAL": 11,
    "UNIT KERJA": "Jurusan Seni dan Desain",
    "POINT POSITION": 1645.8,
    "POINT PERFORMANCE": 634.077,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 2279.88,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 3419820,
    "PPh 100%": 170991,
    "JUMLAH KOTOR 30% (Rp)": 1527660,
    "JUMLAH KOTOR 70% (Rp)": 1892160,
    "PPh 21": 94608,
    "JUMLAH BERSIH 70% (Rp)": 1797552,
    "TANDA TANGAN": 119
  },
  {
    "NIP": "'196012191990031001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Drs. Gede Eka Harsana Koriawan, M.Erg.",
    "JURUSAN": "Pendidikan Seni Rupa (S1)",
    "FAKULTAS": "Fakultas Bahasa dan Seni",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "UNIT KERJA": "-",
    "POINT PERFORMANCE": 72,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 72,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 108000,
    "PPh 100%": 5400,
    "JUMLAH KOTOR 30% (Rp)": 787050,
    "JUMLAH KOTOR 70% (Rp)": 0,
    "PPh 21": 0,
    "JUMLAH BERSIH 70% (Rp)": 0,
    "TANDA TANGAN": 120
  },
  {
    "NIP": "'196012311990031013",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Drs. I Gusti Ngurah Sura Ardana, M.Sn.",
    "JURUSAN": "Pendidikan Seni Rupa (S1)",
    "FAKULTAS": "Fakultas Bahasa dan Seni",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "UNIT KERJA": "-",
    "POINT PERFORMANCE": 107.167,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 107.167,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 160750.5,
    "PPh 100%": 8037.525,
    "JUMLAH KOTOR 30% (Rp)": 787050,
    "JUMLAH KOTOR 70% (Rp)": 0,
    "PPh 21": 0,
    "JUMLAH BERSIH 70% (Rp)": 0,
    "TANDA TANGAN": 121
  },
  {
    "NIP": "'196904091997031002",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "I Gusti Made Budiarta, S.Pd., M.Pd.",
    "JURUSAN": "Pendidikan Seni Rupa (S1)",
    "FAKULTAS": "Fakultas Bahasa dan Seni",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "STRUKTURAL": "[REN126] Pengelola Gugus Kendali Mutu (Fakultas) sebagai Anggota",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Fakultas Bahasa dan Seni",
    "POINT POSITION": 200,
    "POINT PERFORMANCE": 602.792,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 802.792,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 1204188,
    "PPh 100%": 60209.4,
    "JUMLAH KOTOR 30% (Rp)": 877050,
    "JUMLAH KOTOR 70% (Rp)": 327138,
    "PPh 21": 16356.9,
    "JUMLAH BERSIH 70% (Rp)": 310781.1,
    "TANDA TANGAN": 122
  },
  {
    "NIP": "'196904231994031001",
    "STATUS SEKARANG": "Ijin Belajar",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "I Wayan Sudiarta, S.Pd., M.Si.",
    "JURUSAN": "Pendidikan Seni Rupa (S1)",
    "FAKULTAS": "Fakultas Bahasa dan Seni",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "STRUKTURAL": "[REN126] Pengelola Gugus Kendali Mutu (Fakultas) sebagai Anggota",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Fakultas Bahasa dan Seni",
    "POINT POSITION": 200,
    "POINT PERFORMANCE": 765.91,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 965.91,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 1448865,
    "PPh 100%": 72443.25,
    "JUMLAH KOTOR 30% (Rp)": 877050,
    "JUMLAH KOTOR 70% (Rp)": 571815,
    "PPh 21": 28590.75,
    "JUMLAH BERSIH 70% (Rp)": 543224.25,
    "TANDA TANGAN": 123
  },
  {
    "NIP": "'197712022008121001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. I Wayan Gede Wisnu, S.S., M.Si.",
    "JURUSAN": "Pendidikan Bahasa Bali (S1)",
    "FAKULTAS": "Fakultas Bahasa dan Seni",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "STRUKTURAL": "[REN126] Pengelola Gugus Kendali Mutu (Fakultas) sebagai Anggota",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Fakultas Bahasa dan Seni",
    "POINT POSITION": 200,
    "POINT PERFORMANCE": 828.577,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 1028.58,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 1542870,
    "PPh 100%": 77143.5,
    "JUMLAH KOTOR 30% (Rp)": 877050,
    "JUMLAH KOTOR 70% (Rp)": 665820,
    "PPh 21": 33291,
    "JUMLAH BERSIH 70% (Rp)": 632529,
    "TANDA TANGAN": 124
  },
  {
    "NIP": "'198403172008012002",
    "STATUS SEKARANG": "Ijin Belajar",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Ida Ayu Putu Purnami, S.S., M.Pd.",
    "JURUSAN": "Pendidikan Bahasa Bali (S1)",
    "FAKULTAS": "Fakultas Bahasa dan Seni",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "STRUKTURAL": "[REN126] Pengelola Gugus Kendali Mutu (Fakultas) sebagai Anggota",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Fakultas Bahasa dan Seni",
    "POINT POSITION": 200,
    "POINT PERFORMANCE": 1249.17,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 1449.17,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 2173755,
    "PPh 100%": 108687.75,
    "JUMLAH KOTOR 30% (Rp)": 877050,
    "JUMLAH KOTOR 70% (Rp)": 1296705,
    "PPh 21": 64835.25,
    "JUMLAH BERSIH 70% (Rp)": 1231869.75,
    "TANDA TANGAN": 125
  },
  {
    "NIP": "'198312152008122002",
    "STATUS SEKARANG": "Ijin Belajar",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Ida Ayu Sukma Wirani, S.S., M.Pd.",
    "JURUSAN": "Pendidikan Bahasa Bali (S1)",
    "FAKULTAS": "Fakultas Bahasa dan Seni",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "UNIT KERJA": "-",
    "POINT PERFORMANCE": 915.743,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 915.743,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 1373614.5,
    "PPh 100%": 68680.725,
    "JUMLAH KOTOR 30% (Rp)": 787050,
    "JUMLAH KOTOR 70% (Rp)": 586564.5,
    "PPh 21": 29328.225,
    "JUMLAH BERSIH 70% (Rp)": 557236.275,
    "TANDA TANGAN": 126
  },
  {
    "NIP": "'198306172008121004",
    "STATUS SEKARANG": "Ijin Belajar",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Ida Bagus Made Ludy Paryatna, S.S., M.Pd.",
    "JURUSAN": "Pendidikan Bahasa Bali (S1)",
    "FAKULTAS": "Fakultas Bahasa dan Seni",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "STRUKTURAL": "[REN126] Pengelola Gugus Kendali Mutu (Fakultas) sebagai Anggota",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Fakultas Bahasa dan Seni",
    "POINT POSITION": 200,
    "POINT PERFORMANCE": 385.833,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 585.833,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 878749.5,
    "PPh 100%": 43937.475,
    "JUMLAH KOTOR 30% (Rp)": 877050,
    "JUMLAH KOTOR 70% (Rp)": 1699.5,
    "PPh 21": 84.975,
    "JUMLAH BERSIH 70% (Rp)": 1614.525,
    "TANDA TANGAN": 127
  },
  {
    "NIP": "'197312312008121009",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Ida Bagus Putra Manik Aryana, S.S., M.Si.",
    "JURUSAN": "Pendidikan Bahasa Bali (S1)",
    "FAKULTAS": "Fakultas Bahasa dan Seni",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "STRUKTURAL": "[REN126] Pengelola Gugus Kendali Mutu (Fakultas) sebagai Anggota",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Pendidikan Bahasa Bali (S1)",
    "POINT POSITION": 200,
    "POINT PERFORMANCE": 1082,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 1282,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 1923000,
    "PPh 100%": 96150,
    "JUMLAH KOTOR 30% (Rp)": 877050,
    "JUMLAH KOTOR 70% (Rp)": 1045950,
    "PPh 21": 52297.5,
    "JUMLAH BERSIH 70% (Rp)": 993652.5,
    "TANDA TANGAN": 128
  },
  {
    "NIP": "'196802042008011009",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Ida Bagus Rai, S.S., M.Pd.",
    "JURUSAN": "Pendidikan Bahasa Bali (S1)",
    "FAKULTAS": "Fakultas Bahasa dan Seni",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "STRUKTURAL": "Koordinator Program Studi S1/D3",
    "GRADE STRUKTURAL": 11,
    "UNIT KERJA": "Pendidikan Bahasa Bali (S1)",
    "POINT POSITION": 1645.8,
    "POINT PERFORMANCE": 730.41,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 2376.21,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 3564315,
    "PPh 100%": 178215.75,
    "JUMLAH KOTOR 30% (Rp)": 1527660,
    "JUMLAH KOTOR 70% (Rp)": 2036655,
    "PPh 21": 101832.75,
    "JUMLAH BERSIH 70% (Rp)": 1934822.25,
    "TANDA TANGAN": 129
  },
  {
    "NIP": "'198706142023211024",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PPPK",
    "NAMA DOSEN": "Trifalah Nurhuda, M.Pd.",
    "JURUSAN": "Pendidikan Bahasa Bali (S1)",
    "FAKULTAS": "Fakultas Bahasa dan Seni",
    "GOLONGAN": "X",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Asisten Ahli",
    "GRADE FUNGSIONAL": 8,
    "STRUKTURAL": "[REN126] Pengelola Gugus Kendali Mutu (Fakultas) sebagai Anggota",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Fakultas Bahasa dan Seni",
    "POINT POSITION": 200,
    "POINT PERFORMANCE": 743.545,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 943.545,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 1415317.5,
    "PPh 100%": 70765.875,
    "JUMLAH KOTOR 30% (Rp)": 746550,
    "JUMLAH KOTOR 70% (Rp)": 668767.5,
    "PPh 21": 33438.375,
    "JUMLAH BERSIH 70% (Rp)": 635329.125,
    "TANDA TANGAN": 130
  },
  {
    "NIP": "'198201102006042002",
    "STATUS SEKARANG": "Tugas Belajar",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Desak Made Sri Mardani, S.S., M.Pd.",
    "JURUSAN": "Pendidikan Bahasa Jepang (S1)",
    "FAKULTAS": "Fakultas Bahasa dan Seni",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "TIDAK ADA",
    "STATUS PENGABDIAN": "TIDAK ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "UNIT KERJA": "-",
    "POINT POSITION": 0,
    "POINT PERFORMANCE": 0,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 0,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 0,
    "PPh 100%": 0,
    "JUMLAH KOTOR 70% (Rp)": 0,
    "PPh 21": 0,
    "JUMLAH BERSIH 70% (Rp)": 0,
    "TANDA TANGAN": 131
  },
  {
    "NIP": "'198705122012122001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. Kadek Eva Krishna Adnyani, S.S., M.Si.",
    "JURUSAN": "Pendidikan Bahasa Jepang (S1)",
    "FAKULTAS": "Fakultas Bahasa dan Seni",
    "GOLONGAN": "IVA",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor Kepala",
    "GRADE FUNGSIONAL": 11,
    "STRUKTURAL": "Koordinator Program Studi S1/D3",
    "GRADE STRUKTURAL": 11,
    "UNIT KERJA": "Pendidikan Bahasa Jepang (S1)",
    "POINT POSITION": 1645.8,
    "POINT PERFORMANCE": 1791.07,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 3436.87,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 5155305,
    "PPh 100%": 773295.75,
    "JUMLAH KOTOR 30% (Rp)": 1880010,
    "JUMLAH KOTOR 70% (Rp)": 3275295,
    "PPh 21": 491294.25,
    "JUMLAH BERSIH 70% (Rp)": 2784000.75,
    "TANDA TANGAN": 132
  },
  {
    "NIP": "'198202252009122002",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. Putu Dewi Merlyna Yuda Pramesti, S.S., M.Hum.",
    "JURUSAN": "Pendidikan Bahasa Jepang (S1)",
    "FAKULTAS": "Fakultas Bahasa dan Seni",
    "GOLONGAN": "IVA",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor Kepala",
    "GRADE FUNGSIONAL": 11,
    "STRUKTURAL": "[REN222] Kepala Pusat /Kantor/Kepala Gugus Kendali Mutu Fakultas/Ketua Unit Pengelolaan dan Penerimaan Mahasiswa Asing/ Ketua Unit Pengembangan dan Peningkatan Kapasitas Kelembagaan",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "-",
    "POINT POSITION": 1150,
    "POINT PERFORMANCE": 1988.48,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 3138.48,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 4707720,
    "PPh 100%": 706158,
    "JUMLAH KOTOR 30% (Rp)": 1656900,
    "JUMLAH KOTOR 70% (Rp)": 3050820,
    "PPh 21": 457623,
    "JUMLAH BERSIH 70% (Rp)": 2593197,
    "TANDA TANGAN": 133
  },
  {
    "NIP": "'198401202014041003",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Gede Satya Hermawan, S.S., M.Si.",
    "JURUSAN": "Pendidikan Bahasa Jepang (S1)",
    "FAKULTAS": "Fakultas Bahasa dan Seni",
    "GOLONGAN": "IIIC",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "STRUKTURAL": "Sekretaris UPA",
    "GRADE STRUKTURAL": 11,
    "UNIT KERJA": "Unit Penunjang Akademik Bahasa",
    "POINT POSITION": 2152.2,
    "POINT PERFORMANCE": 415.833,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 2568.03,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 3852045,
    "PPh 100%": 192602.25,
    "JUMLAH KOTOR 30% (Rp)": 1755540,
    "JUMLAH KOTOR 70% (Rp)": 2096505,
    "PPh 21": 104825.25,
    "JUMLAH BERSIH 70% (Rp)": 1991679.75,
    "TANDA TANGAN": 134
  },
  {
    "NIP": "'197707252005011003",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "I Kadek Antartika, S.S., M.Hum.",
    "JURUSAN": "Pendidikan Bahasa Jepang (S1)",
    "FAKULTAS": "Fakultas Bahasa dan Seni",
    "GOLONGAN": "IIIC",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "STRUKTURAL": "[REN126] Pengelola Gugus Kendali Mutu (Fakultas) sebagai Anggota",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Fakultas Bahasa dan Seni",
    "POINT POSITION": 200,
    "POINT PERFORMANCE": 960.077,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 1160.08,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 1740120,
    "PPh 100%": 87006,
    "JUMLAH KOTOR 30% (Rp)": 877050,
    "JUMLAH KOTOR 70% (Rp)": 863070,
    "PPh 21": 43153.5,
    "JUMLAH BERSIH 70% (Rp)": 819916.5,
    "TANDA TANGAN": 135
  },
  {
    "NIP": "'197812012006041001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "I Wayan Sadyana, S.S., M.Si.",
    "JURUSAN": "Pendidikan Bahasa Jepang (S1)",
    "FAKULTAS": "Fakultas Bahasa dan Seni",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "UNIT KERJA": "-",
    "POINT PERFORMANCE": 760,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 760,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 1140000,
    "PPh 100%": 57000,
    "JUMLAH KOTOR 30% (Rp)": 787050,
    "JUMLAH KOTOR 70% (Rp)": 352950,
    "PPh 21": 17647.5,
    "JUMLAH BERSIH 70% (Rp)": 335302.5,
    "TANDA TANGAN": 136
  },
  {
    "NIP": "'199309112020122018",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Irvina Restu Handayani, S.Pd., M.Pd.",
    "JURUSAN": "Pendidikan Bahasa Jepang (S1)",
    "FAKULTAS": "Fakultas Bahasa dan Seni",
    "GOLONGAN": "IIIB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Asisten Ahli",
    "GRADE FUNGSIONAL": 8,
    "STRUKTURAL": "[REN126] Pengelola Gugus Kendali Mutu (Fakultas) sebagai Anggota",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Fakultas Bahasa dan Seni",
    "POINT POSITION": 200,
    "POINT PERFORMANCE": 776.212,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 976.212,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 1464318,
    "PPh 100%": 73215.9,
    "JUMLAH KOTOR 30% (Rp)": 746550,
    "JUMLAH KOTOR 70% (Rp)": 717768,
    "PPh 21": 35888.4,
    "JUMLAH BERSIH 70% (Rp)": 681879.6,
    "TANDA TANGAN": 137
  },
  {
    "NIP": "'197404212005012001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Ni Nengah Suartini, S.S., M.A., Ph.D.",
    "JURUSAN": "Pendidikan Bahasa Jepang (S1)",
    "FAKULTAS": "Fakultas Bahasa dan Seni",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "UNIT KERJA": "-",
    "POINT PERFORMANCE": 1120.17,
    "POINT KELEBIHAN": 58.0767,
    "POINT TOTAL": 1178.24,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 1767360,
    "PPh 100%": 88368,
    "JUMLAH KOTOR 30% (Rp)": 787050,
    "JUMLAH KOTOR 70% (Rp)": 980310,
    "PPh 21": 49015.5,
    "JUMLAH BERSIH 70% (Rp)": 931294.5,
    "TANDA TANGAN": 138
  },
  {
    "NIP": "'198804222019032012",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Yeni, S.Pd.,M.Pd.",
    "JURUSAN": "Pendidikan Bahasa Jepang (S1)",
    "FAKULTAS": "Fakultas Bahasa dan Seni",
    "GOLONGAN": "IIIC",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "STRUKTURAL": "[REN126] Pengelola Gugus Kendali Mutu (Fakultas) sebagai Anggota",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Fakultas Bahasa dan Seni",
    "POINT POSITION": 200,
    "POINT PERFORMANCE": 1099.24,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 1299.24,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 1948860,
    "PPh 100%": 97443,
    "JUMLAH KOTOR 30% (Rp)": 877050,
    "JUMLAH KOTOR 70% (Rp)": 1071810,
    "PPh 21": 53590.5,
    "JUMLAH BERSIH 70% (Rp)": 1018219.5,
    "TANDA TANGAN": 139
  },
  {
    "NIP": "'198005062006041002",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. Gede Agus Beni Widana, S.Si., M.Si.",
    "JURUSAN": "Kimia Terapan (D4)",
    "FAKULTAS": "Fakultas Matematika dan Ilmu Pengetahuan Alam",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "STRUKTURAL": "Koordinator Program Studi S1/D3",
    "GRADE STRUKTURAL": 11,
    "UNIT KERJA": "Kimia Terapan (D4)",
    "POINT POSITION": 1899,
    "POINT PERFORMANCE": 318.958,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 2217.96,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 3326940,
    "PPh 100%": 166347,
    "JUMLAH KOTOR 30% (Rp)": 1527660,
    "JUMLAH KOTOR 70% (Rp)": 1799280,
    "PPh 21": 89964,
    "JUMLAH BERSIH 70% (Rp)": 1709316,
    "TANDA TANGAN": 140
  },
  {
    "NIP": "'197712172003121002",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr.rer.nat. I Gusti Ngurah Agung Suryaputra, S.T, M.Sc.",
    "JURUSAN": "Kimia Terapan (D4)",
    "FAKULTAS": "Fakultas Matematika dan Ilmu Pengetahuan Alam",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor Kepala",
    "GRADE FUNGSIONAL": 11,
    "STRUKTURAL": "Kepala Pusat Penelitian",
    "GRADE STRUKTURAL": 12,
    "UNIT KERJA": "-",
    "POINT POSITION": 1957.15,
    "POINT PERFORMANCE": 1134,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 3091.15,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 4636725,
    "PPh 100%": 231836.25,
    "JUMLAH KOTOR 30% (Rp)": 2020117.5,
    "JUMLAH KOTOR 70% (Rp)": 2616607.5,
    "PPh 21": 130830.375,
    "JUMLAH BERSIH 70% (Rp)": 2485777.125,
    "TANDA TANGAN": 141
  },
  {
    "NIP": "'198008052006042002",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Made Vivi Oviantari, S.Si., M.Si.",
    "JURUSAN": "Kimia Terapan (D4)",
    "FAKULTAS": "Fakultas Matematika dan Ilmu Pengetahuan Alam",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "STRUKTURAL": "[REN126] Pengelola Gugus Kendali Mutu (Fakultas) sebagai Anggota",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Kimia Terapan (D4)",
    "POINT POSITION": 200,
    "POINT PERFORMANCE": 466.833,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 666.833,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 1000249.5,
    "PPh 100%": 50012.475,
    "JUMLAH KOTOR 30% (Rp)": 877050,
    "JUMLAH KOTOR 70% (Rp)": 123199.5,
    "PPh 21": 6159.975,
    "JUMLAH BERSIH 70% (Rp)": 117039.525,
    "TANDA TANGAN": 142
  },
  {
    "NIP": "'197601192003122001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Ni Wayan Yuningrat, S.T., M.Sc.",
    "JURUSAN": "Kimia Terapan (D4)",
    "FAKULTAS": "Fakultas Matematika dan Ilmu Pengetahuan Alam",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "STRUKTURAL": "[REN126] Pengelola Gugus Kendali Mutu (Fakultas) sebagai Anggota",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Kimia Terapan (D4)",
    "POINT POSITION": 200,
    "POINT PERFORMANCE": 196.708,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 396.708,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 595062,
    "PPh 100%": 29753.1,
    "JUMLAH KOTOR 30% (Rp)": 877050,
    "JUMLAH KOTOR 70% (Rp)": 0,
    "PPh 21": 0,
    "JUMLAH BERSIH 70% (Rp)": 0,
    "TANDA TANGAN": 143
  },
  {
    "NIP": "'197806032002121004",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Prof. Dr. I Putu Parwata, S.Si., M.Si.",
    "JURUSAN": "Kimia Terapan (D4)",
    "FAKULTAS": "Fakultas Matematika dan Ilmu Pengetahuan Alam",
    "GOLONGAN": "IVB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor Kepala",
    "GRADE FUNGSIONAL": 11,
    "STRUKTURAL": "Sekretaris Jurusan S1",
    "GRADE STRUKTURAL": 11,
    "UNIT KERJA": "Jurusan Kimia",
    "POINT POSITION": 1899,
    "POINT PERFORMANCE": 805.333,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 2704.33,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 4056495,
    "PPh 100%": 608474.25,
    "JUMLAH KOTOR 30% (Rp)": 1880010,
    "JUMLAH KOTOR 70% (Rp)": 2176485,
    "PPh 21": 326472.75,
    "JUMLAH BERSIH 70% (Rp)": 1850012.25,
    "TANDA TANGAN": 144
  },
  {
    "NIP": "'198008302002121001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Prof. I Wayan Mudianta, S.Pd., M.Phil., Ph.D.",
    "JURUSAN": "Kimia Terapan (D4)",
    "FAKULTAS": "Fakultas Matematika dan Ilmu Pengetahuan Alam",
    "GOLONGAN": "IVB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Guru Besar",
    "GRADE FUNGSIONAL": 12,
    "STRUKTURAL": "[REN126] Pengelola Gugus Kendali Mutu (Fakultas) sebagai Anggota",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Kimia Terapan (D4)",
    "POINT POSITION": 200,
    "POINT PERFORMANCE": 727.75,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 927.75,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 1391625,
    "PPh 100%": 208743.75,
    "JUMLAH KOTOR 30% (Rp)": 1444950,
    "JUMLAH KOTOR 70% (Rp)": 0,
    "PPh 21": 0,
    "JUMLAH BERSIH 70% (Rp)": 0,
    "TANDA TANGAN": 145
  },
  {
    "NIP": "'198008232008121004",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Alexander Korinus Marantika, S.Pi., M.P.",
    "JURUSAN": "Bioteknologi Perikanan (D4)",
    "FAKULTAS": "Fakultas Matematika dan Ilmu Pengetahuan Alam",
    "GOLONGAN": "IIIC",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "STRUKTURAL": "[REN126] Pengelola Gugus Kendali Mutu (Fakultas) sebagai Anggota",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Fakultas Matematika dan Ilmu Pengetahuan Alam",
    "POINT POSITION": 200,
    "POINT PERFORMANCE": 845.167,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 1045.17,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 1567755,
    "PPh 100%": 78387.75,
    "JUMLAH KOTOR 30% (Rp)": 877050,
    "JUMLAH KOTOR 70% (Rp)": 690705,
    "PPh 21": 34535.25,
    "JUMLAH BERSIH 70% (Rp)": 656169.75,
    "TANDA TANGAN": 146
  },
  {
    "NIP": "'199508052022032013",
    "STATUS SEKARANG": "Tugas Belajar",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dewi Wulandari, M.P.",
    "JURUSAN": "Bioteknologi Perikanan (D4)",
    "FAKULTAS": "Fakultas Matematika dan Ilmu Pengetahuan Alam",
    "GOLONGAN": "IIIB",
    "STATUS PENELITIAN": "TIDAK ADA",
    "STATUS PENGABDIAN": "TIDAK ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Asisten Ahli",
    "GRADE FUNGSIONAL": 8,
    "STRUKTURAL": "[REN126] Pengelola Gugus Kendali Mutu (Fakultas) sebagai Anggota",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Bioteknologi Perikanan (D4)",
    "POINT POSITION": 0,
    "POINT PERFORMANCE": 0,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 0,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 0,
    "PPh 100%": 0,
    "JUMLAH KOTOR 70% (Rp)": 0,
    "PPh 21": 0,
    "JUMLAH BERSIH 70% (Rp)": 0,
    "TANDA TANGAN": 147
  },
  {
    "NIP": "'197706092008121002",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. I Nyoman Dodik Prasetia, S.Si., M.Si.",
    "JURUSAN": "Bioteknologi Perikanan (D4)",
    "FAKULTAS": "Fakultas Matematika dan Ilmu Pengetahuan Alam",
    "GOLONGAN": "IVA",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor Kepala",
    "GRADE FUNGSIONAL": 11,
    "STRUKTURAL": "Koordinator Program Studi S1/D3",
    "GRADE STRUKTURAL": 11,
    "UNIT KERJA": "Bioteknologi Perikanan (D4)",
    "POINT POSITION": 1645.8,
    "POINT PERFORMANCE": 2075.5,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 3721.3,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 5581950,
    "PPh 100%": 837292.5,
    "JUMLAH KOTOR 30% (Rp)": 1880010,
    "JUMLAH KOTOR 70% (Rp)": 3701940,
    "PPh 21": 555291,
    "JUMLAH BERSIH 70% (Rp)": 3146649,
    "TANDA TANGAN": 148
  },
  {
    "NIP": "'198712202022031004",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Hamdanul Fain, M.Si.",
    "JURUSAN": "Bioteknologi Perikanan (D4)",
    "FAKULTAS": "Fakultas Matematika dan Ilmu Pengetahuan Alam",
    "GOLONGAN": "IIIB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Asisten Ahli",
    "GRADE FUNGSIONAL": 8,
    "STRUKTURAL": "[REN126] Pengelola Gugus Kendali Mutu (Fakultas) sebagai Anggota",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Akuakultur (S1)",
    "POINT POSITION": 200,
    "POINT PERFORMANCE": 522.167,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 722.167,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 1083250.5,
    "PPh 100%": 54162.525,
    "JUMLAH KOTOR 30% (Rp)": 746550,
    "JUMLAH KOTOR 70% (Rp)": 336700.5,
    "PPh 21": 16835.025,
    "JUMLAH BERSIH 70% (Rp)": 319865.475,
    "TANDA TANGAN": 149
  },
  {
    "NIP": "'198307312008121003",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Kadek Lila Antara, S.Pi., M.P.",
    "JURUSAN": "Bioteknologi Perikanan (D4)",
    "FAKULTAS": "Fakultas Matematika dan Ilmu Pengetahuan Alam",
    "GOLONGAN": "IIIB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "UNIT KERJA": "-",
    "POINT PERFORMANCE": 490.833,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 490.833,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 736249.5,
    "PPh 100%": 36812.475,
    "JUMLAH KOTOR 30% (Rp)": 787050,
    "JUMLAH KOTOR 70% (Rp)": 0,
    "PPh 21": 0,
    "JUMLAH BERSIH 70% (Rp)": 0,
    "TANDA TANGAN": 150
  },
  {
    "NIP": "'199507102020122026",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Made Dwipa Kusuma Maharani, S.Tr.Pi., M.P.",
    "JURUSAN": "Bioteknologi Perikanan (D4)",
    "FAKULTAS": "Fakultas Matematika dan Ilmu Pengetahuan Alam",
    "GOLONGAN": "IIIB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Asisten Ahli",
    "GRADE FUNGSIONAL": 8,
    "STRUKTURAL": "[REN126] Pengelola Gugus Kendali Mutu (Fakultas) sebagai Anggota",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Bioteknologi Perikanan (D4)",
    "POINT POSITION": 200,
    "POINT PERFORMANCE": 676.083,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 876.083,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 1314124.5,
    "PPh 100%": 65706.225,
    "JUMLAH KOTOR 30% (Rp)": 746550,
    "JUMLAH KOTOR 70% (Rp)": 567574.5,
    "PPh 21": 28378.725,
    "JUMLAH BERSIH 70% (Rp)": 539195.775,
    "TANDA TANGAN": 151
  },
  {
    "NIP": "'197603272008122001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Ni Nyoman Dian Martini, S.Pi., M.P.",
    "JURUSAN": "Bioteknologi Perikanan (D4)",
    "FAKULTAS": "Fakultas Matematika dan Ilmu Pengetahuan Alam",
    "GOLONGAN": "IIIC",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "STRUKTURAL": "[REN126] Pengelola Gugus Kendali Mutu (Fakultas) sebagai Anggota",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Bioteknologi Perikanan (D4)",
    "POINT POSITION": 200,
    "POINT PERFORMANCE": 663.833,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 863.833,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 1295749.5,
    "PPh 100%": 64787.475,
    "JUMLAH KOTOR 30% (Rp)": 877050,
    "JUMLAH KOTOR 70% (Rp)": 418699.5,
    "PPh 21": 20934.975,
    "JUMLAH BERSIH 70% (Rp)": 397764.525,
    "TANDA TANGAN": 152
  },
  {
    "NIP": "'196112311986031013",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Prof. Dr. Ida Bagus Jelantik Swasta, M.Si.",
    "JURUSAN": "Bioteknologi Perikanan (D4)",
    "FAKULTAS": "Fakultas Matematika dan Ilmu Pengetahuan Alam",
    "GOLONGAN": "IVE",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Guru Besar",
    "GRADE FUNGSIONAL": 12,
    "UNIT KERJA": "-",
    "POINT PERFORMANCE": 1154.61,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 1154.61,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 1731915,
    "PPh 100%": 259787.25,
    "JUMLAH KOTOR 30% (Rp)": 1354950,
    "JUMLAH KOTOR 70% (Rp)": 376965,
    "PPh 21": 56544.75,
    "JUMLAH BERSIH 70% (Rp)": 320420.25,
    "TANDA TANGAN": 153
  },
  {
    "NIP": "'198302172006041003",
    "STATUS SEKARANG": "Tugas Belajar",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. I Made Suarsana, S.Pd., M.Si.",
    "JURUSAN": "Pendidikan Matematika (S1)",
    "FAKULTAS": "Fakultas Matematika dan Ilmu Pengetahuan Alam",
    "GOLONGAN": "IVB",
    "STATUS PENELITIAN": "TIDAK ADA",
    "STATUS PENGABDIAN": "TIDAK ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor Kepala",
    "GRADE FUNGSIONAL": 11,
    "UNIT KERJA": "-",
    "POINT POSITION": 0,
    "POINT PERFORMANCE": 0,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 0,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 0,
    "PPh 100%": 0,
    "JUMLAH KOTOR 70% (Rp)": 0,
    "PPh 21": 0,
    "JUMLAH BERSIH 70% (Rp)": 0,
    "TANDA TANGAN": 154
  },
  {
    "NIP": "'198806172014041001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. I Putu Pasek Suryawan, S.Pd., M.Pd.",
    "JURUSAN": "Pendidikan Matematika (S1)",
    "FAKULTAS": "Fakultas Matematika dan Ilmu Pengetahuan Alam",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "STRUKTURAL": "Koordinator Program Studi S1/D3",
    "GRADE STRUKTURAL": 11,
    "UNIT KERJA": "Pendidikan Matematika (S1)",
    "POINT POSITION": 1899,
    "POINT PERFORMANCE": 1647.5,
    "POINT KELEBIHAN": 315,
    "POINT TOTAL": 3861.5,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 5792250,
    "PPh 100%": 289612.5,
    "JUMLAH KOTOR 30% (Rp)": 1641600,
    "JUMLAH KOTOR 70% (Rp)": 4150650,
    "PPh 21": 207532.5,
    "JUMLAH BERSIH 70% (Rp)": 3943117.5,
    "TANDA TANGAN": 155
  },
  {
    "NIP": "'200002222024062002",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Kadek Ayu Mutiara Pratiwi, M.Pd.",
    "JURUSAN": "Pendidikan Matematika (S1)",
    "FAKULTAS": "Fakultas Matematika dan Ilmu Pengetahuan Alam",
    "GOLONGAN": "IIIB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Tenaga Pengajar",
    "GRADE FUNGSIONAL": 7,
    "UNIT KERJA": "-",
    "POINT PERFORMANCE": 651.427,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 651.427,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 977140.5,
    "PPh 100%": 48857.025,
    "JUMLAH KOTOR 30% (Rp)": 545400,
    "JUMLAH KOTOR 70% (Rp)": 431740.5,
    "PPh 21": 21587.025,
    "JUMLAH BERSIH 70% (Rp)": 410153.475,
    "TANDA TANGAN": 156
  },
  {
    "NIP": "'196008231986012001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Prof. Dr. Dra. Gst. Ayu Mahayukti, M.Si.",
    "JURUSAN": "Pendidikan Matematika (S1)",
    "FAKULTAS": "Fakultas Matematika dan Ilmu Pengetahuan Alam",
    "GOLONGAN": "IVD",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Guru Besar",
    "GRADE FUNGSIONAL": 12,
    "STRUKTURAL": "[REN126] Pengelola Gugus Kendali Mutu (Fakultas) sebagai Anggota",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Fakultas Matematika dan Ilmu Pengetahuan Alam",
    "POINT POSITION": 200,
    "POINT PERFORMANCE": 2562.36,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 2762.36,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 4143540,
    "PPh 100%": 621531,
    "JUMLAH KOTOR 30% (Rp)": 1444950,
    "JUMLAH KOTOR 70% (Rp)": 2698590,
    "PPh 21": 404788.5,
    "JUMLAH BERSIH 70% (Rp)": 2293801.5,
    "TANDA TANGAN": 157
  },
  {
    "NIP": "'196710201993031001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Prof. Dr. I Made Sugiarta, M.Si.",
    "JURUSAN": "Pendidikan Matematika (S1)",
    "FAKULTAS": "Fakultas Matematika dan Ilmu Pengetahuan Alam",
    "GOLONGAN": "IVC",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor Kepala",
    "GRADE FUNGSIONAL": 11,
    "STRUKTURAL": "[REN126] Pengelola Gugus Kendali Mutu (Fakultas) sebagai Anggota",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Penelitian dan Evaluasi Pendidikan(S2)",
    "POINT POSITION": 200,
    "POINT PERFORMANCE": 2272.73,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 2472.73,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 3709095,
    "PPh 100%": 556364.25,
    "JUMLAH KOTOR 30% (Rp)": 1229400,
    "JUMLAH KOTOR 70% (Rp)": 2479695,
    "PPh 21": 371954.25,
    "JUMLAH BERSIH 70% (Rp)": 2107740.75,
    "TANDA TANGAN": 158
  },
  {
    "NIP": "'196805191993031001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Prof. Dr. I Putu Wisna Ariawan, M.Si.",
    "JURUSAN": "Pendidikan Matematika (S1)",
    "FAKULTAS": "Fakultas Matematika dan Ilmu Pengetahuan Alam",
    "GOLONGAN": "IVD",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Guru Besar",
    "GRADE FUNGSIONAL": 12,
    "STRUKTURAL": "Ketua Jurusan S1",
    "GRADE STRUKTURAL": 12,
    "UNIT KERJA": "Jurusan Matematika",
    "POINT POSITION": 2258.25,
    "POINT PERFORMANCE": 2942.67,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 5200.92,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 7801380,
    "PPh 100%": 1170207,
    "JUMLAH KOTOR 30% (Rp)": 2371162.5,
    "JUMLAH KOTOR 70% (Rp)": 5430217.5,
    "PPh 21": 814532.625,
    "JUMLAH BERSIH 70% (Rp)": 4615684.875,
    "TANDA TANGAN": 159
  },
  {
    "NIP": "'197012101995012001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dewi Oktofa Rachmawati, S.Si., M.Si.",
    "JURUSAN": "Pendidikan Fisika (S1)",
    "FAKULTAS": "Fakultas Matematika dan Ilmu Pengetahuan Alam",
    "GOLONGAN": "IVB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor Kepala",
    "GRADE FUNGSIONAL": 11,
    "STRUKTURAL": "[REN126] Pengelola Gugus Kendali Mutu (Fakultas) sebagai Anggota",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Fisika (S1)",
    "POINT POSITION": 200,
    "POINT PERFORMANCE": 798.542,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 998.542,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 1497813,
    "PPh 100%": 224671.95,
    "JUMLAH KOTOR 30% (Rp)": 1229400,
    "JUMLAH KOTOR 70% (Rp)": 268413,
    "PPh 21": 40261.95,
    "JUMLAH BERSIH 70% (Rp)": 228151.05,
    "TANDA TANGAN": 160
  },
  {
    "NIP": "'196012311986031021",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. Drs. I Nyoman Putu Suwindra, M.Kom.",
    "JURUSAN": "Pendidikan Fisika (S1)",
    "FAKULTAS": "Fakultas Matematika dan Ilmu Pengetahuan Alam",
    "GOLONGAN": "IVC",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor Kepala",
    "GRADE FUNGSIONAL": 11,
    "UNIT KERJA": "-",
    "POINT PERFORMANCE": 563.9,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 563.9,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 845850,
    "PPh 100%": 126877.5,
    "JUMLAH KOTOR 30% (Rp)": 1139400,
    "JUMLAH KOTOR 70% (Rp)": 0,
    "PPh 21": 0,
    "JUMLAH BERSIH 70% (Rp)": 0,
    "TANDA TANGAN": 161
  },
  {
    "NIP": "'197703182008121004",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. I Gede Aris Gunadi, S.Si. M.Kom.",
    "JURUSAN": "Pendidikan Fisika (S1)",
    "FAKULTAS": "Fakultas Matematika dan Ilmu Pengetahuan Alam",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "STRUKTURAL": "Ketua Laboratorium Fakultas",
    "GRADE STRUKTURAL": 12,
    "UNIT KERJA": "Fakultas Matematika dan Ilmu Pengetahuan Alam",
    "POINT POSITION": 2709.9,
    "POINT PERFORMANCE": 1436.33,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 4146.23,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 6219345,
    "PPh 100%": 310967.25,
    "JUMLAH KOTOR 30% (Rp)": 2006505,
    "JUMLAH KOTOR 70% (Rp)": 4212840,
    "PPh 21": 210642,
    "JUMLAH BERSIH 70% (Rp)": 4002198,
    "TANDA TANGAN": 162
  },
  {
    "NIP": "'196408271991021001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. Ida Bagus Putu Mardana, M.Si.",
    "JURUSAN": "Pendidikan Fisika (S1)",
    "FAKULTAS": "Fakultas Matematika dan Ilmu Pengetahuan Alam",
    "GOLONGAN": "IVC",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor Kepala",
    "GRADE FUNGSIONAL": 11,
    "STRUKTURAL": "Wakil Dekan III",
    "GRADE STRUKTURAL": 14,
    "UNIT KERJA": "Fakultas Matematika dan Ilmu Pengetahuan Alam",
    "POINT POSITION": 9720,
    "POINT PERFORMANCE": 1548.25,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 11268.2,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 16902300,
    "PPh 100%": 2535345,
    "JUMLAH KOTOR 30% (Rp)": 5513400,
    "JUMLAH KOTOR 70% (Rp)": 11388900,
    "PPh 21": 1708335,
    "JUMLAH BERSIH 70% (Rp)": 9680565,
    "TANDA TANGAN": 163
  },
  {
    "NIP": "'198402222009122008",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. Luh Putu Budi Yasmini, S.Pd., M.Sc.",
    "JURUSAN": "Pendidikan Fisika (S1)",
    "FAKULTAS": "Fakultas Matematika dan Ilmu Pengetahuan Alam",
    "GOLONGAN": "IVA",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor Kepala",
    "GRADE FUNGSIONAL": 11,
    "STRUKTURAL": "Koordinator Program Studi S1/D3",
    "GRADE STRUKTURAL": 11,
    "UNIT KERJA": "Fisika (S1)",
    "POINT POSITION": 1645.8,
    "POINT PERFORMANCE": 970.417,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 2616.22,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 3924330,
    "PPh 100%": 588649.5,
    "JUMLAH KOTOR 30% (Rp)": 1880010,
    "JUMLAH KOTOR 70% (Rp)": 2044320,
    "PPh 21": 306648,
    "JUMLAH BERSIH 70% (Rp)": 1737672,
    "TANDA TANGAN": 164
  },
  {
    "NIP": "'198703012020122015",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. Nurfa Risha, S.Si., M.Sc.",
    "JURUSAN": "Pendidikan Fisika (S1)",
    "FAKULTAS": "Fakultas Matematika dan Ilmu Pengetahuan Alam",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "STRUKTURAL": "[REN126] Pengelola Gugus Kendali Mutu (Fakultas) sebagai Anggota",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Fisika (S1)",
    "POINT POSITION": 200,
    "POINT PERFORMANCE": 482.833,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 682.833,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 1024249.5,
    "PPh 100%": 51212.475,
    "JUMLAH KOTOR 30% (Rp)": 877050,
    "JUMLAH KOTOR 70% (Rp)": 147199.5,
    "PPh 21": 7359.975,
    "JUMLAH BERSIH 70% (Rp)": 139839.525,
    "TANDA TANGAN": 165
  },
  {
    "NIP": "'197912202006041001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. Putu Artawan, S.Pd., M.Si.",
    "JURUSAN": "Pendidikan Fisika (S1)",
    "FAKULTAS": "Fakultas Matematika dan Ilmu Pengetahuan Alam",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor Kepala",
    "GRADE FUNGSIONAL": 11,
    "STRUKTURAL": "Sekretaris Program Studi S2",
    "GRADE STRUKTURAL": 11,
    "UNIT KERJA": "Pendidikan IPA (S2)",
    "POINT POSITION": 2152.2,
    "POINT PERFORMANCE": 1991,
    "POINT KELEBIHAN": 190,
    "POINT TOTAL": 4333.2,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 6499800,
    "PPh 100%": 324990,
    "JUMLAH KOTOR 30% (Rp)": 2107890,
    "JUMLAH KOTOR 70% (Rp)": 4391910,
    "PPh 21": 219595.5,
    "JUMLAH BERSIH 70% (Rp)": 4172314.5,
    "TANDA TANGAN": 166
  },
  {
    "NIP": "'196111041987031002",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Drs. Putu Yasa, M.Si.",
    "JURUSAN": "Pendidikan Fisika (S1)",
    "FAKULTAS": "Fakultas Matematika dan Ilmu Pengetahuan Alam",
    "GOLONGAN": "IVC",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor Kepala",
    "GRADE FUNGSIONAL": 11,
    "STRUKTURAL": "[REN126] Pengelola Gugus Kendali Mutu (Fakultas) sebagai Anggota",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Pendidikan Fisika (S1)",
    "POINT POSITION": 200,
    "POINT PERFORMANCE": 847.817,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 1047.82,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 1571730,
    "PPh 100%": 235759.5,
    "JUMLAH KOTOR 30% (Rp)": 1229400,
    "JUMLAH KOTOR 70% (Rp)": 342330,
    "PPh 21": 51349.5,
    "JUMLAH BERSIH 70% (Rp)": 290980.5,
    "TANDA TANGAN": 167
  },
  {
    "NIP": "'199112262020121009",
    "STATUS SEKARANG": "Tugas Belajar",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "I Gede Arjana, S.Pd., M.Sc., RWTH",
    "JURUSAN": "Pendidikan Fisika (S1)",
    "FAKULTAS": "Fakultas Matematika dan Ilmu Pengetahuan Alam",
    "GOLONGAN": "IIIC",
    "STATUS PENELITIAN": "TIDAK ADA",
    "STATUS PENGABDIAN": "TIDAK ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "UNIT KERJA": "-",
    "POINT POSITION": 0,
    "POINT PERFORMANCE": 0,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 0,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 0,
    "PPh 100%": 0,
    "JUMLAH KOTOR 70% (Rp)": 0,
    "PPh 21": 0,
    "JUMLAH BERSIH 70% (Rp)": 0,
    "TANDA TANGAN": 168
  },
  {
    "NIP": "'199408292022031015",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "I Nengah Edi Budiarta, S.Pd., M.Sc.",
    "JURUSAN": "Pendidikan Fisika (S1)",
    "FAKULTAS": "Fakultas Matematika dan Ilmu Pengetahuan Alam",
    "GOLONGAN": "IIIB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Asisten Ahli",
    "GRADE FUNGSIONAL": 8,
    "STRUKTURAL": "[REN126] Pengelola Gugus Kendali Mutu (Fakultas) sebagai Anggota",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Pendidikan Fisika (S1)",
    "POINT POSITION": 200,
    "POINT PERFORMANCE": 873.378,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 1073.38,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 1610070,
    "PPh 100%": 80503.5,
    "JUMLAH KOTOR 30% (Rp)": 746550,
    "JUMLAH KOTOR 70% (Rp)": 863520,
    "PPh 21": 43176,
    "JUMLAH BERSIH 70% (Rp)": 820344,
    "TANDA TANGAN": 169
  },
  {
    "NIP": "'199405242022032012",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Ina Yuliana, M.Pd.",
    "JURUSAN": "Pendidikan Fisika (S1)",
    "FAKULTAS": "Fakultas Matematika dan Ilmu Pengetahuan Alam",
    "GOLONGAN": "IIIB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Asisten Ahli",
    "GRADE FUNGSIONAL": 8,
    "STRUKTURAL": "[REN126] Pengelola Gugus Kendali Mutu (Fakultas) sebagai Anggota",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Pendidikan Fisika (S1)",
    "POINT POSITION": 200,
    "POINT PERFORMANCE": 409.125,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 609.125,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 913687.5,
    "PPh 100%": 45684.375,
    "JUMLAH KOTOR 30% (Rp)": 746550,
    "JUMLAH KOTOR 70% (Rp)": 167137.5,
    "PPh 21": 8356.875,
    "JUMLAH BERSIH 70% (Rp)": 158780.625,
    "TANDA TANGAN": 170
  },
  {
    "NIP": "'196308301988032002",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Prof. Dr. Ni Ketut Rapi, M.Pd.",
    "JURUSAN": "Pendidikan Fisika (S1)",
    "FAKULTAS": "Fakultas Matematika dan Ilmu Pengetahuan Alam",
    "GOLONGAN": "IVC",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Guru Besar",
    "GRADE FUNGSIONAL": 12,
    "STRUKTURAL": "Koordinator Program Studi S1/D3",
    "GRADE STRUKTURAL": 11,
    "UNIT KERJA": "Pendidikan Fisika (S1)",
    "POINT POSITION": 1645.8,
    "POINT PERFORMANCE": 1625.26,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 3271.06,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 4906590,
    "PPh 100%": 735988.5,
    "JUMLAH KOTOR 30% (Rp)": 2095560,
    "JUMLAH KOTOR 70% (Rp)": 2811030,
    "PPh 21": 421654.5,
    "JUMLAH BERSIH 70% (Rp)": 2389375.5,
    "TANDA TANGAN": 171
  },
  {
    "NIP": "'196410311992031002",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Prof. Dr. Rai Sujanem, M.Si.",
    "JURUSAN": "Pendidikan Fisika (S1)",
    "FAKULTAS": "Fakultas Matematika dan Ilmu Pengetahuan Alam",
    "GOLONGAN": "IVD",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Guru Besar",
    "GRADE FUNGSIONAL": 12,
    "STRUKTURAL": "Sekretaris Jurusan S1",
    "GRADE STRUKTURAL": 11,
    "UNIT KERJA": "Jurusan Fisika dan Pengajaran IPA",
    "POINT POSITION": 1645.8,
    "POINT PERFORMANCE": 2020,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 3665.8,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 5498700,
    "PPh 100%": 824805,
    "JUMLAH KOTOR 30% (Rp)": 2095560,
    "JUMLAH KOTOR 70% (Rp)": 3403140,
    "PPh 21": 510471,
    "JUMLAH BERSIH 70% (Rp)": 2892669,
    "TANDA TANGAN": 172
  },
  {
    "NIP": "'198903272019032020",
    "STATUS SEKARANG": "Ijin Belajar",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Putu Widiarini, S.Pd., M.Sc.",
    "JURUSAN": "Pendidikan Fisika (S1)",
    "FAKULTAS": "Fakultas Matematika dan Ilmu Pengetahuan Alam",
    "GOLONGAN": "IIIC",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "STRUKTURAL": "[REN223] Sekretaris Pusat/ Ketua Divisi/ Asrama/ Koordinator Lab. Jurusan Kepala Unit BPU/ Sekretaris Gugus Kendali Mutu Fakultas/ Sekretaris Tim Pengelolaan dan Penerimaan Mahasiswa Asing/ Sekretaris Unit Pengembangan dan Peningkatan Kapasitas Kelembagaan",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Fakultas Matematika dan Ilmu Pengetahuan Alam",
    "POINT POSITION": 800,
    "POINT PERFORMANCE": 735.077,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 1535.08,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 2302620,
    "PPh 100%": 115131,
    "JUMLAH KOTOR 30% (Rp)": 1147050,
    "JUMLAH KOTOR 70% (Rp)": 1155570,
    "PPh 21": 57778.5,
    "JUMLAH BERSIH 70% (Rp)": 1097791.5,
    "TANDA TANGAN": 173
  },
  {
    "NIP": "'196801081994031004",
    "STATUS SEKARANG": "Ijin Belajar",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. I Nyoman Selamat, S.Si., M.Si.",
    "JURUSAN": "Pendidikan Kimia (S1)",
    "FAKULTAS": "Fakultas Matematika dan Ilmu Pengetahuan Alam",
    "GOLONGAN": "IVB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor Kepala",
    "GRADE FUNGSIONAL": 11,
    "STRUKTURAL": "[REN126] Pengelola Gugus Kendali Mutu (Fakultas) sebagai Anggota",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Pendidikan Kimia (S1)",
    "POINT POSITION": 200,
    "POINT PERFORMANCE": 1216.08,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 1416.08,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 2124120,
    "PPh 100%": 318618,
    "JUMLAH KOTOR 30% (Rp)": 1229400,
    "JUMLAH KOTOR 70% (Rp)": 894720,
    "PPh 21": 134208,
    "JUMLAH BERSIH 70% (Rp)": 760512,
    "TANDA TANGAN": 174
  },
  {
    "NIP": "'198306272006042002",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. Ni Made Wiratini, S.Pd., M.Sc.",
    "JURUSAN": "Pendidikan Kimia (S1)",
    "FAKULTAS": "Fakultas Matematika dan Ilmu Pengetahuan Alam",
    "GOLONGAN": "IVA",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor Kepala",
    "GRADE FUNGSIONAL": 11,
    "STRUKTURAL": "Koordinator Program Studi S1/D3",
    "GRADE STRUKTURAL": 11,
    "UNIT KERJA": "Pendidikan Kimia (S1)",
    "POINT POSITION": 1899,
    "POINT PERFORMANCE": 1646.73,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 3545.73,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 5318595,
    "PPh 100%": 797789.25,
    "JUMLAH KOTOR 30% (Rp)": 1880010,
    "JUMLAH KOTOR 70% (Rp)": 3438585,
    "PPh 21": 515787.75,
    "JUMLAH BERSIH 70% (Rp)": 2922797.25,
    "TANDA TANGAN": 175
  },
  {
    "NIP": "'196310231991031001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Prof. Dr. Drs. I Ketut Sudiana, M.Kes.",
    "JURUSAN": "Pendidikan Kimia (S1)",
    "FAKULTAS": "Fakultas Matematika dan Ilmu Pengetahuan Alam",
    "GOLONGAN": "IVD",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Guru Besar",
    "GRADE FUNGSIONAL": 12,
    "STRUKTURAL": "Wakil Rektor III",
    "GRADE STRUKTURAL": 16,
    "UNIT KERJA": "-",
    "POINT POSITION": 16460,
    "POINT PERFORMANCE": 1592.17,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 18052.2,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 27078300,
    "PPh 100%": 4061745,
    "JUMLAH KOTOR 30% (Rp)": 8761950,
    "JUMLAH KOTOR 70% (Rp)": 18316350,
    "PPh 21": 2747452.5,
    "JUMLAH BERSIH 70% (Rp)": 15568897.5,
    "TANDA TANGAN": 176
  },
  {
    "NIP": "'196703201993031002",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Prof. Dr. Drs. I Wayan Suja, M.Si.",
    "JURUSAN": "Pendidikan Kimia (S1)",
    "FAKULTAS": "Fakultas Matematika dan Ilmu Pengetahuan Alam",
    "GOLONGAN": "IVB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Guru Besar",
    "GRADE FUNGSIONAL": 12,
    "STRUKTURAL": "Wakil Dekan II",
    "GRADE STRUKTURAL": 14,
    "UNIT KERJA": "Fakultas Matematika dan Ilmu Pengetahuan Alam",
    "POINT POSITION": 9720,
    "POINT PERFORMANCE": 2767,
    "POINT KELEBIHAN": 451.5,
    "POINT TOTAL": 12938.5,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 19407750,
    "PPh 100%": 2911162.5,
    "JUMLAH KOTOR 30% (Rp)": 5728950,
    "JUMLAH KOTOR 70% (Rp)": 13678800,
    "PPh 21": 2051820,
    "JUMLAH BERSIH 70% (Rp)": 11626980,
    "TANDA TANGAN": 177
  },
  {
    "NIP": "'196212311987031020",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Prof. Dr. I Gusti Lanang Wiratma, M.Si.",
    "JURUSAN": "Pendidikan Kimia (S1)",
    "FAKULTAS": "Fakultas Matematika dan Ilmu Pengetahuan Alam",
    "GOLONGAN": "IVD",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Guru Besar",
    "GRADE FUNGSIONAL": 12,
    "STRUKTURAL": "[REN222] Kepala Pusat /Kantor/Kepala Gugus Kendali Mutu Fakultas/Ketua Unit Pengelolaan dan Penerimaan Mahasiswa Asing/ Ketua Unit Pengembangan dan Peningkatan Kapasitas Kelembagaan",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "-",
    "POINT POSITION": 1150,
    "POINT PERFORMANCE": 997.667,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 2147.67,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 3221505,
    "PPh 100%": 483225.75,
    "JUMLAH KOTOR 30% (Rp)": 1872450,
    "JUMLAH KOTOR 70% (Rp)": 1349055,
    "PPh 21": 202358.25,
    "JUMLAH BERSIH 70% (Rp)": 1146696.75,
    "TANDA TANGAN": 178
  },
  {
    "NIP": "'196202211986012001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Prof. Dr. Siti Maryam, M.Kes.",
    "JURUSAN": "Pendidikan Kimia (S1)",
    "FAKULTAS": "Fakultas Matematika dan Ilmu Pengetahuan Alam",
    "GOLONGAN": "IVC",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Guru Besar",
    "GRADE FUNGSIONAL": 12,
    "STRUKTURAL": "[REN126] Pengelola Gugus Kendali Mutu (Fakultas) sebagai Anggota",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Pendidikan Kimia (S1)",
    "POINT POSITION": 200,
    "POINT PERFORMANCE": 2145,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 2345,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 3517500,
    "PPh 100%": 527625,
    "JUMLAH KOTOR 30% (Rp)": 1444950,
    "JUMLAH KOTOR 70% (Rp)": 2072550,
    "PPh 21": 310882.5,
    "JUMLAH BERSIH 70% (Rp)": 1761667.5,
    "TANDA TANGAN": 179
  },
  {
    "NIP": "'199401112022032015",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Qonita Awliya Hanif, M.Si.",
    "JURUSAN": "Pendidikan Kimia (S1)",
    "FAKULTAS": "Fakultas Matematika dan Ilmu Pengetahuan Alam",
    "GOLONGAN": "IIIB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Asisten Ahli",
    "GRADE FUNGSIONAL": 8,
    "STRUKTURAL": "[REN126] Pengelola Gugus Kendali Mutu (Fakultas) sebagai Anggota",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Pendidikan Kimia (S1)",
    "POINT POSITION": 200,
    "POINT PERFORMANCE": 683.667,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 883.667,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 1325500.5,
    "PPh 100%": 66275.025,
    "JUMLAH KOTOR 30% (Rp)": 746550,
    "JUMLAH KOTOR 70% (Rp)": 578950.5,
    "PPh 21": 28947.525,
    "JUMLAH BERSIH 70% (Rp)": 550002.975,
    "TANDA TANGAN": 180
  },
  {
    "NIP": "'199302212022032011",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Ajeng Purnama Heny, M.Pd.",
    "JURUSAN": "Pendidikan Biologi (S1)",
    "FAKULTAS": "Fakultas Matematika dan Ilmu Pengetahuan Alam",
    "GOLONGAN": "IIIB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Asisten Ahli",
    "GRADE FUNGSIONAL": 8,
    "STRUKTURAL": "[REN126] Pengelola Gugus Kendali Mutu (Fakultas) sebagai Anggota",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Pendidikan Biologi (S1)",
    "POINT POSITION": 200,
    "POINT PERFORMANCE": 835.607,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 1035.61,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 1553415,
    "PPh 100%": 77670.75,
    "JUMLAH KOTOR 30% (Rp)": 746550,
    "JUMLAH KOTOR 70% (Rp)": 806865,
    "PPh 21": 40343.25,
    "JUMLAH BERSIH 70% (Rp)": 766521.75,
    "TANDA TANGAN": 181
  },
  {
    "NIP": "'198212052014042001",
    "STATUS SEKARANG": "Tugas Belajar",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. Ida Ayu Putu Suryanti, S.Si., M.Si.",
    "JURUSAN": "Pendidikan Biologi (S1)",
    "FAKULTAS": "Fakultas Matematika dan Ilmu Pengetahuan Alam",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "STRUKTURAL": "[REN126] Pengelola Gugus Kendali Mutu (Fakultas) sebagai Anggota",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Fakultas Matematika dan Ilmu Pengetahuan Alam",
    "POINT POSITION": 200,
    "POINT PERFORMANCE": 0,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 200,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 300000,
    "PPh 100%": 15000,
    "JUMLAH KOTOR 70% (Rp)": 300000,
    "PPh 21": 15000,
    "JUMLAH BERSIH 70% (Rp)": 285000,
    "TANDA TANGAN": 182
  },
  {
    "NIP": "'198910032019031008",
    "STATUS SEKARANG": "Ijin Belajar",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "I Made Oka Riawan, S.Pd., M.Sc.",
    "JURUSAN": "Pendidikan Biologi (S1)",
    "FAKULTAS": "Fakultas Matematika dan Ilmu Pengetahuan Alam",
    "GOLONGAN": "IIIC",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "STRUKTURAL": "Koordinator Program Studi S1/D3",
    "GRADE STRUKTURAL": 11,
    "UNIT KERJA": "Biologi (S1)",
    "POINT POSITION": 1645.8,
    "POINT PERFORMANCE": 1319.17,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 2964.97,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 4447455,
    "PPh 100%": 222372.75,
    "JUMLAH KOTOR 30% (Rp)": 1527660,
    "JUMLAH KOTOR 70% (Rp)": 2919795,
    "PPh 21": 145989.75,
    "JUMLAH BERSIH 70% (Rp)": 2773805.25,
    "TANDA TANGAN": 183
  },
  {
    "NIP": "'197610272006041001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "I Made Pasek Anton Santiasa, S.Pd., M.Sc.",
    "JURUSAN": "Pendidikan Biologi (S1)",
    "FAKULTAS": "Fakultas Matematika dan Ilmu Pengetahuan Alam",
    "GOLONGAN": "IIIB",
    "STATUS PENELITIAN": "TIDAK ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Asisten Ahli",
    "GRADE FUNGSIONAL": 8,
    "UNIT KERJA": "-",
    "POINT POSITION": 0,
    "POINT PERFORMANCE": 0,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 0,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 0,
    "PPh 100%": 0,
    "JUMLAH KOTOR 30% (Rp)": 656550,
    "JUMLAH KOTOR 70% (Rp)": 0,
    "PPh 21": 0,
    "JUMLAH BERSIH 70% (Rp)": 0,
    "TANDA TANGAN": 184
  },
  {
    "NIP": "'198907182020122017",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Ida Ayu Purnama Bestari, S.Pd., M. Sc.",
    "JURUSAN": "Pendidikan Biologi (S1)",
    "FAKULTAS": "Fakultas Matematika dan Ilmu Pengetahuan Alam",
    "GOLONGAN": "IIIC",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "STRUKTURAL": "[REN126] Pengelola Gugus Kendali Mutu (Fakultas) sebagai Anggota",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Fakultas Matematika dan Ilmu Pengetahuan Alam",
    "POINT POSITION": 200,
    "POINT PERFORMANCE": 1432.83,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 1632.83,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 2449245,
    "PPh 100%": 122462.25,
    "JUMLAH KOTOR 30% (Rp)": 877050,
    "JUMLAH KOTOR 70% (Rp)": 1572195,
    "PPh 21": 78609.75,
    "JUMLAH BERSIH 70% (Rp)": 1493585.25,
    "TANDA TANGAN": 185
  },
  {
    "NIP": "'198912292022031009",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Moh Jafron Syah, M.Si.",
    "JURUSAN": "Pendidikan Biologi (S1)",
    "FAKULTAS": "Fakultas Matematika dan Ilmu Pengetahuan Alam",
    "GOLONGAN": "IIIB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Asisten Ahli",
    "GRADE FUNGSIONAL": 8,
    "STRUKTURAL": "[REN126] Pengelola Gugus Kendali Mutu (Fakultas) sebagai Anggota",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Pendidikan Biologi (S1)",
    "POINT POSITION": 200,
    "POINT PERFORMANCE": 878.75,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 1078.75,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 1618125,
    "PPh 100%": 80906.25,
    "JUMLAH KOTOR 30% (Rp)": 746550,
    "JUMLAH KOTOR 70% (Rp)": 871575,
    "PPh 21": 43578.75,
    "JUMLAH BERSIH 70% (Rp)": 827996.25,
    "TANDA TANGAN": 186
  },
  {
    "NIP": "'198701022020122008",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Ni Putu Dian Pertiwi, M.Si.",
    "JURUSAN": "Pendidikan Biologi (S1)",
    "FAKULTAS": "Fakultas Matematika dan Ilmu Pengetahuan Alam",
    "GOLONGAN": "IIIC",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "UNIT KERJA": "-",
    "POINT PERFORMANCE": 193.333,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 193.333,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 289999.5,
    "PPh 100%": 14499.975,
    "JUMLAH KOTOR 30% (Rp)": 877050,
    "JUMLAH KOTOR 70% (Rp)": 0,
    "PPh 21": 0,
    "JUMLAH BERSIH 70% (Rp)": 0,
    "TANDA TANGAN": 187
  },
  {
    "NIP": "'198603072015042001",
    "STATUS SEKARANG": "Ijin Belajar",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Ni Putu Sri Ratna Dewi, S.Pd., M.Pd.",
    "JURUSAN": "Pendidikan Biologi (S1)",
    "FAKULTAS": "Fakultas Matematika dan Ilmu Pengetahuan Alam",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor Kepala",
    "GRADE FUNGSIONAL": 11,
    "STRUKTURAL": "Koordinator Program Studi S1/D3",
    "GRADE STRUKTURAL": 11,
    "UNIT KERJA": "Pendidikan Biologi (S1)",
    "POINT POSITION": 1645.8,
    "POINT PERFORMANCE": 2084,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 3729.8,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 5594700,
    "PPh 100%": 279735,
    "JUMLAH KOTOR 30% (Rp)": 1880010,
    "JUMLAH KOTOR 70% (Rp)": 3714690,
    "PPh 21": 185734.5,
    "JUMLAH BERSIH 70% (Rp)": 3528955.5,
    "TANDA TANGAN": 188
  },
  {
    "NIP": "'199512062024061001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "P. Krisna Widyantara Sujana, M.Sc.",
    "JURUSAN": "Pendidikan Biologi (S1)",
    "FAKULTAS": "Fakultas Matematika dan Ilmu Pengetahuan Alam",
    "GOLONGAN": "IIIB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Tenaga Pengajar",
    "GRADE FUNGSIONAL": 7,
    "STRUKTURAL": "[REN126] Pengelola Gugus Kendali Mutu (Fakultas) sebagai Anggota",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Pendidikan Biologi (S1)",
    "POINT POSITION": 200,
    "POINT PERFORMANCE": 348,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 548,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 822000,
    "PPh 100%": 41100,
    "JUMLAH KOTOR 30% (Rp)": 545400,
    "JUMLAH KOTOR 70% (Rp)": 276600,
    "PPh 21": 13830,
    "JUMLAH BERSIH 70% (Rp)": 262770,
    "TANDA TANGAN": 189
  },
  {
    "NIP": "'195808311982032002",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Prof. Dr. Desak Made Citrawathi, M.Kes.",
    "JURUSAN": "Pendidikan Biologi (S1)",
    "FAKULTAS": "Fakultas Matematika dan Ilmu Pengetahuan Alam",
    "GOLONGAN": "IVD",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Guru Besar",
    "GRADE FUNGSIONAL": 12,
    "STRUKTURAL": "[REN126] Pengelola Gugus Kendali Mutu (Fakultas) sebagai Anggota",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Pendidikan Biologi (S1)",
    "POINT POSITION": 200,
    "POINT PERFORMANCE": 2743.67,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 2943.67,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 4415505,
    "PPh 100%": 662325.75,
    "JUMLAH KOTOR 30% (Rp)": 1444950,
    "JUMLAH KOTOR 70% (Rp)": 2970555,
    "PPh 21": 445583.25,
    "JUMLAH BERSIH 70% (Rp)": 2524971.75,
    "TANDA TANGAN": 190
  },
  {
    "NIP": "'197602062005011002",
    "STATUS SEKARANG": "Ijin Belajar",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. I Nyoman Sukarta, S.Pd., M.Si.",
    "JURUSAN": "Kimia (S1)",
    "FAKULTAS": "Fakultas Matematika dan Ilmu Pengetahuan Alam",
    "GOLONGAN": "IVC",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor Kepala",
    "GRADE FUNGSIONAL": 11,
    "STRUKTURAL": "[REN126] Pengelola Gugus Kendali Mutu (Fakultas) sebagai Anggota",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Pendidikan Kimia (S1)",
    "POINT POSITION": 200,
    "POINT PERFORMANCE": 1391.67,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 1591.67,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 2387505,
    "PPh 100%": 358125.75,
    "JUMLAH KOTOR 30% (Rp)": 1229400,
    "JUMLAH KOTOR 70% (Rp)": 1158105,
    "PPh 21": 173715.75,
    "JUMLAH BERSIH 70% (Rp)": 984389.25,
    "TANDA TANGAN": 191
  },
  {
    "NIP": "'199410022019032013",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Ni Luh Putu Ananda Saraswati, S.Si.,M.Si.",
    "JURUSAN": "Kimia (S1)",
    "FAKULTAS": "Fakultas Matematika dan Ilmu Pengetahuan Alam",
    "GOLONGAN": "IIIC",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "STRUKTURAL": "Koordinator Program Studi S1/D3",
    "GRADE STRUKTURAL": 11,
    "UNIT KERJA": "Kimia (S1)",
    "POINT POSITION": 1899,
    "POINT PERFORMANCE": 679,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 2578,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 3867000,
    "PPh 100%": 193350,
    "JUMLAH KOTOR 30% (Rp)": 1527660,
    "JUMLAH KOTOR 70% (Rp)": 2339340,
    "PPh 21": 116967,
    "JUMLAH BERSIH 70% (Rp)": 2222373,
    "TANDA TANGAN": 192
  },
  {
    "NIP": "'198110292008122002",
    "STATUS SEKARANG": "Ijin Belajar",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Ni Putu Sri Ayuni, S.Si., M.Sc.",
    "JURUSAN": "Kimia (S1)",
    "FAKULTAS": "Fakultas Matematika dan Ilmu Pengetahuan Alam",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "STRUKTURAL": "[REN126] Pengelola Gugus Kendali Mutu (Fakultas) sebagai Anggota",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Kimia (S1)",
    "POINT POSITION": 200,
    "POINT PERFORMANCE": 571.5,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 771.5,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 1157250,
    "PPh 100%": 57862.5,
    "JUMLAH KOTOR 30% (Rp)": 877050,
    "JUMLAH KOTOR 70% (Rp)": 280200,
    "PPh 21": 14010,
    "JUMLAH BERSIH 70% (Rp)": 266190,
    "TANDA TANGAN": 193
  },
  {
    "NIP": "'198603072008122003",
    "STATUS SEKARANG": "Tugas Belajar",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Ni Wayan Martiningsih, S.Si., M.Sc.",
    "JURUSAN": "Kimia (S1)",
    "FAKULTAS": "Fakultas Matematika dan Ilmu Pengetahuan Alam",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "TIDAK ADA",
    "STATUS PENGABDIAN": "TIDAK ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "UNIT KERJA": "-",
    "POINT POSITION": 0,
    "POINT PERFORMANCE": 0,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 0,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 0,
    "PPh 100%": 0,
    "JUMLAH KOTOR 70% (Rp)": 0,
    "PPh 21": 0,
    "JUMLAH BERSIH 70% (Rp)": 0,
    "TANDA TANGAN": 194
  },
  {
    "NIP": "'196804171995011001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Prof. Dr. I Dewa Ketut Sastrawidana, S.Si., M.Si.",
    "JURUSAN": "Kimia (S1)",
    "FAKULTAS": "Fakultas Matematika dan Ilmu Pengetahuan Alam",
    "GOLONGAN": "IVB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Guru Besar",
    "GRADE FUNGSIONAL": 12,
    "STRUKTURAL": "[REN222] Kepala Pusat /Kantor/Kepala Gugus Kendali Mutu Fakultas/Ketua Unit Pengelolaan dan Penerimaan Mahasiswa Asing/ Ketua Unit Pengembangan dan Peningkatan Kapasitas Kelembagaan",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Manajemen Lingkungan (S2)",
    "POINT POSITION": 1150,
    "POINT PERFORMANCE": 1822.46,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 2972.46,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 4458690,
    "PPh 100%": 668803.5,
    "JUMLAH KOTOR 30% (Rp)": 1872450,
    "JUMLAH KOTOR 70% (Rp)": 2586240,
    "PPh 21": 387936,
    "JUMLAH BERSIH 70% (Rp)": 2198304,
    "TANDA TANGAN": 195
  },
  {
    "NIP": "'196010091985031002",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Prof. Dr. I Wayan Muderawan, M.S.",
    "JURUSAN": "Kimia (S1)",
    "FAKULTAS": "Fakultas Matematika dan Ilmu Pengetahuan Alam",
    "GOLONGAN": "IVC",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Guru Besar",
    "GRADE FUNGSIONAL": 12,
    "UNIT KERJA": "-",
    "POINT PERFORMANCE": 1425.33,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 1425.33,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 2137995,
    "PPh 100%": 320699.25,
    "JUMLAH KOTOR 30% (Rp)": 1354950,
    "JUMLAH KOTOR 70% (Rp)": 783045,
    "PPh 21": 117456.75,
    "JUMLAH BERSIH 70% (Rp)": 665588.25,
    "TANDA TANGAN": 196
  },
  {
    "NIP": "'196912311994031012",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Prof. Dr.rer.nat. I Wayan Karyasa, S.Pd., M.Sc.",
    "JURUSAN": "Kimia (S1)",
    "FAKULTAS": "Fakultas Matematika dan Ilmu Pengetahuan Alam",
    "GOLONGAN": "IVB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Guru Besar",
    "GRADE FUNGSIONAL": 12,
    "UNIT KERJA": "-",
    "POINT PERFORMANCE": 1568.88,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 1568.88,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 2353320,
    "PPh 100%": 352998,
    "JUMLAH KOTOR 30% (Rp)": 1354950,
    "JUMLAH KOTOR 70% (Rp)": 998370,
    "PPh 21": 149755.5,
    "JUMLAH BERSIH 70% (Rp)": 848614.5,
    "TANDA TANGAN": 197
  },
  {
    "NIP": "'199303042022032015",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Rachmadhani, S.Si., M.Si.",
    "JURUSAN": "Kimia (S1)",
    "FAKULTAS": "Fakultas Matematika dan Ilmu Pengetahuan Alam",
    "GOLONGAN": "IIIB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Asisten Ahli",
    "GRADE FUNGSIONAL": 8,
    "STRUKTURAL": "[REN126] Pengelola Gugus Kendali Mutu (Fakultas) sebagai Anggota",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Kimia (S1)",
    "POINT POSITION": 200,
    "POINT PERFORMANCE": 547.75,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 747.75,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 1121625,
    "PPh 100%": 56081.25,
    "JUMLAH KOTOR 30% (Rp)": 746550,
    "JUMLAH KOTOR 70% (Rp)": 375075,
    "PPh 21": 18753.75,
    "JUMLAH BERSIH 70% (Rp)": 356321.25,
    "TANDA TANGAN": 198
  },
  {
    "NIP": "'199212272020122015",
    "STATUS SEKARANG": "Tugas Belajar",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Safira Noor Andayani, S.Si., M.Si.",
    "JURUSAN": "Kimia (S1)",
    "FAKULTAS": "Fakultas Matematika dan Ilmu Pengetahuan Alam",
    "GOLONGAN": "IIIB",
    "STATUS PENELITIAN": "TIDAK ADA",
    "STATUS PENGABDIAN": "TIDAK ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Asisten Ahli",
    "GRADE FUNGSIONAL": 8,
    "UNIT KERJA": "-",
    "POINT POSITION": 0,
    "POINT PERFORMANCE": 0,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 0,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 0,
    "PPh 100%": 0,
    "JUMLAH KOTOR 70% (Rp)": 0,
    "PPh 21": 0,
    "JUMLAH BERSIH 70% (Rp)": 0,
    "TANDA TANGAN": 199
  },
  {
    "NIP": "'196307031990032001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. Ir. Ketut Srie Marhaeni Julyasih, M.Si.",
    "JURUSAN": "Biologi (S1)",
    "FAKULTAS": "Fakultas Matematika dan Ilmu Pengetahuan Alam",
    "GOLONGAN": "IVA",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "STRUKTURAL": "Sekretaris Jurusan S1",
    "GRADE STRUKTURAL": 11,
    "UNIT KERJA": "Jurusan Biologi dan Perikanan Kelautan",
    "POINT POSITION": 1899,
    "POINT PERFORMANCE": 1157,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 3056,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 4584000,
    "PPh 100%": 687600,
    "JUMLAH KOTOR 30% (Rp)": 1641600,
    "JUMLAH KOTOR 70% (Rp)": 2942400,
    "PPh 21": 441360,
    "JUMLAH BERSIH 70% (Rp)": 2501040,
    "TANDA TANGAN": 200
  },
  {
    "NIP": "'199401062022032016",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Jean Nihana Mulyo Putri Manalu, S.P., M.Si.",
    "JURUSAN": "Biologi (S1)",
    "FAKULTAS": "Fakultas Matematika dan Ilmu Pengetahuan Alam",
    "GOLONGAN": "IIIB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Asisten Ahli",
    "GRADE FUNGSIONAL": 8,
    "UNIT KERJA": "-",
    "POINT PERFORMANCE": 860.417,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 860.417,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 1290625.5,
    "PPh 100%": 64531.275,
    "JUMLAH KOTOR 30% (Rp)": 746550,
    "JUMLAH KOTOR 70% (Rp)": 544075.5,
    "PPh 21": 27203.775,
    "JUMLAH BERSIH 70% (Rp)": 516871.725,
    "TANDA TANGAN": 201
  },
  {
    "NIP": "'198907242022032010",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Yuliastuti, M.Si.",
    "JURUSAN": "Biologi (S1)",
    "FAKULTAS": "Fakultas Matematika dan Ilmu Pengetahuan Alam",
    "GOLONGAN": "IIIB",
    "STATUS PENELITIAN": "TIDAK ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Asisten Ahli",
    "GRADE FUNGSIONAL": 8,
    "STRUKTURAL": "[REN126] Pengelola Gugus Kendali Mutu (Fakultas) sebagai Anggota",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Biologi (S1)",
    "POINT POSITION": 0,
    "POINT PERFORMANCE": 0,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 0,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 0,
    "PPh 100%": 0,
    "JUMLAH KOTOR 30% (Rp)": 746550,
    "JUMLAH KOTOR 70% (Rp)": 0,
    "PPh 21": 0,
    "JUMLAH BERSIH 70% (Rp)": 0,
    "TANDA TANGAN": 202
  },
  {
    "NIP": "'198405252008121008",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. I Gusti Nyoman Yudi Hartawan, S.Si., M.Sc.",
    "JURUSAN": "Matematika (S1)",
    "FAKULTAS": "Fakultas Matematika dan Ilmu Pengetahuan Alam",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "STRUKTURAL": "Sekretaris Jurusan S1",
    "GRADE STRUKTURAL": 11,
    "UNIT KERJA": "Jurusan Matematika",
    "POINT POSITION": 1899,
    "POINT PERFORMANCE": 1664.17,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 3563.17,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 5344755,
    "PPh 100%": 267237.75,
    "JUMLAH KOTOR 30% (Rp)": 1641600,
    "JUMLAH KOTOR 70% (Rp)": 3703155,
    "PPh 21": 185157.75,
    "JUMLAH BERSIH 70% (Rp)": 3517997.25,
    "TANDA TANGAN": 203
  },
  {
    "NIP": "'199010242020121005",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "I Nyoman Budayana, S.Pd.,M.Sc",
    "JURUSAN": "Matematika (S1)",
    "FAKULTAS": "Fakultas Matematika dan Ilmu Pengetahuan Alam",
    "GOLONGAN": "IIIC",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "STRUKTURAL": "Koordinator Program Studi S1/D3",
    "GRADE STRUKTURAL": 11,
    "UNIT KERJA": "Matematika (S1)",
    "POINT POSITION": 1645.8,
    "POINT PERFORMANCE": 1603.17,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 3248.97,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 4873455,
    "PPh 100%": 243672.75,
    "JUMLAH KOTOR 30% (Rp)": 1527660,
    "JUMLAH KOTOR 70% (Rp)": 3345795,
    "PPh 21": 167289.75,
    "JUMLAH BERSIH 70% (Rp)": 3178505.25,
    "TANDA TANGAN": 204
  },
  {
    "NIP": "'199408112024061002",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Nyoman Arda Wibawa, M.Si.",
    "JURUSAN": "Matematika (S1)",
    "FAKULTAS": "Fakultas Matematika dan Ilmu Pengetahuan Alam",
    "GOLONGAN": "IIIB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Tenaga Pengajar",
    "GRADE FUNGSIONAL": 7,
    "UNIT KERJA": "-",
    "POINT PERFORMANCE": 490.479,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 490.479,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 735718.5,
    "PPh 100%": 36785.925,
    "JUMLAH KOTOR 30% (Rp)": 545400,
    "JUMLAH KOTOR 70% (Rp)": 190318.5,
    "PPh 21": 9515.925,
    "JUMLAH BERSIH 70% (Rp)": 180802.575,
    "TANDA TANGAN": 205
  },
  {
    "NIP": "'199004202019032021",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Putu Kartika Dewi, S.Pd.,M.Sc.",
    "JURUSAN": "Matematika (S1)",
    "FAKULTAS": "Fakultas Matematika dan Ilmu Pengetahuan Alam",
    "GOLONGAN": "IIIC",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "STRUKTURAL": "[REN126] Pengelola Gugus Kendali Mutu (Fakultas) sebagai Anggota",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Pendidikan Matematika (S1)",
    "POINT POSITION": 200,
    "POINT PERFORMANCE": 1449.06,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 1649.06,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 2473590,
    "PPh 100%": 123679.5,
    "JUMLAH KOTOR 30% (Rp)": 877050,
    "JUMLAH KOTOR 70% (Rp)": 1596540,
    "PPh 21": 79827,
    "JUMLAH BERSIH 70% (Rp)": 1516713,
    "TANDA TANGAN": 206
  },
  {
    "NIP": "'199301012022032020",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Raphita Yanisari Silalahi, M.Sc.",
    "JURUSAN": "Matematika (S1)",
    "FAKULTAS": "Fakultas Matematika dan Ilmu Pengetahuan Alam",
    "GOLONGAN": "IIIB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Asisten Ahli",
    "GRADE FUNGSIONAL": 8,
    "STRUKTURAL": "[REN223] Sekretaris Pusat/ Ketua Divisi/ Asrama/ Koordinator Lab. Jurusan Kepala Unit BPU/ Sekretaris Gugus Kendali Mutu Fakultas/ Sekretaris Tim Pengelolaan dan Penerimaan Mahasiswa Asing/ Sekretaris Unit Pengembangan dan Peningkatan Kapasitas Kelembagaan",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "-",
    "POINT POSITION": 800,
    "POINT PERFORMANCE": 1184.67,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 1984.67,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 2977005,
    "PPh 100%": 148850.25,
    "JUMLAH KOTOR 30% (Rp)": 1016550,
    "JUMLAH KOTOR 70% (Rp)": 1960455,
    "PPh 21": 98022.75,
    "JUMLAH BERSIH 70% (Rp)": 1862432.25,
    "TANDA TANGAN": 207
  },
  {
    "NIP": "'197904142002121002",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. Gede Ari Yudasmara, S.Si., M.Si.",
    "JURUSAN": "Akuakultur (S1)",
    "FAKULTAS": "Fakultas Matematika dan Ilmu Pengetahuan Alam",
    "GOLONGAN": "IVB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor Kepala",
    "GRADE FUNGSIONAL": 11,
    "STRUKTURAL": "Ketua Jurusan S1",
    "GRADE STRUKTURAL": 12,
    "UNIT KERJA": "Jurusan Biologi dan Perikanan Kelautan",
    "POINT POSITION": 2258.25,
    "POINT PERFORMANCE": 1250.83,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 3509.08,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 5263620,
    "PPh 100%": 789543,
    "JUMLAH KOTOR 30% (Rp)": 2155612.5,
    "JUMLAH KOTOR 70% (Rp)": 3108007.5,
    "PPh 21": 466201.125,
    "JUMLAH BERSIH 70% (Rp)": 2641806.375,
    "TANDA TANGAN": 208
  },
  {
    "NIP": "'198005182006041002",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. Gede Iwan Setiabudi, S.Pd., M.Si.",
    "JURUSAN": "Akuakultur (S1)",
    "FAKULTAS": "Fakultas Matematika dan Ilmu Pengetahuan Alam",
    "GOLONGAN": "IIIB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "STRUKTURAL": "Koordinator Program Studi S1/D3",
    "GRADE STRUKTURAL": 11,
    "UNIT KERJA": "Akuakultur (S1)",
    "POINT POSITION": 1645.8,
    "POINT PERFORMANCE": 1266.67,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 2912.47,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 4368705,
    "PPh 100%": 218435.25,
    "JUMLAH KOTOR 30% (Rp)": 1527660,
    "JUMLAH KOTOR 70% (Rp)": 2841045,
    "PPh 21": 142052.25,
    "JUMLAH BERSIH 70% (Rp)": 2698992.75,
    "TANDA TANGAN": 209
  },
  {
    "NIP": "'199411082020122030",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Gressty Sari Br Sitepu, S.Pi., M.Si.",
    "JURUSAN": "Akuakultur (S1)",
    "FAKULTAS": "Fakultas Matematika dan Ilmu Pengetahuan Alam",
    "GOLONGAN": "IIIC",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "STRUKTURAL": "[REN222] Kepala Pusat /Kantor/Kepala Gugus Kendali Mutu Fakultas/Ketua Unit Pengelolaan dan Penerimaan Mahasiswa Asing/ Ketua Unit Pengembangan dan Peningkatan Kapasitas Kelembagaan",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "-",
    "POINT POSITION": 1150,
    "POINT PERFORMANCE": 371,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 1521,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 2281500,
    "PPh 100%": 114075,
    "JUMLAH KOTOR 30% (Rp)": 1304550,
    "JUMLAH KOTOR 70% (Rp)": 976950,
    "PPh 21": 48847.5,
    "JUMLAH BERSIH 70% (Rp)": 928102.5,
    "TANDA TANGAN": 210
  },
  {
    "NIP": "'198804222019032013",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Jasmine Masyitha Amelia, S.PI.,M.Si.",
    "JURUSAN": "Akuakultur (S1)",
    "FAKULTAS": "Fakultas Matematika dan Ilmu Pengetahuan Alam",
    "GOLONGAN": "IIIB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Asisten Ahli",
    "GRADE FUNGSIONAL": 8,
    "STRUKTURAL": "[REN126] Pengelola Gugus Kendali Mutu (Fakultas) sebagai Anggota",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Akuakultur (S1)",
    "POINT POSITION": 200,
    "POINT PERFORMANCE": 616.917,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 816.917,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 1225375.5,
    "PPh 100%": 61268.775,
    "JUMLAH KOTOR 30% (Rp)": 746550,
    "JUMLAH KOTOR 70% (Rp)": 478825.5,
    "PPh 21": 23941.275,
    "JUMLAH BERSIH 70% (Rp)": 454884.225,
    "TANDA TANGAN": 211
  },
  {
    "NIP": "'199401182024061001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Bartolomeus Kristi Brahmantia Putra, M.Pd.",
    "JURUSAN": "Pendidikan IPA (S1)",
    "FAKULTAS": "Fakultas Matematika dan Ilmu Pengetahuan Alam",
    "GOLONGAN": "IIIB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Tenaga Pengajar",
    "GRADE FUNGSIONAL": 7,
    "UNIT KERJA": "-",
    "POINT PERFORMANCE": 576.635,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 576.635,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 864952.5,
    "PPh 100%": 43247.625,
    "JUMLAH KOTOR 30% (Rp)": 545400,
    "JUMLAH KOTOR 70% (Rp)": 319552.5,
    "PPh 21": 15977.625,
    "JUMLAH BERSIH 70% (Rp)": 303574.875,
    "TANDA TANGAN": 212
  },
  {
    "NIP": "'198708102020122011",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. Nia Erlina, S.Pd., M.Pd.",
    "JURUSAN": "Pendidikan IPA (S1)",
    "FAKULTAS": "Fakultas Matematika dan Ilmu Pengetahuan Alam",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "STRUKTURAL": "[REN126] Pengelola Gugus Kendali Mutu (Fakultas) sebagai Anggota",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Pendidikan IPA (S1)",
    "POINT POSITION": 200,
    "POINT PERFORMANCE": 966.743,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 1166.74,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 1750110,
    "PPh 100%": 87505.5,
    "JUMLAH KOTOR 30% (Rp)": 877050,
    "JUMLAH KOTOR 70% (Rp)": 873060,
    "PPh 21": 43653,
    "JUMLAH BERSIH 70% (Rp)": 829407,
    "TANDA TANGAN": 213
  },
  {
    "NIP": "'197812022014042001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. Putri Sarini, S.T., M.Pd.",
    "JURUSAN": "Pendidikan IPA (S1)",
    "FAKULTAS": "Fakultas Matematika dan Ilmu Pengetahuan Alam",
    "GOLONGAN": "IIIC",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "STRUKTURAL": "[REN126] Pengelola Gugus Kendali Mutu (Fakultas) sebagai Anggota",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Fakultas Matematika dan Ilmu Pengetahuan Alam",
    "POINT POSITION": 200,
    "POINT PERFORMANCE": 1101.33,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 1301.33,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 1951995,
    "PPh 100%": 97599.75,
    "JUMLAH KOTOR 30% (Rp)": 877050,
    "JUMLAH KOTOR 70% (Rp)": 1074945,
    "PPh 21": 53747.25,
    "JUMLAH BERSIH 70% (Rp)": 1021197.75,
    "TANDA TANGAN": 214
  },
  {
    "NIP": "'198809282014042002",
    "STATUS SEKARANG": "Ijin Belajar",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Kadek Ayu Astiti, S.Pd., M.Pd.",
    "JURUSAN": "Pendidikan IPA (S1)",
    "FAKULTAS": "Fakultas Matematika dan Ilmu Pengetahuan Alam",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "STRUKTURAL": "[REN126] Pengelola Gugus Kendali Mutu (Fakultas) sebagai Anggota",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Pendidikan IPA (S1)",
    "POINT POSITION": 200,
    "POINT PERFORMANCE": 282.667,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 482.667,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 724000.5,
    "PPh 100%": 36200.025,
    "JUMLAH KOTOR 30% (Rp)": 877050,
    "JUMLAH KOTOR 70% (Rp)": 0,
    "PPh 21": 0,
    "JUMLAH BERSIH 70% (Rp)": 0,
    "TANDA TANGAN": 215
  },
  {
    "NIP": "'198906252015041001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Kompyang Selamet, S.Pd., M.Pd.",
    "JURUSAN": "Pendidikan IPA (S1)",
    "FAKULTAS": "Fakultas Matematika dan Ilmu Pengetahuan Alam",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "STRUKTURAL": "[REN126] Pengelola Gugus Kendali Mutu (Fakultas) sebagai Anggota",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Pendidikan IPA (S1)",
    "POINT POSITION": 200,
    "POINT PERFORMANCE": 1102.91,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 1302.91,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 1954365,
    "PPh 100%": 97718.25,
    "JUMLAH KOTOR 30% (Rp)": 877050,
    "JUMLAH KOTOR 70% (Rp)": 1077315,
    "PPh 21": 53865.75,
    "JUMLAH BERSIH 70% (Rp)": 1023449.25,
    "TANDA TANGAN": 216
  },
  {
    "NIP": "'199310062019032021",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Luh Mitha Priyanka, S.Pd., M.Pd.",
    "JURUSAN": "Pendidikan IPA (S1)",
    "FAKULTAS": "Fakultas Matematika dan Ilmu Pengetahuan Alam",
    "GOLONGAN": "IIIC",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "STRUKTURAL": "[REN223] Sekretaris Pusat/ Ketua Divisi/ Asrama/ Koordinator Lab. Jurusan Kepala Unit BPU/ Sekretaris Gugus Kendali Mutu Fakultas/ Sekretaris Tim Pengelolaan dan Penerimaan Mahasiswa Asing/ Sekretaris Unit Pengembangan dan Peningkatan Kapasitas Kelembagaan",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "-",
    "POINT POSITION": 800,
    "POINT PERFORMANCE": 1401.74,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 2201.74,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 3302610,
    "PPh 100%": 165130.5,
    "JUMLAH KOTOR 30% (Rp)": 1147050,
    "JUMLAH KOTOR 70% (Rp)": 2155560,
    "PPh 21": 107778,
    "JUMLAH BERSIH 70% (Rp)": 2047782,
    "TANDA TANGAN": 217
  },
  {
    "NIP": "'198803262023212024",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PPPK",
    "NAMA DOSEN": "Ni Luh Putu Mery Marlinda, M.Pd.",
    "JURUSAN": "Pendidikan IPA (S1)",
    "FAKULTAS": "Fakultas Matematika dan Ilmu Pengetahuan Alam",
    "GOLONGAN": "X",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Asisten Ahli",
    "GRADE FUNGSIONAL": 8,
    "UNIT KERJA": "-",
    "POINT PERFORMANCE": 794.378,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 794.378,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 1191567,
    "PPh 100%": 59578.35,
    "JUMLAH KOTOR 30% (Rp)": 656550,
    "JUMLAH KOTOR 70% (Rp)": 535017,
    "PPh 21": 26750.85,
    "JUMLAH BERSIH 70% (Rp)": 508266.15,
    "TANDA TANGAN": 218
  },
  {
    "NIP": "'196611231993031001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Prof. Dr. I Nyoman Suardana, M.Si.",
    "JURUSAN": "Pendidikan IPA (S1)",
    "FAKULTAS": "Fakultas Matematika dan Ilmu Pengetahuan Alam",
    "GOLONGAN": "IVB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Guru Besar",
    "GRADE FUNGSIONAL": 12,
    "STRUKTURAL": "Ketua Jurusan S1",
    "GRADE STRUKTURAL": 12,
    "UNIT KERJA": "Jurusan Kimia",
    "POINT POSITION": 2258.25,
    "POINT PERFORMANCE": 2900.5,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 5158.75,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 7738125,
    "PPh 100%": 1160718.75,
    "JUMLAH KOTOR 30% (Rp)": 2235667.5,
    "JUMLAH KOTOR 70% (Rp)": 5502457.5,
    "PPh 21": 825368.625,
    "JUMLAH BERSIH 70% (Rp)": 4677088.875,
    "TANDA TANGAN": 219
  },
  {
    "NIP": "'196311041988032001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Prof. Dr. Ni Made Pujani, M.Si.",
    "JURUSAN": "Pendidikan IPA (S1)",
    "FAKULTAS": "Fakultas Matematika dan Ilmu Pengetahuan Alam",
    "GOLONGAN": "IVC",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Guru Besar",
    "GRADE FUNGSIONAL": 12,
    "STRUKTURAL": "Ketua Jurusan S1",
    "GRADE STRUKTURAL": 12,
    "UNIT KERJA": "Jurusan Fisika dan Pengajaran IPA",
    "POINT POSITION": 1957.15,
    "POINT PERFORMANCE": 1709.78,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 3666.93,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 5500395,
    "PPh 100%": 825059.25,
    "JUMLAH KOTOR 30% (Rp)": 2235667.5,
    "JUMLAH KOTOR 70% (Rp)": 3264727.5,
    "PPh 21": 489709.125,
    "JUMLAH BERSIH 70% (Rp)": 2775018.375,
    "TANDA TANGAN": 220
  },
  {
    "NIP": "'199201112023211027",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PPPK",
    "NAMA DOSEN": "Putu Hari Sudewa, S.Pd., M.Pd.",
    "JURUSAN": "Pendidikan IPA (S1)",
    "FAKULTAS": "Fakultas Matematika dan Ilmu Pengetahuan Alam",
    "GOLONGAN": "X",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Asisten Ahli",
    "GRADE FUNGSIONAL": 8,
    "UNIT KERJA": "-",
    "POINT PERFORMANCE": 566.712,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 566.712,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 850068,
    "PPh 100%": 42503.4,
    "JUMLAH KOTOR 30% (Rp)": 656550,
    "JUMLAH KOTOR 70% (Rp)": 193518,
    "PPh 21": 9675.9,
    "JUMLAH BERSIH 70% (Rp)": 183842.1,
    "TANDA TANGAN": 221
  },
  {
    "NIP": "'198806142015041001",
    "STATUS SEKARANG": "Ijin Belajar",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Putu Prima Juniartina, S.Pd., M.Pd.",
    "JURUSAN": "Pendidikan IPA (S1)",
    "FAKULTAS": "Fakultas Matematika dan Ilmu Pengetahuan Alam",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "STRUKTURAL": "Koordinator Program Studi S1/D3",
    "GRADE STRUKTURAL": 11,
    "UNIT KERJA": "Pendidikan IPA (S1)",
    "POINT POSITION": 1645.8,
    "POINT PERFORMANCE": 1404.74,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 3050.54,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 4575810,
    "PPh 100%": 228790.5,
    "JUMLAH KOTOR 30% (Rp)": 1527660,
    "JUMLAH KOTOR 70% (Rp)": 3048150,
    "PPh 21": 152407.5,
    "JUMLAH BERSIH 70% (Rp)": 2895742.5,
    "TANDA TANGAN": 222
  },
  {
    "NIP": "'196901161994031001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. I Wayan Puja Astawa, S.Pd., M.Stat.Sci.",
    "JURUSAN": "Pendidikan Matematika (S2)",
    "FAKULTAS": "Program Pascasarjana",
    "GOLONGAN": "IVB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor Kepala",
    "GRADE FUNGSIONAL": 11,
    "STRUKTURAL": "Wakil Dekan I",
    "GRADE STRUKTURAL": 14,
    "UNIT KERJA": "Fakultas Matematika dan Ilmu Pengetahuan Alam",
    "POINT POSITION": 9720,
    "POINT PERFORMANCE": 2473.33,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 12193.3,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 18289950,
    "PPh 100%": 2743492.5,
    "JUMLAH KOTOR 30% (Rp)": 5513400,
    "JUMLAH KOTOR 70% (Rp)": 12776550,
    "PPh 21": 1916482.5,
    "JUMLAH BERSIH 70% (Rp)": 10860067.5,
    "TANDA TANGAN": 223
  },
  {
    "NIP": "'196111111987021001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Prof. Dr. Gede Suweken, M.Sc.",
    "JURUSAN": "Pendidikan Matematika (S2)",
    "FAKULTAS": "Program Pascasarjana",
    "GOLONGAN": "IVA",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor Kepala",
    "GRADE FUNGSIONAL": 11,
    "STRUKTURAL": "Sekretaris Program Studi S2",
    "GRADE STRUKTURAL": 11,
    "UNIT KERJA": "Pendidikan Matematika (S2)",
    "POINT POSITION": 2152.2,
    "POINT PERFORMANCE": 2459.17,
    "POINT KELEBIHAN": 190,
    "POINT TOTAL": 4801.37,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 7202055,
    "PPh 100%": 1080308.25,
    "JUMLAH KOTOR 30% (Rp)": 2107890,
    "JUMLAH KOTOR 70% (Rp)": 5094165,
    "PPh 21": 764124.75,
    "JUMLAH BERSIH 70% (Rp)": 4330040.25,
    "TANDA TANGAN": 224
  },
  {
    "NIP": "'196212151988031002",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Prof. Dr. I Gusti Putu Suharta, M.Si.",
    "JURUSAN": "Pendidikan Matematika (S2)",
    "FAKULTAS": "Program Pascasarjana",
    "GOLONGAN": "IVE",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Guru Besar",
    "GRADE FUNGSIONAL": 12,
    "STRUKTURAL": "Direktur Sumber Daya dan Pembelajaran (SDP)",
    "GRADE STRUKTURAL": 15,
    "UNIT KERJA": "-",
    "POINT POSITION": 10965,
    "POINT PERFORMANCE": 2868.67,
    "POINT KELEBIHAN": 300.358,
    "POINT TOTAL": 14134,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 21201000,
    "PPh 100%": 3180150,
    "JUMLAH KOTOR 30% (Rp)": 6289200,
    "JUMLAH KOTOR 70% (Rp)": 14911800,
    "PPh 21": 2236770,
    "JUMLAH BERSIH 70% (Rp)": 12675030,
    "TANDA TANGAN": 225
  },
  {
    "NIP": "'196208271989031001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Prof. Dr. I Made Ardana, M.Pd.",
    "JURUSAN": "Pendidikan Matematika (S2)",
    "FAKULTAS": "Program Pascasarjana",
    "GOLONGAN": "IVE",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Guru Besar",
    "GRADE FUNGSIONAL": 12,
    "STRUKTURAL": "Ketua Program Studi S2",
    "GRADE STRUKTURAL": 12,
    "UNIT KERJA": "Pendidikan Matematika (S2)",
    "POINT POSITION": 2559.35,
    "POINT PERFORMANCE": 2994,
    "POINT KELEBIHAN": 541.8,
    "POINT TOTAL": 6095.15,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 9142725,
    "PPh 100%": 1371408.75,
    "JUMLAH KOTOR 30% (Rp)": 2506657.5,
    "JUMLAH KOTOR 70% (Rp)": 6636067.5,
    "PPh 21": 995410.125,
    "JUMLAH BERSIH 70% (Rp)": 5640657.375,
    "TANDA TANGAN": 226
  },
  {
    "NIP": "'196507111990031003",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Prof. Dr. I Nengah Suparta, M.Si.",
    "JURUSAN": "Pendidikan Matematika (S2)",
    "FAKULTAS": "Program Pascasarjana",
    "GOLONGAN": "IVE",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Guru Besar",
    "GRADE FUNGSIONAL": 12,
    "UNIT KERJA": "Pendidikan Matematika (S2)",
    "POINT POSITION": 10965,
    "POINT PERFORMANCE": 2875.67,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 13840.7,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 20761050,
    "PPh 100%": 3114157.5,
    "JUMLAH KOTOR 30% (Rp)": 6289200,
    "JUMLAH KOTOR 70% (Rp)": 14471850,
    "PPh 21": 2170777.5,
    "JUMLAH BERSIH 70% (Rp)": 12301072.5,
    "TANDA TANGAN": 227
  },
  {
    "NIP": "'196609201991032001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Prof. Dr. Ni Made Sri Mertasari, M.Pd.",
    "JURUSAN": "Pendidikan Matematika (S2)",
    "FAKULTAS": "Program Pascasarjana",
    "GOLONGAN": "IVB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Guru Besar",
    "GRADE FUNGSIONAL": 12,
    "UNIT KERJA": "-",
    "POINT PERFORMANCE": 2838.67,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 2838.67,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 4258005,
    "PPh 100%": 638700.75,
    "JUMLAH KOTOR 30% (Rp)": 1354950,
    "JUMLAH KOTOR 70% (Rp)": 2903055,
    "PPh 21": 435458.25,
    "JUMLAH BERSIH 70% (Rp)": 2467596.75,
    "TANDA TANGAN": 228
  },
  {
    "NIP": "'196512051991031005",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Prof. Dr.Phill. I Gst. Putu Sudiarta, M.Si.",
    "JURUSAN": "Pendidikan Matematika (S2)",
    "FAKULTAS": "Program Pascasarjana",
    "GOLONGAN": "IVD",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Guru Besar",
    "GRADE FUNGSIONAL": 12,
    "UNIT KERJA": "Pendidikan Matematika (S2)",
    "POINT PERFORMANCE": 2886.17,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 2886.17,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 4329255,
    "PPh 100%": 649388.25,
    "JUMLAH KOTOR 30% (Rp)": 1354950,
    "JUMLAH KOTOR 70% (Rp)": 2974305,
    "PPh 21": 446145.75,
    "JUMLAH BERSIH 70% (Rp)": 2528159.25,
    "TANDA TANGAN": 229
  },
  {
    "NIP": "'196909181994032001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. Ni Luh Putu Manik Widiyanti, S.Si., M.Kes.",
    "JURUSAN": "Pendidikan IPA (S2)",
    "FAKULTAS": "Program Pascasarjana",
    "GOLONGAN": "IVB",
    "STATUS PENELITIAN": "TIDAK ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor Kepala",
    "GRADE FUNGSIONAL": 11,
    "STRUKTURAL": "[REN126] Pengelola Gugus Kendali Mutu (Fakultas) sebagai Anggota",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Biologi (S1)",
    "POINT POSITION": 0,
    "POINT PERFORMANCE": 0,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 0,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 0,
    "PPh 100%": 0,
    "JUMLAH KOTOR 30% (Rp)": 1139400,
    "JUMLAH KOTOR 70% (Rp)": 0,
    "PPh 21": 0,
    "JUMLAH BERSIH 70% (Rp)": 0,
    "TANDA TANGAN": 230
  },
  {
    "NIP": "'196503251991031001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Prof. Dr. I Wayan Redhana, M.Si.",
    "JURUSAN": "Pendidikan IPA (S2)",
    "FAKULTAS": "Program Pascasarjana",
    "GOLONGAN": "IVE",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Guru Besar",
    "GRADE FUNGSIONAL": 12,
    "UNIT KERJA": "-",
    "POINT PERFORMANCE": 2851.5,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 2851.5,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 4277250,
    "PPh 100%": 641587.5,
    "JUMLAH KOTOR 30% (Rp)": 1354950,
    "JUMLAH KOTOR 70% (Rp)": 2922300,
    "PPh 21": 438345,
    "JUMLAH BERSIH 70% (Rp)": 2483955,
    "TANDA TANGAN": 231
  },
  {
    "NIP": "'196404121989031005",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Prof. Dr. Ida Bagus Nyoman Sudria, M.Sc.",
    "JURUSAN": "Pendidikan IPA (S2)",
    "FAKULTAS": "Program Pascasarjana",
    "GOLONGAN": "IVC",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Guru Besar",
    "GRADE FUNGSIONAL": 12,
    "UNIT KERJA": "-",
    "POINT PERFORMANCE": 880.083,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 880.083,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 1320124.5,
    "PPh 100%": 198018.675,
    "JUMLAH KOTOR 30% (Rp)": 1354950,
    "JUMLAH KOTOR 70% (Rp)": 0,
    "PPh 21": 0,
    "JUMLAH BERSIH 70% (Rp)": 0,
    "TANDA TANGAN": 232
  },
  {
    "NIP": "'195901011984031003",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Prof. Dr. Ketut Suma, M.S.",
    "JURUSAN": "Pendidikan IPA (S2)",
    "FAKULTAS": "Program Pascasarjana",
    "GOLONGAN": "IVE",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Guru Besar",
    "GRADE FUNGSIONAL": 12,
    "STRUKTURAL": "Wakil Direktur 2",
    "GRADE STRUKTURAL": 14,
    "UNIT KERJA": "Pascasarjana",
    "POINT POSITION": 9180,
    "POINT PERFORMANCE": 2844,
    "POINT KELEBIHAN": 541.8,
    "POINT TOTAL": 12565.8,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 18848700,
    "PPh 100%": 2827305,
    "JUMLAH KOTOR 30% (Rp)": 5485950,
    "JUMLAH KOTOR 70% (Rp)": 13362750,
    "PPh 21": 2004412.5,
    "JUMLAH BERSIH 70% (Rp)": 11358337.5,
    "TANDA TANGAN": 233
  },
  {
    "NIP": "'196212311988031015",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Prof. Drs. I Wayan Subagia, M.App.Sc., Ph.D.",
    "JURUSAN": "Pendidikan IPA (S2)",
    "FAKULTAS": "Program Pascasarjana",
    "GOLONGAN": "IVE",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Guru Besar",
    "GRADE FUNGSIONAL": 12,
    "UNIT KERJA": "-",
    "POINT PERFORMANCE": 2265.33,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 2265.33,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 3397995,
    "PPh 100%": 509699.25,
    "JUMLAH KOTOR 30% (Rp)": 1354950,
    "JUMLAH KOTOR 70% (Rp)": 2043045,
    "PPh 21": 306456.75,
    "JUMLAH BERSIH 70% (Rp)": 1736588.25,
    "TANDA TANGAN": 234
  },
  {
    "NIP": "'197704242003122002",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. Luh Putu Sri Ariyani, S.S., M.Hum.",
    "JURUSAN": "Perpustakaan (D3)",
    "FAKULTAS": "Fakultas Hukum dan Ilmu Sosial",
    "GOLONGAN": "IVA",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor Kepala",
    "GRADE FUNGSIONAL": 11,
    "STRUKTURAL": "Koordinator Program Studi S1/D3",
    "GRADE STRUKTURAL": 11,
    "UNIT KERJA": "Perpustakaan (D3)",
    "POINT POSITION": 1645.8,
    "POINT PERFORMANCE": 1427.04,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 3072.84,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 4609260,
    "PPh 100%": 691389,
    "JUMLAH KOTOR 30% (Rp)": 1880010,
    "JUMLAH KOTOR 70% (Rp)": 2729250,
    "PPh 21": 409387.5,
    "JUMLAH BERSIH 70% (Rp)": 2319862.5,
    "TANDA TANGAN": 235
  },
  {
    "NIP": "'198701172020121009",
    "STATUS SEKARANG": "Ijin Belajar",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "I Putu Putra Yana Wardana, S.Pd., M.T.",
    "JURUSAN": "Perpustakaan (D3)",
    "FAKULTAS": "Fakultas Hukum dan Ilmu Sosial",
    "GOLONGAN": "IIIB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Asisten Ahli",
    "GRADE FUNGSIONAL": 8,
    "STRUKTURAL": "[REN126] Pengelola Gugus Kendali Mutu (Fakultas) sebagai Anggota",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Fakultas Hukum dan Ilmu Sosial",
    "POINT POSITION": 200,
    "POINT PERFORMANCE": 656.052,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 856.052,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 1284078,
    "PPh 100%": 64203.9,
    "JUMLAH KOTOR 30% (Rp)": 656550,
    "JUMLAH KOTOR 70% (Rp)": 627528,
    "PPh 21": 31376.4,
    "JUMLAH BERSIH 70% (Rp)": 596151.6,
    "TANDA TANGAN": 236
  },
  {
    "NIP": "'196012311987031015",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Prof. Dr. Drs. I Wayan Mudana, M.Si.",
    "JURUSAN": "Perpustakaan (D3)",
    "FAKULTAS": "Fakultas Hukum dan Ilmu Sosial",
    "GOLONGAN": "IVD",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Guru Besar",
    "GRADE FUNGSIONAL": 12,
    "STRUKTURAL": "Sekretaris Program Studi S2",
    "GRADE STRUKTURAL": 11,
    "UNIT KERJA": "Pendidikan Ilmu Pengetahuan Sosial (S2)",
    "POINT POSITION": 2152.2,
    "POINT PERFORMANCE": 2777,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 4929.2,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 7393800,
    "PPh 100%": 1109070,
    "JUMLAH KOTOR 30% (Rp)": 2323440,
    "JUMLAH KOTOR 70% (Rp)": 5070360,
    "PPh 21": 760554,
    "JUMLAH BERSIH 70% (Rp)": 4309806,
    "TANDA TANGAN": 237
  },
  {
    "NIP": "'196212311988031018",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Prof. Dr. I Made Pageh, M.Hum.",
    "JURUSAN": "Perpustakaan (D3)",
    "FAKULTAS": "Fakultas Hukum dan Ilmu Sosial",
    "GOLONGAN": "IVE",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Guru Besar",
    "GRADE FUNGSIONAL": 12,
    "STRUKTURAL": "Kepala UPA",
    "GRADE STRUKTURAL": 12,
    "UNIT KERJA": "-",
    "POINT POSITION": 2559.35,
    "POINT PERFORMANCE": 2904.5,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 5463.85,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 8195775,
    "PPh 100%": 1229366.25,
    "JUMLAH KOTOR 30% (Rp)": 2506657.5,
    "JUMLAH KOTOR 70% (Rp)": 5689117.5,
    "PPh 21": 853367.625,
    "JUMLAH BERSIH 70% (Rp)": 4835749.875,
    "TANDA TANGAN": 238
  },
  {
    "NIP": "'199406292020121009",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Santana Sembiring, S.Sos., M.A.",
    "JURUSAN": "Perpustakaan (D3)",
    "FAKULTAS": "Fakultas Hukum dan Ilmu Sosial",
    "GOLONGAN": "IIIB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Asisten Ahli",
    "GRADE FUNGSIONAL": 8,
    "STRUKTURAL": "[REN126] Pengelola Gugus Kendali Mutu (Fakultas) sebagai Anggota",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Fakultas Hukum dan Ilmu Sosial",
    "POINT POSITION": 200,
    "POINT PERFORMANCE": 509.917,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 709.917,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 1064875.5,
    "PPh 100%": 53243.775,
    "JUMLAH KOTOR 30% (Rp)": 656550,
    "JUMLAH KOTOR 70% (Rp)": 408325.5,
    "PPh 21": 20416.275,
    "JUMLAH BERSIH 70% (Rp)": 387909.225,
    "TANDA TANGAN": 239
  },
  {
    "NIP": "'198307282008121001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "I Gede Budiarta, S.Pd., M.Si.",
    "JURUSAN": "Survey dan Pemetaan (D3)",
    "FAKULTAS": "Fakultas Hukum dan Ilmu Sosial",
    "GOLONGAN": "IIIB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "STRUKTURAL": "Sekretaris Jurusan S1",
    "GRADE STRUKTURAL": 11,
    "UNIT KERJA": "Jurusan Geografi",
    "POINT POSITION": 1645.8,
    "POINT PERFORMANCE": 964.5,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 2610.3,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 3915450,
    "PPh 100%": 195772.5,
    "JUMLAH KOTOR 30% (Rp)": 1527660,
    "JUMLAH KOTOR 70% (Rp)": 2387790,
    "PPh 21": 119389.5,
    "JUMLAH BERSIH 70% (Rp)": 2268400.5,
    "TANDA TANGAN": 240
  },
  {
    "NIP": "'198901202015041001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. I Wayan Krisna Eka Putra, S.Pd., M.Eng.",
    "JURUSAN": "Teknologi Rekayasa Penginderaan Jauh (D4)",
    "FAKULTAS": "Fakultas Hukum dan Ilmu Sosial",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "STRUKTURAL": "Ketua Satuan Pengawas Internal",
    "GRADE STRUKTURAL": 14,
    "UNIT KERJA": "-",
    "POINT POSITION": 10800,
    "POINT PERFORMANCE": 647.646,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 11447.6,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 17171400,
    "PPh 100%": 858570,
    "JUMLAH KOTOR 30% (Rp)": 5647050,
    "JUMLAH KOTOR 70% (Rp)": 11524350,
    "PPh 21": 576217.5,
    "JUMLAH BERSIH 70% (Rp)": 10948132.5,
    "TANDA TANGAN": 241
  },
  {
    "NIP": "'198304242009121005",
    "STATUS SEKARANG": "Ijin Belajar",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "I Gede Yudi Wisnawa, S.Pd., M.Sc.",
    "JURUSAN": "Teknologi Rekayasa Penginderaan Jauh (D4)",
    "FAKULTAS": "Fakultas Hukum dan Ilmu Sosial",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "STRUKTURAL": "Ketua Jurusan S1",
    "GRADE STRUKTURAL": 12,
    "UNIT KERJA": "Jurusan Geografi",
    "POINT POSITION": 1957.15,
    "POINT PERFORMANCE": 1105.17,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 3062.32,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 4593480,
    "PPh 100%": 229674,
    "JUMLAH KOTOR 30% (Rp)": 1667767.5,
    "JUMLAH KOTOR 70% (Rp)": 2925712.5,
    "PPh 21": 146285.625,
    "JUMLAH BERSIH 70% (Rp)": 2779426.875,
    "TANDA TANGAN": 242
  },
  {
    "NIP": "'199102142019031013",
    "STATUS SEKARANG": "Tugas Belajar",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "I Gst Ngr Yoga Jayantara, S.T., M.T.",
    "JURUSAN": "Teknologi Rekayasa Penginderaan Jauh (D4)",
    "FAKULTAS": "Fakultas Hukum dan Ilmu Sosial",
    "GOLONGAN": "IIIC",
    "STATUS PENELITIAN": "TIDAK ADA",
    "STATUS PENGABDIAN": "TIDAK ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "STRUKTURAL": "[REN126] Pengelola Gugus Kendali Mutu (Fakultas) sebagai Anggota",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Fakultas Hukum dan Ilmu Sosial",
    "POINT POSITION": 0,
    "POINT PERFORMANCE": 0,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 0,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 0,
    "PPh 100%": 0,
    "JUMLAH KOTOR 70% (Rp)": 0,
    "PPh 21": 0,
    "JUMLAH BERSIH 70% (Rp)": 0,
    "TANDA TANGAN": 243
  },
  {
    "NIP": "'196912312002121007",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "I Wayan Treman, S.Pd., M.Sc.",
    "JURUSAN": "Teknologi Rekayasa Penginderaan Jauh (D4)",
    "FAKULTAS": "Fakultas Hukum dan Ilmu Sosial",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "STRUKTURAL": "[REN126] Pengelola Gugus Kendali Mutu (Fakultas) sebagai Anggota",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Fakultas Hukum dan Ilmu Sosial",
    "POINT POSITION": 200,
    "POINT PERFORMANCE": 1000,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 1200,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 1800000,
    "PPh 100%": 90000,
    "JUMLAH KOTOR 30% (Rp)": 787050,
    "JUMLAH KOTOR 70% (Rp)": 1012950,
    "PPh 21": 50647.5,
    "JUMLAH BERSIH 70% (Rp)": 962302.5,
    "TANDA TANGAN": 244
  },
  {
    "NIP": "'198911282018031001",
    "STATUS SEKARANG": "Tugas Belajar",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Wayan Damar Windu Kurniawan, S.Si., M.Sc.",
    "JURUSAN": "Teknologi Rekayasa Penginderaan Jauh (D4)",
    "FAKULTAS": "Fakultas Hukum dan Ilmu Sosial",
    "GOLONGAN": "IIIB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "TIDAK ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Asisten Ahli",
    "GRADE FUNGSIONAL": 8,
    "STRUKTURAL": "[REN126] Pengelola Gugus Kendali Mutu (Fakultas) sebagai Anggota",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Fakultas Hukum dan Ilmu Sosial",
    "POINT POSITION": 0,
    "POINT PERFORMANCE": 0,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 0,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 0,
    "PPh 100%": 0,
    "JUMLAH KOTOR 70% (Rp)": 0,
    "PPh 21": 0,
    "JUMLAH BERSIH 70% (Rp)": 0,
    "TANDA TANGAN": 245
  },
  {
    "NIP": "'198406242018031001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. I Wayan Putra Yasa, S.Pd, M.Pd.",
    "JURUSAN": "Pendidikan Sejarah (S1)",
    "FAKULTAS": "Fakultas Hukum dan Ilmu Sosial",
    "GOLONGAN": "IIIC",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "STRUKTURAL": "Sekretaris Jurusan S1",
    "GRADE STRUKTURAL": 11,
    "UNIT KERJA": "Jurusan Sejarah Sosiologi dan Perpustakaan",
    "POINT POSITION": 1899,
    "POINT PERFORMANCE": 1421.67,
    "POINT KELEBIHAN": 305.667,
    "POINT TOTAL": 3626.33,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 5439495,
    "PPh 100%": 271974.75,
    "JUMLAH KOTOR 30% (Rp)": 1641600,
    "JUMLAH KOTOR 70% (Rp)": 3797895,
    "PPh 21": 189894.75,
    "JUMLAH BERSIH 70% (Rp)": 3608000.25,
    "TANDA TANGAN": 246
  },
  {
    "NIP": "'197604122006041001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. Ketut Sedana Arta, S.Pd., M.Pd.",
    "JURUSAN": "Pendidikan Sejarah (S1)",
    "FAKULTAS": "Fakultas Hukum dan Ilmu Sosial",
    "GOLONGAN": "IVA",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor Kepala",
    "GRADE FUNGSIONAL": 11,
    "STRUKTURAL": "Wakil Dekan III",
    "GRADE STRUKTURAL": 14,
    "UNIT KERJA": "Fakultas Hukum dan Ilmu Sosial",
    "POINT POSITION": 9720,
    "POINT PERFORMANCE": 2050.83,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 11770.8,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 17656200,
    "PPh 100%": 2648430,
    "JUMLAH KOTOR 30% (Rp)": 5513400,
    "JUMLAH KOTOR 70% (Rp)": 12142800,
    "PPh 21": 1821420,
    "JUMLAH BERSIH 70% (Rp)": 10321380,
    "TANDA TANGAN": 247
  },
  {
    "NIP": "'196608311993032001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. Tuty Maryati, M.Pd.",
    "JURUSAN": "Pendidikan Sejarah (S1)",
    "FAKULTAS": "Fakultas Hukum dan Ilmu Sosial",
    "GOLONGAN": "IVB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor Kepala",
    "GRADE FUNGSIONAL": 11,
    "STRUKTURAL": "[REN126] Pengelola Gugus Kendali Mutu (Fakultas) sebagai Anggota",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Pendidikan Ilmu Pengetahuan Sosial (S2)",
    "POINT POSITION": 200,
    "POINT PERFORMANCE": 2333.17,
    "POINT KELEBIHAN": 84.2333,
    "POINT TOTAL": 2617.4,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 3926100,
    "PPh 100%": 588915,
    "JUMLAH KOTOR 30% (Rp)": 1229400,
    "JUMLAH KOTOR 70% (Rp)": 2696700,
    "PPh 21": 404505,
    "JUMLAH BERSIH 70% (Rp)": 2292195,
    "TANDA TANGAN": 248
  },
  {
    "NIP": "'196805171993032002",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dra. Desak Made Oka Purnawati, M.Hum.",
    "JURUSAN": "Pendidikan Sejarah (S1)",
    "FAKULTAS": "Fakultas Hukum dan Ilmu Sosial",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "STRUKTURAL": "Koordinator Program Studi S1/D3",
    "GRADE STRUKTURAL": 11,
    "UNIT KERJA": "Pendidikan Sejarah (S1)",
    "POINT POSITION": 1645.8,
    "POINT PERFORMANCE": 1197.76,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 2843.56,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 4265340,
    "PPh 100%": 213267,
    "JUMLAH KOTOR 30% (Rp)": 1527660,
    "JUMLAH KOTOR 70% (Rp)": 2737680,
    "PPh 21": 136884,
    "JUMLAH BERSIH 70% (Rp)": 2600796,
    "TANDA TANGAN": 249
  },
  {
    "NIP": "'198908142023211022",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PPPK",
    "NAMA DOSEN": "I Putu Hendra Mas Martayana, S.Pd., M.A",
    "JURUSAN": "Pendidikan Sejarah (S1)",
    "FAKULTAS": "Fakultas Hukum dan Ilmu Sosial",
    "GOLONGAN": "X",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Asisten Ahli",
    "GRADE FUNGSIONAL": 8,
    "STRUKTURAL": "[REN126] Pengelola Gugus Kendali Mutu (Fakultas) sebagai Anggota",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Fakultas Hukum dan Ilmu Sosial",
    "POINT POSITION": 200,
    "POINT PERFORMANCE": 1109,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 1309,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 1963500,
    "PPh 100%": 98175,
    "JUMLAH KOTOR 30% (Rp)": 656550,
    "JUMLAH KOTOR 70% (Rp)": 1306950,
    "PPh 21": 65347.5,
    "JUMLAH BERSIH 70% (Rp)": 1241602.5,
    "TANDA TANGAN": 250
  },
  {
    "NIP": "'199006082019031009",
    "STATUS SEKARANG": "Ijin Belajar",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "I Wayan Pardi, S.Pd., M.Pd.",
    "JURUSAN": "Pendidikan Sejarah (S1)",
    "FAKULTAS": "Fakultas Hukum dan Ilmu Sosial",
    "GOLONGAN": "IIIC",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "STRUKTURAL": "Ketua Jurusan S1",
    "GRADE STRUKTURAL": 12,
    "UNIT KERJA": "Jurusan Sejarah Sosiologi dan Perpustakaan",
    "POINT POSITION": 2258.25,
    "POINT PERFORMANCE": 1347.67,
    "POINT KELEBIHAN": 216.368,
    "POINT TOTAL": 3822.28,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 5733420,
    "PPh 100%": 286671,
    "JUMLAH KOTOR 30% (Rp)": 1803262.5,
    "JUMLAH KOTOR 70% (Rp)": 3930157.5,
    "PPh 21": 196507.875,
    "JUMLAH BERSIH 70% (Rp)": 3733649.625,
    "TANDA TANGAN": 251
  },
  {
    "NIP": "'199112052020121013",
    "STATUS SEKARANG": "Tugas Belajar",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "R. Ahmad Ginanjar Purnawibawa, M.Hum.",
    "JURUSAN": "Pendidikan Sejarah (S1)",
    "FAKULTAS": "Fakultas Hukum dan Ilmu Sosial",
    "GOLONGAN": "IIIB",
    "STATUS PENELITIAN": "TIDAK ADA",
    "STATUS PENGABDIAN": "TIDAK ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Asisten Ahli",
    "GRADE FUNGSIONAL": 8,
    "UNIT KERJA": "-",
    "POINT POSITION": 0,
    "POINT PERFORMANCE": 0,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 0,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 0,
    "PPh 100%": 0,
    "JUMLAH KOTOR 70% (Rp)": 0,
    "PPh 21": 0,
    "JUMLAH BERSIH 70% (Rp)": 0,
    "TANDA TANGAN": 252
  },
  {
    "NIP": "'198911012018031001",
    "STATUS SEKARANG": "Tugas Belajar",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. A. Sediyo Adi Nugraha, S.Si., M.Sc.",
    "JURUSAN": "Pendidikan Geografi (S1)",
    "FAKULTAS": "Fakultas Hukum dan Ilmu Sosial",
    "GOLONGAN": "IIIB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Asisten Ahli",
    "GRADE FUNGSIONAL": 8,
    "STRUKTURAL": "[REN126] Pengelola Gugus Kendali Mutu (Fakultas) sebagai Anggota",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Fakultas Hukum dan Ilmu Sosial",
    "POINT POSITION": 200,
    "POINT PERFORMANCE": 0,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 200,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 300000,
    "PPh 100%": 15000,
    "JUMLAH KOTOR 70% (Rp)": 300000,
    "PPh 21": 15000,
    "JUMLAH BERSIH 70% (Rp)": 285000,
    "TANDA TANGAN": 253
  },
  {
    "NIP": "'196212311994031009",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. Drs. Dewa Made Atmaja, M.Si.",
    "JURUSAN": "Pendidikan Geografi (S1)",
    "FAKULTAS": "Fakultas Hukum dan Ilmu Sosial",
    "GOLONGAN": "IVC",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor Kepala",
    "GRADE FUNGSIONAL": 11,
    "STRUKTURAL": "Koordinator Program Studi S1/D3",
    "GRADE STRUKTURAL": 11,
    "UNIT KERJA": "Teknologi Rekayasa Penginderaan Jauh (D4)",
    "POINT POSITION": 1645.8,
    "POINT PERFORMANCE": 2044,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 3689.8,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 5534700,
    "PPh 100%": 830205,
    "JUMLAH KOTOR 30% (Rp)": 1880010,
    "JUMLAH KOTOR 70% (Rp)": 3654690,
    "PPh 21": 548203.5,
    "JUMLAH BERSIH 70% (Rp)": 3106486.5,
    "TANDA TANGAN": 254
  },
  {
    "NIP": "'198408182008121001",
    "STATUS SEKARANG": "Ijin Belajar",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. I Putu Ananda Citra, S.Pd. M.Sc.",
    "JURUSAN": "Pendidikan Geografi (S1)",
    "FAKULTAS": "Fakultas Hukum dan Ilmu Sosial",
    "GOLONGAN": "IVA",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor Kepala",
    "GRADE FUNGSIONAL": 11,
    "STRUKTURAL": "Wakil Dekan II",
    "GRADE STRUKTURAL": 14,
    "UNIT KERJA": "Fakultas Hukum dan Ilmu Sosial",
    "POINT POSITION": 9720,
    "POINT PERFORMANCE": 2005.17,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 11725.2,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 17587800,
    "PPh 100%": 2638170,
    "JUMLAH KOTOR 30% (Rp)": 5513400,
    "JUMLAH KOTOR 70% (Rp)": 12074400,
    "PPh 21": 1811160,
    "JUMLAH BERSIH 70% (Rp)": 10263240,
    "TANDA TANGAN": 255
  },
  {
    "NIP": "'198905232015041003",
    "STATUS SEKARANG": "Tugas Belajar",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "I Made Sarmita, S.Pd., M.Sc.",
    "JURUSAN": "Pendidikan Geografi (S1)",
    "FAKULTAS": "Fakultas Hukum dan Ilmu Sosial",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "STRUKTURAL": "[REN126] Pengelola Gugus Kendali Mutu (Fakultas) sebagai Anggota",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Fakultas Hukum dan Ilmu Sosial",
    "POINT POSITION": 200,
    "POINT PERFORMANCE": 0,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 200,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 300000,
    "PPh 100%": 15000,
    "JUMLAH KOTOR 70% (Rp)": 300000,
    "PPh 21": 15000,
    "JUMLAH BERSIH 70% (Rp)": 285000,
    "TANDA TANGAN": 256
  },
  {
    "NIP": "'195808191986011001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Prof. Dr. Ida Bagus Made Astawa, M.Si.",
    "JURUSAN": "Pendidikan Geografi (S1)",
    "FAKULTAS": "Fakultas Hukum dan Ilmu Sosial",
    "GOLONGAN": "IVD",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Guru Besar",
    "GRADE FUNGSIONAL": 12,
    "UNIT KERJA": "-",
    "POINT PERFORMANCE": 2405.17,
    "POINT KELEBIHAN": 514.527,
    "POINT TOTAL": 2919.69,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 4379535,
    "PPh 100%": 656930.25,
    "JUMLAH KOTOR 30% (Rp)": 1354950,
    "JUMLAH KOTOR 70% (Rp)": 3024585,
    "PPh 21": 453687.75,
    "JUMLAH BERSIH 70% (Rp)": 2570897.25,
    "TANDA TANGAN": 257
  },
  {
    "NIP": "'198707172014041002",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Putu Indra Christiawan, S.Pd., M.Sc., Ph.D.",
    "JURUSAN": "Pendidikan Geografi (S1)",
    "FAKULTAS": "Fakultas Hukum dan Ilmu Sosial",
    "GOLONGAN": "IVA",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor Kepala",
    "GRADE FUNGSIONAL": 11,
    "STRUKTURAL": "[REN222] Kepala Pusat /Kantor/Kepala Gugus Kendali Mutu Fakultas/Ketua Unit Pengelolaan dan Penerimaan Mahasiswa Asing/ Ketua Unit Pengembangan dan Peningkatan Kapasitas Kelembagaan",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Fakultas Hukum dan Ilmu Sosial",
    "POINT POSITION": 1150,
    "POINT PERFORMANCE": 1965.5,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 3115.5,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 4673250,
    "PPh 100%": 700987.5,
    "JUMLAH KOTOR 30% (Rp)": 1656900,
    "JUMLAH KOTOR 70% (Rp)": 3016350,
    "PPh 21": 452452.5,
    "JUMLAH BERSIH 70% (Rp)": 2563897.5,
    "TANDA TANGAN": 258
  },
  {
    "NIP": "'198705142020122005",
    "STATUS SEKARANG": "Ijin Belajar",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Anak Agung Istri Dewi Adhi Utami, S.Pd.,M.Pd",
    "JURUSAN": "Pendidikan Pancasila dan Kewarganegaraan (S1)",
    "FAKULTAS": "Fakultas Hukum dan Ilmu Sosial",
    "GOLONGAN": "IIIC",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "STRUKTURAL": "Sekretaris Jurusan S1",
    "GRADE STRUKTURAL": 11,
    "UNIT KERJA": "Jurusan Hukum dan Kewarganegaraan",
    "POINT POSITION": 2152.2,
    "POINT PERFORMANCE": 1368,
    "POINT KELEBIHAN": 401.733,
    "POINT TOTAL": 3921.93,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 5882895,
    "PPh 100%": 294144.75,
    "JUMLAH KOTOR 30% (Rp)": 1755540,
    "JUMLAH KOTOR 70% (Rp)": 4127355,
    "PPh 21": 206367.75,
    "JUMLAH BERSIH 70% (Rp)": 3920987.25,
    "TANDA TANGAN": 259
  },
  {
    "NIP": "'199103112019031016",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. I Putu Windu Mertha Sujana, S.Pd., M.Pd.",
    "JURUSAN": "Pendidikan Pancasila dan Kewarganegaraan (S1)",
    "FAKULTAS": "Fakultas Hukum dan Ilmu Sosial",
    "GOLONGAN": "IIIC",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "STRUKTURAL": "Koordinator Program Studi S1/D3",
    "GRADE STRUKTURAL": 11,
    "UNIT KERJA": "Pendidikan Pancasila dan Kewarganegaraan (S1)",
    "POINT POSITION": 1645.8,
    "POINT PERFORMANCE": 1395.33,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 3041.13,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 4561695,
    "PPh 100%": 228084.75,
    "JUMLAH KOTOR 30% (Rp)": 1527660,
    "JUMLAH KOTOR 70% (Rp)": 3034035,
    "PPh 21": 151701.75,
    "JUMLAH BERSIH 70% (Rp)": 2882333.25,
    "TANDA TANGAN": 260
  },
  {
    "NIP": "'196012311986031018",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Drs. I Wayan Landrawan, M.Si.",
    "JURUSAN": "Pendidikan Pancasila dan Kewarganegaraan (S1)",
    "FAKULTAS": "Fakultas Hukum dan Ilmu Sosial",
    "GOLONGAN": "IVC",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor Kepala",
    "GRADE FUNGSIONAL": 11,
    "UNIT KERJA": "-",
    "POINT PERFORMANCE": 2226,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 2226,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 3339000,
    "PPh 100%": 500850,
    "JUMLAH KOTOR 30% (Rp)": 1139400,
    "JUMLAH KOTOR 70% (Rp)": 2199600,
    "PPh 21": 329940,
    "JUMLAH BERSIH 70% (Rp)": 1869660,
    "TANDA TANGAN": 261
  },
  {
    "NIP": "'198208062024211001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PPPK",
    "NAMA DOSEN": "I Wayan Budiarta, M.Pd",
    "JURUSAN": "Pendidikan Pancasila dan Kewarganegaraan (S1)",
    "FAKULTAS": "Fakultas Hukum dan Ilmu Sosial",
    "GOLONGAN": "X",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Asisten Ahli",
    "GRADE FUNGSIONAL": 8,
    "STRUKTURAL": "[REN223] Sekretaris Pusat/ Ketua Divisi/ Asrama/ Koordinator Lab. Jurusan Kepala Unit BPU/ Sekretaris Gugus Kendali Mutu Fakultas/ Sekretaris Tim Pengelolaan dan Penerimaan Mahasiswa Asing/ Sekretaris Unit Pengembangan dan Peningkatan Kapasitas Kelembagaan",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Fakultas Hukum dan Ilmu Sosial",
    "POINT POSITION": 800,
    "POINT PERFORMANCE": 1141,
    "POINT KELEBIHAN": 335.8,
    "POINT TOTAL": 2276.8,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 3415200,
    "PPh 100%": 170760,
    "JUMLAH KOTOR 30% (Rp)": 1016550,
    "JUMLAH KOTOR 70% (Rp)": 2398650,
    "PPh 21": 119932.5,
    "JUMLAH BERSIH 70% (Rp)": 2278717.5,
    "TANDA TANGAN": 262
  },
  {
    "NIP": "'198709152022032003",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Ni Nyoman Asri Sidaryanti, M.Pd.",
    "JURUSAN": "Pendidikan Pancasila dan Kewarganegaraan (S1)",
    "FAKULTAS": "Fakultas Hukum dan Ilmu Sosial",
    "GOLONGAN": "IIIB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Asisten Ahli",
    "GRADE FUNGSIONAL": 8,
    "STRUKTURAL": "[REN223] Sekretaris Pusat/ Ketua Divisi/ Asrama/ Koordinator Lab. Jurusan Kepala Unit BPU/ Sekretaris Gugus Kendali Mutu Fakultas/ Sekretaris Tim Pengelolaan dan Penerimaan Mahasiswa Asing/ Sekretaris Unit Pengembangan dan Peningkatan Kapasitas Kelembagaan",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Fakultas Hukum dan Ilmu Sosial",
    "POINT POSITION": 800,
    "POINT PERFORMANCE": 1082.67,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 1882.67,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 2824005,
    "PPh 100%": 141200.25,
    "JUMLAH KOTOR 30% (Rp)": 1016550,
    "JUMLAH KOTOR 70% (Rp)": 1807455,
    "PPh 21": 90372.75,
    "JUMLAH BERSIH 70% (Rp)": 1717082.25,
    "TANDA TANGAN": 263
  },
  {
    "NIP": "'199501112022031008",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Alif Alfi Syahrin, M.Pd.",
    "JURUSAN": "Pendidikan Sosiologi (S1)",
    "FAKULTAS": "Fakultas Hukum dan Ilmu Sosial",
    "GOLONGAN": "IIIB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Asisten Ahli",
    "GRADE FUNGSIONAL": 8,
    "UNIT KERJA": "-",
    "POINT PERFORMANCE": 1099.67,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 1099.67,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 1649505,
    "PPh 100%": 82475.25,
    "JUMLAH KOTOR 30% (Rp)": 656550,
    "JUMLAH KOTOR 70% (Rp)": 992955,
    "PPh 21": 49647.75,
    "JUMLAH BERSIH 70% (Rp)": 943307.25,
    "TANDA TANGAN": 264
  },
  {
    "NIP": "'196312312002121044",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. I Ketut Margi, M.Si.",
    "JURUSAN": "Pendidikan Sosiologi (S1)",
    "FAKULTAS": "Fakultas Hukum dan Ilmu Sosial",
    "GOLONGAN": "IVB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor Kepala",
    "GRADE FUNGSIONAL": 11,
    "UNIT KERJA": "-",
    "POINT PERFORMANCE": 1412.62,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 1412.62,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 2118930,
    "PPh 100%": 317839.5,
    "JUMLAH KOTOR 30% (Rp)": 1139400,
    "JUMLAH KOTOR 70% (Rp)": 979530,
    "PPh 21": 146929.5,
    "JUMLAH BERSIH 70% (Rp)": 832600.5,
    "TANDA TANGAN": 265
  },
  {
    "NIP": "'199211142022032006",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Fitri Noviani, M.Pd.",
    "JURUSAN": "Pendidikan Sosiologi (S1)",
    "FAKULTAS": "Fakultas Hukum dan Ilmu Sosial",
    "GOLONGAN": "IIIB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Asisten Ahli",
    "GRADE FUNGSIONAL": 8,
    "STRUKTURAL": "[REN126] Pengelola Gugus Kendali Mutu (Fakultas) sebagai Anggota",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Fakultas Hukum dan Ilmu Sosial",
    "POINT POSITION": 200,
    "POINT PERFORMANCE": 985,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 1185,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 1777500,
    "PPh 100%": 88875,
    "JUMLAH KOTOR 30% (Rp)": 656550,
    "JUMLAH KOTOR 70% (Rp)": 1120950,
    "PPh 21": 56047.5,
    "JUMLAH BERSIH 70% (Rp)": 1064902.5,
    "TANDA TANGAN": 266
  },
  {
    "NIP": "'198505162020121008",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Irwan Nur, S.Sos., M.Pd.",
    "JURUSAN": "Pendidikan Sosiologi (S1)",
    "FAKULTAS": "Fakultas Hukum dan Ilmu Sosial",
    "GOLONGAN": "IIIC",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "STRUKTURAL": "Koordinator Program Studi S1/D3",
    "GRADE STRUKTURAL": 11,
    "UNIT KERJA": "Pendidikan Sosiologi (S1)",
    "POINT POSITION": 1645.8,
    "POINT PERFORMANCE": 1323.67,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 2969.47,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 4454205,
    "PPh 100%": 222710.25,
    "JUMLAH KOTOR 30% (Rp)": 1527660,
    "JUMLAH KOTOR 70% (Rp)": 2926545,
    "PPh 21": 146327.25,
    "JUMLAH BERSIH 70% (Rp)": 2780217.75,
    "TANDA TANGAN": 267
  },
  {
    "NIP": "'198704262020122011",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Lola Utama Sitompul, S.Sos., M.Si.",
    "JURUSAN": "Pendidikan Sosiologi (S1)",
    "FAKULTAS": "Fakultas Hukum dan Ilmu Sosial",
    "GOLONGAN": "IIIB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "STRUKTURAL": "[REN223] Sekretaris Pusat/ Ketua Divisi/ Asrama/ Koordinator Lab. Jurusan Kepala Unit BPU/ Sekretaris Gugus Kendali Mutu Fakultas/ Sekretaris Tim Pengelolaan dan Penerimaan Mahasiswa Asing/ Sekretaris Unit Pengembangan dan Peningkatan Kapasitas Kelembagaan",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "-",
    "POINT POSITION": 800,
    "POINT PERFORMANCE": 1158.17,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 1958.17,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 2937255,
    "PPh 100%": 146862.75,
    "JUMLAH KOTOR 30% (Rp)": 1147050,
    "JUMLAH KOTOR 70% (Rp)": 1790205,
    "PPh 21": 89510.25,
    "JUMLAH BERSIH 70% (Rp)": 1700694.75,
    "TANDA TANGAN": 268
  },
  {
    "NIP": "'199312232022031009",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Muhammad Idris, M.Pd.",
    "JURUSAN": "Pendidikan Sosiologi (S1)",
    "FAKULTAS": "Fakultas Hukum dan Ilmu Sosial",
    "GOLONGAN": "IIIB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Asisten Ahli",
    "GRADE FUNGSIONAL": 8,
    "STRUKTURAL": "[REN126] Pengelola Gugus Kendali Mutu (Fakultas) sebagai Anggota",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Fakultas Hukum dan Ilmu Sosial",
    "POINT POSITION": 200,
    "POINT PERFORMANCE": 1073.5,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 1273.5,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 1910250,
    "PPh 100%": 95512.5,
    "JUMLAH KOTOR 30% (Rp)": 746550,
    "JUMLAH KOTOR 70% (Rp)": 1163700,
    "PPh 21": 58185,
    "JUMLAH BERSIH 70% (Rp)": 1105515,
    "TANDA TANGAN": 269
  },
  {
    "NIP": "'196112081986032001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Prof. Dr. Luh Putu Sendratari, M.Hum.",
    "JURUSAN": "Pendidikan Sosiologi (S1)",
    "FAKULTAS": "Fakultas Hukum dan Ilmu Sosial",
    "GOLONGAN": "IVC",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Guru Besar",
    "GRADE FUNGSIONAL": 12,
    "STRUKTURAL": "[REN222] Kepala Pusat /Kantor/Kepala Gugus Kendali Mutu Fakultas/Ketua Unit Pengelolaan dan Penerimaan Mahasiswa Asing/ Ketua Unit Pengembangan dan Peningkatan Kapasitas Kelembagaan",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "-",
    "POINT POSITION": 1150,
    "POINT PERFORMANCE": 2659.67,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 3809.67,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 5714505,
    "PPh 100%": 857175.75,
    "JUMLAH KOTOR 30% (Rp)": 1872450,
    "JUMLAH KOTOR 70% (Rp)": 3842055,
    "PPh 21": 576308.25,
    "JUMLAH BERSIH 70% (Rp)": 3265746.75,
    "TANDA TANGAN": 270
  },
  {
    "NIP": "'198402092005012002",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. Komang Febrinayanti Dantes, S.H.,M.Kn",
    "JURUSAN": "Ilmu Hukum (S1)",
    "FAKULTAS": "Fakultas Hukum dan Ilmu Sosial",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "STRUKTURAL": "Koordinator Program Studi S1/D3",
    "GRADE STRUKTURAL": 11,
    "UNIT KERJA": "Ilmu Hukum (S1)",
    "POINT POSITION": 1899,
    "POINT PERFORMANCE": 1716,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 3615,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 5422500,
    "PPh 100%": 271125,
    "JUMLAH KOTOR 30% (Rp)": 1641600,
    "JUMLAH KOTOR 70% (Rp)": 3780900,
    "PPh 21": 189045,
    "JUMLAH BERSIH 70% (Rp)": 3591855,
    "TANDA TANGAN": 271
  },
  {
    "NIP": "'199003232018031001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. Made Sugi Hartono, S.H., M.H.",
    "JURUSAN": "Ilmu Hukum (S1)",
    "FAKULTAS": "Fakultas Hukum dan Ilmu Sosial",
    "GOLONGAN": "IIIC",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "STRUKTURAL": "Ketua Jurusan S1",
    "GRADE STRUKTURAL": 12,
    "UNIT KERJA": "Jurusan Hukum dan Kewarganegaraan",
    "POINT POSITION": 2559.35,
    "POINT PERFORMANCE": 1716,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 4275.35,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 6413025,
    "PPh 100%": 320651.25,
    "JUMLAH KOTOR 30% (Rp)": 1938757.5,
    "JUMLAH KOTOR 70% (Rp)": 4474267.5,
    "PPh 21": 223713.375,
    "JUMLAH BERSIH 70% (Rp)": 4250554.125,
    "TANDA TANGAN": 272
  },
  {
    "NIP": "'198202042009122004",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. Ni Ketut Sari Adnyani, S.Pd., M.Hum.",
    "JURUSAN": "Ilmu Hukum (S1)",
    "FAKULTAS": "Fakultas Hukum dan Ilmu Sosial",
    "GOLONGAN": "IVB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor Kepala",
    "GRADE FUNGSIONAL": 11,
    "STRUKTURAL": "Sekretaris Program Studi S2",
    "GRADE STRUKTURAL": 11,
    "UNIT KERJA": "Hukum (S2)",
    "POINT POSITION": 2152.2,
    "POINT PERFORMANCE": 2378.17,
    "POINT KELEBIHAN": 582.667,
    "POINT TOTAL": 5113.03,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 7669545,
    "PPh 100%": 1150431.75,
    "JUMLAH KOTOR 30% (Rp)": 2107890,
    "JUMLAH KOTOR 70% (Rp)": 5561655,
    "PPh 21": 834248.25,
    "JUMLAH BERSIH 70% (Rp)": 4727406.75,
    "TANDA TANGAN": 273
  },
  {
    "NIP": "'198307162008122003",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. Ni Putu Rai Yuliartini, S.H., M.H.",
    "JURUSAN": "Ilmu Hukum (S1)",
    "FAKULTAS": "Fakultas Hukum dan Ilmu Sosial",
    "GOLONGAN": "IVA",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor Kepala",
    "GRADE FUNGSIONAL": 11,
    "UNIT KERJA": "-",
    "POINT PERFORMANCE": 2250.17,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 2250.17,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 3375255,
    "PPh 100%": 506288.25,
    "JUMLAH KOTOR 30% (Rp)": 1139400,
    "JUMLAH KOTOR 70% (Rp)": 2235855,
    "PPh 21": 335378.25,
    "JUMLAH BERSIH 70% (Rp)": 1900476.75,
    "TANDA TANGAN": 274
  },
  {
    "NIP": "'198312152008122003",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. Ratna Artha Windari, S.H., M.H.",
    "JURUSAN": "Ilmu Hukum (S1)",
    "FAKULTAS": "Fakultas Hukum dan Ilmu Sosial",
    "GOLONGAN": "IVA",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor Kepala",
    "GRADE FUNGSIONAL": 11,
    "STRUKTURAL": "Koordinator Program Studi S2",
    "GRADE STRUKTURAL": 12,
    "UNIT KERJA": "Hukum (S2)",
    "POINT POSITION": 2559.35,
    "POINT PERFORMANCE": 2361.33,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 4920.68,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 7381020,
    "PPh 100%": 1107153,
    "JUMLAH KOTOR 30% (Rp)": 2291107.5,
    "JUMLAH KOTOR 70% (Rp)": 5089912.5,
    "PPh 21": 763486.875,
    "JUMLAH BERSIH 70% (Rp)": 4326425.625,
    "TANDA TANGAN": 275
  },
  {
    "NIP": "'198808102019031009",
    "STATUS SEKARANG": "Ijin Belajar",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. Si Ngurah Ardhya, S.H., M.H.",
    "JURUSAN": "Ilmu Hukum (S1)",
    "FAKULTAS": "Fakultas Hukum dan Ilmu Sosial",
    "GOLONGAN": "IIIC",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "STRUKTURAL": "Anggota Satuan Pengawas Internal",
    "GRADE STRUKTURAL": 11,
    "UNIT KERJA": "-",
    "POINT POSITION": 2532,
    "POINT PERFORMANCE": 1716,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 4248,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 6372000,
    "PPh 100%": 318600,
    "JUMLAH KOTOR 30% (Rp)": 1926450,
    "JUMLAH KOTOR 70% (Rp)": 4445550,
    "PPh 21": 222277.5,
    "JUMLAH BERSIH 70% (Rp)": 4223272.5,
    "TANDA TANGAN": 276
  },
  {
    "NIP": "'199203182022031002",
    "STATUS SEKARANG": "Ijin Belajar",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "I Dewa Gede Herman Yudiawan, M.H.",
    "JURUSAN": "Ilmu Hukum (S1)",
    "FAKULTAS": "Fakultas Hukum dan Ilmu Sosial",
    "GOLONGAN": "IIIB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Asisten Ahli",
    "GRADE FUNGSIONAL": 8,
    "STRUKTURAL": "[REN126] Pengelola Gugus Kendali Mutu (Fakultas) sebagai Anggota",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Fakultas Hukum dan Ilmu Sosial",
    "POINT POSITION": 200,
    "POINT PERFORMANCE": 1272.67,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 1472.67,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 2209005,
    "PPh 100%": 110450.25,
    "JUMLAH KOTOR 30% (Rp)": 656550,
    "JUMLAH KOTOR 70% (Rp)": 1552455,
    "PPh 21": 77622.75,
    "JUMLAH BERSIH 70% (Rp)": 1474832.25,
    "TANDA TANGAN": 277
  },
  {
    "NIP": "'199001212023212041",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PPPK",
    "NAMA DOSEN": "I Gusti Ayu Apsari Hadi, S.H.,M.H",
    "JURUSAN": "Ilmu Hukum (S1)",
    "FAKULTAS": "Fakultas Hukum dan Ilmu Sosial",
    "GOLONGAN": "X",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Asisten Ahli",
    "GRADE FUNGSIONAL": 8,
    "STRUKTURAL": "[REN126] Pengelola Gugus Kendali Mutu (Fakultas) sebagai Anggota",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Fakultas Hukum dan Ilmu Sosial",
    "POINT POSITION": 200,
    "POINT PERFORMANCE": 1312.5,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 1512.5,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 2268750,
    "PPh 100%": 113437.5,
    "JUMLAH KOTOR 30% (Rp)": 656550,
    "JUMLAH KOTOR 70% (Rp)": 1612200,
    "PPh 21": 80610,
    "JUMLAH BERSIH 70% (Rp)": 1531590,
    "TANDA TANGAN": 278
  },
  {
    "NIP": "'199005272019031015",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Muhamad Jodi Setianto, S.H.,M.H.",
    "JURUSAN": "Ilmu Hukum (S1)",
    "FAKULTAS": "Fakultas Hukum dan Ilmu Sosial",
    "GOLONGAN": "IIIC",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "UNIT KERJA": "-",
    "POINT PERFORMANCE": 1393.33,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 1393.33,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 2089995,
    "PPh 100%": 104499.75,
    "JUMLAH KOTOR 30% (Rp)": 787050,
    "JUMLAH KOTOR 70% (Rp)": 1302945,
    "PPh 21": 65147.25,
    "JUMLAH BERSIH 70% (Rp)": 1237797.75,
    "TANDA TANGAN": 279
  },
  {
    "NIP": "'199709022024062001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Ni Komang Irma Adi Sukmaningsih, M.H.",
    "JURUSAN": "Ilmu Hukum (S1)",
    "FAKULTAS": "Fakultas Hukum dan Ilmu Sosial",
    "GOLONGAN": "IIIB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Tenaga Pengajar",
    "GRADE FUNGSIONAL": 7,
    "UNIT KERJA": "-",
    "POINT PERFORMANCE": 775.5,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 775.5,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 1163250,
    "PPh 100%": 58162.5,
    "JUMLAH KOTOR 30% (Rp)": 545400,
    "JUMLAH KOTOR 70% (Rp)": 617850,
    "PPh 21": 30892.5,
    "JUMLAH BERSIH 70% (Rp)": 586957.5,
    "TANDA TANGAN": 280
  },
  {
    "NIP": "'196312061990112001",
    "STATUS SEKARANG": "Ijin Belajar",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Ni Luh Wayan Yasmiati, S.H., M.Pd.",
    "JURUSAN": "Ilmu Hukum (S1)",
    "FAKULTAS": "Fakultas Hukum dan Ilmu Sosial",
    "GOLONGAN": "IVD",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "STRUKTURAL": "[REN221] Anggota Tim Ahli Rektor/SP4/ Sekretaris Balingkang Confucius Institute/ Sekretaris Unit Kerjasama",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "-",
    "POINT POSITION": 1300,
    "POINT PERFORMANCE": 1177.5,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 2477.5,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 3716250,
    "PPh 100%": 557437.5,
    "JUMLAH KOTOR 30% (Rp)": 1372050,
    "JUMLAH KOTOR 70% (Rp)": 2344200,
    "PPh 21": 351630,
    "JUMLAH BERSIH 70% (Rp)": 1992570,
    "TANDA TANGAN": 281
  },
  {
    "NIP": "'199704192024062002",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Ni Putu Ega Parwati, S.H., M.H.",
    "JURUSAN": "Ilmu Hukum (S1)",
    "FAKULTAS": "Fakultas Hukum dan Ilmu Sosial",
    "GOLONGAN": "IIIB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Tenaga Pengajar",
    "GRADE FUNGSIONAL": 7,
    "UNIT KERJA": "-",
    "POINT PERFORMANCE": 895.667,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 895.667,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 1343500.5,
    "PPh 100%": 67175.025,
    "JUMLAH KOTOR 30% (Rp)": 545400,
    "JUMLAH KOTOR 70% (Rp)": 798100.5,
    "PPh 21": 39905.025,
    "JUMLAH BERSIH 70% (Rp)": 758195.475,
    "TANDA TANGAN": 282
  },
  {
    "NIP": "'198412272009121007",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Prof. Dr. Dewa Gede Sudika Mangku, S.H., LL.M.",
    "JURUSAN": "Ilmu Hukum (S1)",
    "FAKULTAS": "Fakultas Hukum dan Ilmu Sosial",
    "GOLONGAN": "IVA",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Guru Besar",
    "GRADE FUNGSIONAL": 12,
    "STRUKTURAL": "Wakil Dekan I",
    "GRADE STRUKTURAL": 14,
    "UNIT KERJA": "Fakultas Hukum dan Ilmu Sosial",
    "POINT POSITION": 9720,
    "POINT PERFORMANCE": 2735,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 12455,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 18682500,
    "PPh 100%": 2802375,
    "JUMLAH KOTOR 30% (Rp)": 5728950,
    "JUMLAH KOTOR 70% (Rp)": 12953550,
    "PPh 21": 1943032.5,
    "JUMLAH BERSIH 70% (Rp)": 11010517.5,
    "TANDA TANGAN": 283
  },
  {
    "NIP": "'199711052024061001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Putu Riski Ananda Kusuma, S.H., M.H.",
    "JURUSAN": "Ilmu Hukum (S1)",
    "FAKULTAS": "Fakultas Hukum dan Ilmu Sosial",
    "GOLONGAN": "IIIB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Tenaga Pengajar",
    "GRADE FUNGSIONAL": 7,
    "UNIT KERJA": "-",
    "POINT PERFORMANCE": 836.833,
    "POINT KELEBIHAN": 279.067,
    "POINT TOTAL": 1115.9,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 1673850,
    "PPh 100%": 83692.5,
    "JUMLAH KOTOR 30% (Rp)": 545400,
    "JUMLAH KOTOR 70% (Rp)": 1128450,
    "PPh 21": 56422.5,
    "JUMLAH BERSIH 70% (Rp)": 1072027.5,
    "TANDA TANGAN": 284
  },
  {
    "NIP": "'198811132022031005",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "I Gede Putu Eka Suryana, S.Pd., M.Sc.",
    "JURUSAN": "Geografi (S1)",
    "FAKULTAS": "Fakultas Hukum dan Ilmu Sosial",
    "GOLONGAN": "IIIB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Asisten Ahli",
    "GRADE FUNGSIONAL": 8,
    "STRUKTURAL": "Koordinator Program Studi S1/D3",
    "GRADE STRUKTURAL": 11,
    "UNIT KERJA": "Geografi (S1)",
    "POINT POSITION": 1645.8,
    "POINT PERFORMANCE": 777.062,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 2422.86,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 3634290,
    "PPh 100%": 181714.5,
    "JUMLAH KOTOR 30% (Rp)": 1397160,
    "JUMLAH KOTOR 70% (Rp)": 2237130,
    "PPh 21": 111856.5,
    "JUMLAH BERSIH 70% (Rp)": 2125273.5,
    "TANDA TANGAN": 285
  },
  {
    "NIP": "'199403212022031007",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Made Dwipayana, S.Pd., M.Sc.",
    "JURUSAN": "Geografi (S1)",
    "FAKULTAS": "Fakultas Hukum dan Ilmu Sosial",
    "GOLONGAN": "IIIB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Asisten Ahli",
    "GRADE FUNGSIONAL": 8,
    "STRUKTURAL": "Koordinator Program Studi S1/D3",
    "GRADE STRUKTURAL": 11,
    "UNIT KERJA": "Pendidikan Geografi (S1)",
    "POINT POSITION": 1645.8,
    "POINT PERFORMANCE": 292,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 1937.8,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 2906700,
    "PPh 100%": 145335,
    "JUMLAH KOTOR 30% (Rp)": 1397160,
    "JUMLAH KOTOR 70% (Rp)": 1509540,
    "PPh 21": 75477,
    "JUMLAH BERSIH 70% (Rp)": 1434063,
    "TANDA TANGAN": 286
  },
  {
    "NIP": "'198708042015041001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. Agus Aan Jiwa Permana, S.Kom., M.Cs.",
    "JURUSAN": "Teknologi Rekayasa Perangkat Lunak (D4)",
    "FAKULTAS": "Fakultas Teknik dan Kejuruan",
    "GOLONGAN": "IVA",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor Kepala",
    "GRADE FUNGSIONAL": 11,
    "STRUKTURAL": "Ketua Laboratorium Fakultas",
    "GRADE STRUKTURAL": 12,
    "UNIT KERJA": "Fakultas Teknik dan Kejuruan",
    "POINT POSITION": 2709.9,
    "POINT PERFORMANCE": 1915.5,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 4625.4,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 6938100,
    "PPh 100%": 1040715,
    "JUMLAH KOTOR 30% (Rp)": 2358855,
    "JUMLAH KOTOR 70% (Rp)": 4579245,
    "PPh 21": 686886.75,
    "JUMLAH BERSIH 70% (Rp)": 3892358.25,
    "TANDA TANGAN": 287
  },
  {
    "NIP": "'197011181997032001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. Ni Ketut Kertiasih, S.Si., M.Pd.",
    "JURUSAN": "Teknologi Rekayasa Perangkat Lunak (D4)",
    "FAKULTAS": "Fakultas Teknik dan Kejuruan",
    "GOLONGAN": "IVC",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor Kepala",
    "GRADE FUNGSIONAL": 11,
    "STRUKTURAL": "[REN126] Pengelola Gugus Kendali Mutu (Fakultas) sebagai Anggota",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Fakultas Teknik dan Kejuruan",
    "POINT POSITION": 200,
    "POINT PERFORMANCE": 1761.83,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 1961.83,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 2942745,
    "PPh 100%": 441411.75,
    "JUMLAH KOTOR 30% (Rp)": 1229400,
    "JUMLAH KOTOR 70% (Rp)": 1713345,
    "PPh 21": 257001.75,
    "JUMLAH BERSIH 70% (Rp)": 1456343.25,
    "TANDA TANGAN": 288
  },
  {
    "NIP": "'197711282001122001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. Ni Wayan Marti, S.Kom., M.Kom.",
    "JURUSAN": "Teknologi Rekayasa Perangkat Lunak (D4)",
    "FAKULTAS": "Fakultas Teknik dan Kejuruan",
    "GOLONGAN": "IVB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor Kepala",
    "GRADE FUNGSIONAL": 11,
    "STRUKTURAL": "Sekretaris Senat Fakultas",
    "GRADE STRUKTURAL": 10,
    "UNIT KERJA": "Fakultas Teknik dan Kejuruan",
    "POINT POSITION": 1895.4,
    "POINT PERFORMANCE": 1993.67,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 3889.07,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 5833605,
    "PPh 100%": 875040.75,
    "JUMLAH KOTOR 30% (Rp)": 1992330,
    "JUMLAH KOTOR 70% (Rp)": 3841275,
    "PPh 21": 576191.25,
    "JUMLAH BERSIH 70% (Rp)": 3265083.75,
    "TANDA TANGAN": 289
  },
  {
    "NIP": "'198212222006041001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. Putu Hendra Suputra, S.Kom., M.Cs.",
    "JURUSAN": "Teknologi Rekayasa Perangkat Lunak (D4)",
    "FAKULTAS": "Fakultas Teknik dan Kejuruan",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "STRUKTURAL": "Ketua Jurusan S1",
    "GRADE STRUKTURAL": 12,
    "UNIT KERJA": "Jurusan Teknik Informatika",
    "POINT POSITION": 2559.35,
    "POINT PERFORMANCE": 1709.33,
    "POINT KELEBIHAN": 131.25,
    "POINT TOTAL": 4399.93,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 6599895,
    "PPh 100%": 329994.75,
    "JUMLAH KOTOR 30% (Rp)": 1938757.5,
    "JUMLAH KOTOR 70% (Rp)": 4661137.5,
    "PPh 21": 233056.875,
    "JUMLAH BERSIH 70% (Rp)": 4428080.625,
    "TANDA TANGAN": 290
  },
  {
    "NIP": "'199008152019031018",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Ir. Ketut Agus Seputra, S.ST.,M.T.",
    "JURUSAN": "Teknologi Rekayasa Perangkat Lunak (D4)",
    "FAKULTAS": "Fakultas Teknik dan Kejuruan",
    "GOLONGAN": "IIIC",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "STRUKTURAL": "Koordinator Program Studi S1/D3",
    "GRADE STRUKTURAL": 11,
    "UNIT KERJA": "Teknologi Rekayasa Perangkat Lunak (D4)",
    "POINT POSITION": 1645.8,
    "POINT PERFORMANCE": 1521.33,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 3167.13,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 4750695,
    "PPh 100%": 237534.75,
    "JUMLAH KOTOR 30% (Rp)": 1527660,
    "JUMLAH KOTOR 70% (Rp)": 3223035,
    "PPh 21": 161151.75,
    "JUMLAH BERSIH 70% (Rp)": 3061883.25,
    "TANDA TANGAN": 291
  },
  {
    "NIP": "'197903082006041003",
    "STATUS SEKARANG": "Ijin Belajar",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. I Wayan Sutaya, S.T., M.T.",
    "JURUSAN": "Teknologi Rekayasa Sistem Elektronika (D4)",
    "FAKULTAS": "Fakultas Teknik dan Kejuruan",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "UNIT KERJA": "-",
    "POINT PERFORMANCE": 765.833,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 765.833,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 1148749.5,
    "PPh 100%": 57437.475,
    "JUMLAH KOTOR 30% (Rp)": 787050,
    "JUMLAH KOTOR 70% (Rp)": 361699.5,
    "PPh 21": 18084.975,
    "JUMLAH BERSIH 70% (Rp)": 343614.525,
    "TANDA TANGAN": 292
  },
  {
    "NIP": "'197912102003121001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. Ir. Made Santo Gitakarma, S.T., M.T., MCE.",
    "JURUSAN": "Teknologi Rekayasa Sistem Elektronika (D4)",
    "FAKULTAS": "Fakultas Teknik dan Kejuruan",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "STRUKTURAL": "Koordinator Program Studi S1/D3",
    "GRADE STRUKTURAL": 11,
    "UNIT KERJA": "Teknologi Rekayasa Sistem Elektronika (D4)",
    "POINT POSITION": 1645.8,
    "POINT PERFORMANCE": 905.833,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 2551.63,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 3827445,
    "PPh 100%": 191372.25,
    "JUMLAH KOTOR 30% (Rp)": 1527660,
    "JUMLAH KOTOR 70% (Rp)": 2299785,
    "PPh 21": 114989.25,
    "JUMLAH BERSIH 70% (Rp)": 2184795.75,
    "TANDA TANGAN": 293
  },
  {
    "NIP": "'197504042002121001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "I Gede Nurhayata, S.T., M.T.",
    "JURUSAN": "Teknologi Rekayasa Sistem Elektronika (D4)",
    "FAKULTAS": "Fakultas Teknik dan Kejuruan",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "UNIT KERJA": "-",
    "POINT PERFORMANCE": 520.5,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 520.5,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 780750,
    "PPh 100%": 39037.5,
    "JUMLAH KOTOR 30% (Rp)": 787050,
    "JUMLAH KOTOR 70% (Rp)": 0,
    "PPh 21": 0,
    "JUMLAH BERSIH 70% (Rp)": 0,
    "TANDA TANGAN": 294
  },
  {
    "NIP": "'197901232010121001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Ketut Udy Ariawan, S.T., M.T.",
    "JURUSAN": "Teknologi Rekayasa Sistem Elektronika (D4)",
    "FAKULTAS": "Fakultas Teknik dan Kejuruan",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "STRUKTURAL": "Ketua Jurusan S1",
    "GRADE STRUKTURAL": 12,
    "UNIT KERJA": "Jurusan Teknologi Industri",
    "POINT POSITION": 2258.25,
    "POINT PERFORMANCE": 1113.5,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 3371.75,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 5057625,
    "PPh 100%": 252881.25,
    "JUMLAH KOTOR 30% (Rp)": 1803262.5,
    "JUMLAH KOTOR 70% (Rp)": 3254362.5,
    "PPh 21": 162718.125,
    "JUMLAH BERSIH 70% (Rp)": 3091644.375,
    "TANDA TANGAN": 295
  },
  {
    "NIP": "'196504191990032001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. Dra. Risa Panti Ariani, M.Si.",
    "JURUSAN": "Pendidikan Kesejahteraan Keluarga (PKK) (S1)",
    "FAKULTAS": "Fakultas Teknik dan Kejuruan",
    "GOLONGAN": "IVB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor Kepala",
    "GRADE FUNGSIONAL": 11,
    "STRUKTURAL": "Koordinator Program Studi S1/D3",
    "GRADE STRUKTURAL": 11,
    "UNIT KERJA": "Pendidikan Kesejahteraan Keluarga (PKK) (S1)",
    "POINT POSITION": 1645.8,
    "POINT PERFORMANCE": 2166,
    "POINT KELEBIHAN": 337.567,
    "POINT TOTAL": 4149.37,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 6224055,
    "PPh 100%": 933608.25,
    "JUMLAH KOTOR 30% (Rp)": 1880010,
    "JUMLAH KOTOR 70% (Rp)": 4344045,
    "PPh 21": 651606.75,
    "JUMLAH BERSIH 70% (Rp)": 3692438.25,
    "TANDA TANGAN": 296
  },
  {
    "NIP": "'197309022002122001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. Ida Ayu Putu Hemy Ekayani, S.Pd., M.Pd.",
    "JURUSAN": "Pendidikan Kesejahteraan Keluarga (PKK) (S1)",
    "FAKULTAS": "Fakultas Teknik dan Kejuruan",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "STRUKTURAL": "Koordinator Program Studi S1/D3",
    "GRADE STRUKTURAL": 11,
    "UNIT KERJA": "Pendidikan Vokasional Seni Kuliner (S1)",
    "POINT POSITION": 1645.8,
    "POINT PERFORMANCE": 1330.67,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 2976.47,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 4464705,
    "PPh 100%": 223235.25,
    "JUMLAH KOTOR 30% (Rp)": 1527660,
    "JUMLAH KOTOR 70% (Rp)": 2937045,
    "PPh 21": 146852.25,
    "JUMLAH BERSIH 70% (Rp)": 2790192.75,
    "TANDA TANGAN": 297
  },
  {
    "NIP": "'197104212002122001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. Luh Masdarini, S.Pd., M.Pd.",
    "JURUSAN": "Pendidikan Kesejahteraan Keluarga (PKK) (S1)",
    "FAKULTAS": "Fakultas Teknik dan Kejuruan",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "STRUKTURAL": "[REN126] Pengelola Gugus Kendali Mutu (Fakultas) sebagai Anggota",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Fakultas Teknik dan Kejuruan",
    "POINT POSITION": 200,
    "POINT PERFORMANCE": 1342.5,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 1542.5,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 2313750,
    "PPh 100%": 115687.5,
    "JUMLAH KOTOR 30% (Rp)": 877050,
    "JUMLAH KOTOR 70% (Rp)": 1436700,
    "PPh 21": 71835,
    "JUMLAH BERSIH 70% (Rp)": 1364865,
    "TANDA TANGAN": 298
  },
  {
    "NIP": "'197403162006042001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. Made Diah Angendari, S.Pd., M.Pd.",
    "JURUSAN": "Pendidikan Kesejahteraan Keluarga (PKK) (S1)",
    "FAKULTAS": "Fakultas Teknik dan Kejuruan",
    "GOLONGAN": "IVA",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor Kepala",
    "GRADE FUNGSIONAL": 11,
    "UNIT KERJA": "-",
    "POINT PERFORMANCE": 2003.67,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 2003.67,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 3005505,
    "PPh 100%": 450825.75,
    "JUMLAH KOTOR 30% (Rp)": 1139400,
    "JUMLAH KOTOR 70% (Rp)": 1866105,
    "PPh 21": 279915.75,
    "JUMLAH BERSIH 70% (Rp)": 1586189.25,
    "TANDA TANGAN": 299
  },
  {
    "NIP": "'197212072002122003",
    "STATUS SEKARANG": "Ijin Belajar",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. Ni Made Suriani, S.Pd., M.Par.",
    "JURUSAN": "Pendidikan Kesejahteraan Keluarga (PKK) (S1)",
    "FAKULTAS": "Fakultas Teknik dan Kejuruan",
    "GOLONGAN": "IVA",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor Kepala",
    "GRADE FUNGSIONAL": 11,
    "UNIT KERJA": "-",
    "POINT PERFORMANCE": 1864.17,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 1864.17,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 2796255,
    "PPh 100%": 419438.25,
    "JUMLAH KOTOR 30% (Rp)": 1139400,
    "JUMLAH KOTOR 70% (Rp)": 1656855,
    "PPh 21": 248528.25,
    "JUMLAH BERSIH 70% (Rp)": 1408326.75,
    "TANDA TANGAN": 300
  },
  {
    "NIP": "'197108281997032001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. Putu Agus Mayuni, S.Pd., M.Si.",
    "JURUSAN": "Pendidikan Kesejahteraan Keluarga (PKK) (S1)",
    "FAKULTAS": "Fakultas Teknik dan Kejuruan",
    "GOLONGAN": "IVA",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor Kepala",
    "GRADE FUNGSIONAL": 11,
    "STRUKTURAL": "[REN223] Sekretaris Pusat/ Ketua Divisi/ Asrama/ Koordinator Lab. Jurusan Kepala Unit BPU/ Sekretaris Gugus Kendali Mutu Fakultas/ Sekretaris Tim Pengelolaan dan Penerimaan Mahasiswa Asing/ Sekretaris Unit Pengembangan dan Peningkatan Kapasitas Kelembagaan",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Fakultas Teknik dan Kejuruan",
    "POINT POSITION": 800,
    "POINT PERFORMANCE": 1838.33,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 2638.33,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 3957495,
    "PPh 100%": 593624.25,
    "JUMLAH KOTOR 30% (Rp)": 1499400,
    "JUMLAH KOTOR 70% (Rp)": 2458095,
    "PPh 21": 368714.25,
    "JUMLAH BERSIH 70% (Rp)": 2089380.75,
    "TANDA TANGAN": 301
  },
  {
    "NIP": "'198704302024212001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PPPK",
    "NAMA DOSEN": "Ida Ayu Reviena Damasanti, M.Pd.",
    "JURUSAN": "Pendidikan Kesejahteraan Keluarga (PKK) (S1)",
    "FAKULTAS": "Fakultas Teknik dan Kejuruan",
    "GOLONGAN": "X",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Asisten Ahli",
    "GRADE FUNGSIONAL": 8,
    "UNIT KERJA": "Fakultas Teknik dan Kejuruan",
    "POINT PERFORMANCE": 944.722,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 944.722,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 1417083,
    "PPh 100%": 70854.15,
    "JUMLAH KOTOR 30% (Rp)": 746550,
    "JUMLAH KOTOR 70% (Rp)": 670533,
    "PPh 21": 33526.65,
    "JUMLAH BERSIH 70% (Rp)": 637006.35,
    "TANDA TANGAN": 302
  },
  {
    "NIP": "'199410262020121015",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Made Riki Ponga Kusyanda, S.Tr.Par., M.Par.",
    "JURUSAN": "Pendidikan Kesejahteraan Keluarga (PKK) (S1)",
    "FAKULTAS": "Fakultas Teknik dan Kejuruan",
    "GOLONGAN": "IIIC",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "STRUKTURAL": "[REN221] Anggota Tim Ahli Rektor/SP4/ Sekretaris Balingkang Confucius Institute/ Sekretaris Unit Kerjasama",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "-",
    "POINT POSITION": 1300,
    "POINT PERFORMANCE": 1339,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 2639,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 3958500,
    "PPh 100%": 197925,
    "JUMLAH KOTOR 30% (Rp)": 1372050,
    "JUMLAH KOTOR 70% (Rp)": 2586450,
    "PPh 21": 129322.5,
    "JUMLAH BERSIH 70% (Rp)": 2457127.5,
    "TANDA TANGAN": 303
  },
  {
    "NIP": "'196501261992112001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Prof. Dr. Dra. I Dewa Ayu Made Budhyani, M.Pd.",
    "JURUSAN": "Pendidikan Kesejahteraan Keluarga (PKK) (S1)",
    "FAKULTAS": "Fakultas Teknik dan Kejuruan",
    "GOLONGAN": "IVC",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor Kepala",
    "GRADE FUNGSIONAL": 11,
    "STRUKTURAL": "Sekretaris Program Studi S3",
    "GRADE STRUKTURAL": 11,
    "UNIT KERJA": "Ilmu Pendidikan (S3)",
    "POINT POSITION": 2152.2,
    "POINT PERFORMANCE": 2416.33,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 4568.53,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 6852795,
    "PPh 100%": 1027919.25,
    "JUMLAH KOTOR 30% (Rp)": 2107890,
    "JUMLAH KOTOR 70% (Rp)": 4744905,
    "PPh 21": 711735.75,
    "JUMLAH BERSIH 70% (Rp)": 4033169.25,
    "TANDA TANGAN": 304
  },
  {
    "NIP": "'199208122024061003",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. Bagus Gede Krishna Yudistira, M.Kom.",
    "JURUSAN": "Pendidikan Teknik Informatika (PTI) (S1)",
    "FAKULTAS": "Fakultas Teknik dan Kejuruan",
    "GOLONGAN": "IIIB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Tenaga Pengajar",
    "GRADE FUNGSIONAL": 7,
    "UNIT KERJA": "-",
    "POINT PERFORMANCE": 530.167,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 530.167,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 795250.5,
    "PPh 100%": 39762.525,
    "JUMLAH KOTOR 30% (Rp)": 545400,
    "JUMLAH KOTOR 70% (Rp)": 249850.5,
    "PPh 21": 12492.525,
    "JUMLAH BERSIH 70% (Rp)": 237357.975,
    "TANDA TANGAN": 305
  },
  {
    "NIP": "'198709072015041001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. I Gede Partha Sindu, S.Pd., M.Pd.",
    "JURUSAN": "Pendidikan Teknik Informatika (PTI) (S1)",
    "FAKULTAS": "Fakultas Teknik dan Kejuruan",
    "GOLONGAN": "IVA",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor Kepala",
    "GRADE FUNGSIONAL": 11,
    "STRUKTURAL": "[REN223] Sekretaris Pusat/ Ketua Divisi/ Asrama/ Koordinator Lab. Jurusan Kepala Unit BPU/ Sekretaris Gugus Kendali Mutu Fakultas/ Sekretaris Tim Pengelolaan dan Penerimaan Mahasiswa Asing/ Sekretaris Unit Pengembangan dan Peningkatan Kapasitas Kelembagaan",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "-",
    "POINT POSITION": 800,
    "POINT PERFORMANCE": 2422.33,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 3222.33,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 4833495,
    "PPh 100%": 725024.25,
    "JUMLAH KOTOR 30% (Rp)": 1499400,
    "JUMLAH KOTOR 70% (Rp)": 3334095,
    "PPh 21": 500114.25,
    "JUMLAH BERSIH 70% (Rp)": 2833980.75,
    "TANDA TANGAN": 306
  },
  {
    "NIP": "'198408272008121001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. I Made Agus Wirawan, S.Kom., M.Cs.",
    "JURUSAN": "Pendidikan Teknik Informatika (PTI) (S1)",
    "FAKULTAS": "Fakultas Teknik dan Kejuruan",
    "GOLONGAN": "IVA",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor Kepala",
    "GRADE FUNGSIONAL": 11,
    "STRUKTURAL": "[REN222] Kepala Pusat /Kantor/Kepala Gugus Kendali Mutu Fakultas/Ketua Unit Pengelolaan dan Penerimaan Mahasiswa Asing/ Ketua Unit Pengembangan dan Peningkatan Kapasitas Kelembagaan",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "-",
    "POINT POSITION": 1150,
    "POINT PERFORMANCE": 2015.17,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 3165.17,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 4747755,
    "PPh 100%": 712163.25,
    "JUMLAH KOTOR 30% (Rp)": 1656900,
    "JUMLAH KOTOR 70% (Rp)": 3090855,
    "PPh 21": 463628.25,
    "JUMLAH BERSIH 70% (Rp)": 2627226.75,
    "TANDA TANGAN": 307
  },
  {
    "NIP": "'199410232022031012",
    "STATUS SEKARANG": "Ijin Belajar",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. I Nyoman Indhi Wiradika, M.Pd.",
    "JURUSAN": "Pendidikan Teknik Informatika (PTI) (S1)",
    "FAKULTAS": "Fakultas Teknik dan Kejuruan",
    "GOLONGAN": "IIIB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Asisten Ahli",
    "GRADE FUNGSIONAL": 8,
    "UNIT KERJA": "-",
    "POINT PERFORMANCE": 744.982,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 744.982,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 1117473,
    "PPh 100%": 55873.65,
    "JUMLAH KOTOR 30% (Rp)": 656550,
    "JUMLAH KOTOR 70% (Rp)": 460923,
    "PPh 21": 23046.15,
    "JUMLAH BERSIH 70% (Rp)": 437876.85,
    "TANDA TANGAN": 308
  },
  {
    "NIP": "'198307252008011008",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. Ir. I Made Gede Sunarya, S.Kom., M.Cs.",
    "JURUSAN": "Pendidikan Teknik Informatika (PTI) (S1)",
    "FAKULTAS": "Fakultas Teknik dan Kejuruan",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor Kepala",
    "GRADE FUNGSIONAL": 11,
    "STRUKTURAL": "Koordinator Program Studi S2",
    "GRADE STRUKTURAL": 12,
    "UNIT KERJA": "Ilmu Komputer (S2)",
    "POINT POSITION": 2559.35,
    "POINT PERFORMANCE": 2521,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 5080.35,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 7620525,
    "PPh 100%": 381026.25,
    "JUMLAH KOTOR 30% (Rp)": 2291107.5,
    "JUMLAH KOTOR 70% (Rp)": 5329417.5,
    "PPh 21": 266470.875,
    "JUMLAH BERSIH 70% (Rp)": 5062946.625,
    "TANDA TANGAN": 309
  },
  {
    "NIP": "'198502152008122007",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. phil. Dessy Seri Wahyuni, S.Kom., M.Eng.",
    "JURUSAN": "Pendidikan Teknik Informatika (PTI) (S1)",
    "FAKULTAS": "Fakultas Teknik dan Kejuruan",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor Kepala",
    "GRADE FUNGSIONAL": 11,
    "STRUKTURAL": "Koordinator Program Studi S1/D3",
    "GRADE STRUKTURAL": 11,
    "UNIT KERJA": "Pendidikan Teknik Informatika (PTI) (S1)",
    "POINT POSITION": 1899,
    "POINT PERFORMANCE": 2016.5,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 3915.5,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 5873250,
    "PPh 100%": 293662.5,
    "JUMLAH KOTOR 30% (Rp)": 1993950,
    "JUMLAH KOTOR 70% (Rp)": 3879300,
    "PPh 21": 193965,
    "JUMLAH BERSIH 70% (Rp)": 3685335,
    "TANDA TANGAN": 310
  },
  {
    "NIP": "'199311172019031014",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "I Gede Bendesa Subawa, S.Pd.,M.Kom.",
    "JURUSAN": "Pendidikan Teknik Informatika (PTI) (S1)",
    "FAKULTAS": "Fakultas Teknik dan Kejuruan",
    "GOLONGAN": "IIIC",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "UNIT KERJA": "-",
    "POINT PERFORMANCE": 1264.67,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 1264.67,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 1897005,
    "PPh 100%": 94850.25,
    "JUMLAH KOTOR 30% (Rp)": 787050,
    "JUMLAH KOTOR 70% (Rp)": 1109955,
    "PPh 21": 55497.75,
    "JUMLAH BERSIH 70% (Rp)": 1054457.25,
    "TANDA TANGAN": 311
  },
  {
    "NIP": "'199603142024061003",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "I Ketut Andika Pradnyana, S.Pd., M.Pd.",
    "JURUSAN": "Pendidikan Teknik Informatika (PTI) (S1)",
    "FAKULTAS": "Fakultas Teknik dan Kejuruan",
    "GOLONGAN": "IIIB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Tenaga Pengajar",
    "GRADE FUNGSIONAL": 7,
    "UNIT KERJA": "-",
    "POINT PERFORMANCE": 826.167,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 826.167,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 1239250.5,
    "PPh 100%": 61962.525,
    "JUMLAH KOTOR 30% (Rp)": 545400,
    "JUMLAH KOTOR 70% (Rp)": 693850.5,
    "PPh 21": 34692.525,
    "JUMLAH BERSIH 70% (Rp)": 659157.975,
    "TANDA TANGAN": 312
  },
  {
    "NIP": "'199503022019031006",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "I Nengah Eka Mertayasa, S.Pd.,M.Pd.",
    "JURUSAN": "Pendidikan Teknik Informatika (PTI) (S1)",
    "FAKULTAS": "Fakultas Teknik dan Kejuruan",
    "GOLONGAN": "IIIC",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "STRUKTURAL": "[REN223] Sekretaris Pusat/ Ketua Divisi/ Asrama/ Koordinator Lab. Jurusan Kepala Unit BPU/ Sekretaris Gugus Kendali Mutu Fakultas/ Sekretaris Tim Pengelolaan dan Penerimaan Mahasiswa Asing/ Sekretaris Unit Pengembangan dan Peningkatan Kapasitas Kelembagaan",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Unit Penunjang Akademik Teknologi Informasi dan Komunikasi",
    "POINT POSITION": 1200,
    "POINT PERFORMANCE": 1662,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 2862,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 4293000,
    "PPh 100%": 214650,
    "JUMLAH KOTOR 30% (Rp)": 1327050,
    "JUMLAH KOTOR 70% (Rp)": 2965950,
    "PPh 21": 148297.5,
    "JUMLAH BERSIH 70% (Rp)": 2817652.5,
    "TANDA TANGAN": 313
  },
  {
    "NIP": "'198907132019031017",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Ida Bagus Nyoman Pascima, S.Pd., M.Cs.",
    "JURUSAN": "Pendidikan Teknik Informatika (PTI) (S1)",
    "FAKULTAS": "Fakultas Teknik dan Kejuruan",
    "GOLONGAN": "IIIC",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "UNIT KERJA": "-",
    "POINT PERFORMANCE": 1433.17,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 1433.17,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 2149755,
    "PPh 100%": 107487.75,
    "JUMLAH KOTOR 30% (Rp)": 787050,
    "JUMLAH KOTOR 70% (Rp)": 1362705,
    "PPh 21": 68135.25,
    "JUMLAH BERSIH 70% (Rp)": 1294569.75,
    "TANDA TANGAN": 314
  },
  {
    "NIP": "'198211112008121001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Ir. Made Windu Antara Kesiman, S.T., M.Sc., Ph.D.",
    "JURUSAN": "Pendidikan Teknik Informatika (PTI) (S1)",
    "FAKULTAS": "Fakultas Teknik dan Kejuruan",
    "GOLONGAN": "IVB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor Kepala",
    "GRADE FUNGSIONAL": 11,
    "STRUKTURAL": "Wakil Dekan I",
    "GRADE STRUKTURAL": 14,
    "UNIT KERJA": "Fakultas Teknik dan Kejuruan",
    "POINT POSITION": 9720,
    "POINT PERFORMANCE": 2094.67,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 11814.7,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 17722050,
    "PPh 100%": 2658307.5,
    "JUMLAH KOTOR 30% (Rp)": 5513400,
    "JUMLAH KOTOR 70% (Rp)": 12208650,
    "PPh 21": 1831297.5,
    "JUMLAH BERSIH 70% (Rp)": 10377352.5,
    "TANDA TANGAN": 315
  },
  {
    "NIP": "'198603132024212001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PPPK",
    "NAMA DOSEN": "Luh Putu Eka Damayanthi, S.Pd., M.Pd.",
    "JURUSAN": "Pendidikan Teknik Informatika (PTI) (S1)",
    "FAKULTAS": "Fakultas Teknik dan Kejuruan",
    "GOLONGAN": "X",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Asisten Ahli",
    "GRADE FUNGSIONAL": 8,
    "STRUKTURAL": "[REN225] Anggota Divisi",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "-",
    "POINT POSITION": 250,
    "POINT PERFORMANCE": 970.462,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 1220.46,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 1830690,
    "PPh 100%": 91534.5,
    "JUMLAH KOTOR 30% (Rp)": 769050,
    "JUMLAH KOTOR 70% (Rp)": 1061640,
    "PPh 21": 53082,
    "JUMLAH BERSIH 70% (Rp)": 1008558,
    "TANDA TANGAN": 316
  },
  {
    "NIP": "'199010192020122011",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Made Susi Lissia Andayani, M.Pd.",
    "JURUSAN": "Pendidikan Teknik Informatika (PTI) (S1)",
    "FAKULTAS": "Fakultas Teknik dan Kejuruan",
    "GOLONGAN": "IIIB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Asisten Ahli",
    "GRADE FUNGSIONAL": 8,
    "UNIT KERJA": "-",
    "POINT PERFORMANCE": 575.399,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 575.399,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 863098.5,
    "PPh 100%": 43154.925,
    "JUMLAH KOTOR 30% (Rp)": 656550,
    "JUMLAH KOTOR 70% (Rp)": 206548.5,
    "PPh 21": 10327.425,
    "JUMLAH BERSIH 70% (Rp)": 196221.075,
    "TANDA TANGAN": 317
  },
  {
    "NIP": "'198711092015041001",
    "STATUS SEKARANG": "Ijin Belajar",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "P Wayan Arta Suyasa, S.Pd., M.Pd.",
    "JURUSAN": "Pendidikan Teknik Informatika (PTI) (S1)",
    "FAKULTAS": "Fakultas Teknik dan Kejuruan",
    "GOLONGAN": "IVA",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor Kepala",
    "GRADE FUNGSIONAL": 11,
    "UNIT KERJA": "-",
    "POINT PERFORMANCE": 1597,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 1597,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 2395500,
    "PPh 100%": 359325,
    "JUMLAH KOTOR 30% (Rp)": 1139400,
    "JUMLAH KOTOR 70% (Rp)": 1256100,
    "PPh 21": 188415,
    "JUMLAH BERSIH 70% (Rp)": 1067685,
    "TANDA TANGAN": 318
  },
  {
    "NIP": "'197009182001121001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. I Putu Suka Arsa, S.T., M.T.",
    "JURUSAN": "Pendidikan Teknik Elektro (PTE) (S1)",
    "FAKULTAS": "Fakultas Teknik dan Kejuruan",
    "GOLONGAN": "IVB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor Kepala",
    "GRADE FUNGSIONAL": 11,
    "STRUKTURAL": "[REN222] Kepala Pusat /Kantor/Kepala Gugus Kendali Mutu Fakultas/Ketua Unit Pengelolaan dan Penerimaan Mahasiswa Asing/ Ketua Unit Pengembangan dan Peningkatan Kapasitas Kelembagaan",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "-",
    "POINT POSITION": 1150,
    "POINT PERFORMANCE": 850.833,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 2000.83,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 3001245,
    "PPh 100%": 450186.75,
    "JUMLAH KOTOR 30% (Rp)": 1656900,
    "JUMLAH KOTOR 70% (Rp)": 1344345,
    "PPh 21": 201651.75,
    "JUMLAH BERSIH 70% (Rp)": 1142693.25,
    "TANDA TANGAN": 319
  },
  {
    "NIP": "'197301092002121001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. Ir. I Gede Ratnaya, S.T., M.Pd., MCE., IPM.",
    "JURUSAN": "Pendidikan Teknik Elektro (PTE) (S1)",
    "FAKULTAS": "Fakultas Teknik dan Kejuruan",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor Kepala",
    "GRADE FUNGSIONAL": 11,
    "STRUKTURAL": "Sekretaris Program Studi S2",
    "GRADE STRUKTURAL": 11,
    "UNIT KERJA": "Penelitian dan Evaluasi Pendidikan(S2)",
    "POINT POSITION": 2152.2,
    "POINT PERFORMANCE": 2332.67,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 4484.87,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 6727305,
    "PPh 100%": 336365.25,
    "JUMLAH KOTOR 30% (Rp)": 2107890,
    "JUMLAH KOTOR 70% (Rp)": 4619415,
    "PPh 21": 230970.75,
    "JUMLAH BERSIH 70% (Rp)": 4388444.25,
    "TANDA TANGAN": 320
  },
  {
    "NIP": "'197106161999031007",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. Ir. Nyoman Santiyadnya, S.Si., M.T. MCE.",
    "JURUSAN": "Pendidikan Teknik Elektro (PTE) (S1)",
    "FAKULTAS": "Fakultas Teknik dan Kejuruan",
    "GOLONGAN": "IVB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor Kepala",
    "GRADE FUNGSIONAL": 11,
    "STRUKTURAL": "Kepala Pusat Pengembangan Kurikulum dan Pelaksanaan Pembelajaran",
    "GRADE STRUKTURAL": 12,
    "UNIT KERJA": "-",
    "POINT POSITION": 1957.15,
    "POINT PERFORMANCE": 1831.17,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 3788.32,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 5682480,
    "PPh 100%": 852372,
    "JUMLAH KOTOR 30% (Rp)": 2020117.5,
    "JUMLAH KOTOR 70% (Rp)": 3662362.5,
    "PPh 21": 549354.375,
    "JUMLAH BERSIH 70% (Rp)": 3113008.125,
    "TANDA TANGAN": 321
  },
  {
    "NIP": "'199011032024062001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Gusti Ayu Cantika Putri, S.T., M.Ars.",
    "JURUSAN": "Pendidikan Teknik Elektro (PTE) (S1)",
    "FAKULTAS": "Fakultas Teknik dan Kejuruan",
    "GOLONGAN": "IIIB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Tenaga Pengajar",
    "GRADE FUNGSIONAL": 7,
    "UNIT KERJA": "-",
    "POINT PERFORMANCE": 242.667,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 242.667,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 364000.5,
    "PPh 100%": 18200.025,
    "JUMLAH KOTOR 30% (Rp)": 545400,
    "JUMLAH KOTOR 70% (Rp)": 0,
    "PPh 21": 0,
    "JUMLAH BERSIH 70% (Rp)": 0,
    "TANDA TANGAN": 322
  },
  {
    "NIP": "'198705052020121014",
    "STATUS SEKARANG": "Ijin Belajar",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "I Gede Made Surya Bumi Pracasitaram, S.T., M.T.",
    "JURUSAN": "Pendidikan Teknik Elektro (PTE) (S1)",
    "FAKULTAS": "Fakultas Teknik dan Kejuruan",
    "GOLONGAN": "IIIB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Asisten Ahli",
    "GRADE FUNGSIONAL": 8,
    "STRUKTURAL": "[REN223] Sekretaris Pusat/ Ketua Divisi/ Asrama/ Koordinator Lab. Jurusan Kepala Unit BPU/ Sekretaris Gugus Kendali Mutu Fakultas/ Sekretaris Tim Pengelolaan dan Penerimaan Mahasiswa Asing/ Sekretaris Unit Pengembangan dan Peningkatan Kapasitas Kelembagaan",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Fakultas Teknik dan Kejuruan",
    "POINT POSITION": 800,
    "POINT PERFORMANCE": 953.833,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 1753.83,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 2630745,
    "PPh 100%": 131537.25,
    "JUMLAH KOTOR 30% (Rp)": 1016550,
    "JUMLAH KOTOR 70% (Rp)": 1614195,
    "PPh 21": 80709.75,
    "JUMLAH BERSIH 70% (Rp)": 1533485.25,
    "TANDA TANGAN": 323
  },
  {
    "NIP": "'199002232024211001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PPPK",
    "NAMA DOSEN": "I Komang Gede Sukawijana, M.Pd",
    "JURUSAN": "Pendidikan Teknik Elektro (PTE) (S1)",
    "FAKULTAS": "Fakultas Teknik dan Kejuruan",
    "GOLONGAN": "X",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Asisten Ahli",
    "GRADE FUNGSIONAL": 8,
    "STRUKTURAL": "[REN126] Pengelola Gugus Kendali Mutu (Fakultas) sebagai Anggota",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Fakultas Teknik dan Kejuruan",
    "POINT POSITION": 200,
    "POINT PERFORMANCE": 598.878,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 798.878,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 1198317,
    "PPh 100%": 59915.85,
    "JUMLAH KOTOR 30% (Rp)": 746550,
    "JUMLAH KOTOR 70% (Rp)": 451767,
    "PPh 21": 22588.35,
    "JUMLAH BERSIH 70% (Rp)": 429178.65,
    "TANDA TANGAN": 324
  },
  {
    "NIP": "'199605202024061001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "I Nyoman Sutrisna Angga, S.T., M.T.",
    "JURUSAN": "Pendidikan Teknik Elektro (PTE) (S1)",
    "FAKULTAS": "Fakultas Teknik dan Kejuruan",
    "GOLONGAN": "IIIB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Tenaga Pengajar",
    "GRADE FUNGSIONAL": 7,
    "UNIT KERJA": "-",
    "POINT PERFORMANCE": 253,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 253,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 379500,
    "PPh 100%": 18975,
    "JUMLAH KOTOR 30% (Rp)": 545400,
    "JUMLAH KOTOR 70% (Rp)": 0,
    "PPh 21": 0,
    "JUMLAH BERSIH 70% (Rp)": 0,
    "TANDA TANGAN": 325
  },
  {
    "NIP": "'196608181998021001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Prof. Dr. Ir. Agus Adiarta, S.T., M.T., IPU., ASEAN Eng.",
    "JURUSAN": "Pendidikan Teknik Elektro (PTE) (S1)",
    "FAKULTAS": "Fakultas Teknik dan Kejuruan",
    "GOLONGAN": "IVC",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Guru Besar",
    "GRADE FUNGSIONAL": 12,
    "STRUKTURAL": "Koordinator Program Studi S1/D3",
    "GRADE STRUKTURAL": 11,
    "UNIT KERJA": "Pendidikan Teknik Elektro (PTE) (S1)",
    "POINT POSITION": 1645.8,
    "POINT PERFORMANCE": 949.333,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 2595.13,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 3892695,
    "PPh 100%": 583904.25,
    "JUMLAH KOTOR 30% (Rp)": 2095560,
    "JUMLAH KOTOR 70% (Rp)": 1797135,
    "PPh 21": 269570.25,
    "JUMLAH BERSIH 70% (Rp)": 1527564.75,
    "TANDA TANGAN": 326
  },
  {
    "NIP": "'199310042019031010",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Wayan Mahardika Prasetya Wiratama, S.Pd.,M.Pd",
    "JURUSAN": "Pendidikan Teknik Elektro (PTE) (S1)",
    "FAKULTAS": "Fakultas Teknik dan Kejuruan",
    "GOLONGAN": "IIIC",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "STRUKTURAL": "[REN126] Pengelola Gugus Kendali Mutu (Fakultas) sebagai Anggota",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Fakultas Teknik dan Kejuruan",
    "POINT POSITION": 200,
    "POINT PERFORMANCE": 915.743,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 1115.74,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 1673610,
    "PPh 100%": 83680.5,
    "JUMLAH KOTOR 30% (Rp)": 877050,
    "JUMLAH KOTOR 70% (Rp)": 796560,
    "PPh 21": 39828,
    "JUMLAH BERSIH 70% (Rp)": 756732,
    "TANDA TANGAN": 327
  },
  {
    "NIP": "'197301102006041002",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. Gede Widayana, S.T., M.T.",
    "JURUSAN": "Pendidikan Teknik Mesin (PTM) (S1)",
    "FAKULTAS": "Fakultas Teknik dan Kejuruan",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor Kepala",
    "GRADE FUNGSIONAL": 11,
    "STRUKTURAL": "Sekretaris Jurusan S1",
    "GRADE STRUKTURAL": 11,
    "UNIT KERJA": "Jurusan Teknologi Industri",
    "POINT POSITION": 1899,
    "POINT PERFORMANCE": 1753.67,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 3652.67,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 5479005,
    "PPh 100%": 273950.25,
    "JUMLAH KOTOR 30% (Rp)": 1993950,
    "JUMLAH KOTOR 70% (Rp)": 3485055,
    "PPh 21": 174252.75,
    "JUMLAH BERSIH 70% (Rp)": 3310802.25,
    "TANDA TANGAN": 328
  },
  {
    "NIP": "'197707212006041001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. I Nyoman Pasek Nugraha, S.T., M.T.",
    "JURUSAN": "Pendidikan Teknik Mesin (PTM) (S1)",
    "FAKULTAS": "Fakultas Teknik dan Kejuruan",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "STRUKTURAL": "Koordinator Program Studi S1/D3",
    "GRADE STRUKTURAL": 11,
    "UNIT KERJA": "Pendidikan Teknik Mesin (PTM) (S1)",
    "POINT POSITION": 1645.8,
    "POINT PERFORMANCE": 1039,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 2684.8,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 4027200,
    "PPh 100%": 201360,
    "JUMLAH KOTOR 30% (Rp)": 1527660,
    "JUMLAH KOTOR 70% (Rp)": 2499540,
    "PPh 21": 124977,
    "JUMLAH BERSIH 70% (Rp)": 2374563,
    "TANDA TANGAN": 329
  },
  {
    "NIP": "'197312052006041001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. Nyoman Arya Wigraha, S.T., M.T., MCE.",
    "JURUSAN": "Pendidikan Teknik Mesin (PTM) (S1)",
    "FAKULTAS": "Fakultas Teknik dan Kejuruan",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "UNIT KERJA": "-",
    "POINT PERFORMANCE": 752.91,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 752.91,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 1129365,
    "PPh 100%": 56468.25,
    "JUMLAH KOTOR 30% (Rp)": 787050,
    "JUMLAH KOTOR 70% (Rp)": 342315,
    "PPh 21": 17115.75,
    "JUMLAH BERSIH 70% (Rp)": 325199.25,
    "TANDA TANGAN": 330
  },
  {
    "NIP": "'198606252019031011",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Edi Elisa, S.Pd.,M.Pd.",
    "JURUSAN": "Pendidikan Teknik Mesin (PTM) (S1)",
    "FAKULTAS": "Fakultas Teknik dan Kejuruan",
    "GOLONGAN": "IIIC",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "STRUKTURAL": "[REN126] Pengelola Gugus Kendali Mutu (Fakultas) sebagai Anggota",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Fakultas Teknik dan Kejuruan",
    "POINT POSITION": 200,
    "POINT PERFORMANCE": 1037.66,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 1237.66,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 1856490,
    "PPh 100%": 92824.5,
    "JUMLAH KOTOR 30% (Rp)": 877050,
    "JUMLAH KOTOR 70% (Rp)": 979440,
    "PPh 21": 48972,
    "JUMLAH BERSIH 70% (Rp)": 930468,
    "TANDA TANGAN": 331
  },
  {
    "NIP": "'199006072023211024",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PPPK",
    "NAMA DOSEN": "Edy Agus Juny Artha, S.Pd.,M.Pd",
    "JURUSAN": "Pendidikan Teknik Mesin (PTM) (S1)",
    "FAKULTAS": "Fakultas Teknik dan Kejuruan",
    "GOLONGAN": "X",
    "STATUS PENELITIAN": "TIDAK ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Asisten Ahli",
    "GRADE FUNGSIONAL": 8,
    "STRUKTURAL": "[REN126] Pengelola Gugus Kendali Mutu (Fakultas) sebagai Anggota",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Fakultas Teknik dan Kejuruan",
    "POINT POSITION": 0,
    "POINT PERFORMANCE": 0,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 0,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 0,
    "PPh 100%": 0,
    "JUMLAH KOTOR 30% (Rp)": 746550,
    "JUMLAH KOTOR 70% (Rp)": 0,
    "PPh 21": 0,
    "JUMLAH BERSIH 70% (Rp)": 0,
    "TANDA TANGAN": 332
  },
  {
    "NIP": "'198810282019031009",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "I Gede Wiratmaja, S.T., M.T., MCE.",
    "JURUSAN": "Pendidikan Teknik Mesin (PTM) (S1)",
    "FAKULTAS": "Fakultas Teknik dan Kejuruan",
    "GOLONGAN": "IIIC",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "STRUKTURAL": "[REN126] Pengelola Gugus Kendali Mutu (Fakultas) sebagai Anggota",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Fakultas Teknik dan Kejuruan",
    "POINT POSITION": 200,
    "POINT PERFORMANCE": 990.333,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 1190.33,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 1785495,
    "PPh 100%": 89274.75,
    "JUMLAH KOTOR 30% (Rp)": 877050,
    "JUMLAH KOTOR 70% (Rp)": 908445,
    "PPh 21": 45422.25,
    "JUMLAH BERSIH 70% (Rp)": 863022.75,
    "TANDA TANGAN": 333
  },
  {
    "NIP": "'199806192024061001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Ida Bagus Putu Purwadnyana, S.T., M.T.",
    "JURUSAN": "Pendidikan Teknik Mesin (PTM) (S1)",
    "FAKULTAS": "Fakultas Teknik dan Kejuruan",
    "GOLONGAN": "IIIB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Tenaga Pengajar",
    "GRADE FUNGSIONAL": 7,
    "UNIT KERJA": "-",
    "POINT PERFORMANCE": 479.917,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 479.917,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 719875.5,
    "PPh 100%": 35993.775,
    "JUMLAH KOTOR 30% (Rp)": 545400,
    "JUMLAH KOTOR 70% (Rp)": 174475.5,
    "PPh 21": 8723.775,
    "JUMLAH BERSIH 70% (Rp)": 165751.725,
    "TANDA TANGAN": 334
  },
  {
    "NIP": "'199011172022032005",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Ir. Ni Made Novia Kusumayani, S.T., M.Sc.",
    "JURUSAN": "Pendidikan Teknik Mesin (PTM) (S1)",
    "FAKULTAS": "Fakultas Teknik dan Kejuruan",
    "GOLONGAN": "IIIB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Asisten Ahli",
    "GRADE FUNGSIONAL": 8,
    "STRUKTURAL": "[REN223] Sekretaris Pusat/ Ketua Divisi/ Asrama/ Koordinator Lab. Jurusan Kepala Unit BPU/ Sekretaris Gugus Kendali Mutu Fakultas/ Sekretaris Tim Pengelolaan dan Penerimaan Mahasiswa Asing/ Sekretaris Unit Pengembangan dan Peningkatan Kapasitas Kelembagaan",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "-",
    "POINT POSITION": 800,
    "POINT PERFORMANCE": 476.333,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 1276.33,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 1914495,
    "PPh 100%": 95724.75,
    "JUMLAH KOTOR 30% (Rp)": 1016550,
    "JUMLAH KOTOR 70% (Rp)": 897945,
    "PPh 21": 44897.25,
    "JUMLAH BERSIH 70% (Rp)": 853047.75,
    "TANDA TANGAN": 335
  },
  {
    "NIP": "'199706202024061001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Jhony Langgeng Baruna Wirawan, S.T., M.T.",
    "JURUSAN": "Pendidikan Teknik Mesin (PTM) (S1)",
    "FAKULTAS": "Fakultas Teknik dan Kejuruan",
    "GOLONGAN": "IIIB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Tenaga Pengajar",
    "GRADE FUNGSIONAL": 7,
    "UNIT KERJA": "-",
    "POINT PERFORMANCE": 526.125,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 526.125,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 789187.5,
    "PPh 100%": 39459.375,
    "JUMLAH KOTOR 30% (Rp)": 545400,
    "JUMLAH KOTOR 70% (Rp)": 243787.5,
    "PPh 21": 12189.375,
    "JUMLAH BERSIH 70% (Rp)": 231598.125,
    "TANDA TANGAN": 336
  },
  {
    "NIP": "'197912012006041001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Prof. Dr. Ir. Kadek Rihendra Dantes, S.T., M.T.",
    "JURUSAN": "Pendidikan Teknik Mesin (PTM) (S1)",
    "FAKULTAS": "Fakultas Teknik dan Kejuruan",
    "GOLONGAN": "IVB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Guru Besar",
    "GRADE FUNGSIONAL": 12,
    "STRUKTURAL": "Dekan",
    "GRADE STRUKTURAL": 15,
    "UNIT KERJA": "Fakultas Teknik dan Kejuruan",
    "POINT POSITION": 11610,
    "POINT PERFORMANCE": 2536.58,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 14146.6,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 21219900,
    "PPh 100%": 3182985,
    "JUMLAH KOTOR 30% (Rp)": 6579450,
    "JUMLAH KOTOR 70% (Rp)": 14640450,
    "PPh 21": 2196067.5,
    "JUMLAH BERSIH 70% (Rp)": 12444382.5,
    "TANDA TANGAN": 337
  },
  {
    "NIP": "'198901192015041004",
    "STATUS SEKARANG": "Tugas Belajar",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. Gede Aditra Pradnyana, S.Kom., M.Kom.",
    "JURUSAN": "Sistem Informasi (SI) (S1)",
    "FAKULTAS": "Fakultas Teknik dan Kejuruan",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "TIDAK ADA",
    "STATUS PENGABDIAN": "TIDAK ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "UNIT KERJA": "-",
    "POINT POSITION": 0,
    "POINT PERFORMANCE": 0,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 0,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 0,
    "PPh 100%": 0,
    "JUMLAH KOTOR 70% (Rp)": 0,
    "PPh 21": 0,
    "JUMLAH BERSIH 70% (Rp)": 0,
    "TANDA TANGAN": 338
  },
  {
    "NIP": "'198908272019031008",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "I Gusti Lanang Agung Raditya Putra, S.Pd.,M.T.",
    "JURUSAN": "Sistem Informasi (SI) (S1)",
    "FAKULTAS": "Fakultas Teknik dan Kejuruan",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "UNIT KERJA": "-",
    "POINT PERFORMANCE": 1369.5,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 1369.5,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 2054250,
    "PPh 100%": 102712.5,
    "JUMLAH KOTOR 30% (Rp)": 787050,
    "JUMLAH KOTOR 70% (Rp)": 1267200,
    "PPh 21": 63360,
    "JUMLAH BERSIH 70% (Rp)": 1203840,
    "TANDA TANGAN": 339
  },
  {
    "NIP": "'199105152020121003",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Ir. Gede Arna Jude Saskara, S.T.,M.T",
    "JURUSAN": "Sistem Informasi (SI) (S1)",
    "FAKULTAS": "Fakultas Teknik dan Kejuruan",
    "GOLONGAN": "IIIC",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "STRUKTURAL": "[REN223] Sekretaris Pusat/ Ketua Divisi/ Asrama/ Koordinator Lab. Jurusan Kepala Unit BPU/ Sekretaris Gugus Kendali Mutu Fakultas/ Sekretaris Tim Pengelolaan dan Penerimaan Mahasiswa Asing/ Sekretaris Unit Pengembangan dan Peningkatan Kapasitas Kelembagaan",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Unit Penunjang Akademik Teknologi Informasi dan Komunikasi",
    "POINT POSITION": 1200,
    "POINT PERFORMANCE": 1586.17,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 2786.17,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 4179255,
    "PPh 100%": 208962.75,
    "JUMLAH KOTOR 30% (Rp)": 1327050,
    "JUMLAH KOTOR 70% (Rp)": 2852205,
    "PPh 21": 142610.25,
    "JUMLAH BERSIH 70% (Rp)": 2709594.75,
    "TANDA TANGAN": 340
  },
  {
    "NIP": "'199003132022031009",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Ir. Gede Surya Mahendra, S.Pd., M.Kom.",
    "JURUSAN": "Sistem Informasi (SI) (S1)",
    "FAKULTAS": "Fakultas Teknik dan Kejuruan",
    "GOLONGAN": "IIIB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Asisten Ahli",
    "GRADE FUNGSIONAL": 8,
    "STRUKTURAL": "[REN126] Pengelola Gugus Kendali Mutu (Fakultas) sebagai Anggota",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Fakultas Teknik dan Kejuruan",
    "POINT POSITION": 200,
    "POINT PERFORMANCE": 1135,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 1335,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 2002500,
    "PPh 100%": 100125,
    "JUMLAH KOTOR 30% (Rp)": 746550,
    "JUMLAH KOTOR 70% (Rp)": 1255950,
    "PPh 21": 62797.5,
    "JUMLAH BERSIH 70% (Rp)": 1193152.5,
    "TANDA TANGAN": 341
  },
  {
    "NIP": "'198501042010121004",
    "STATUS SEKARANG": "Tugas Belajar",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Ir. I Gede Mahendra Darmawiguna, S.Kom., M.Sc.",
    "JURUSAN": "Sistem Informasi (SI) (S1)",
    "FAKULTAS": "Fakultas Teknik dan Kejuruan",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "UNIT KERJA": "-",
    "POINT PERFORMANCE": 0,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 0,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 0,
    "PPh 100%": 0,
    "JUMLAH KOTOR 70% (Rp)": 0,
    "PPh 21": 0,
    "JUMLAH BERSIH 70% (Rp)": 0,
    "TANDA TANGAN": 342
  },
  {
    "NIP": "'198907112020122004",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Ir. I Gusti Ayu Agung Diatri Indradewi, S.Kom., M.T.",
    "JURUSAN": "Sistem Informasi (SI) (S1)",
    "FAKULTAS": "Fakultas Teknik dan Kejuruan",
    "GOLONGAN": "IIIC",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "STRUKTURAL": "Sekretaris Jurusan S1",
    "GRADE STRUKTURAL": 11,
    "UNIT KERJA": "Jurusan Teknik Informatika",
    "POINT POSITION": 2152.2,
    "POINT PERFORMANCE": 1285.17,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 3437.37,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 5156055,
    "PPh 100%": 257802.75,
    "JUMLAH KOTOR 30% (Rp)": 1755540,
    "JUMLAH KOTOR 70% (Rp)": 3400515,
    "PPh 21": 170025.75,
    "JUMLAH BERSIH 70% (Rp)": 3230489.25,
    "TANDA TANGAN": 343
  },
  {
    "NIP": "'198611182015041001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Ir. I Made Ardwi Pradnyana, S.T., M.T.",
    "JURUSAN": "Sistem Informasi (SI) (S1)",
    "FAKULTAS": "Fakultas Teknik dan Kejuruan",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "STRUKTURAL": "[REN223] Sekretaris Pusat/ Ketua Divisi/ Asrama/ Koordinator Lab. Jurusan Kepala Unit BPU/ Sekretaris Gugus Kendali Mutu Fakultas/ Sekretaris Tim Pengelolaan dan Penerimaan Mahasiswa Asing/ Sekretaris Unit Pengembangan dan Peningkatan Kapasitas Kelembagaan",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Unit Penunjang Akademik Teknologi Informasi dan Komunikasi",
    "POINT POSITION": 1200,
    "POINT PERFORMANCE": 1588,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 2788,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 4182000,
    "PPh 100%": 209100,
    "JUMLAH KOTOR 30% (Rp)": 1327050,
    "JUMLAH KOTOR 70% (Rp)": 2854950,
    "PPh 21": 142747.5,
    "JUMLAH BERSIH 70% (Rp)": 2712202.5,
    "TANDA TANGAN": 344
  },
  {
    "NIP": "'199005152019031008",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Ir. I Made Dendi Maysanjaya, S.Pd., M.Eng.",
    "JURUSAN": "Sistem Informasi (SI) (S1)",
    "FAKULTAS": "Fakultas Teknik dan Kejuruan",
    "GOLONGAN": "IIIC",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "STRUKTURAL": "Koordinator Program Studi S1/D3",
    "GRADE STRUKTURAL": 11,
    "UNIT KERJA": "Sistem Informasi (SI) (S1)",
    "POINT POSITION": 1899,
    "POINT PERFORMANCE": 1368,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 3267,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 4900500,
    "PPh 100%": 245025,
    "JUMLAH KOTOR 30% (Rp)": 1641600,
    "JUMLAH KOTOR 70% (Rp)": 3258900,
    "PPh 21": 162945,
    "JUMLAH BERSIH 70% (Rp)": 3095955,
    "TANDA TANGAN": 345
  },
  {
    "NIP": "'198608122019031005",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Ir. I Made Edy Listartha, S.Kom.,M.Kom.",
    "JURUSAN": "Sistem Informasi (SI) (S1)",
    "FAKULTAS": "Fakultas Teknik dan Kejuruan",
    "GOLONGAN": "IIIC",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "STRUKTURAL": "[REN223] Sekretaris Pusat/ Ketua Divisi/ Asrama/ Koordinator Lab. Jurusan Kepala Unit BPU/ Sekretaris Gugus Kendali Mutu Fakultas/ Sekretaris Tim Pengelolaan dan Penerimaan Mahasiswa Asing/ Sekretaris Unit Pengembangan dan Peningkatan Kapasitas Kelembagaan",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "-",
    "POINT POSITION": 800,
    "POINT PERFORMANCE": 1209.17,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 2009.17,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 3013755,
    "PPh 100%": 150687.75,
    "JUMLAH KOTOR 30% (Rp)": 1147050,
    "JUMLAH KOTOR 70% (Rp)": 1866705,
    "PPh 21": 93335.25,
    "JUMLAH BERSIH 70% (Rp)": 1773369.75,
    "TANDA TANGAN": 346
  },
  {
    "NIP": "'199111302024061001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Ir. I Nyoman Tri Anindia Putra, S.Kom., M.Cs.",
    "JURUSAN": "Sistem Informasi (SI) (S1)",
    "FAKULTAS": "Fakultas Teknik dan Kejuruan",
    "GOLONGAN": "IIIB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Tenaga Pengajar",
    "GRADE FUNGSIONAL": 7,
    "UNIT KERJA": "-",
    "POINT PERFORMANCE": 662.333,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 662.333,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 993499.5,
    "PPh 100%": 49674.975,
    "JUMLAH KOTOR 30% (Rp)": 545400,
    "JUMLAH KOTOR 70% (Rp)": 448099.5,
    "PPh 21": 22404.975,
    "JUMLAH BERSIH 70% (Rp)": 425694.525,
    "TANDA TANGAN": 347
  },
  {
    "NIP": "'199308042020122008",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Ir. Putu Yudia Pratiwi, S.Pd., M.Eng.",
    "JURUSAN": "Sistem Informasi (SI) (S1)",
    "FAKULTAS": "Fakultas Teknik dan Kejuruan",
    "GOLONGAN": "IIIC",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "STRUKTURAL": "[REN222] Kepala Pusat /Kantor/Kepala Gugus Kendali Mutu Fakultas/Ketua Unit Pengelolaan dan Penerimaan Mahasiswa Asing/ Ketua Unit Pengembangan dan Peningkatan Kapasitas Kelembagaan",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Fakultas Teknik dan Kejuruan",
    "POINT POSITION": 1150,
    "POINT PERFORMANCE": 1486.67,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 2636.67,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 3955005,
    "PPh 100%": 197750.25,
    "JUMLAH KOTOR 30% (Rp)": 1304550,
    "JUMLAH KOTOR 70% (Rp)": 2650455,
    "PPh 21": 132522.75,
    "JUMLAH BERSIH 70% (Rp)": 2517932.25,
    "TANDA TANGAN": 348
  },
  {
    "NIP": "'198804232024211001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PPPK",
    "NAMA DOSEN": "Putu Buddhi Prameswara, M.Kom.",
    "JURUSAN": "Sistem Informasi (SI) (S1)",
    "FAKULTAS": "Fakultas Teknik dan Kejuruan",
    "GOLONGAN": "X",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Asisten Ahli",
    "GRADE FUNGSIONAL": 8,
    "STRUKTURAL": "[REN126] Pengelola Gugus Kendali Mutu (Fakultas) sebagai Anggota",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Fakultas Teknik dan Kejuruan",
    "POINT POSITION": 200,
    "POINT PERFORMANCE": 406.24,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 606.24,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 909360,
    "PPh 100%": 45468,
    "JUMLAH KOTOR 30% (Rp)": 746550,
    "JUMLAH KOTOR 70% (Rp)": 162810,
    "PPh 21": 8140.5,
    "JUMLAH BERSIH 70% (Rp)": 154669.5,
    "TANDA TANGAN": 349
  },
  {
    "NIP": "'198806222015041003",
    "STATUS SEKARANG": "Tugas Belajar",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "A.A. Gede Yudhi Paramartha, S.Kom., M.Kom.",
    "JURUSAN": "Ilmu Komputer (S1)",
    "FAKULTAS": "Fakultas Teknik dan Kejuruan",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "TIDAK ADA",
    "STATUS PENGABDIAN": "TIDAK ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "UNIT KERJA": "-",
    "POINT POSITION": 0,
    "POINT PERFORMANCE": 0,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 0,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 0,
    "PPh 100%": 0,
    "JUMLAH KOTOR 70% (Rp)": 0,
    "PPh 21": 0,
    "JUMLAH BERSIH 70% (Rp)": 0,
    "TANDA TANGAN": 350
  },
  {
    "NIP": "'197905112006041004",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "I Ketut Purnamawan, S.Kom., M.Kom.",
    "JURUSAN": "Ilmu Komputer (S1)",
    "FAKULTAS": "Fakultas Teknik dan Kejuruan",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "STRUKTURAL": "[REN126] Pengelola Gugus Kendali Mutu (Fakultas) sebagai Anggota",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Fakultas Teknik dan Kejuruan",
    "POINT POSITION": 200,
    "POINT PERFORMANCE": 1306.17,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 1506.17,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 2259255,
    "PPh 100%": 112962.75,
    "JUMLAH KOTOR 30% (Rp)": 877050,
    "JUMLAH KOTOR 70% (Rp)": 1382205,
    "PPh 21": 69110.25,
    "JUMLAH BERSIH 70% (Rp)": 1313094.75,
    "TANDA TANGAN": 351
  },
  {
    "NIP": "'198005242014041003",
    "STATUS SEKARANG": "Tugas Belajar",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "I Made Putrama, S.T., M.Tech., Ph.D.",
    "JURUSAN": "Ilmu Komputer (S1)",
    "FAKULTAS": "Fakultas Teknik dan Kejuruan",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "TIDAK ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "UNIT KERJA": "-",
    "POINT POSITION": 0,
    "POINT PERFORMANCE": 0,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 0,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 0,
    "PPh 100%": 0,
    "JUMLAH KOTOR 70% (Rp)": 0,
    "PPh 21": 0,
    "JUMLAH BERSIH 70% (Rp)": 0,
    "TANDA TANGAN": 352
  },
  {
    "NIP": "'198910262019031004",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "I Nyoman Saputra Wahyu Wijaya, S.Kom., M.Cs.",
    "JURUSAN": "Ilmu Komputer (S1)",
    "FAKULTAS": "Fakultas Teknik dan Kejuruan",
    "GOLONGAN": "IIIC",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "STRUKTURAL": "Koordinator Program Studi S1/D3",
    "GRADE STRUKTURAL": 11,
    "UNIT KERJA": "Ilmu Komputer (S1)",
    "POINT POSITION": 1899,
    "POINT PERFORMANCE": 1569.83,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 3468.83,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 5203245,
    "PPh 100%": 260162.25,
    "JUMLAH KOTOR 30% (Rp)": 1641600,
    "JUMLAH KOTOR 70% (Rp)": 3561645,
    "PPh 21": 178082.25,
    "JUMLAH BERSIH 70% (Rp)": 3383562.75,
    "TANDA TANGAN": 353
  },
  {
    "NIP": "'198412012012121002",
    "STATUS SEKARANG": "Ijin Belajar",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Ir. I Ketut Resika Arthana, S.T., M.Kom.",
    "JURUSAN": "Ilmu Komputer (S1)",
    "FAKULTAS": "Fakultas Teknik dan Kejuruan",
    "GOLONGAN": "IVA",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor Kepala",
    "GRADE FUNGSIONAL": 11,
    "STRUKTURAL": "Kepala UPA",
    "GRADE STRUKTURAL": 12,
    "UNIT KERJA": "Unit Penunjang Akademik Teknologi Informasi dan Komunikasi",
    "POINT POSITION": 4516.5,
    "POINT PERFORMANCE": 2252.17,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 6768.67,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 10153005,
    "PPh 100%": 1522950.75,
    "JUMLAH KOTOR 30% (Rp)": 3171825,
    "JUMLAH KOTOR 70% (Rp)": 6981180,
    "PPh 21": 1047177,
    "JUMLAH BERSIH 70% (Rp)": 5934003,
    "TANDA TANGAN": 354
  },
  {
    "NIP": "'197803242005011001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Kadek Yota Ernanda Aryanto, S.Kom., M.T., Ph.D.",
    "JURUSAN": "Ilmu Komputer (S1)",
    "FAKULTAS": "Fakultas Teknik dan Kejuruan",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor Kepala",
    "GRADE FUNGSIONAL": 11,
    "STRUKTURAL": "Sekretaris Senat Universitas",
    "GRADE STRUKTURAL": 13,
    "UNIT KERJA": "-",
    "POINT POSITION": 5400,
    "POINT PERFORMANCE": 2389.33,
    "POINT KELEBIHAN": 456,
    "POINT TOTAL": 8245.33,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 12367995,
    "PPh 100%": 618399.75,
    "JUMLAH KOTOR 30% (Rp)": 3569400,
    "JUMLAH KOTOR 70% (Rp)": 8798595,
    "PPh 21": 439929.75,
    "JUMLAH BERSIH 70% (Rp)": 8358665.25,
    "TANDA TANGAN": 355
  },
  {
    "NIP": "'199205082024062002",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Ni Luh Dewi Sintiari, S.Pd., M.Sc., Ph.D.",
    "JURUSAN": "Ilmu Komputer (S1)",
    "FAKULTAS": "Fakultas Teknik dan Kejuruan",
    "GOLONGAN": "IIIB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Tenaga Pengajar",
    "GRADE FUNGSIONAL": 7,
    "STRUKTURAL": "[REN126] Pengelola Gugus Kendali Mutu (Fakultas) sebagai Anggota",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Fakultas Teknik dan Kejuruan",
    "POINT POSITION": 200,
    "POINT PERFORMANCE": 665.167,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 865.167,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 1297750.5,
    "PPh 100%": 64887.525,
    "JUMLAH KOTOR 30% (Rp)": 635400,
    "JUMLAH KOTOR 70% (Rp)": 662350.5,
    "PPh 21": 33117.525,
    "JUMLAH BERSIH 70% (Rp)": 629232.975,
    "TANDA TANGAN": 356
  },
  {
    "NIP": "'199410032020122015",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Ni Putu Novita Puspa Dewi, S.Kom., M.Cs., MIM.",
    "JURUSAN": "Ilmu Komputer (S1)",
    "FAKULTAS": "Fakultas Teknik dan Kejuruan",
    "GOLONGAN": "IIIC",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "STRUKTURAL": "[REN126] Pengelola Gugus Kendali Mutu (Fakultas) sebagai Anggota",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Fakultas Teknik dan Kejuruan",
    "POINT POSITION": 200,
    "POINT PERFORMANCE": 1430.67,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 1630.67,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 2446005,
    "PPh 100%": 122300.25,
    "JUMLAH KOTOR 30% (Rp)": 877050,
    "JUMLAH KOTOR 70% (Rp)": 1568955,
    "PPh 21": 78447.75,
    "JUMLAH BERSIH 70% (Rp)": 1490507.25,
    "TANDA TANGAN": 357
  },
  {
    "NIP": "'197103031997032001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. Cokorda Istri Raka Marsiti, S.Pd., M.Pd.",
    "JURUSAN": "Pendidikan Vokasional Seni Kuliner (S1)",
    "FAKULTAS": "Fakultas Teknik dan Kejuruan",
    "GOLONGAN": "IVB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor Kepala",
    "GRADE FUNGSIONAL": 11,
    "STRUKTURAL": "Ketua Senat Fakultas",
    "GRADE STRUKTURAL": 11,
    "UNIT KERJA": "Fakultas Teknik dan Kejuruan",
    "POINT POSITION": 2278.8,
    "POINT PERFORMANCE": 1957.5,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 4236.3,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 6354450,
    "PPh 100%": 953167.5,
    "JUMLAH KOTOR 30% (Rp)": 2164860,
    "JUMLAH KOTOR 70% (Rp)": 4189590,
    "PPh 21": 628438.5,
    "JUMLAH BERSIH 70% (Rp)": 3561151.5,
    "TANDA TANGAN": 358
  },
  {
    "NIP": "'197107111999032001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. Ni Wayan Sukerti, S.Pd., M.Pd.",
    "JURUSAN": "Pendidikan Vokasional Seni Kuliner (S1)",
    "FAKULTAS": "Fakultas Teknik dan Kejuruan",
    "GOLONGAN": "IVC",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor Kepala",
    "GRADE FUNGSIONAL": 11,
    "STRUKTURAL": "Kepala UPA",
    "GRADE STRUKTURAL": 12,
    "UNIT KERJA": "Unit Penunjang Akademik Pengembangan Karier dan Kewirausahaan",
    "POINT POSITION": 2559.35,
    "POINT PERFORMANCE": 2422.33,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 4981.68,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 7472520,
    "PPh 100%": 1120878,
    "JUMLAH KOTOR 30% (Rp)": 2291107.5,
    "JUMLAH KOTOR 70% (Rp)": 5181412.5,
    "PPh 21": 777211.875,
    "JUMLAH BERSIH 70% (Rp)": 4404200.625,
    "TANDA TANGAN": 359
  },
  {
    "NIP": "'196502191991032001",
    "STATUS SEKARANG": "Ijin Belajar",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dra. Damiati, M.Kes.",
    "JURUSAN": "Pendidikan Vokasional Seni Kuliner (S1)",
    "FAKULTAS": "Fakultas Teknik dan Kejuruan",
    "GOLONGAN": "IVA",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor Kepala",
    "GRADE FUNGSIONAL": 11,
    "UNIT KERJA": "-",
    "POINT PERFORMANCE": 1955,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 1955,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 2932500,
    "PPh 100%": 439875,
    "JUMLAH KOTOR 30% (Rp)": 1139400,
    "JUMLAH KOTOR 70% (Rp)": 1793100,
    "PPh 21": 268965,
    "JUMLAH BERSIH 70% (Rp)": 1524135,
    "TANDA TANGAN": 360
  },
  {
    "NIP": "'199009252019032016",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Anjar Tri Astuti, S.ST.,M.Keb.",
    "JURUSAN": "Kebidanan (D3)",
    "FAKULTAS": "Fakultas Kedokteran",
    "GOLONGAN": "IIIC",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "STRUKTURAL": "[REN223] Sekretaris Pusat/ Ketua Divisi/ Asrama/ Koordinator Lab. Jurusan Kepala Unit BPU/ Sekretaris Gugus Kendali Mutu Fakultas/ Sekretaris Tim Pengelolaan dan Penerimaan Mahasiswa Asing/ Sekretaris Unit Pengembangan dan Peningkatan Kapasitas Kelembagaan",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Fakultas Kedokteran",
    "POINT POSITION": 800,
    "POINT PERFORMANCE": 569.417,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 1369.42,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 2054130,
    "PPh 100%": 102706.5,
    "JUMLAH KOTOR 30% (Rp)": 1147050,
    "JUMLAH KOTOR 70% (Rp)": 907080,
    "PPh 21": 45354,
    "JUMLAH BERSIH 70% (Rp)": 861726,
    "TANDA TANGAN": 361
  },
  {
    "NIP": "'199108022024062001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Bdn. Luh Yenny Armayanti, S.ST., M.Biomed",
    "JURUSAN": "Kebidanan (D3)",
    "FAKULTAS": "Fakultas Kedokteran",
    "GOLONGAN": "IIIB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Tenaga Pengajar",
    "GRADE FUNGSIONAL": 7,
    "STRUKTURAL": "[REN126] Pengelola Gugus Kendali Mutu (Fakultas) sebagai Anggota",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Fakultas Kedokteran",
    "POINT POSITION": 200,
    "POINT PERFORMANCE": 447.333,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 647.333,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 970999.5,
    "PPh 100%": 48549.975,
    "JUMLAH KOTOR 30% (Rp)": 635400,
    "JUMLAH KOTOR 70% (Rp)": 335599.5,
    "PPh 21": 16779.975,
    "JUMLAH BERSIH 70% (Rp)": 318819.525,
    "TANDA TANGAN": 362
  },
  {
    "NIP": "'198612272019032006",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Bdn. Ni Nyoman Ayu Desy Sekarini, SST.,M.Keb.",
    "JURUSAN": "Kebidanan (D3)",
    "FAKULTAS": "Fakultas Kedokteran",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "UNIT KERJA": "-",
    "POINT PERFORMANCE": 359.5,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 359.5,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 539250,
    "PPh 100%": 26962.5,
    "JUMLAH KOTOR 30% (Rp)": 787050,
    "JUMLAH KOTOR 70% (Rp)": 0,
    "PPh 21": 0,
    "JUMLAH BERSIH 70% (Rp)": 0,
    "TANDA TANGAN": 363
  },
  {
    "NIP": "'199007222019032010",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Bdn. Putu Irma Pratiwi, S.Tr.Keb.,M.Keb.",
    "JURUSAN": "Kebidanan (D3)",
    "FAKULTAS": "Fakultas Kedokteran",
    "GOLONGAN": "IIIC",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "STRUKTURAL": "Koordinator Program Studi S1/D3",
    "GRADE STRUKTURAL": 11,
    "UNIT KERJA": "Kebidanan (S1)",
    "POINT POSITION": 1645.8,
    "POINT PERFORMANCE": 684.75,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 2330.55,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 3495825,
    "PPh 100%": 174791.25,
    "JUMLAH KOTOR 30% (Rp)": 1527660,
    "JUMLAH KOTOR 70% (Rp)": 1968165,
    "PPh 21": 98408.25,
    "JUMLAH BERSIH 70% (Rp)": 1869756.75,
    "TANDA TANGAN": 364
  },
  {
    "NIP": "'199108282018032001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. Luh Ari Arini, S.ST., M.Biomed.",
    "JURUSAN": "Kebidanan (D3)",
    "FAKULTAS": "Fakultas Kedokteran",
    "GOLONGAN": "IIIC",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "STRUKTURAL": "Koordinator Program Studi S1/D3",
    "GRADE STRUKTURAL": 11,
    "UNIT KERJA": "Kebidanan (D3)",
    "POINT POSITION": 1645.8,
    "POINT PERFORMANCE": 853.25,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 2499.05,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 3748575,
    "PPh 100%": 187428.75,
    "JUMLAH KOTOR 30% (Rp)": 1527660,
    "JUMLAH KOTOR 70% (Rp)": 2220915,
    "PPh 21": 111045.75,
    "JUMLAH BERSIH 70% (Rp)": 2109869.25,
    "TANDA TANGAN": 365
  },
  {
    "NIP": "'198307162006042009",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. Luh Nik Armini, S.ST., M.Keb.",
    "JURUSAN": "Kebidanan (D3)",
    "FAKULTAS": "Fakultas Kedokteran",
    "GOLONGAN": "IIIC",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "STRUKTURAL": "Koordinator Program Studi S1/D3",
    "GRADE STRUKTURAL": 11,
    "UNIT KERJA": "Pendidikan Profesi Bidan",
    "POINT POSITION": 800,
    "POINT PERFORMANCE": 701.25,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 1501.25,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 2251875,
    "PPh 100%": 112593.75,
    "JUMLAH KOTOR 30% (Rp)": 1147050,
    "JUMLAH KOTOR 70% (Rp)": 1104825,
    "PPh 21": 55241.25,
    "JUMLAH BERSIH 70% (Rp)": 1049583.75,
    "TANDA TANGAN": 366
  },
  {
    "NIP": "'197908022006042008",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. Ni Komang Sulyastini, S.ST., M.Pd.",
    "JURUSAN": "Kebidanan (D3)",
    "FAKULTAS": "Fakultas Kedokteran",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "UNIT KERJA": "-",
    "POINT PERFORMANCE": 758.667,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 758.667,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 1138000.5,
    "PPh 100%": 56900.025,
    "JUMLAH KOTOR 30% (Rp)": 787050,
    "JUMLAH KOTOR 70% (Rp)": 350950.5,
    "PPh 21": 17547.525,
    "JUMLAH BERSIH 70% (Rp)": 333402.975,
    "TANDA TANGAN": 367
  },
  {
    "NIP": "'198907172020122022",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Hesteria Friska Armynia Subratha, S.ST., M.Kes.",
    "JURUSAN": "Kebidanan (D3)",
    "FAKULTAS": "Fakultas Kedokteran",
    "GOLONGAN": "IIIC",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "STRUKTURAL": "[REN126] Pengelola Gugus Kendali Mutu (Fakultas) sebagai Anggota",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Fakultas Kedokteran",
    "POINT POSITION": 200,
    "POINT PERFORMANCE": 801.25,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 1001.25,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 1501875,
    "PPh 100%": 75093.75,
    "JUMLAH KOTOR 30% (Rp)": 877050,
    "JUMLAH KOTOR 70% (Rp)": 624825,
    "PPh 21": 31241.25,
    "JUMLAH BERSIH 70% (Rp)": 593583.75,
    "TANDA TANGAN": 368
  },
  {
    "NIP": "'198206292006042016",
    "STATUS SEKARANG": "Ijin Belajar",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Ketut Espana Giri, S.ST., M.Kes.",
    "JURUSAN": "Kebidanan (D3)",
    "FAKULTAS": "Fakultas Kedokteran",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "STRUKTURAL": "[REN223] Sekretaris Pusat/ Ketua Divisi/ Asrama/ Koordinator Lab. Jurusan Kepala Unit BPU/ Sekretaris Gugus Kendali Mutu Fakultas/ Sekretaris Tim Pengelolaan dan Penerimaan Mahasiswa Asing/ Sekretaris Unit Pengembangan dan Peningkatan Kapasitas Kelembagaan",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Fakultas Kedokteran",
    "POINT POSITION": 800,
    "POINT PERFORMANCE": 440.917,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 1240.92,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 1861380,
    "PPh 100%": 93069,
    "JUMLAH KOTOR 30% (Rp)": 1147050,
    "JUMLAH KOTOR 70% (Rp)": 714330,
    "PPh 21": 35716.5,
    "JUMLAH BERSIH 70% (Rp)": 678613.5,
    "TANDA TANGAN": 369
  },
  {
    "NIP": "'199506172022032020",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Nabila Amelia Hanisyah Putri, M.Keb.",
    "JURUSAN": "Kebidanan (D3)",
    "FAKULTAS": "Fakultas Kedokteran",
    "GOLONGAN": "IIIB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Asisten Ahli",
    "GRADE FUNGSIONAL": 8,
    "STRUKTURAL": "[REN126] Pengelola Gugus Kendali Mutu (Fakultas) sebagai Anggota",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Fakultas Kedokteran",
    "POINT POSITION": 200,
    "POINT PERFORMANCE": 632.542,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 832.542,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 1248813,
    "PPh 100%": 62440.65,
    "JUMLAH KOTOR 30% (Rp)": 746550,
    "JUMLAH KOTOR 70% (Rp)": 502263,
    "PPh 21": 25113.15,
    "JUMLAH BERSIH 70% (Rp)": 477149.85,
    "TANDA TANGAN": 370
  },
  {
    "NIP": "'199412272022032012",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Nis'atul Khoiroh, M.Keb.",
    "JURUSAN": "Kebidanan (D3)",
    "FAKULTAS": "Fakultas Kedokteran",
    "GOLONGAN": "IIIB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Asisten Ahli",
    "GRADE FUNGSIONAL": 8,
    "STRUKTURAL": "[REN126] Pengelola Gugus Kendali Mutu (Fakultas) sebagai Anggota",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Fakultas Kedokteran",
    "POINT POSITION": 200,
    "POINT PERFORMANCE": 446.417,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 646.417,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 969625.5,
    "PPh 100%": 48481.275,
    "JUMLAH KOTOR 30% (Rp)": 746550,
    "JUMLAH KOTOR 70% (Rp)": 223075.5,
    "PPh 21": 11153.775,
    "JUMLAH BERSIH 70% (Rp)": 211921.725,
    "TANDA TANGAN": 371
  },
  {
    "NIP": "'199506292024062001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Putu Eva Yuni Dyantari, S.Tr.Keb., M.Keb.",
    "JURUSAN": "Kebidanan (D3)",
    "FAKULTAS": "Fakultas Kedokteran",
    "GOLONGAN": "IIIB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Tenaga Pengajar",
    "GRADE FUNGSIONAL": 7,
    "STRUKTURAL": "[REN126] Pengelola Gugus Kendali Mutu (Fakultas) sebagai Anggota",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Fakultas Kedokteran",
    "POINT POSITION": 200,
    "POINT PERFORMANCE": 305.354,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 505.354,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 758031,
    "PPh 100%": 37901.55,
    "JUMLAH KOTOR 30% (Rp)": 635400,
    "JUMLAH KOTOR 70% (Rp)": 122631,
    "PPh 21": 6131.55,
    "JUMLAH BERSIH 70% (Rp)": 116499.45,
    "TANDA TANGAN": 372
  },
  {
    "NIP": "'198810302020121009",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. Hendra Mashuri, M.Pd.",
    "JURUSAN": "Pendidikan Jasmani, Kesehatan dan Rekreasi /PJKR (S1)",
    "FAKULTAS": "Fakultas Olahraga dan Kesehatan",
    "GOLONGAN": "IVA",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor Kepala",
    "GRADE FUNGSIONAL": 11,
    "STRUKTURAL": "[REN126] Pengelola Gugus Kendali Mutu (Fakultas) sebagai Anggota",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Fakultas Olahraga dan Kesehatan",
    "POINT POSITION": 200,
    "POINT PERFORMANCE": 1866,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 2066,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 3099000,
    "PPh 100%": 464850,
    "JUMLAH KOTOR 30% (Rp)": 1139400,
    "JUMLAH KOTOR 70% (Rp)": 1959600,
    "PPh 21": 293940,
    "JUMLAH BERSIH 70% (Rp)": 1665660,
    "TANDA TANGAN": 373
  },
  {
    "NIP": "'198501172008121001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. I Gede Suwiwa, S.Pd., M.Pd.",
    "JURUSAN": "Pendidikan Jasmani, Kesehatan dan Rekreasi /PJKR (S1)",
    "FAKULTAS": "Fakultas Olahraga dan Kesehatan",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor Kepala",
    "GRADE FUNGSIONAL": 11,
    "STRUKTURAL": "Wakil Dekan I",
    "GRADE STRUKTURAL": 14,
    "UNIT KERJA": "Fakultas Olahraga dan Kesehatan",
    "POINT POSITION": 8640,
    "POINT PERFORMANCE": 2003.83,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 10643.8,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 15965700,
    "PPh 100%": 798285,
    "JUMLAH KOTOR 30% (Rp)": 5027400,
    "JUMLAH KOTOR 70% (Rp)": 10938300,
    "PPh 21": 546915,
    "JUMLAH BERSIH 70% (Rp)": 10391385,
    "TANDA TANGAN": 374
  },
  {
    "NIP": "'198003112008121002",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. I Ketut Semarayasa, S.Pd., M.Or., AIFO-P",
    "JURUSAN": "Pendidikan Jasmani, Kesehatan dan Rekreasi /PJKR (S1)",
    "FAKULTAS": "Fakultas Olahraga dan Kesehatan",
    "GOLONGAN": "IVA",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor Kepala",
    "GRADE FUNGSIONAL": 11,
    "STRUKTURAL": "Koordinator Program Studi S2",
    "GRADE STRUKTURAL": 12,
    "UNIT KERJA": "Pendidikan Olahraga (S2)",
    "POINT POSITION": 2559.35,
    "POINT PERFORMANCE": 1950,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 4509.35,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 6764025,
    "PPh 100%": 1014603.75,
    "JUMLAH KOTOR 30% (Rp)": 2291107.5,
    "JUMLAH KOTOR 70% (Rp)": 4472917.5,
    "PPh 21": 670937.625,
    "JUMLAH BERSIH 70% (Rp)": 3801979.875,
    "TANDA TANGAN": 375
  },
  {
    "NIP": "'198206062008121002",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. I Made Satyawan, S.Pd., M.Pd.",
    "JURUSAN": "Pendidikan Jasmani, Kesehatan dan Rekreasi /PJKR (S1)",
    "FAKULTAS": "Fakultas Olahraga dan Kesehatan",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "STRUKTURAL": "Wakil Dekan III",
    "GRADE STRUKTURAL": 14,
    "UNIT KERJA": "Fakultas Olahraga dan Kesehatan",
    "POINT POSITION": 8640,
    "POINT PERFORMANCE": 1388.17,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 10028.2,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 15042300,
    "PPh 100%": 752115,
    "JUMLAH KOTOR 30% (Rp)": 4675050,
    "JUMLAH KOTOR 70% (Rp)": 10367250,
    "PPh 21": 518362.5,
    "JUMLAH BERSIH 70% (Rp)": 9848887.5,
    "TANDA TANGAN": 376
  },
  {
    "NIP": "'198410252008121002",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. Kadek Yogi Parta Lesmana, S.Pd., M.Pd., AIFO-P",
    "JURUSAN": "Pendidikan Jasmani, Kesehatan dan Rekreasi /PJKR (S1)",
    "FAKULTAS": "Fakultas Olahraga dan Kesehatan",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor Kepala",
    "GRADE FUNGSIONAL": 11,
    "STRUKTURAL": "Sekretaris Program Studi S2",
    "GRADE STRUKTURAL": 11,
    "UNIT KERJA": "Pendidikan Olahraga (S2)",
    "POINT POSITION": 2152.2,
    "POINT PERFORMANCE": 1803.17,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 3955.37,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 5933055,
    "PPh 100%": 296652.75,
    "JUMLAH KOTOR 30% (Rp)": 2107890,
    "JUMLAH KOTOR 70% (Rp)": 3825165,
    "PPh 21": 191258.25,
    "JUMLAH BERSIH 70% (Rp)": 3633906.75,
    "TANDA TANGAN": 377
  },
  {
    "NIP": "'198008112008121001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. Made Agus Wijaya, S.Pd., M.Pd.",
    "JURUSAN": "Pendidikan Jasmani, Kesehatan dan Rekreasi /PJKR (S1)",
    "FAKULTAS": "Fakultas Olahraga dan Kesehatan",
    "GOLONGAN": "IVA",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor Kepala",
    "GRADE FUNGSIONAL": 11,
    "STRUKTURAL": "Ketua Jurusan S1",
    "GRADE STRUKTURAL": 12,
    "UNIT KERJA": "Jurusan Pendidikan Olahraga",
    "POINT POSITION": 2258.25,
    "POINT PERFORMANCE": 2041.17,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 4299.42,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 6449130,
    "PPh 100%": 967369.5,
    "JUMLAH KOTOR 30% (Rp)": 2155612.5,
    "JUMLAH KOTOR 70% (Rp)": 4293517.5,
    "PPh 21": 644027.625,
    "JUMLAH BERSIH 70% (Rp)": 3649489.875,
    "TANDA TANGAN": 378
  },
  {
    "NIP": "'197001291994031002",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. Wahjoedi, S.Pd., M.Pd.",
    "JURUSAN": "Pendidikan Jasmani, Kesehatan dan Rekreasi /PJKR (S1)",
    "FAKULTAS": "Fakultas Olahraga dan Kesehatan",
    "GOLONGAN": "IVB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor Kepala",
    "GRADE FUNGSIONAL": 11,
    "STRUKTURAL": "[REN126] Pengelola Gugus Kendali Mutu (Fakultas) sebagai Anggota",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Fakultas Olahraga dan Kesehatan",
    "POINT POSITION": 200,
    "POINT PERFORMANCE": 1361.9,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 1561.9,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 2342850,
    "PPh 100%": 351427.5,
    "JUMLAH KOTOR 30% (Rp)": 1139400,
    "JUMLAH KOTOR 70% (Rp)": 1203450,
    "PPh 21": 180517.5,
    "JUMLAH BERSIH 70% (Rp)": 1022932.5,
    "TANDA TANGAN": 379
  },
  {
    "NIP": "'196307091990031001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Drs. I Putu Panca Adi, M.Pd.",
    "JURUSAN": "Pendidikan Jasmani, Kesehatan dan Rekreasi /PJKR (S1)",
    "FAKULTAS": "Fakultas Olahraga dan Kesehatan",
    "GOLONGAN": "IVB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor Kepala",
    "GRADE FUNGSIONAL": 11,
    "STRUKTURAL": "[REN223] Sekretaris Pusat/ Ketua Divisi/ Asrama/ Koordinator Lab. Jurusan Kepala Unit BPU/ Sekretaris Gugus Kendali Mutu Fakultas/ Sekretaris Tim Pengelolaan dan Penerimaan Mahasiswa Asing/ Sekretaris Unit Pengembangan dan Peningkatan Kapasitas Kelembagaan",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Fakultas Olahraga dan Kesehatan",
    "POINT POSITION": 800,
    "POINT PERFORMANCE": 1025.98,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 1825.98,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 2738970,
    "PPh 100%": 410845.5,
    "JUMLAH KOTOR 30% (Rp)": 1499400,
    "JUMLAH KOTOR 70% (Rp)": 1239570,
    "PPh 21": 185935.5,
    "JUMLAH BERSIH 70% (Rp)": 1053634.5,
    "TANDA TANGAN": 380
  },
  {
    "NIP": "'196804081997031002",
    "STATUS SEKARANG": "Ijin Belajar",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "I Ketut Budaya Astra, S.Pd., M.Or.",
    "JURUSAN": "Pendidikan Jasmani, Kesehatan dan Rekreasi /PJKR (S1)",
    "FAKULTAS": "Fakultas Olahraga dan Kesehatan",
    "GOLONGAN": "IVC",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor Kepala",
    "GRADE FUNGSIONAL": 11,
    "STRUKTURAL": "Ketua Senat Fakultas",
    "GRADE STRUKTURAL": 11,
    "UNIT KERJA": "Fakultas Olahraga dan Kesehatan",
    "POINT POSITION": 2025.6,
    "POINT PERFORMANCE": 1146.07,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 3171.67,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 4757505,
    "PPh 100%": 713625.75,
    "JUMLAH KOTOR 30% (Rp)": 2050920,
    "JUMLAH KOTOR 70% (Rp)": 2706585,
    "PPh 21": 405987.75,
    "JUMLAH BERSIH 70% (Rp)": 2300597.25,
    "TANDA TANGAN": 381
  },
  {
    "NIP": "'198503082019031005",
    "STATUS SEKARANG": "Ijin Belajar",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "I Komang Sukarata Adnyana, S.Pd., M.Or.",
    "JURUSAN": "Pendidikan Jasmani, Kesehatan dan Rekreasi /PJKR (S1)",
    "FAKULTAS": "Fakultas Olahraga dan Kesehatan",
    "GOLONGAN": "IIIC",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "STRUKTURAL": "Koordinator Program Studi S1/D3",
    "GRADE STRUKTURAL": 11,
    "UNIT KERJA": "Pendidikan Jasmani, Kesehatan dan Rekreasi /PJKR (S1)",
    "POINT POSITION": 1899,
    "POINT PERFORMANCE": 1263.67,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 3162.67,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 4744005,
    "PPh 100%": 237200.25,
    "JUMLAH KOTOR 30% (Rp)": 1641600,
    "JUMLAH KOTOR 70% (Rp)": 3102405,
    "PPh 21": 155120.25,
    "JUMLAH BERSIH 70% (Rp)": 2947284.75,
    "TANDA TANGAN": 382
  },
  {
    "NIP": "'199610222024061001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "I Putu Agus Dharma Hita, S.Pd., M.Or.",
    "JURUSAN": "Pendidikan Jasmani, Kesehatan dan Rekreasi /PJKR (S1)",
    "FAKULTAS": "Fakultas Olahraga dan Kesehatan",
    "GOLONGAN": "IIIB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Tenaga Pengajar",
    "GRADE FUNGSIONAL": 7,
    "STRUKTURAL": "[REN224] Sekretaris Unit BPU",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Fakultas Olahraga dan Kesehatan",
    "POINT POSITION": 500,
    "POINT PERFORMANCE": 733.177,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 1233.18,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 1849770,
    "PPh 100%": 92488.5,
    "JUMLAH KOTOR 30% (Rp)": 770400,
    "JUMLAH KOTOR 70% (Rp)": 1079370,
    "PPh 21": 53968.5,
    "JUMLAH BERSIH 70% (Rp)": 1025401.5,
    "TANDA TANGAN": 383
  },
  {
    "NIP": "'196902061996011001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "I Putu Darmayasa, S.Pd., M.For.",
    "JURUSAN": "Pendidikan Jasmani, Kesehatan dan Rekreasi /PJKR (S1)",
    "FAKULTAS": "Fakultas Olahraga dan Kesehatan",
    "GOLONGAN": "IVB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor Kepala",
    "GRADE FUNGSIONAL": 11,
    "STRUKTURAL": "[REN126] Pengelola Gugus Kendali Mutu (Fakultas) sebagai Anggota",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Fakultas Olahraga dan Kesehatan",
    "POINT POSITION": 200,
    "POINT PERFORMANCE": 1383.07,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 1583.07,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 2374605,
    "PPh 100%": 356190.75,
    "JUMLAH KOTOR 30% (Rp)": 1139400,
    "JUMLAH KOTOR 70% (Rp)": 1235205,
    "PPh 21": 185280.75,
    "JUMLAH BERSIH 70% (Rp)": 1049924.25,
    "TANDA TANGAN": 384
  },
  {
    "NIP": "'198403032008122004",
    "STATUS SEKARANG": "Ijin Belajar",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Ni Luh Putu Spyanawati, S.Pd., M.Pd.",
    "JURUSAN": "Pendidikan Jasmani, Kesehatan dan Rekreasi /PJKR (S1)",
    "FAKULTAS": "Fakultas Olahraga dan Kesehatan",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "STRUKTURAL": "Sekretaris Jurusan S1",
    "GRADE STRUKTURAL": 11,
    "UNIT KERJA": "Jurusan Pendidikan Olahraga",
    "POINT POSITION": 1899,
    "POINT PERFORMANCE": 1188.33,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 3087.33,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 4630995,
    "PPh 100%": 231549.75,
    "JUMLAH KOTOR 30% (Rp)": 1641600,
    "JUMLAH KOTOR 70% (Rp)": 2989395,
    "PPh 21": 149469.75,
    "JUMLAH BERSIH 70% (Rp)": 2839925.25,
    "TANDA TANGAN": 385
  },
  {
    "NIP": "'198705222015042004",
    "STATUS SEKARANG": "Ijin Belajar",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Ni Putu Dwi Sucita Dartini, S.Pd., M.Pd.",
    "JURUSAN": "Pendidikan Jasmani, Kesehatan dan Rekreasi /PJKR (S1)",
    "FAKULTAS": "Fakultas Olahraga dan Kesehatan",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "STRUKTURAL": "[REN222] Kepala Pusat /Kantor/Kepala Gugus Kendali Mutu Fakultas/Ketua Unit Pengelolaan dan Penerimaan Mahasiswa Asing/ Ketua Unit Pengembangan dan Peningkatan Kapasitas Kelembagaan",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "-",
    "POINT POSITION": 1150,
    "POINT PERFORMANCE": 1270.7,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 2420.7,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 3631050,
    "PPh 100%": 181552.5,
    "JUMLAH KOTOR 30% (Rp)": 1304550,
    "JUMLAH KOTOR 70% (Rp)": 2326500,
    "PPh 21": 116325,
    "JUMLAH BERSIH 70% (Rp)": 2210175,
    "TANDA TANGAN": 386
  },
  {
    "NIP": "'199202022019031025",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Peby Gunarto, S.Pd.,M.Pd.",
    "JURUSAN": "Pendidikan Jasmani, Kesehatan dan Rekreasi /PJKR (S1)",
    "FAKULTAS": "Fakultas Olahraga dan Kesehatan",
    "GOLONGAN": "IIIC",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "STRUKTURAL": "[REN126] Pengelola Gugus Kendali Mutu (Fakultas) sebagai Anggota",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Fakultas Olahraga dan Kesehatan",
    "POINT POSITION": 200,
    "POINT PERFORMANCE": 950.764,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 1150.76,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 1726140,
    "PPh 100%": 86307,
    "JUMLAH KOTOR 30% (Rp)": 787050,
    "JUMLAH KOTOR 70% (Rp)": 939090,
    "PPh 21": 46954.5,
    "JUMLAH BERSIH 70% (Rp)": 892135.5,
    "TANDA TANGAN": 387
  },
  {
    "NIP": "'197309262001121001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Prof. Dr. I Wayan Artanayasa, S.Pd., M.Pd., AIFO-FIT.",
    "JURUSAN": "Pendidikan Jasmani, Kesehatan dan Rekreasi /PJKR (S1)",
    "FAKULTAS": "Fakultas Olahraga dan Kesehatan",
    "GOLONGAN": "IVD",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Guru Besar",
    "GRADE FUNGSIONAL": 12,
    "STRUKTURAL": "Wakil Rektor II",
    "GRADE STRUKTURAL": 16,
    "UNIT KERJA": "-",
    "POINT POSITION": 16460,
    "POINT PERFORMANCE": 2664.59,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 19124.6,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 28686900,
    "PPh 100%": 4303035,
    "JUMLAH KOTOR 30% (Rp)": 8761950,
    "JUMLAH KOTOR 70% (Rp)": 19924950,
    "PPh 21": 2988742.5,
    "JUMLAH BERSIH 70% (Rp)": 16936207.5,
    "TANDA TANGAN": 388
  },
  {
    "NIP": "'198905232022031003",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. Anak Agung Ngurah Putra Laksana, S.Pd., M.Pd.",
    "JURUSAN": "Pendidikan Kepelatihan Olahraga (S1)",
    "FAKULTAS": "Fakultas Olahraga dan Kesehatan",
    "GOLONGAN": "IIIC",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "STRUKTURAL": "[REN126] Pengelola Gugus Kendali Mutu (Fakultas) sebagai Anggota",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Fakultas Olahraga dan Kesehatan",
    "POINT POSITION": 200,
    "POINT PERFORMANCE": 992.667,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 1192.67,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 1789005,
    "PPh 100%": 89450.25,
    "JUMLAH KOTOR 30% (Rp)": 787050,
    "JUMLAH KOTOR 70% (Rp)": 1001955,
    "PPh 21": 50097.75,
    "JUMLAH BERSIH 70% (Rp)": 951857.25,
    "TANDA TANGAN": 389
  },
  {
    "NIP": "'197903172008121005",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. Gede Eka Budi Darmawan, S.Pd., M.Or.",
    "JURUSAN": "Pendidikan Kepelatihan Olahraga (S1)",
    "FAKULTAS": "Fakultas Olahraga dan Kesehatan",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "STRUKTURAL": "Ketua Jurusan S1",
    "GRADE STRUKTURAL": 12,
    "UNIT KERJA": "Jurusan Ilmu Olahraga dan Kesehatan",
    "POINT POSITION": 2258.25,
    "POINT PERFORMANCE": 1041.17,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 3299.42,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 4949130,
    "PPh 100%": 247456.5,
    "JUMLAH KOTOR 30% (Rp)": 1803262.5,
    "JUMLAH KOTOR 70% (Rp)": 3145867.5,
    "PPh 21": 157293.375,
    "JUMLAH BERSIH 70% (Rp)": 2988574.125,
    "TANDA TANGAN": 390
  },
  {
    "NIP": "'198407162008121001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. I Wayan Muliarta, S.Pd., M.Or.",
    "JURUSAN": "Pendidikan Kepelatihan Olahraga (S1)",
    "FAKULTAS": "Fakultas Olahraga dan Kesehatan",
    "GOLONGAN": "IVA",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor Kepala",
    "GRADE FUNGSIONAL": 11,
    "STRUKTURAL": "Sekretaris Pusat Layanan Pengabdian Kepada Masyarakat",
    "GRADE STRUKTURAL": 11,
    "UNIT KERJA": "-",
    "POINT POSITION": 1645.8,
    "POINT PERFORMANCE": 1371.67,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 3017.47,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 4526205,
    "PPh 100%": 678930.75,
    "JUMLAH KOTOR 30% (Rp)": 1880010,
    "JUMLAH KOTOR 70% (Rp)": 2646195,
    "PPh 21": 396929.25,
    "JUMLAH BERSIH 70% (Rp)": 2249265.75,
    "TANDA TANGAN": 391
  },
  {
    "NIP": "'197812142001122001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. Luh Putu Tuti Ariani, S.Pd., M.Fis.",
    "JURUSAN": "Pendidikan Kepelatihan Olahraga (S1)",
    "FAKULTAS": "Fakultas Olahraga dan Kesehatan",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor Kepala",
    "GRADE FUNGSIONAL": 11,
    "STRUKTURAL": "[REN225] Anggota Divisi",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "-",
    "POINT POSITION": 250,
    "POINT PERFORMANCE": 1685,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 1935,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 2902500,
    "PPh 100%": 145125,
    "JUMLAH KOTOR 30% (Rp)": 1251900,
    "JUMLAH KOTOR 70% (Rp)": 1650600,
    "PPh 21": 82530,
    "JUMLAH BERSIH 70% (Rp)": 1568070,
    "TANDA TANGAN": 392
  },
  {
    "NIP": "'197105202001121002",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. Suratmin, S.Pd., M.Or.",
    "JURUSAN": "Pendidikan Kepelatihan Olahraga (S1)",
    "FAKULTAS": "Fakultas Olahraga dan Kesehatan",
    "GOLONGAN": "IVA",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor Kepala",
    "GRADE FUNGSIONAL": 11,
    "STRUKTURAL": "[REN126] Pengelola Gugus Kendali Mutu (Fakultas) sebagai Anggota",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Fakultas Olahraga dan Kesehatan",
    "POINT POSITION": 200,
    "POINT PERFORMANCE": 1513.17,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 1713.17,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 2569755,
    "PPh 100%": 385463.25,
    "JUMLAH KOTOR 30% (Rp)": 1139400,
    "JUMLAH KOTOR 70% (Rp)": 1430355,
    "PPh 21": 214553.25,
    "JUMLAH BERSIH 70% (Rp)": 1215801.75,
    "TANDA TANGAN": 393
  },
  {
    "NIP": "'197711152001121001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. Syarif Hidayat, S.Pd., M.Pd.",
    "JURUSAN": "Pendidikan Kepelatihan Olahraga (S1)",
    "FAKULTAS": "Fakultas Olahraga dan Kesehatan",
    "GOLONGAN": "IVA",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor Kepala",
    "GRADE FUNGSIONAL": 11,
    "STRUKTURAL": "Koordinator Program Studi S1/D3",
    "GRADE STRUKTURAL": 11,
    "UNIT KERJA": "Pendidikan Kepelatihan Olahraga (S1)",
    "POINT POSITION": 1645.8,
    "POINT PERFORMANCE": 1756.5,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 3402.3,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 5103450,
    "PPh 100%": 765517.5,
    "JUMLAH KOTOR 30% (Rp)": 1880010,
    "JUMLAH KOTOR 70% (Rp)": 3223440,
    "PPh 21": 483516,
    "JUMLAH BERSIH 70% (Rp)": 2739924,
    "TANDA TANGAN": 394
  },
  {
    "NIP": "'197806012001122001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. Wasti Danardani, S.Pd., M.A.",
    "JURUSAN": "Pendidikan Kepelatihan Olahraga (S1)",
    "FAKULTAS": "Fakultas Olahraga dan Kesehatan",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "STRUKTURAL": "[REN223] Sekretaris Pusat/ Ketua Divisi/ Asrama/ Koordinator Lab. Jurusan Kepala Unit BPU/ Sekretaris Gugus Kendali Mutu Fakultas/ Sekretaris Tim Pengelolaan dan Penerimaan Mahasiswa Asing/ Sekretaris Unit Pengembangan dan Peningkatan Kapasitas Kelembagaan",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Fakultas Olahraga dan Kesehatan",
    "POINT POSITION": 800,
    "POINT PERFORMANCE": 1032.5,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 1832.5,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 2748750,
    "PPh 100%": 137437.5,
    "JUMLAH KOTOR 30% (Rp)": 1147050,
    "JUMLAH KOTOR 70% (Rp)": 1601700,
    "PPh 21": 80085,
    "JUMLAH BERSIH 70% (Rp)": 1521615,
    "TANDA TANGAN": 395
  },
  {
    "NIP": "'197905132006041002",
    "STATUS SEKARANG": "Ijin Belajar",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "I Kadek Happy Kardiawan, S.Pd., M.Pd.",
    "JURUSAN": "Pendidikan Kepelatihan Olahraga (S1)",
    "FAKULTAS": "Fakultas Olahraga dan Kesehatan",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "STRUKTURAL": "Sekretaris Senat Fakultas",
    "GRADE STRUKTURAL": 10,
    "UNIT KERJA": "Fakultas Olahraga dan Kesehatan",
    "POINT POSITION": 1684.8,
    "POINT PERFORMANCE": 968.833,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 2653.63,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 3980445,
    "PPh 100%": 199022.25,
    "JUMLAH KOTOR 30% (Rp)": 1545210,
    "JUMLAH KOTOR 70% (Rp)": 2435235,
    "PPh 21": 121761.75,
    "JUMLAH BERSIH 70% (Rp)": 2313473.25,
    "TANDA TANGAN": 396
  },
  {
    "NIP": "'198712252014041001",
    "STATUS SEKARANG": "Ijin Belajar",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Ketut Chandra Adinata Kusuma, S.Pd., M.Pd.",
    "JURUSAN": "Pendidikan Kepelatihan Olahraga (S1)",
    "FAKULTAS": "Fakultas Olahraga dan Kesehatan",
    "GOLONGAN": "IVA",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor Kepala",
    "GRADE FUNGSIONAL": 11,
    "STRUKTURAL": "Sekretaris Jurusan S1",
    "GRADE STRUKTURAL": 11,
    "UNIT KERJA": "Jurusan Ilmu Olahraga dan Kesehatan",
    "POINT POSITION": 1899,
    "POINT PERFORMANCE": 1702,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 3601,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 5401500,
    "PPh 100%": 810225,
    "JUMLAH KOTOR 30% (Rp)": 1993950,
    "JUMLAH KOTOR 70% (Rp)": 3407550,
    "PPh 21": 511132.5,
    "JUMLAH BERSIH 70% (Rp)": 2896417.5,
    "TANDA TANGAN": 397
  },
  {
    "NIP": "'197608272006041001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Prof. Dr. Made Agus Dharmadi, S.Pd., M.Pd.",
    "JURUSAN": "Pendidikan Kepelatihan Olahraga (S1)",
    "FAKULTAS": "Fakultas Olahraga dan Kesehatan",
    "GOLONGAN": "IVB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Guru Besar",
    "GRADE FUNGSIONAL": 12,
    "STRUKTURAL": "Kepala Pusat Penjaminan Mutu",
    "GRADE STRUKTURAL": 12,
    "UNIT KERJA": "-",
    "POINT POSITION": 1957.15,
    "POINT PERFORMANCE": 2243.17,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 4200.32,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 6300480,
    "PPh 100%": 945072,
    "JUMLAH KOTOR 30% (Rp)": 2235667.5,
    "JUMLAH KOTOR 70% (Rp)": 4064812.5,
    "PPh 21": 609721.875,
    "JUMLAH BERSIH 70% (Rp)": 3455090.625,
    "TANDA TANGAN": 398
  },
  {
    "NIP": "'198405212008121002",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. Gede Doddy Tisna, M.S., S.Or., M.Or.",
    "JURUSAN": "Ilmu Keolahragaan (S1)",
    "FAKULTAS": "Fakultas Olahraga dan Kesehatan",
    "GOLONGAN": "IVA",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor Kepala",
    "GRADE FUNGSIONAL": 11,
    "STRUKTURAL": "Wakil Dekan II",
    "GRADE STRUKTURAL": 14,
    "UNIT KERJA": "Fakultas Olahraga dan Kesehatan",
    "POINT POSITION": 8640,
    "POINT PERFORMANCE": 1645.33,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 10285.3,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 15427950,
    "PPh 100%": 2314192.5,
    "JUMLAH KOTOR 30% (Rp)": 5027400,
    "JUMLAH KOTOR 70% (Rp)": 10400550,
    "PPh 21": 1560082.5,
    "JUMLAH BERSIH 70% (Rp)": 8840467.5,
    "TANDA TANGAN": 399
  },
  {
    "NIP": "'197305112001121001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. I Ketut Iwan Swadesi, S.Pd., M.Or.",
    "JURUSAN": "Ilmu Keolahragaan (S1)",
    "FAKULTAS": "Fakultas Olahraga dan Kesehatan",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor Kepala",
    "GRADE FUNGSIONAL": 11,
    "STRUKTURAL": "Koordinator Program Studi S1/D3",
    "GRADE STRUKTURAL": 11,
    "UNIT KERJA": "Ilmu Keolahragaan (S1)",
    "POINT POSITION": 1645.8,
    "POINT PERFORMANCE": 1859.83,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 3505.63,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 5258445,
    "PPh 100%": 262922.25,
    "JUMLAH KOTOR 30% (Rp)": 1880010,
    "JUMLAH KOTOR 70% (Rp)": 3378435,
    "PPh 21": 168921.75,
    "JUMLAH BERSIH 70% (Rp)": 3209513.25,
    "TANDA TANGAN": 400
  },
  {
    "NIP": "'196805172001121001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. I Ketut Yoda, S.Pd., M.Or.",
    "JURUSAN": "Ilmu Keolahragaan (S1)",
    "FAKULTAS": "Fakultas Olahraga dan Kesehatan",
    "GOLONGAN": "IVB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor Kepala",
    "GRADE FUNGSIONAL": 11,
    "STRUKTURAL": "Dekan",
    "GRADE STRUKTURAL": 15,
    "UNIT KERJA": "Fakultas Olahraga dan Kesehatan",
    "POINT POSITION": 10320,
    "POINT PERFORMANCE": 1793.33,
    "POINT KELEBIHAN": 218.817,
    "POINT TOTAL": 12332.2,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 18498300,
    "PPh 100%": 2774745,
    "JUMLAH KOTOR 30% (Rp)": 5783400,
    "JUMLAH KOTOR 70% (Rp)": 12714900,
    "PPh 21": 1907235,
    "JUMLAH BERSIH 70% (Rp)": 10807665,
    "TANDA TANGAN": 401
  },
  {
    "NIP": "'198608102008121001",
    "STATUS SEKARANG": "Ijin Belajar",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "I Nyoman Sudarmada, S.Or., M.Or.",
    "JURUSAN": "Ilmu Keolahragaan (S1)",
    "FAKULTAS": "Fakultas Olahraga dan Kesehatan",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "STRUKTURAL": "Sekretaris UPA",
    "GRADE STRUKTURAL": 11,
    "UNIT KERJA": "Unit Penunjang Akademik Pengembangan Karier dan Kewirausahaan",
    "POINT POSITION": 2152.2,
    "POINT PERFORMANCE": 744.5,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 2896.7,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 4345050,
    "PPh 100%": 217252.5,
    "JUMLAH KOTOR 30% (Rp)": 1755540,
    "JUMLAH KOTOR 70% (Rp)": 2589510,
    "PPh 21": 129475.5,
    "JUMLAH BERSIH 70% (Rp)": 2460034.5,
    "TANDA TANGAN": 402
  },
  {
    "NIP": "'199205072022032013",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Luh Ita Mahendrayani, S.Ft., Ftr., M.Fis.",
    "JURUSAN": "Ilmu Keolahragaan (S1)",
    "FAKULTAS": "Fakultas Olahraga dan Kesehatan",
    "GOLONGAN": "IIIB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Asisten Ahli",
    "GRADE FUNGSIONAL": 8,
    "STRUKTURAL": "[REN126] Pengelola Gugus Kendali Mutu (Fakultas) sebagai Anggota",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Fakultas Olahraga dan Kesehatan",
    "POINT POSITION": 200,
    "POINT PERFORMANCE": 648.583,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 848.583,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 1272874.5,
    "PPh 100%": 63643.725,
    "JUMLAH KOTOR 30% (Rp)": 656550,
    "JUMLAH KOTOR 70% (Rp)": 616324.5,
    "PPh 21": 30816.225,
    "JUMLAH BERSIH 70% (Rp)": 585508.275,
    "TANDA TANGAN": 403
  },
  {
    "NIP": "'196705272001121001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Prof. Dr. I Ketut Sudiana, S.Pd., M.Kes.",
    "JURUSAN": "Ilmu Keolahragaan (S1)",
    "FAKULTAS": "Fakultas Olahraga dan Kesehatan",
    "GOLONGAN": "IVC",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Guru Besar",
    "GRADE FUNGSIONAL": 12,
    "STRUKTURAL": "Ketua Laboratorium Fakultas",
    "GRADE STRUKTURAL": 12,
    "UNIT KERJA": "Fakultas Olahraga dan Kesehatan",
    "POINT POSITION": 2408.8,
    "POINT PERFORMANCE": 2027,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 4435.8,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 6653700,
    "PPh 100%": 998055,
    "JUMLAH KOTOR 30% (Rp)": 2438910,
    "JUMLAH KOTOR 70% (Rp)": 4214790,
    "PPh 21": 632218.5,
    "JUMLAH BERSIH 70% (Rp)": 3582571.5,
    "TANDA TANGAN": 404
  },
  {
    "NIP": "'197508012006042001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. Ni Ketut Widiartini, S.Pd., M.Pd.",
    "JURUSAN": "Penelitian dan Evaluasi Pendidikan(S2)",
    "FAKULTAS": "Program Pascasarjana",
    "GOLONGAN": "IVB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor Kepala",
    "GRADE FUNGSIONAL": 11,
    "STRUKTURAL": "Wakil Dekan II",
    "GRADE STRUKTURAL": 14,
    "UNIT KERJA": "Fakultas Teknik dan Kejuruan",
    "POINT POSITION": 9720,
    "POINT PERFORMANCE": 2355.19,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 12075.2,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 18112800,
    "PPh 100%": 2716920,
    "JUMLAH KOTOR 30% (Rp)": 5513400,
    "JUMLAH KOTOR 70% (Rp)": 12599400,
    "PPh 21": 1889910,
    "JUMLAH BERSIH 70% (Rp)": 10709490,
    "TANDA TANGAN": 405
  },
  {
    "NIP": "'196906061994121001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Prof. Dr. I Gusti Lanang Agung Parwata, S.Pd., M.Kes.",
    "JURUSAN": "Penelitian dan Evaluasi Pendidikan(S2)",
    "FAKULTAS": "Program Pascasarjana",
    "GOLONGAN": "IVC",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Guru Besar",
    "GRADE FUNGSIONAL": 12,
    "STRUKTURAL": "Sekretaris Lembaga",
    "GRADE STRUKTURAL": 14,
    "UNIT KERJA": "-",
    "POINT POSITION": 9180,
    "POINT PERFORMANCE": 2531.33,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 11711.3,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 17566950,
    "PPh 100%": 2635042.5,
    "JUMLAH KOTOR 30% (Rp)": 5485950,
    "JUMLAH KOTOR 70% (Rp)": 12081000,
    "PPh 21": 1812150,
    "JUMLAH BERSIH 70% (Rp)": 10268850,
    "TANDA TANGAN": 406
  },
  {
    "NIP": "'196012311986011003",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Prof. Dr. I Gusti Ngurah Pujawan, M.Kes.",
    "JURUSAN": "Penelitian dan Evaluasi Pendidikan(S2)",
    "FAKULTAS": "Program Pascasarjana",
    "GOLONGAN": "IVD",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Guru Besar",
    "GRADE FUNGSIONAL": 12,
    "STRUKTURAL": "[REN126] Pengelola Gugus Kendali Mutu (Fakultas) sebagai Anggota",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Penelitian dan Evaluasi Pendidikan(S2)",
    "POINT POSITION": 200,
    "POINT PERFORMANCE": 2893.17,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 3093.17,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 4639755,
    "PPh 100%": 695963.25,
    "JUMLAH KOTOR 30% (Rp)": 1444950,
    "JUMLAH KOTOR 70% (Rp)": 3194805,
    "PPh 21": 479220.75,
    "JUMLAH BERSIH 70% (Rp)": 2715584.25,
    "TANDA TANGAN": 407
  },
  {
    "NIP": "'198407242015041002",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Prof. Dr. Ir. Dewa Gede Hendra Divayana, S.Kom., M.Kom., MCE., IPU., ASEAN.Eng., APEC.Eng.",
    "JURUSAN": "Penelitian dan Evaluasi Pendidikan(S2)",
    "FAKULTAS": "Program Pascasarjana",
    "GOLONGAN": "IVB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Guru Besar",
    "GRADE FUNGSIONAL": 12,
    "STRUKTURAL": "[REN126] Pengelola Gugus Kendali Mutu (Fakultas) sebagai Anggota",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Penelitian dan Evaluasi Pendidikan(S2)",
    "POINT POSITION": 200,
    "POINT PERFORMANCE": 2850.17,
    "POINT KELEBIHAN": 414,
    "POINT TOTAL": 3464.17,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 5196255,
    "PPh 100%": 779438.25,
    "JUMLAH KOTOR 30% (Rp)": 1444950,
    "JUMLAH KOTOR 70% (Rp)": 3751305,
    "PPh 21": 562695.75,
    "JUMLAH BERSIH 70% (Rp)": 3188609.25,
    "TANDA TANGAN": 408
  },
  {
    "NIP": "'197609022000031001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. Dewa Putu Ramendra, S.Pd., M.Pd.",
    "JURUSAN": "Pendidikan Bahasa (S2)",
    "FAKULTAS": "Program Pascasarjana",
    "GOLONGAN": "IVA",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor Kepala",
    "GRADE FUNGSIONAL": 11,
    "STRUKTURAL": "Sekretaris Program Studi S2",
    "GRADE STRUKTURAL": 11,
    "UNIT KERJA": "Pendidikan Bahasa Inggris (S2)",
    "POINT POSITION": 2152.2,
    "POINT PERFORMANCE": 2253.83,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 4406.03,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 6609045,
    "PPh 100%": 991356.75,
    "JUMLAH KOTOR 30% (Rp)": 2107890,
    "JUMLAH KOTOR 70% (Rp)": 4501155,
    "PPh 21": 675173.25,
    "JUMLAH BERSIH 70% (Rp)": 3825981.75,
    "TANDA TANGAN": 409
  },
  {
    "NIP": "'198212082008011005",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. I Ketut Paramarta, S.S., M.Hum.",
    "JURUSAN": "Pendidikan Bahasa (S2)",
    "FAKULTAS": "Program Pascasarjana",
    "GOLONGAN": "IVA",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor Kepala",
    "GRADE FUNGSIONAL": 11,
    "STRUKTURAL": "Sekretaris Jurusan S1",
    "GRADE STRUKTURAL": 11,
    "UNIT KERJA": "Jurusan Bahasa dan Sastra Indonesia dan Daerah",
    "POINT POSITION": 2152.2,
    "POINT PERFORMANCE": 1967.83,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 4120.03,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 6180045,
    "PPh 100%": 927006.75,
    "JUMLAH KOTOR 30% (Rp)": 2107890,
    "JUMLAH KOTOR 70% (Rp)": 4072155,
    "PPh 21": 610823.25,
    "JUMLAH BERSIH 70% (Rp)": 3461331.75,
    "TANDA TANGAN": 410
  },
  {
    "NIP": "'196707051994031004",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. I Wayan Artika, S.Pd., M.Hum.",
    "JURUSAN": "Pendidikan Bahasa (S2)",
    "FAKULTAS": "Program Pascasarjana",
    "GOLONGAN": "IVB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor Kepala",
    "GRADE FUNGSIONAL": 11,
    "STRUKTURAL": "Ketua Jurusan S1",
    "GRADE STRUKTURAL": 12,
    "UNIT KERJA": "Jurusan Bahasa dan Sastra Indonesia dan Daerah",
    "POINT POSITION": 2559.35,
    "POINT PERFORMANCE": 1972.17,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 4531.52,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 6797280,
    "PPh 100%": 1019592,
    "JUMLAH KOTOR 30% (Rp)": 2291107.5,
    "JUMLAH KOTOR 70% (Rp)": 4506172.5,
    "PPh 21": 675925.875,
    "JUMLAH BERSIH 70% (Rp)": 3830246.625,
    "TANDA TANGAN": 411
  },
  {
    "NIP": "'195812311985031022",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Prof. Dr. I Gede Budasi, M.Ed.",
    "JURUSAN": "Pendidikan Bahasa (S2)",
    "FAKULTAS": "Program Pascasarjana",
    "GOLONGAN": "IVD",
    "STATUS PENELITIAN": "TIDAK ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Guru Besar",
    "GRADE FUNGSIONAL": 12,
    "UNIT KERJA": "-",
    "POINT POSITION": 0,
    "POINT PERFORMANCE": 0,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 0,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 0,
    "PPh 100%": 0,
    "JUMLAH KOTOR 30% (Rp)": 1354950,
    "JUMLAH KOTOR 70% (Rp)": 0,
    "PPh 21": 0,
    "JUMLAH BERSIH 70% (Rp)": 0,
    "TANDA TANGAN": 412
  },
  {
    "NIP": "'196004241986031002",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Prof. Dr. I Made Sutama, M.Pd.",
    "JURUSAN": "Pendidikan Bahasa (S2)",
    "FAKULTAS": "Program Pascasarjana",
    "GOLONGAN": "IVE",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Guru Besar",
    "GRADE FUNGSIONAL": 12,
    "STRUKTURAL": "[REN220] Ketua Tim Ahli Rektor/ SP4/Kepala Balingkang Confucius Institute/Kepala Unit Kerjasama",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "-",
    "POINT POSITION": 1500,
    "POINT PERFORMANCE": 2566.67,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 4066.67,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 6100005,
    "PPh 100%": 915000.75,
    "JUMLAH KOTOR 30% (Rp)": 2029950,
    "JUMLAH KOTOR 70% (Rp)": 4070055,
    "PPh 21": 610508.25,
    "JUMLAH BERSIH 70% (Rp)": 3459546.75,
    "TANDA TANGAN": 413
  },
  {
    "NIP": "'195712311985031013",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Prof. Dr. I Nyoman Sudiana, M.Pd.",
    "JURUSAN": "Pendidikan Bahasa (S2)",
    "FAKULTAS": "Program Pascasarjana",
    "GOLONGAN": "IVE",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Guru Besar",
    "GRADE FUNGSIONAL": 12,
    "STRUKTURAL": "Ketua Senat Universitas",
    "GRADE STRUKTURAL": 14,
    "UNIT KERJA": "-",
    "POINT POSITION": 10800,
    "POINT PERFORMANCE": 2684.33,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 13484.3,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 20226450,
    "PPh 100%": 3033967.5,
    "JUMLAH KOTOR 30% (Rp)": 6214950,
    "JUMLAH KOTOR 70% (Rp)": 14011500,
    "PPh 21": 2101725,
    "JUMLAH BERSIH 70% (Rp)": 11909775,
    "TANDA TANGAN": 414
  },
  {
    "NIP": "'195605201983031002",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Prof. Dr. Anak Agung Gede Agung, M.Pd.",
    "JURUSAN": "Administrasi Pendidikan (S2)",
    "FAKULTAS": "Program Pascasarjana",
    "GOLONGAN": "IVE",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Guru Besar",
    "GRADE FUNGSIONAL": 12,
    "STRUKTURAL": "Wakil Direktur Sumber Daya dan Pembelajaran (SDP)",
    "GRADE STRUKTURAL": 14,
    "UNIT KERJA": "-",
    "POINT POSITION": 9180,
    "POINT PERFORMANCE": 2961.33,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 12141.3,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 18211950,
    "PPh 100%": 2731792.5,
    "JUMLAH KOTOR 30% (Rp)": 5485950,
    "JUMLAH KOTOR 70% (Rp)": 12726000,
    "PPh 21": 1908900,
    "JUMLAH BERSIH 70% (Rp)": 10817100,
    "TANDA TANGAN": 415
  },
  {
    "NIP": "'196008191985031001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Prof. Dr. I Made Yudana, M.Pd.",
    "JURUSAN": "Administrasi Pendidikan (S2)",
    "FAKULTAS": "Program Pascasarjana",
    "GOLONGAN": "IVE",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Guru Besar",
    "GRADE FUNGSIONAL": 12,
    "UNIT KERJA": "-",
    "POINT PERFORMANCE": 2902.83,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 2902.83,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 4354245,
    "PPh 100%": 653136.75,
    "JUMLAH KOTOR 30% (Rp)": 1354950,
    "JUMLAH KOTOR 70% (Rp)": 2999295,
    "PPh 21": 449894.25,
    "JUMLAH BERSIH 70% (Rp)": 2549400.75,
    "TANDA TANGAN": 416
  },
  {
    "NIP": "'196312311989031026",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. I Nyoman Tika, M.Si.",
    "JURUSAN": "Pendidikan Dasar (S2)",
    "FAKULTAS": "Program Pascasarjana",
    "GOLONGAN": "IVA",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor Kepala",
    "GRADE FUNGSIONAL": 11,
    "STRUKTURAL": "Koordinator Program Studi S2",
    "GRADE STRUKTURAL": 12,
    "UNIT KERJA": "Pendidikan IPA (S2)",
    "POINT POSITION": 2559.35,
    "POINT PERFORMANCE": 2358.17,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 4917.52,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 7376280,
    "PPh 100%": 1106442,
    "JUMLAH KOTOR 30% (Rp)": 2291107.5,
    "JUMLAH KOTOR 70% (Rp)": 5085172.5,
    "PPh 21": 762775.875,
    "JUMLAH BERSIH 70% (Rp)": 4322396.625,
    "TANDA TANGAN": 417
  },
  {
    "NIP": "'196112311987031013",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Prof. Dr. Dewa Bagus Sanjaya, M.Si.",
    "JURUSAN": "Pendidikan Dasar (S2)",
    "FAKULTAS": "Program Pascasarjana",
    "GOLONGAN": "IVD",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Guru Besar",
    "GRADE FUNGSIONAL": 12,
    "STRUKTURAL": "Ketua Laboratorium Fakultas",
    "GRADE STRUKTURAL": 12,
    "UNIT KERJA": "Fakultas Hukum dan Ilmu Sosial",
    "POINT POSITION": 2709.9,
    "POINT PERFORMANCE": 2946,
    "POINT KELEBIHAN": 514.527,
    "POINT TOTAL": 6170.43,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 9255645,
    "PPh 100%": 1388346.75,
    "JUMLAH KOTOR 30% (Rp)": 2574405,
    "JUMLAH KOTOR 70% (Rp)": 6681240,
    "PPh 21": 1002186,
    "JUMLAH BERSIH 70% (Rp)": 5679054,
    "TANDA TANGAN": 418
  },
  {
    "NIP": "'198007202006041001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Prof. Dr. I Nengah Suastika, S.Pd., M.Pd.",
    "JURUSAN": "Pendidikan Dasar (S2)",
    "FAKULTAS": "Program Pascasarjana",
    "GOLONGAN": "IVB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Guru Besar",
    "GRADE FUNGSIONAL": 12,
    "STRUKTURAL": "Dekan",
    "GRADE STRUKTURAL": 15,
    "UNIT KERJA": "Fakultas Hukum dan Ilmu Sosial",
    "POINT POSITION": 11610,
    "POINT PERFORMANCE": 2976.33,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 14586.3,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 21879450,
    "PPh 100%": 3281917.5,
    "JUMLAH KOTOR 30% (Rp)": 6579450,
    "JUMLAH KOTOR 70% (Rp)": 15300000,
    "PPh 21": 2295000,
    "JUMLAH BERSIH 70% (Rp)": 13005000,
    "TANDA TANGAN": 419
  },
  {
    "NIP": "'195910101986031003",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Prof. Dr. I Nyoman Jampel, M.Pd.",
    "JURUSAN": "Pendidikan Dasar (S2)",
    "FAKULTAS": "Program Pascasarjana",
    "GOLONGAN": "IVE",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Guru Besar",
    "GRADE FUNGSIONAL": 12,
    "STRUKTURAL": "Direktur Pascasarjana",
    "GRADE STRUKTURAL": 15,
    "UNIT KERJA": "Pascasarjana",
    "POINT POSITION": 10965,
    "POINT PERFORMANCE": 1957.45,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 12922.4,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 19383600,
    "PPh 100%": 2907540,
    "JUMLAH KOTOR 30% (Rp)": 6289200,
    "JUMLAH KOTOR 70% (Rp)": 13094400,
    "PPh 21": 1964160,
    "JUMLAH BERSIH 70% (Rp)": 11130240,
    "TANDA TANGAN": 420
  },
  {
    "NIP": "'198507052010121007",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Prof. Dr. I Wayan Widiana, S.Pd., M.Pd.",
    "JURUSAN": "Pendidikan Dasar (S2)",
    "FAKULTAS": "Program Pascasarjana",
    "GOLONGAN": "IVB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Guru Besar",
    "GRADE FUNGSIONAL": 12,
    "STRUKTURAL": "Dekan",
    "GRADE STRUKTURAL": 15,
    "UNIT KERJA": "Fakultas Ilmu Pendidikan",
    "POINT POSITION": 12900,
    "POINT PERFORMANCE": 2982.67,
    "POINT KELEBIHAN": 639.75,
    "POINT TOTAL": 16522.4,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 24783600,
    "PPh 100%": 3717540,
    "JUMLAH KOTOR 30% (Rp)": 7159950,
    "JUMLAH KOTOR 70% (Rp)": 17623650,
    "PPh 21": 2643547.5,
    "JUMLAH BERSIH 70% (Rp)": 14980102.5,
    "TANDA TANGAN": 421
  },
  {
    "NIP": "'195901281982031002",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Prof. Dr. Putu Budi Adnyana, M.Si.",
    "JURUSAN": "Pendidikan Dasar (S2)",
    "FAKULTAS": "Program Pascasarjana",
    "GOLONGAN": "IVE",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Guru Besar",
    "GRADE FUNGSIONAL": 12,
    "STRUKTURAL": "Ketua Senat Fakultas",
    "GRADE STRUKTURAL": 11,
    "UNIT KERJA": "Fakultas Matematika dan Ilmu Pengetahuan Alam",
    "POINT POSITION": 2278.8,
    "POINT PERFORMANCE": 2714.67,
    "POINT KELEBIHAN": 15.4433,
    "POINT TOTAL": 5008.91,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 7513365,
    "PPh 100%": 1127004.75,
    "JUMLAH KOTOR 30% (Rp)": 2380410,
    "JUMLAH KOTOR 70% (Rp)": 5132955,
    "PPh 21": 769943.25,
    "JUMLAH BERSIH 70% (Rp)": 4363011.75,
    "TANDA TANGAN": 422
  },
  {
    "NIP": "'197910232003121001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Made Hery Santosa, S.Pd, M.Pd., Ph.D.",
    "JURUSAN": "Pendidikan Bahasa Inggris (S2)",
    "FAKULTAS": "Program Pascasarjana",
    "GOLONGAN": "IVA",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor Kepala",
    "GRADE FUNGSIONAL": 11,
    "STRUKTURAL": "Ketua Laboratorium Fakultas",
    "GRADE STRUKTURAL": 12,
    "UNIT KERJA": "Fakultas Bahasa dan Seni",
    "POINT POSITION": 2709.9,
    "POINT PERFORMANCE": 2502,
    "POINT KELEBIHAN": 455.6,
    "POINT TOTAL": 5667.5,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 8501250,
    "PPh 100%": 1275187.5,
    "JUMLAH KOTOR 30% (Rp)": 2358855,
    "JUMLAH KOTOR 70% (Rp)": 6142395,
    "PPh 21": 921359.25,
    "JUMLAH BERSIH 70% (Rp)": 5221035.75,
    "TANDA TANGAN": 423
  },
  {
    "NIP": "'196203191987031001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Prof. Dr. I Nyoman Adi Jaya Putra, M.A.",
    "JURUSAN": "Pendidikan Bahasa Inggris (S2)",
    "FAKULTAS": "Program Pascasarjana",
    "GOLONGAN": "IVE",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Guru Besar",
    "GRADE FUNGSIONAL": 12,
    "UNIT KERJA": "-",
    "POINT PERFORMANCE": 1660.74,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 1660.74,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 2491110,
    "PPh 100%": 373666.5,
    "JUMLAH KOTOR 30% (Rp)": 1354950,
    "JUMLAH KOTOR 70% (Rp)": 1136160,
    "PPh 21": 170424,
    "JUMLAH BERSIH 70% (Rp)": 965736,
    "TANDA TANGAN": 424
  },
  {
    "NIP": "'196609081991022002",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Prof. Dr. Ni Made Ratminingsih, M.A.",
    "JURUSAN": "Pendidikan Bahasa Inggris (S2)",
    "FAKULTAS": "Program Pascasarjana",
    "GOLONGAN": "IVD",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Guru Besar",
    "GRADE FUNGSIONAL": 12,
    "UNIT KERJA": "-",
    "POINT PERFORMANCE": 2476,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 2476,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 3714000,
    "PPh 100%": 557100,
    "JUMLAH KOTOR 30% (Rp)": 1354950,
    "JUMLAH KOTOR 70% (Rp)": 2359050,
    "PPh 21": 353857.5,
    "JUMLAH BERSIH 70% (Rp)": 2005192.5,
    "TANDA TANGAN": 425
  },
  {
    "NIP": "'196202021988032001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Prof. Dr. Ni Nyoman Padmadewi, M.A.",
    "JURUSAN": "Pendidikan Bahasa Inggris (S2)",
    "FAKULTAS": "Program Pascasarjana",
    "GOLONGAN": "IVE",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Guru Besar",
    "GRADE FUNGSIONAL": 12,
    "STRUKTURAL": "Ketua Program Studi S3",
    "GRADE STRUKTURAL": 12,
    "UNIT KERJA": "Pendidikan Bahasa Inggris (S3)",
    "POINT POSITION": 2559.35,
    "POINT PERFORMANCE": 2983.33,
    "POINT KELEBIHAN": 75.25,
    "POINT TOTAL": 5617.93,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 8426895,
    "PPh 100%": 1264034.25,
    "JUMLAH KOTOR 30% (Rp)": 2506657.5,
    "JUMLAH KOTOR 70% (Rp)": 5920237.5,
    "PPh 21": 888035.625,
    "JUMLAH BERSIH 70% (Rp)": 5032201.875,
    "TANDA TANGAN": 426
  },
  {
    "NIP": "'196206261986032002",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Prof. Dr. Putu Kerti Nitiasih, M.A.",
    "JURUSAN": "Pendidikan Bahasa Inggris (S2)",
    "FAKULTAS": "Program Pascasarjana",
    "GOLONGAN": "IVE",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Guru Besar",
    "GRADE FUNGSIONAL": 12,
    "STRUKTURAL": "Ketua Program Studi S3",
    "GRADE STRUKTURAL": 12,
    "UNIT KERJA": "Ilmu Pendidikan (S3)",
    "POINT POSITION": 2559.35,
    "POINT PERFORMANCE": 2607.26,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 5166.61,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 7749915,
    "PPh 100%": 1162487.25,
    "JUMLAH KOTOR 30% (Rp)": 2506657.5,
    "JUMLAH KOTOR 70% (Rp)": 5243257.5,
    "PPh 21": 786488.625,
    "JUMLAH BERSIH 70% (Rp)": 4456768.875,
    "TANDA TANGAN": 427
  },
  {
    "NIP": "'196110201988031002",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Prof. Dr. I Putu Sriartha, M.S.",
    "JURUSAN": "Pendidikan Ilmu Pengetahuan Sosial (S2)",
    "FAKULTAS": "Program Pascasarjana",
    "GOLONGAN": "IVD",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Guru Besar",
    "GRADE FUNGSIONAL": 12,
    "STRUKTURAL": "[REN126] Pengelola Gugus Kendali Mutu (Fakultas) sebagai Anggota",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Pendidikan Ilmu Pengetahuan Sosial (S2)",
    "POINT POSITION": 200,
    "POINT PERFORMANCE": 2877.33,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 3077.33,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 4615995,
    "PPh 100%": 692399.25,
    "JUMLAH KOTOR 30% (Rp)": 1444950,
    "JUMLAH KOTOR 70% (Rp)": 3171045,
    "PPh 21": 475656.75,
    "JUMLAH BERSIH 70% (Rp)": 2695388.25,
    "TANDA TANGAN": 428
  },
  {
    "NIP": "'196411081990031002",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Prof. Dr. I Wayan Kertih, M.Pd.",
    "JURUSAN": "Pendidikan Ilmu Pengetahuan Sosial (S2)",
    "FAKULTAS": "Program Pascasarjana",
    "GOLONGAN": "IVD",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Guru Besar",
    "GRADE FUNGSIONAL": 12,
    "STRUKTURAL": "Koordinator Program Studi S2",
    "GRADE STRUKTURAL": 12,
    "UNIT KERJA": "Pendidikan Ilmu Pengetahuan Sosial (S2)",
    "POINT POSITION": 2559.35,
    "POINT PERFORMANCE": 2969.33,
    "POINT KELEBIHAN": 541.8,
    "POINT TOTAL": 6070.48,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 9105720,
    "PPh 100%": 1365858,
    "JUMLAH KOTOR 30% (Rp)": 2506657.5,
    "JUMLAH KOTOR 70% (Rp)": 6599062.5,
    "PPh 21": 989859.375,
    "JUMLAH BERSIH 70% (Rp)": 5609203.125,
    "TANDA TANGAN": 429
  },
  {
    "NIP": "'196303101988031003",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Prof. Dr. Sukadi, M.Pd., M.Ed.",
    "JURUSAN": "Pendidikan Ilmu Pengetahuan Sosial (S2)",
    "FAKULTAS": "Program Pascasarjana",
    "GOLONGAN": "IVE",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Guru Besar",
    "GRADE FUNGSIONAL": 12,
    "STRUKTURAL": "[REN221] Anggota Tim Ahli Rektor/SP4/ Sekretaris Balingkang Confucius Institute/ Sekretaris Unit Kerjasama",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "-",
    "POINT POSITION": 1300,
    "POINT PERFORMANCE": 2650.83,
    "POINT KELEBIHAN": 693.067,
    "POINT TOTAL": 4643.9,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 6965850,
    "PPh 100%": 1044877.5,
    "JUMLAH KOTOR 30% (Rp)": 1939950,
    "JUMLAH KOTOR 70% (Rp)": 5025900,
    "PPh 21": 753885,
    "JUMLAH BERSIH 70% (Rp)": 4272015,
    "TANDA TANGAN": 430
  },
  {
    "NIP": "'196711151993031001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. I Nyoman Sukajaya, M.T.",
    "JURUSAN": "Ilmu Komputer (S2)",
    "FAKULTAS": "Program Pascasarjana",
    "GOLONGAN": "IVB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor Kepala",
    "GRADE FUNGSIONAL": 11,
    "STRUKTURAL": "[REN126] Pengelola Gugus Kendali Mutu (Fakultas) sebagai Anggota",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Pendidikan Matematika (S1)",
    "POINT POSITION": 200,
    "POINT PERFORMANCE": 2182,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 2382,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 3573000,
    "PPh 100%": 535950,
    "JUMLAH KOTOR 30% (Rp)": 1229400,
    "JUMLAH KOTOR 70% (Rp)": 2343600,
    "PPh 21": 351540,
    "JUMLAH BERSIH 70% (Rp)": 1992060,
    "TANDA TANGAN": 431
  },
  {
    "NIP": "'197601022003121001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Prof. Dr. Gede Indrawan, S.T., M.T.",
    "JURUSAN": "Ilmu Komputer (S2)",
    "FAKULTAS": "Program Pascasarjana",
    "GOLONGAN": "IVB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Guru Besar",
    "GRADE FUNGSIONAL": 12,
    "STRUKTURAL": "Kepala Pusat Layanan Pengabdian Kepada Masyarakat",
    "GRADE STRUKTURAL": 12,
    "UNIT KERJA": "-",
    "POINT POSITION": 1957.15,
    "POINT PERFORMANCE": 983.167,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 2940.32,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 4410480,
    "PPh 100%": 661572,
    "JUMLAH KOTOR 30% (Rp)": 2235667.5,
    "JUMLAH KOTOR 70% (Rp)": 2174812.5,
    "PPh 21": 326221.875,
    "JUMLAH BERSIH 70% (Rp)": 1848590.625,
    "TANDA TANGAN": 432
  },
  {
    "NIP": "'197502212003121001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Prof. Dr. Gede Rasben Dantes, S.T., M.T.I.",
    "JURUSAN": "Ilmu Komputer (S2)",
    "FAKULTAS": "Program Pascasarjana",
    "GOLONGAN": "IVB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Guru Besar",
    "GRADE FUNGSIONAL": 12,
    "STRUKTURAL": "Wakil Rektor I",
    "GRADE STRUKTURAL": 16,
    "UNIT KERJA": "-",
    "POINT POSITION": 16460,
    "POINT PERFORMANCE": 2630.17,
    "POINT KELEBIHAN": 75.25,
    "POINT TOTAL": 19165.4,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 28748100,
    "PPh 100%": 4312215,
    "JUMLAH KOTOR 30% (Rp)": 8761950,
    "JUMLAH KOTOR 70% (Rp)": 19986150,
    "PPh 21": 2997922.5,
    "JUMLAH BERSIH 70% (Rp)": 16988227.5,
    "TANDA TANGAN": 433
  },
  {
    "NIP": "'197606252001122001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Prof. Dr. Luh Joni Erawati Dewi, S.T., M.Pd.",
    "JURUSAN": "Ilmu Komputer (S2)",
    "FAKULTAS": "Program Pascasarjana",
    "GOLONGAN": "IVB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor Kepala",
    "GRADE FUNGSIONAL": 11,
    "UNIT KERJA": "-",
    "POINT PERFORMANCE": 2350,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 2350,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 3525000,
    "PPh 100%": 528750,
    "JUMLAH KOTOR 30% (Rp)": 1139400,
    "JUMLAH KOTOR 70% (Rp)": 2385600,
    "PPh 21": 357840,
    "JUMLAH BERSIH 70% (Rp)": 2027760,
    "TANDA TANGAN": 434
  },
  {
    "NIP": "'196406151989021001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Prof. Drs. Sariyasa, M.Sc., Ph.D.",
    "JURUSAN": "Ilmu Komputer (S2)",
    "FAKULTAS": "Program Pascasarjana",
    "GOLONGAN": "IVD",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Guru Besar",
    "GRADE FUNGSIONAL": 12,
    "STRUKTURAL": "[REN126] Pengelola Gugus Kendali Mutu (Fakultas) sebagai Anggota",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Ilmu Komputer (S2)",
    "POINT POSITION": 200,
    "POINT PERFORMANCE": 2959.33,
    "POINT KELEBIHAN": 451.5,
    "POINT TOTAL": 3610.83,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 5416245,
    "PPh 100%": 812436.75,
    "JUMLAH KOTOR 30% (Rp)": 1444950,
    "JUMLAH KOTOR 70% (Rp)": 3971295,
    "PPh 21": 595694.25,
    "JUMLAH BERSIH 70% (Rp)": 3375600.75,
    "TANDA TANGAN": 435
  },
  {
    "NIP": "'196012311986012001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Prof. Dr. Desak Putu Parmiti, M.S.",
    "JURUSAN": "Bimbingan Konseling (S2)",
    "FAKULTAS": "Program Pascasarjana",
    "GOLONGAN": "IVE",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Guru Besar",
    "GRADE FUNGSIONAL": 12,
    "STRUKTURAL": "Koordinator Program Studi S2",
    "GRADE STRUKTURAL": 12,
    "UNIT KERJA": "Penelitian dan Evaluasi Pendidikan(S2)",
    "POINT POSITION": 2559.35,
    "POINT PERFORMANCE": 2990.33,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 5549.68,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 8324520,
    "PPh 100%": 1248678,
    "JUMLAH KOTOR 30% (Rp)": 2506657.5,
    "JUMLAH KOTOR 70% (Rp)": 5817862.5,
    "PPh 21": 872679.375,
    "JUMLAH BERSIH 70% (Rp)": 4945183.125,
    "TANDA TANGAN": 436
  },
  {
    "NIP": "'195708011983031003",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Prof. Dr. I Ketut Dharsana, M.Pd.",
    "JURUSAN": "Bimbingan Konseling (S2)",
    "FAKULTAS": "Program Pascasarjana",
    "GOLONGAN": "IVE",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Guru Besar",
    "GRADE FUNGSIONAL": 12,
    "STRUKTURAL": "[REN126] Pengelola Gugus Kendali Mutu (Fakultas) sebagai Anggota",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Bimbingan Konseling (S2)",
    "POINT POSITION": 200,
    "POINT PERFORMANCE": 2471.17,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 2671.17,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 4006755,
    "PPh 100%": 601013.25,
    "JUMLAH KOTOR 30% (Rp)": 1444950,
    "JUMLAH KOTOR 70% (Rp)": 2561805,
    "PPh 21": 384270.75,
    "JUMLAH BERSIH 70% (Rp)": 2177534.25,
    "TANDA TANGAN": 437
  },
  {
    "NIP": "'195912311984031009",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Prof. Dr. I Ketut Gading, M.Psi.",
    "JURUSAN": "Bimbingan Konseling (S2)",
    "FAKULTAS": "Program Pascasarjana",
    "GOLONGAN": "IVE",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Guru Besar",
    "GRADE FUNGSIONAL": 12,
    "STRUKTURAL": "[REN221] Anggota Tim Ahli Rektor/SP4/ Sekretaris Balingkang Confucius Institute/ Sekretaris Unit Kerjasama",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "-",
    "POINT POSITION": 1300,
    "POINT PERFORMANCE": 2684.33,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 3984.33,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 5976495,
    "PPh 100%": 896474.25,
    "JUMLAH KOTOR 30% (Rp)": 1939950,
    "JUMLAH KOTOR 70% (Rp)": 4036545,
    "PPh 21": 605481.75,
    "JUMLAH BERSIH 70% (Rp)": 3431063.25,
    "TANDA TANGAN": 438
  },
  {
    "NIP": "'195703031983032001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Prof. Dr. Ni Ketut Suarni, M.S., Kons.",
    "JURUSAN": "Bimbingan Konseling (S2)",
    "FAKULTAS": "Program Pascasarjana",
    "GOLONGAN": "IVE",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Guru Besar",
    "GRADE FUNGSIONAL": 12,
    "STRUKTURAL": "Koordinator Program Studi S2",
    "GRADE STRUKTURAL": 12,
    "UNIT KERJA": "Bimbingan Konseling (S2)",
    "POINT POSITION": 2559.35,
    "POINT PERFORMANCE": 2860.17,
    "POINT KELEBIHAN": 903.583,
    "POINT TOTAL": 6323.1,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 9484650,
    "PPh 100%": 1422697.5,
    "JUMLAH KOTOR 30% (Rp)": 2506657.5,
    "JUMLAH KOTOR 70% (Rp)": 6977992.5,
    "PPh 21": 1046698.875,
    "JUMLAH BERSIH 70% (Rp)": 5931293.625,
    "TANDA TANGAN": 439
  },
  {
    "NIP": "'198004042003122001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Prof. Dr. Ni Komang Arie Suwastini, S.Pd., M.Hum.",
    "JURUSAN": "Bimbingan Konseling (S2)",
    "FAKULTAS": "Program Pascasarjana",
    "GOLONGAN": "IVB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Guru Besar",
    "GRADE FUNGSIONAL": 12,
    "UNIT KERJA": "-",
    "POINT PERFORMANCE": 2662.17,
    "POINT KELEBIHAN": 150.5,
    "POINT TOTAL": 2812.67,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 4219005,
    "PPh 100%": 632850.75,
    "JUMLAH KOTOR 30% (Rp)": 1354950,
    "JUMLAH KOTOR 70% (Rp)": 2864055,
    "PPh 21": 429608.25,
    "JUMLAH BERSIH 70% (Rp)": 2434446.75,
    "TANDA TANGAN": 440
  },
  {
    "NIP": "'196204251990031002",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Prof. Dr. I Gede Astra Wesnawa, M.Si.",
    "JURUSAN": "Manajemen Lingkungan (S2)",
    "FAKULTAS": "Program Pascasarjana",
    "GOLONGAN": "IVE",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Guru Besar",
    "GRADE FUNGSIONAL": 12,
    "STRUKTURAL": "Koordinator Program Studi S2",
    "GRADE STRUKTURAL": 12,
    "UNIT KERJA": "Manajemen Lingkungan (S2)",
    "POINT POSITION": 2559.35,
    "POINT PERFORMANCE": 2886.83,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 5446.18,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 8169270,
    "PPh 100%": 1225390.5,
    "JUMLAH KOTOR 30% (Rp)": 2506657.5,
    "JUMLAH KOTOR 70% (Rp)": 5662612.5,
    "PPh 21": 849391.875,
    "JUMLAH BERSIH 70% (Rp)": 4813220.625,
    "TANDA TANGAN": 441
  },
  {
    "NIP": "'197204202001121001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Prof. Dr. I Komang Sudarma, S.Pd., M.Pd.",
    "JURUSAN": "Teknologi Pendidikan (S2)",
    "FAKULTAS": "Program Pascasarjana",
    "GOLONGAN": "IVA",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor Kepala",
    "GRADE FUNGSIONAL": 11,
    "STRUKTURAL": "Wakil Dekan II",
    "GRADE STRUKTURAL": 14,
    "UNIT KERJA": "Fakultas Ilmu Pendidikan",
    "POINT POSITION": 10800,
    "POINT PERFORMANCE": 2352.02,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 13152,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 19728000,
    "PPh 100%": 2959200,
    "JUMLAH KOTOR 30% (Rp)": 5999400,
    "JUMLAH KOTOR 70% (Rp)": 13728600,
    "PPh 21": 2059290,
    "JUMLAH BERSIH 70% (Rp)": 11669310,
    "TANDA TANGAN": 442
  },
  {
    "NIP": "'197108152001121001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Prof. Dr. I Made Tegeh, S.Pd., M.Pd.",
    "JURUSAN": "Teknologi Pendidikan (S2)",
    "FAKULTAS": "Program Pascasarjana",
    "GOLONGAN": "IVB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Guru Besar",
    "GRADE FUNGSIONAL": 12,
    "STRUKTURAL": "Ketua Lembaga",
    "GRADE STRUKTURAL": 15,
    "UNIT KERJA": "-",
    "POINT POSITION": 10965,
    "POINT PERFORMANCE": 3007.33,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 13972.3,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 20958450,
    "PPh 100%": 3143767.5,
    "JUMLAH KOTOR 30% (Rp)": 6289200,
    "JUMLAH KOTOR 70% (Rp)": 14669250,
    "PPh 21": 2200387.5,
    "JUMLAH BERSIH 70% (Rp)": 12468862.5,
    "TANDA TANGAN": 443
  },
  {
    "NIP": "'195902201982031002",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Prof. Dr. Gde Artawan, M.Pd.",
    "JURUSAN": "Pendidikan Bahasa (S3)",
    "FAKULTAS": "Program Pascasarjana",
    "GOLONGAN": "IVB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Guru Besar",
    "GRADE FUNGSIONAL": 12,
    "STRUKTURAL": "[REN126] Pengelola Gugus Kendali Mutu (Fakultas) sebagai Anggota",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Pendidikan Bahasa (S2)",
    "POINT POSITION": 200,
    "POINT PERFORMANCE": 1983.5,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 2183.5,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 3275250,
    "PPh 100%": 491287.5,
    "JUMLAH KOTOR 30% (Rp)": 1444950,
    "JUMLAH KOTOR 70% (Rp)": 1830300,
    "PPh 21": 274545,
    "JUMLAH BERSIH 70% (Rp)": 1555755,
    "TANDA TANGAN": 444
  },
  {
    "NIP": "'195612311979031030",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Prof. Dr. I Nengah Martha, M.Pd.",
    "JURUSAN": "Pendidikan Bahasa (S3)",
    "FAKULTAS": "Program Pascasarjana",
    "GOLONGAN": "IVE",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Guru Besar",
    "GRADE FUNGSIONAL": 12,
    "STRUKTURAL": "[REN126] Pengelola Gugus Kendali Mutu (Fakultas) sebagai Anggota",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Pascasarjana",
    "POINT POSITION": 200,
    "POINT PERFORMANCE": 2100.59,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 2300.59,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 3450885,
    "PPh 100%": 517632.75,
    "JUMLAH KOTOR 30% (Rp)": 1444950,
    "JUMLAH KOTOR 70% (Rp)": 2005935,
    "PPh 21": 300890.25,
    "JUMLAH BERSIH 70% (Rp)": 1705044.75,
    "TANDA TANGAN": 445
  },
  {
    "NIP": "'195612311983031022",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Prof. Dr. I Nengah Suandi, M.Hum.",
    "JURUSAN": "Pendidikan Bahasa (S3)",
    "FAKULTAS": "Program Pascasarjana",
    "GOLONGAN": "IVE",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Guru Besar",
    "GRADE FUNGSIONAL": 12,
    "UNIT KERJA": "-",
    "POINT PERFORMANCE": 644.167,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 644.167,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 966250.5,
    "PPh 100%": 144937.575,
    "JUMLAH KOTOR 30% (Rp)": 1354950,
    "JUMLAH KOTOR 70% (Rp)": 0,
    "PPh 21": 0,
    "JUMLAH BERSIH 70% (Rp)": 0,
    "TANDA TANGAN": 446
  },
  {
    "NIP": "'196012311984031011",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Prof. Dr. I Wayan Rasna, M.Pd.",
    "JURUSAN": "Pendidikan Bahasa (S3)",
    "FAKULTAS": "Program Pascasarjana",
    "GOLONGAN": "IVE",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Guru Besar",
    "GRADE FUNGSIONAL": 12,
    "UNIT KERJA": "-",
    "POINT PERFORMANCE": 2056,
    "POINT KELEBIHAN": 38.3917,
    "POINT TOTAL": 2094.39,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 3141585,
    "PPh 100%": 471237.75,
    "JUMLAH KOTOR 30% (Rp)": 1354950,
    "JUMLAH KOTOR 70% (Rp)": 1786635,
    "PPh 21": 267995.25,
    "JUMLAH BERSIH 70% (Rp)": 1518639.75,
    "TANDA TANGAN": 447
  },
  {
    "NIP": "'196002101986021001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Prof. Dr. Ida Bagus Putrayasa, M.Pd.",
    "JURUSAN": "Pendidikan Bahasa (S3)",
    "FAKULTAS": "Program Pascasarjana",
    "GOLONGAN": "IVE",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Guru Besar",
    "GRADE FUNGSIONAL": 12,
    "STRUKTURAL": "Koordinator Program Studi S2",
    "GRADE STRUKTURAL": 12,
    "UNIT KERJA": "Pendidikan Bahasa (S2)",
    "POINT POSITION": 2559.35,
    "POINT PERFORMANCE": 2944,
    "POINT KELEBIHAN": 264.225,
    "POINT TOTAL": 5767.58,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 8651370,
    "PPh 100%": 1297705.5,
    "JUMLAH KOTOR 30% (Rp)": 2506657.5,
    "JUMLAH KOTOR 70% (Rp)": 6144712.5,
    "PPh 21": 921706.875,
    "JUMLAH BERSIH 70% (Rp)": 5223005.625,
    "TANDA TANGAN": 448
  },
  {
    "NIP": "'196407141988102001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Prof. Dra. Luh Putu Artini, M.A., Ph.D.",
    "JURUSAN": "Pendidikan Bahasa (S3)",
    "FAKULTAS": "Program Pascasarjana",
    "GOLONGAN": "IVD",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Guru Besar",
    "GRADE FUNGSIONAL": 12,
    "STRUKTURAL": "Koordinator Program Studi S2",
    "GRADE STRUKTURAL": 12,
    "UNIT KERJA": "Pendidikan Bahasa Inggris (S2)",
    "POINT POSITION": 2559.35,
    "POINT PERFORMANCE": 2930.83,
    "POINT KELEBIHAN": 150.5,
    "POINT TOTAL": 5640.68,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 8461020,
    "PPh 100%": 1269153,
    "JUMLAH KOTOR 30% (Rp)": 2506657.5,
    "JUMLAH KOTOR 70% (Rp)": 5954362.5,
    "PPh 21": 893154.375,
    "JUMLAH BERSIH 70% (Rp)": 5061208.125,
    "TANDA TANGAN": 449
  },
  {
    "NIP": "'196808282002121001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Prof. Dr. I Made Gunamantha, S.T., M.M.",
    "JURUSAN": "Pendidikan Dasar (S3)",
    "FAKULTAS": "Program Pascasarjana",
    "GOLONGAN": "IVB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Guru Besar",
    "GRADE FUNGSIONAL": 12,
    "STRUKTURAL": "Sekretaris Program Studi S2",
    "GRADE STRUKTURAL": 11,
    "UNIT KERJA": "Manajemen Lingkungan (S2)",
    "POINT POSITION": 2152.2,
    "POINT PERFORMANCE": 1405.42,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 3557.62,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 5336430,
    "PPh 100%": 800464.5,
    "JUMLAH KOTOR 30% (Rp)": 2323440,
    "JUMLAH KOTOR 70% (Rp)": 3012990,
    "PPh 21": 451948.5,
    "JUMLAH BERSIH 70% (Rp)": 2561041.5,
    "TANDA TANGAN": 450
  },
  {
    "NIP": "'196702211993031002",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Prof. Dr. I Wayan Lasmawan, M.Pd.",
    "JURUSAN": "Pendidikan Dasar (S3)",
    "FAKULTAS": "Program Pascasarjana",
    "GOLONGAN": "IVE",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Guru Besar",
    "GRADE FUNGSIONAL": 12,
    "STRUKTURAL": "Rektor",
    "GRADE STRUKTURAL": 17,
    "UNIT KERJA": "-",
    "POINT POSITION": 19890,
    "POINT PERFORMANCE": 2941.33,
    "POINT KELEBIHAN": 541.8,
    "POINT TOTAL": 23373.1,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 35059650,
    "PPh 100%": 5258947.5,
    "JUMLAH KOTOR 30% (Rp)": 10305450,
    "JUMLAH KOTOR 70% (Rp)": 24754200,
    "PPh 21": 3713130,
    "JUMLAH BERSIH 70% (Rp)": 21041070,
    "TANDA TANGAN": 451
  },
  {
    "NIP": "'196205151988031005",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Prof. Dr. I Wayan Suastra, M.Pd.",
    "JURUSAN": "Pendidikan Dasar (S3)",
    "FAKULTAS": "Program Pascasarjana",
    "GOLONGAN": "IVE",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Guru Besar",
    "GRADE FUNGSIONAL": 12,
    "STRUKTURAL": "Ketua Program Studi S3",
    "GRADE STRUKTURAL": 12,
    "UNIT KERJA": "Pendidikan Dasar (S3)",
    "POINT POSITION": 2559.35,
    "POINT PERFORMANCE": 2892.17,
    "POINT KELEBIHAN": 679.592,
    "POINT TOTAL": 6131.11,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 9196665,
    "PPh 100%": 1379499.75,
    "JUMLAH KOTOR 30% (Rp)": 2506657.5,
    "JUMLAH KOTOR 70% (Rp)": 6690007.5,
    "PPh 21": 1003501.125,
    "JUMLAH BERSIH 70% (Rp)": 5686506.375,
    "TANDA TANGAN": 452
  },
  {
    "NIP": "'195812311986011005",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Prof. Dr. Ida Bagus Putu Arnyana, M.Si.",
    "JURUSAN": "Pendidikan Dasar (S3)",
    "FAKULTAS": "Program Pascasarjana",
    "GOLONGAN": "IVE",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Guru Besar",
    "GRADE FUNGSIONAL": 12,
    "STRUKTURAL": "Wakil Direktur 1",
    "GRADE STRUKTURAL": 14,
    "UNIT KERJA": "Pascasarjana",
    "POINT POSITION": 9180,
    "POINT PERFORMANCE": 2970.67,
    "POINT KELEBIHAN": 602.167,
    "POINT TOTAL": 12752.8,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 19129200,
    "PPh 100%": 2869380,
    "JUMLAH KOTOR 30% (Rp)": 5485950,
    "JUMLAH KOTOR 70% (Rp)": 13643250,
    "PPh 21": 2046487.5,
    "JUMLAH BERSIH 70% (Rp)": 11596762.5,
    "TANDA TANGAN": 453
  },
  {
    "NIP": "'196012311986011004",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Prof. Dr. I Made Candiasa, M.I.Kom.",
    "JURUSAN": "Ilmu Pendidikan (S3)",
    "FAKULTAS": "Program Pascasarjana",
    "GOLONGAN": "IVE",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Guru Besar",
    "GRADE FUNGSIONAL": 12,
    "STRUKTURAL": "[REN126] Pengelola Gugus Kendali Mutu (Fakultas) sebagai Anggota",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Ilmu Komputer (S2)",
    "POINT POSITION": 200,
    "POINT PERFORMANCE": 2988.67,
    "POINT KELEBIHAN": 541.8,
    "POINT TOTAL": 3730.47,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 5595705,
    "PPh 100%": 839355.75,
    "JUMLAH KOTOR 30% (Rp)": 1444950,
    "JUMLAH KOTOR 70% (Rp)": 4150755,
    "PPh 21": 622613.25,
    "JUMLAH BERSIH 70% (Rp)": 3528141.75,
    "TANDA TANGAN": 454
  },
  {
    "NIP": "'196812171993031003",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Prof. Dr. I Made Sutajaya, M.Kes.",
    "JURUSAN": "Ilmu Pendidikan (S3)",
    "FAKULTAS": "Program Pascasarjana",
    "GOLONGAN": "IVE",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Guru Besar",
    "GRADE FUNGSIONAL": 12,
    "STRUKTURAL": "[REN126] Pengelola Gugus Kendali Mutu (Fakultas) sebagai Anggota",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Pascasarjana",
    "POINT POSITION": 200,
    "POINT PERFORMANCE": 2328,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 2528,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 3792000,
    "PPh 100%": 568800,
    "JUMLAH KOTOR 30% (Rp)": 1444950,
    "JUMLAH KOTOR 70% (Rp)": 2347050,
    "PPh 21": 352057.5,
    "JUMLAH BERSIH 70% (Rp)": 1994992.5,
    "TANDA TANGAN": 455
  },
  {
    "NIP": "'196710131994031001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. I Wayan Sukra Warpala, S.Pd., M.Sc.",
    "JURUSAN": "Teknologi Pendidikan (S3)",
    "FAKULTAS": "Program Pascasarjana",
    "GOLONGAN": "IVB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor Kepala",
    "GRADE FUNGSIONAL": 11,
    "STRUKTURAL": "Dekan",
    "GRADE STRUKTURAL": 15,
    "UNIT KERJA": "Fakultas Matematika dan Ilmu Pengetahuan Alam",
    "POINT POSITION": 11610,
    "POINT PERFORMANCE": 2513.33,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 14123.3,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 21184950,
    "PPh 100%": 3177742.5,
    "JUMLAH KOTOR 30% (Rp)": 6363900,
    "JUMLAH KOTOR 70% (Rp)": 14821050,
    "PPh 21": 2223157.5,
    "JUMLAH BERSIH 70% (Rp)": 12597892.5,
    "TANDA TANGAN": 456
  },
  {
    "NIP": "'196112191987021001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Prof. Dr. I Wayan Santyasa, M.Si.",
    "JURUSAN": "Teknologi Pendidikan (S3)",
    "FAKULTAS": "Program Pascasarjana",
    "GOLONGAN": "IVE",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Guru Besar",
    "GRADE FUNGSIONAL": 12,
    "UNIT KERJA": "-",
    "POINT PERFORMANCE": 2210.33,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 2210.33,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 3315495,
    "PPh 100%": 497324.25,
    "JUMLAH KOTOR 30% (Rp)": 1354950,
    "JUMLAH KOTOR 70% (Rp)": 1960545,
    "PPh 21": 294081.75,
    "JUMLAH BERSIH 70% (Rp)": 1666463.25,
    "TANDA TANGAN": 457
  },
  {
    "NIP": "'197408012000032001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Prof. Dr. Ketut Agustini, S.Si., M.Si.",
    "JURUSAN": "Teknologi Pendidikan (S3)",
    "FAKULTAS": "Program Pascasarjana",
    "GOLONGAN": "IVB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Guru Besar",
    "GRADE FUNGSIONAL": 12,
    "STRUKTURAL": "Wakil Dekan III",
    "GRADE STRUKTURAL": 14,
    "UNIT KERJA": "Fakultas Teknik dan Kejuruan",
    "POINT POSITION": 9720,
    "POINT PERFORMANCE": 2996.67,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 12716.7,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 19075050,
    "PPh 100%": 2861257.5,
    "JUMLAH KOTOR 30% (Rp)": 5728950,
    "JUMLAH KOTOR 70% (Rp)": 13346100,
    "PPh 21": 2001915,
    "JUMLAH BERSIH 70% (Rp)": 11344185,
    "TANDA TANGAN": 458
  },
  {
    "NIP": "'196512291990032002",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Prof. Dr. Ni Nyoman Parwati, M.Pd.",
    "JURUSAN": "Teknologi Pendidikan (S3)",
    "FAKULTAS": "Program Pascasarjana",
    "GOLONGAN": "IVE",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Guru Besar",
    "GRADE FUNGSIONAL": 12,
    "STRUKTURAL": "Ketua Program Studi S3",
    "GRADE STRUKTURAL": 12,
    "UNIT KERJA": "Teknologi Pendidikan (S3)",
    "POINT POSITION": 2559.35,
    "POINT PERFORMANCE": 2986,
    "POINT KELEBIHAN": 74.525,
    "POINT TOTAL": 5619.88,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 8429820,
    "PPh 100%": 1264473,
    "JUMLAH KOTOR 30% (Rp)": 2506657.5,
    "JUMLAH KOTOR 70% (Rp)": 5923162.5,
    "PPh 21": 888474.375,
    "JUMLAH BERSIH 70% (Rp)": 5034688.125,
    "TANDA TANGAN": 459
  },
  {
    "NIP": "'198902122024212001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PPPK",
    "NAMA DOSEN": "Ni Luh Asri Savitri, S.E., M.Si",
    "JURUSAN": "Akuntansi (D3)",
    "FAKULTAS": "Fakultas Ekonomi",
    "GOLONGAN": "X",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Asisten Ahli",
    "GRADE FUNGSIONAL": 8,
    "UNIT KERJA": "-",
    "POINT PERFORMANCE": 974.167,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 974.167,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 1461250.5,
    "PPh 100%": 73062.525,
    "JUMLAH KOTOR 30% (Rp)": 656550,
    "JUMLAH KOTOR 70% (Rp)": 804700.5,
    "PPh 21": 40235.025,
    "JUMLAH BERSIH 70% (Rp)": 764465.475,
    "TANDA TANGAN": 460
  },
  {
    "NIP": "'198003122002121002",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. A.A. Ngurah Yudha Martin Mahardika, S.Pd., M.Pd.",
    "JURUSAN": "Pengelolaan Perhotelan (D4)",
    "FAKULTAS": "Fakultas Ekonomi",
    "GOLONGAN": "IVA",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor Kepala",
    "GRADE FUNGSIONAL": 11,
    "STRUKTURAL": "Sekretaris Jurusan S1",
    "GRADE STRUKTURAL": 11,
    "UNIT KERJA": "Jurusan Manajemen",
    "POINT POSITION": 2152.2,
    "POINT PERFORMANCE": 1674.2,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 3826.4,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 5739600,
    "PPh 100%": 860940,
    "JUMLAH KOTOR 30% (Rp)": 2107890,
    "JUMLAH KOTOR 70% (Rp)": 3631710,
    "PPh 21": 544756.5,
    "JUMLAH BERSIH 70% (Rp)": 3086953.5,
    "TANDA TANGAN": 461
  },
  {
    "NIP": "'198412142015041002",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. I Gede Putra Nugraha, S.S., M.Par.",
    "JURUSAN": "Pengelolaan Perhotelan (D4)",
    "FAKULTAS": "Fakultas Ekonomi",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "STRUKTURAL": "[REN224] Sekretaris Unit BPU",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "-",
    "POINT POSITION": 500,
    "POINT PERFORMANCE": 1107.33,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 1607.33,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 2410995,
    "PPh 100%": 120549.75,
    "JUMLAH KOTOR 30% (Rp)": 1012050,
    "JUMLAH KOTOR 70% (Rp)": 1398945,
    "PPh 21": 69947.25,
    "JUMLAH BERSIH 70% (Rp)": 1328997.75,
    "TANDA TANGAN": 462
  },
  {
    "NIP": "'197708192002121003",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. I Putu Gede Parma, S.St.Par., M.Par.",
    "JURUSAN": "Pengelolaan Perhotelan (D4)",
    "FAKULTAS": "Fakultas Ekonomi",
    "GOLONGAN": "IVC",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor Kepala",
    "GRADE FUNGSIONAL": 11,
    "STRUKTURAL": "Sekretaris Lembaga",
    "GRADE STRUKTURAL": 14,
    "UNIT KERJA": "-",
    "POINT POSITION": 9180,
    "POINT PERFORMANCE": 1771.33,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 10951.3,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 16426950,
    "PPh 100%": 2464042.5,
    "JUMLAH KOTOR 30% (Rp)": 5270400,
    "JUMLAH KOTOR 70% (Rp)": 11156550,
    "PPh 21": 1673482.5,
    "JUMLAH BERSIH 70% (Rp)": 9483067.5,
    "TANDA TANGAN": 463
  },
  {
    "NIP": "'198304142010122002",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. Ni Luh Henny Andayani, S.St.Par., M.Par.",
    "JURUSAN": "Pengelolaan Perhotelan (D4)",
    "FAKULTAS": "Fakultas Ekonomi",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "UNIT KERJA": "-",
    "POINT PERFORMANCE": 941.667,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 941.667,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 1412500.5,
    "PPh 100%": 70625.025,
    "JUMLAH KOTOR 30% (Rp)": 787050,
    "JUMLAH KOTOR 70% (Rp)": 625450.5,
    "PPh 21": 31272.525,
    "JUMLAH BERSIH 70% (Rp)": 594177.975,
    "TANDA TANGAN": 464
  },
  {
    "NIP": "'198104162005012002",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. Ni Made Ary Widiastini, S.St.Par., M.Par.",
    "JURUSAN": "Pengelolaan Perhotelan (D4)",
    "FAKULTAS": "Fakultas Ekonomi",
    "GOLONGAN": "IVB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor Kepala",
    "GRADE FUNGSIONAL": 11,
    "STRUKTURAL": "Koordinator Program Studi S1/D3",
    "GRADE STRUKTURAL": 11,
    "UNIT KERJA": "Pengelolaan Perhotelan (D4)",
    "POINT POSITION": 1645.8,
    "POINT PERFORMANCE": 1598.5,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 3244.3,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 4866450,
    "PPh 100%": 729967.5,
    "JUMLAH KOTOR 30% (Rp)": 1880010,
    "JUMLAH KOTOR 70% (Rp)": 2986440,
    "PPh 21": 447966,
    "JUMLAH BERSIH 70% (Rp)": 2538474,
    "TANDA TANGAN": 465
  },
  {
    "NIP": "'198304052008122001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. Nyoman Dini Andiani, SST.Par., M.Par.",
    "JURUSAN": "Pengelolaan Perhotelan (D4)",
    "FAKULTAS": "Fakultas Ekonomi",
    "GOLONGAN": "IVA",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor Kepala",
    "GRADE FUNGSIONAL": 11,
    "STRUKTURAL": "[REN223] Sekretaris Pusat/ Ketua Divisi/ Asrama/ Koordinator Lab. Jurusan Kepala Unit BPU/ Sekretaris Gugus Kendali Mutu Fakultas/ Sekretaris Tim Pengelolaan dan Penerimaan Mahasiswa Asing/ Sekretaris Unit Pengembangan dan Peningkatan Kapasitas Kelembagaan",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Unit Penunjang Akademik layanan Uji Kompetensi",
    "POINT POSITION": 800,
    "POINT PERFORMANCE": 1698,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 2498,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 3747000,
    "PPh 100%": 562050,
    "JUMLAH KOTOR 30% (Rp)": 1499400,
    "JUMLAH KOTOR 70% (Rp)": 2247600,
    "PPh 21": 337140,
    "JUMLAH BERSIH 70% (Rp)": 1910460,
    "TANDA TANGAN": 466
  },
  {
    "NIP": "'199303302022032013",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Luh Putu Triyanti Ariestiana Dewi, S.Pd., M.Par.",
    "JURUSAN": "Pengelolaan Perhotelan (D4)",
    "FAKULTAS": "Fakultas Ekonomi",
    "GOLONGAN": "IIIB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Asisten Ahli",
    "GRADE FUNGSIONAL": 8,
    "STRUKTURAL": "[REN223] Sekretaris Pusat/ Ketua Divisi/ Asrama/ Koordinator Lab. Jurusan Kepala Unit BPU/ Sekretaris Gugus Kendali Mutu Fakultas/ Sekretaris Tim Pengelolaan dan Penerimaan Mahasiswa Asing/ Sekretaris Unit Pengembangan dan Peningkatan Kapasitas Kelembagaan",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "-",
    "POINT POSITION": 800,
    "POINT PERFORMANCE": 948.583,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 1748.58,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 2622870,
    "PPh 100%": 131143.5,
    "JUMLAH KOTOR 30% (Rp)": 1016550,
    "JUMLAH KOTOR 70% (Rp)": 1606320,
    "PPh 21": 80316,
    "JUMLAH BERSIH 70% (Rp)": 1526004,
    "TANDA TANGAN": 467
  },
  {
    "NIP": "'198002172002122001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Prof. Putu Indah Rahmawati, M.Bis., Ph.D.",
    "JURUSAN": "Pengelolaan Perhotelan (D4)",
    "FAKULTAS": "Fakultas Ekonomi",
    "GOLONGAN": "IVB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Guru Besar",
    "GRADE FUNGSIONAL": 12,
    "STRUKTURAL": "[REN223] Sekretaris Pusat/ Ketua Divisi/ Asrama/ Koordinator Lab. Jurusan Kepala Unit BPU/ Sekretaris Gugus Kendali Mutu Fakultas/ Sekretaris Tim Pengelolaan dan Penerimaan Mahasiswa Asing/ Sekretaris Unit Pengembangan dan Peningkatan Kapasitas Kelembagaan",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "-",
    "POINT POSITION": 800,
    "POINT PERFORMANCE": 2416.83,
    "POINT KELEBIHAN": 301,
    "POINT TOTAL": 3517.83,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 5276745,
    "PPh 100%": 791511.75,
    "JUMLAH KOTOR 30% (Rp)": 1714950,
    "JUMLAH KOTOR 70% (Rp)": 3561795,
    "PPh 21": 534269.25,
    "JUMLAH BERSIH 70% (Rp)": 3027525.75,
    "TANDA TANGAN": 468
  },
  {
    "NIP": "'197006062002122002",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Trianasari, M.M., Ph.D.",
    "JURUSAN": "Pengelolaan Perhotelan (D4)",
    "FAKULTAS": "Fakultas Ekonomi",
    "GOLONGAN": "IVA",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor Kepala",
    "GRADE FUNGSIONAL": 11,
    "STRUKTURAL": "[REN222] Kepala Pusat /Kantor/Kepala Gugus Kendali Mutu Fakultas/Ketua Unit Pengelolaan dan Penerimaan Mahasiswa Asing/ Ketua Unit Pengembangan dan Peningkatan Kapasitas Kelembagaan",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "-",
    "POINT POSITION": 1150,
    "POINT PERFORMANCE": 1952,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 3102,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 4653000,
    "PPh 100%": 697950,
    "JUMLAH KOTOR 30% (Rp)": 1656900,
    "JUMLAH KOTOR 70% (Rp)": 2996100,
    "PPh 21": 449415,
    "JUMLAH BERSIH 70% (Rp)": 2546685,
    "TANDA TANGAN": 469
  },
  {
    "NIP": "'197912062008122001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. Desak Nyoman Sri Werastuti, S.E., Ak., M.Si.",
    "JURUSAN": "Akuntansi Sektor Publik (D4)",
    "FAKULTAS": "Fakultas Ekonomi",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor Kepala",
    "GRADE FUNGSIONAL": 11,
    "STRUKTURAL": "Sekretaris Program Studi S2",
    "GRADE STRUKTURAL": 11,
    "UNIT KERJA": "Akuntansi (S2)",
    "POINT POSITION": 2152.2,
    "POINT PERFORMANCE": 2113.33,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 4265.53,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 6398295,
    "PPh 100%": 319914.75,
    "JUMLAH KOTOR 30% (Rp)": 2107890,
    "JUMLAH KOTOR 70% (Rp)": 4290405,
    "PPh 21": 214520.25,
    "JUMLAH BERSIH 70% (Rp)": 4075884.75,
    "TANDA TANGAN": 470
  },
  {
    "NIP": "'197008152001121002",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. I Putu Gede Diatmika, S.E., Ak., M.Si.",
    "JURUSAN": "Akuntansi Sektor Publik (D4)",
    "FAKULTAS": "Fakultas Ekonomi",
    "GOLONGAN": "IVC",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor Kepala",
    "GRADE FUNGSIONAL": 11,
    "STRUKTURAL": "Wakil Dekan II",
    "GRADE STRUKTURAL": 14,
    "UNIT KERJA": "Fakultas Ekonomi",
    "POINT POSITION": 10800,
    "POINT PERFORMANCE": 2142.33,
    "POINT KELEBIHAN": 63.3333,
    "POINT TOTAL": 13005.7,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 19508550,
    "PPh 100%": 2926282.5,
    "JUMLAH KOTOR 30% (Rp)": 5999400,
    "JUMLAH KOTOR 70% (Rp)": 13509150,
    "PPh 21": 2026372.5,
    "JUMLAH BERSIH 70% (Rp)": 11482777.5,
    "TANDA TANGAN": 471
  },
  {
    "NIP": "'197105101999032001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. Lucy Sri Musmini, S.E., M.Si., Ak.",
    "JURUSAN": "Akuntansi Sektor Publik (D4)",
    "FAKULTAS": "Fakultas Ekonomi",
    "GOLONGAN": "IVC",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor Kepala",
    "GRADE FUNGSIONAL": 11,
    "STRUKTURAL": "Sekretaris Jurusan S1",
    "GRADE STRUKTURAL": 11,
    "UNIT KERJA": "Jurusan Ekonomi dan Akutansi",
    "POINT POSITION": 2532,
    "POINT PERFORMANCE": 2213,
    "POINT KELEBIHAN": 190,
    "POINT TOTAL": 4935,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 7402500,
    "PPh 100%": 1110375,
    "JUMLAH KOTOR 30% (Rp)": 2278800,
    "JUMLAH KOTOR 70% (Rp)": 5123700,
    "PPh 21": 768555,
    "JUMLAH BERSIH 70% (Rp)": 4355145,
    "TANDA TANGAN": 472
  },
  {
    "NIP": "'196909042003122001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. Ni Luh Gede Erni Sulindawati, S.E., Ak., M.Pd.",
    "JURUSAN": "Akuntansi Sektor Publik (D4)",
    "FAKULTAS": "Fakultas Ekonomi",
    "GOLONGAN": "IVC",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor Kepala",
    "GRADE FUNGSIONAL": 11,
    "STRUKTURAL": "Koordinator Program Studi S2",
    "GRADE STRUKTURAL": 12,
    "UNIT KERJA": "Administrasi Pendidikan (S2)",
    "POINT POSITION": 2559.35,
    "POINT PERFORMANCE": 2456.33,
    "POINT KELEBIHAN": 416.733,
    "POINT TOTAL": 5432.42,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 8148630,
    "PPh 100%": 1222294.5,
    "JUMLAH KOTOR 30% (Rp)": 2291107.5,
    "JUMLAH KOTOR 70% (Rp)": 5857522.5,
    "PPh 21": 878628.375,
    "JUMLAH BERSIH 70% (Rp)": 4978894.125,
    "TANDA TANGAN": 473
  },
  {
    "NIP": "'198205112008121004",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. Nyoman Ari Surya Dharmawan, S.E., Ak., M.Si.",
    "JURUSAN": "Akuntansi Sektor Publik (D4)",
    "FAKULTAS": "Fakultas Ekonomi",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "STRUKTURAL": "[REN223] Sekretaris Pusat/ Ketua Divisi/ Asrama/ Koordinator Lab. Jurusan Kepala Unit BPU/ Sekretaris Gugus Kendali Mutu Fakultas/ Sekretaris Tim Pengelolaan dan Penerimaan Mahasiswa Asing/ Sekretaris Unit Pengembangan dan Peningkatan Kapasitas Kelembagaan",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "-",
    "POINT POSITION": 800,
    "POINT PERFORMANCE": 1472.67,
    "POINT KELEBIHAN": 43.75,
    "POINT TOTAL": 2316.42,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 3474630,
    "PPh 100%": 173731.5,
    "JUMLAH KOTOR 30% (Rp)": 1147050,
    "JUMLAH KOTOR 70% (Rp)": 2327580,
    "PPh 21": 116379,
    "JUMLAH BERSIH 70% (Rp)": 2211201,
    "TANDA TANGAN": 474
  },
  {
    "NIP": "'198208262008121002",
    "STATUS SEKARANG": "Ijin Belajar",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "I Gede Agus Pertama Yudantara, S.E., M.S.A.",
    "JURUSAN": "Akuntansi Sektor Publik (D4)",
    "FAKULTAS": "Fakultas Ekonomi",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "STRUKTURAL": "Ketua Laboratorium Fakultas",
    "GRADE STRUKTURAL": 12,
    "UNIT KERJA": "Fakultas Ekonomi",
    "POINT POSITION": 3011,
    "POINT PERFORMANCE": 1373.83,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 4384.83,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 6577245,
    "PPh 100%": 328862.25,
    "JUMLAH KOTOR 30% (Rp)": 2142000,
    "JUMLAH KOTOR 70% (Rp)": 4435245,
    "PPh 21": 221762.25,
    "JUMLAH BERSIH 70% (Rp)": 4213482.75,
    "TANDA TANGAN": 475
  },
  {
    "NIP": "'198207302023211005",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PPPK",
    "NAMA DOSEN": "I Made Dwita Atmaja, S.E., M.Si.",
    "JURUSAN": "Akuntansi Sektor Publik (D4)",
    "FAKULTAS": "Fakultas Ekonomi",
    "GOLONGAN": "X",
    "STATUS PENELITIAN": "TIDAK ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Asisten Ahli",
    "GRADE FUNGSIONAL": 8,
    "STRUKTURAL": "[REN126] Pengelola Gugus Kendali Mutu (Fakultas) sebagai Anggota",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Fakultas Ekonomi",
    "POINT POSITION": 0,
    "POINT PERFORMANCE": 0,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 0,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 0,
    "PPh 100%": 0,
    "JUMLAH KOTOR 30% (Rp)": 746550,
    "JUMLAH KOTOR 70% (Rp)": 0,
    "PPh 21": 0,
    "JUMLAH BERSIH 70% (Rp)": 0,
    "TANDA TANGAN": 476
  },
  {
    "NIP": "'197906162002121003",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Prof. Dr. Gede Adi Yuniarta, S.E., Ak., M.Si.",
    "JURUSAN": "Akuntansi Sektor Publik (D4)",
    "FAKULTAS": "Fakultas Ekonomi",
    "GOLONGAN": "IVE",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Guru Besar",
    "GRADE FUNGSIONAL": 12,
    "STRUKTURAL": "Dekan",
    "GRADE STRUKTURAL": 15,
    "UNIT KERJA": "Fakultas Ekonomi",
    "POINT POSITION": 12900,
    "POINT PERFORMANCE": 2544.83,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 15444.8,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 23167200,
    "PPh 100%": 3475080,
    "JUMLAH KOTOR 30% (Rp)": 7159950,
    "JUMLAH KOTOR 70% (Rp)": 16007250,
    "PPh 21": 2401087.5,
    "JUMLAH BERSIH 70% (Rp)": 13606162.5,
    "TANDA TANGAN": 477
  },
  {
    "NIP": "'197911042008122003",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Prof. Dr. I Gusti Ayu Purnamawati, S.E., M.Si., Ak.",
    "JURUSAN": "Akuntansi Sektor Publik (D4)",
    "FAKULTAS": "Fakultas Ekonomi",
    "GOLONGAN": "IVB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Guru Besar",
    "GRADE FUNGSIONAL": 12,
    "STRUKTURAL": "Koordinator Program Studi S1/D3",
    "GRADE STRUKTURAL": 11,
    "UNIT KERJA": "Akuntansi Sektor Publik (D4)",
    "POINT POSITION": 1645.8,
    "POINT PERFORMANCE": 2466.5,
    "POINT KELEBIHAN": 75.25,
    "POINT TOTAL": 4187.55,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 6281325,
    "PPh 100%": 942198.75,
    "JUMLAH KOTOR 30% (Rp)": 2095560,
    "JUMLAH KOTOR 70% (Rp)": 4185765,
    "PPh 21": 627864.75,
    "JUMLAH BERSIH 70% (Rp)": 3557900.25,
    "TANDA TANGAN": 478
  },
  {
    "NIP": "'199110302019031009",
    "STATUS SEKARANG": "Ijin Belajar",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. I Putu Arya Dharmayasa, S.Pd.,M.Pd.",
    "JURUSAN": "Pendidikan Ekonomi (S1)",
    "FAKULTAS": "Fakultas Ekonomi",
    "GOLONGAN": "IIIC",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "STRUKTURAL": "[REN222] Kepala Pusat /Kantor/Kepala Gugus Kendali Mutu Fakultas/Ketua Unit Pengelolaan dan Penerimaan Mahasiswa Asing/ Ketua Unit Pengembangan dan Peningkatan Kapasitas Kelembagaan",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Fakultas Ekonomi",
    "POINT POSITION": 1150,
    "POINT PERFORMANCE": 1375.67,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 2525.67,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 3788505,
    "PPh 100%": 189425.25,
    "JUMLAH KOTOR 30% (Rp)": 1304550,
    "JUMLAH KOTOR 70% (Rp)": 2483955,
    "PPh 21": 124197.75,
    "JUMLAH BERSIH 70% (Rp)": 2359757.25,
    "TANDA TANGAN": 479
  },
  {
    "NIP": "'198304242009121002",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. Kadek Rai Suwena, S.Pd., M.Pd.",
    "JURUSAN": "Pendidikan Ekonomi (S1)",
    "FAKULTAS": "Fakultas Ekonomi",
    "GOLONGAN": "IVA",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor Kepala",
    "GRADE FUNGSIONAL": 11,
    "STRUKTURAL": "Ketua Jurusan S1",
    "GRADE STRUKTURAL": 12,
    "UNIT KERJA": "Jurusan Ekonomi dan Akutansi",
    "POINT POSITION": 3011,
    "POINT PERFORMANCE": 2247.5,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 5258.5,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 7887750,
    "PPh 100%": 1183162.5,
    "JUMLAH KOTOR 30% (Rp)": 2494350,
    "JUMLAH KOTOR 70% (Rp)": 5393400,
    "PPh 21": 809010,
    "JUMLAH BERSIH 70% (Rp)": 4584390,
    "TANDA TANGAN": 480
  },
  {
    "NIP": "'198208192009122003",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. Luh Indrayani, S.Pd., M.Pd.",
    "JURUSAN": "Pendidikan Ekonomi (S1)",
    "FAKULTAS": "Fakultas Ekonomi",
    "GOLONGAN": "IVA",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor Kepala",
    "GRADE FUNGSIONAL": 11,
    "STRUKTURAL": "[REN222] Kepala Pusat /Kantor/Kepala Gugus Kendali Mutu Fakultas/Ketua Unit Pengelolaan dan Penerimaan Mahasiswa Asing/ Ketua Unit Pengembangan dan Peningkatan Kapasitas Kelembagaan",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "-",
    "POINT POSITION": 1150,
    "POINT PERFORMANCE": 2252.83,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 3402.83,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 5104245,
    "PPh 100%": 765636.75,
    "JUMLAH KOTOR 30% (Rp)": 1656900,
    "JUMLAH KOTOR 70% (Rp)": 3447345,
    "PPh 21": 517101.75,
    "JUMLAH BERSIH 70% (Rp)": 2930243.25,
    "TANDA TANGAN": 481
  },
  {
    "NIP": "'198712112018031002",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. M. Rudi Irwansyah, S.Pd., M.Pd.",
    "JURUSAN": "Pendidikan Ekonomi (S1)",
    "FAKULTAS": "Fakultas Ekonomi",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor Kepala",
    "GRADE FUNGSIONAL": 11,
    "STRUKTURAL": "Koordinator Program Studi S1/D3",
    "GRADE STRUKTURAL": 11,
    "UNIT KERJA": "Pendidikan Ekonomi (S1)",
    "POINT POSITION": 1899,
    "POINT PERFORMANCE": 2139.5,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 4038.5,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 6057750,
    "PPh 100%": 302887.5,
    "JUMLAH KOTOR 30% (Rp)": 1993950,
    "JUMLAH KOTOR 70% (Rp)": 4063800,
    "PPh 21": 203190,
    "JUMLAH BERSIH 70% (Rp)": 3860610,
    "TANDA TANGAN": 482
  },
  {
    "NIP": "'198005032006042003",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. Made Ary Meitriana, S.Pd., M.Pd.",
    "JURUSAN": "Pendidikan Ekonomi (S1)",
    "FAKULTAS": "Fakultas Ekonomi",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "STRUKTURAL": "Ketua Senat Fakultas",
    "GRADE STRUKTURAL": 11,
    "UNIT KERJA": "Fakultas Ekonomi",
    "POINT POSITION": 2532,
    "POINT PERFORMANCE": 1593.17,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 4125.17,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 6187755,
    "PPh 100%": 309387.75,
    "JUMLAH KOTOR 30% (Rp)": 1926450,
    "JUMLAH KOTOR 70% (Rp)": 4261305,
    "PPh 21": 213065.25,
    "JUMLAH BERSIH 70% (Rp)": 4048239.75,
    "TANDA TANGAN": 483
  },
  {
    "NIP": "'196706261993031003",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Drs. I Nyoman Sujana, M.Si.",
    "JURUSAN": "Pendidikan Ekonomi (S1)",
    "FAKULTAS": "Fakultas Ekonomi",
    "GOLONGAN": "IVC",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor Kepala",
    "GRADE FUNGSIONAL": 11,
    "UNIT KERJA": "-",
    "POINT PERFORMANCE": 1811.83,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 1811.83,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 2717745,
    "PPh 100%": 407661.75,
    "JUMLAH KOTOR 30% (Rp)": 1139400,
    "JUMLAH KOTOR 70% (Rp)": 1578345,
    "PPh 21": 236751.75,
    "JUMLAH BERSIH 70% (Rp)": 1341593.25,
    "TANDA TANGAN": 484
  },
  {
    "NIP": "'197005142008121003",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "I Wayan Suwendra, S.E., M.Si.",
    "JURUSAN": "Pendidikan Ekonomi (S1)",
    "FAKULTAS": "Fakultas Ekonomi",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "UNIT KERJA": "-",
    "POINT PERFORMANCE": 1267.33,
    "POINT KELEBIHAN": 232.743,
    "POINT TOTAL": 1500.08,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 2250120,
    "PPh 100%": 112506,
    "JUMLAH KOTOR 30% (Rp)": 787050,
    "JUMLAH KOTOR 70% (Rp)": 1463070,
    "PPh 21": 73153.5,
    "JUMLAH BERSIH 70% (Rp)": 1389916.5,
    "TANDA TANGAN": 485
  },
  {
    "NIP": "'198901112024062001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Ni Made Anintia Trisna Sari, S.Pd., M.Pd.",
    "JURUSAN": "Pendidikan Ekonomi (S1)",
    "FAKULTAS": "Fakultas Ekonomi",
    "GOLONGAN": "IIIB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Tenaga Pengajar",
    "GRADE FUNGSIONAL": 7,
    "UNIT KERJA": "-",
    "POINT PERFORMANCE": 521,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 521,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 781500,
    "PPh 100%": 39075,
    "JUMLAH KOTOR 30% (Rp)": 545400,
    "JUMLAH KOTOR 70% (Rp)": 236100,
    "PPh 21": 11805,
    "JUMLAH BERSIH 70% (Rp)": 224295,
    "TANDA TANGAN": 486
  },
  {
    "NIP": "'199806122024062001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Ni Made Firayanti Pratiwi, S.Pd., M.Pd.",
    "JURUSAN": "Pendidikan Ekonomi (S1)",
    "FAKULTAS": "Fakultas Ekonomi",
    "GOLONGAN": "IIIB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Tenaga Pengajar",
    "GRADE FUNGSIONAL": 7,
    "UNIT KERJA": "-",
    "POINT PERFORMANCE": 649.833,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 649.833,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 974749.5,
    "PPh 100%": 48737.475,
    "JUMLAH KOTOR 30% (Rp)": 545400,
    "JUMLAH KOTOR 70% (Rp)": 429349.5,
    "PPh 21": 21467.475,
    "JUMLAH BERSIH 70% (Rp)": 407882.025,
    "TANDA TANGAN": 487
  },
  {
    "NIP": "'199206062020122019",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Ni Wayan Ayu Santi, S.Pd., M.Pd.",
    "JURUSAN": "Pendidikan Ekonomi (S1)",
    "FAKULTAS": "Fakultas Ekonomi",
    "GOLONGAN": "IIIC",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "STRUKTURAL": "[REN126] Pengelola Gugus Kendali Mutu (Fakultas) sebagai Anggota",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Fakultas Ekonomi",
    "POINT POSITION": 200,
    "POINT PERFORMANCE": 1297.67,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 1497.67,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 2246505,
    "PPh 100%": 112325.25,
    "JUMLAH KOTOR 30% (Rp)": 877050,
    "JUMLAH KOTOR 70% (Rp)": 1369455,
    "PPh 21": 68472.75,
    "JUMLAH BERSIH 70% (Rp)": 1300982.25,
    "TANDA TANGAN": 488
  },
  {
    "NIP": "'196810291993032001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. Dra. Ni Made Suci, M.Si.",
    "JURUSAN": "Manajemen (S1)",
    "FAKULTAS": "Fakultas Ekonomi",
    "GOLONGAN": "IVB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor Kepala",
    "GRADE FUNGSIONAL": 11,
    "STRUKTURAL": "Wakil Dekan I",
    "GRADE STRUKTURAL": 14,
    "UNIT KERJA": "Fakultas Ekonomi",
    "POINT POSITION": 10800,
    "POINT PERFORMANCE": 2447.67,
    "POINT KELEBIHAN": 380,
    "POINT TOTAL": 13627.7,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 20441550,
    "PPh 100%": 3066232.5,
    "JUMLAH KOTOR 30% (Rp)": 5999400,
    "JUMLAH KOTOR 70% (Rp)": 14442150,
    "PPh 21": 2166322.5,
    "JUMLAH BERSIH 70% (Rp)": 12275827.5,
    "TANDA TANGAN": 489
  },
  {
    "NIP": "'197404122010121001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. Fridayana Yudiaatmaja, M.Sc.",
    "JURUSAN": "Manajemen (S1)",
    "FAKULTAS": "Fakultas Ekonomi",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "STRUKTURAL": "[REN126] Pengelola Gugus Kendali Mutu (Fakultas) sebagai Anggota",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Ilmu Manajemen (S2)",
    "POINT POSITION": 200,
    "POINT PERFORMANCE": 1459.67,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 1659.67,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 2489505,
    "PPh 100%": 124475.25,
    "JUMLAH KOTOR 30% (Rp)": 877050,
    "JUMLAH KOTOR 70% (Rp)": 1612455,
    "PPh 21": 80622.75,
    "JUMLAH BERSIH 70% (Rp)": 1531832.25,
    "TANDA TANGAN": 490
  },
  {
    "NIP": "'198502202010121007",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. I Nengah Suarmanayasa, S.E., M.Si.",
    "JURUSAN": "Manajemen (S1)",
    "FAKULTAS": "Fakultas Ekonomi",
    "GOLONGAN": "IVA",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor Kepala",
    "GRADE FUNGSIONAL": 11,
    "STRUKTURAL": "Wakil Dekan III",
    "GRADE STRUKTURAL": 14,
    "UNIT KERJA": "Fakultas Ekonomi",
    "POINT POSITION": 10800,
    "POINT PERFORMANCE": 2498.67,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 13298.7,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 19948050,
    "PPh 100%": 2992207.5,
    "JUMLAH KOTOR 30% (Rp)": 5999400,
    "JUMLAH KOTOR 70% (Rp)": 13948650,
    "PPh 21": 2092297.5,
    "JUMLAH BERSIH 70% (Rp)": 11856352.5,
    "TANDA TANGAN": 491
  },
  {
    "NIP": "'198602112019031005",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. Komang Endrawan Sumadi Putra, S.E., M.M.",
    "JURUSAN": "Manajemen (S1)",
    "FAKULTAS": "Fakultas Ekonomi",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "STRUKTURAL": "[REN224] Sekretaris Unit BPU",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "-",
    "POINT POSITION": 500,
    "POINT PERFORMANCE": 1236.67,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 1736.67,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 2605005,
    "PPh 100%": 130250.25,
    "JUMLAH KOTOR 30% (Rp)": 1012050,
    "JUMLAH KOTOR 70% (Rp)": 1592955,
    "PPh 21": 79647.75,
    "JUMLAH BERSIH 70% (Rp)": 1513307.25,
    "TANDA TANGAN": 492
  },
  {
    "NIP": "'198309212015041001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. Komang Krisna Heryanda, S.E., M.M.",
    "JURUSAN": "Manajemen (S1)",
    "FAKULTAS": "Fakultas Ekonomi",
    "GOLONGAN": "IVA",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor Kepala",
    "GRADE FUNGSIONAL": 11,
    "STRUKTURAL": "Sekretaris Program Studi S2",
    "GRADE STRUKTURAL": 11,
    "UNIT KERJA": "Ilmu Manajemen (S2)",
    "POINT POSITION": 2152.2,
    "POINT PERFORMANCE": 2290.67,
    "POINT KELEBIHAN": 253.333,
    "POINT TOTAL": 4696.2,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 7044300,
    "PPh 100%": 1056645,
    "JUMLAH KOTOR 30% (Rp)": 2107890,
    "JUMLAH KOTOR 70% (Rp)": 4936410,
    "PPh 21": 740461.5,
    "JUMLAH BERSIH 70% (Rp)": 4195948.5,
    "TANDA TANGAN": 493
  },
  {
    "NIP": "'197611102014042001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. Ni Luh Wayan Sayang Telagawathi, S.E., M.Si.",
    "JURUSAN": "Manajemen (S1)",
    "FAKULTAS": "Fakultas Ekonomi",
    "GOLONGAN": "IVA",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor Kepala",
    "GRADE FUNGSIONAL": 11,
    "STRUKTURAL": "Koordinator Program Studi S2",
    "GRADE STRUKTURAL": 12,
    "UNIT KERJA": "Ilmu Manajemen (S2)",
    "POINT POSITION": 2559.35,
    "POINT PERFORMANCE": 2318.17,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 4877.52,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 7316280,
    "PPh 100%": 1097442,
    "JUMLAH KOTOR 30% (Rp)": 2291107.5,
    "JUMLAH KOTOR 70% (Rp)": 5025172.5,
    "PPh 21": 753775.875,
    "JUMLAH BERSIH 70% (Rp)": 4271396.625,
    "TANDA TANGAN": 494
  },
  {
    "NIP": "'198207292010122003",
    "STATUS SEKARANG": "Ijin Belajar",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. Ni Nyoman Yulianthini, S.E., M.M.",
    "JURUSAN": "Manajemen (S1)",
    "FAKULTAS": "Fakultas Ekonomi",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "STRUKTURAL": "Sekretaris Senat Fakultas",
    "GRADE STRUKTURAL": 10,
    "UNIT KERJA": "Fakultas Ekonomi",
    "POINT POSITION": 2106,
    "POINT PERFORMANCE": 1404.5,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 3510.5,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 5265750,
    "PPh 100%": 263287.5,
    "JUMLAH KOTOR 30% (Rp)": 1734750,
    "JUMLAH KOTOR 70% (Rp)": 3531000,
    "PPh 21": 176550,
    "JUMLAH BERSIH 70% (Rp)": 3354450,
    "TANDA TANGAN": 495
  },
  {
    "NIP": "'198208312010121001",
    "STATUS SEKARANG": "Ijin Belajar",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Gede Putu Agus Jana Susila, S.E., M.B.A.",
    "JURUSAN": "Manajemen (S1)",
    "FAKULTAS": "Fakultas Ekonomi",
    "GOLONGAN": "IVA",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor Kepala",
    "GRADE FUNGSIONAL": 11,
    "STRUKTURAL": "Ketua Jurusan S1",
    "GRADE STRUKTURAL": 12,
    "UNIT KERJA": "Jurusan Manajemen",
    "POINT POSITION": 2559.35,
    "POINT PERFORMANCE": 2092.17,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 4651.52,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 6977280,
    "PPh 100%": 1046592,
    "JUMLAH KOTOR 30% (Rp)": 2291107.5,
    "JUMLAH KOTOR 70% (Rp)": 4686172.5,
    "PPh 21": 702925.875,
    "JUMLAH BERSIH 70% (Rp)": 3983246.625,
    "TANDA TANGAN": 496
  },
  {
    "NIP": "'198612252022031003",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "I Gusti Ketut Adi Winata, S.E., M.Agb.",
    "JURUSAN": "Manajemen (S1)",
    "FAKULTAS": "Fakultas Ekonomi",
    "GOLONGAN": "IIIB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Asisten Ahli",
    "GRADE FUNGSIONAL": 8,
    "UNIT KERJA": "-",
    "POINT PERFORMANCE": 950.167,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 950.167,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 1425250.5,
    "PPh 100%": 71262.525,
    "JUMLAH KOTOR 30% (Rp)": 656550,
    "JUMLAH KOTOR 70% (Rp)": 768700.5,
    "PPh 21": 38435.025,
    "JUMLAH BERSIH 70% (Rp)": 730265.475,
    "TANDA TANGAN": 497
  },
  {
    "NIP": "'199105122023211031",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PPPK",
    "NAMA DOSEN": "Ida Bagus Koman Suarmaja, S.E., M.M.",
    "JURUSAN": "Manajemen (S1)",
    "FAKULTAS": "Fakultas Ekonomi",
    "GOLONGAN": "X",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Asisten Ahli",
    "GRADE FUNGSIONAL": 8,
    "UNIT KERJA": "-",
    "POINT PERFORMANCE": 1063.5,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 1063.5,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 1595250,
    "PPh 100%": 79762.5,
    "JUMLAH KOTOR 30% (Rp)": 656550,
    "JUMLAH KOTOR 70% (Rp)": 938700,
    "PPh 21": 46935,
    "JUMLAH BERSIH 70% (Rp)": 891765,
    "TANDA TANGAN": 498
  },
  {
    "NIP": "'199207212024061001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Jemmy Regri Ferdianto, S.Pd., M.M.",
    "JURUSAN": "Manajemen (S1)",
    "FAKULTAS": "Fakultas Ekonomi",
    "GOLONGAN": "IIIB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Tenaga Pengajar",
    "GRADE FUNGSIONAL": 7,
    "UNIT KERJA": "-",
    "POINT PERFORMANCE": 746.833,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 746.833,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 1120249.5,
    "PPh 100%": 56012.475,
    "JUMLAH KOTOR 30% (Rp)": 545400,
    "JUMLAH KOTOR 70% (Rp)": 574849.5,
    "PPh 21": 28742.475,
    "JUMLAH BERSIH 70% (Rp)": 546107.025,
    "TANDA TANGAN": 499
  },
  {
    "NIP": "'199106072020122017",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Made Amanda Dewanti, S.E.,M.M",
    "JURUSAN": "Manajemen (S1)",
    "FAKULTAS": "Fakultas Ekonomi",
    "GOLONGAN": "IIIC",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "STRUKTURAL": "Koordinator Program Studi S1/D3",
    "GRADE STRUKTURAL": 11,
    "UNIT KERJA": "Manajemen (S1)",
    "POINT POSITION": 2152.2,
    "POINT PERFORMANCE": 1504.67,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 3656.87,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 5485305,
    "PPh 100%": 274265.25,
    "JUMLAH KOTOR 30% (Rp)": 1755540,
    "JUMLAH KOTOR 70% (Rp)": 3729765,
    "PPh 21": 186488.25,
    "JUMLAH BERSIH 70% (Rp)": 3543276.75,
    "TANDA TANGAN": 500
  },
  {
    "NIP": "'199607192024061001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Made Pramana Putra, M.M.",
    "JURUSAN": "Manajemen (S1)",
    "FAKULTAS": "Fakultas Ekonomi",
    "GOLONGAN": "IIIB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Tenaga Pengajar",
    "GRADE FUNGSIONAL": 7,
    "UNIT KERJA": "-",
    "POINT PERFORMANCE": 734.5,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 734.5,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 1101750,
    "PPh 100%": 55087.5,
    "JUMLAH KOTOR 30% (Rp)": 545400,
    "JUMLAH KOTOR 70% (Rp)": 556350,
    "PPh 21": 27817.5,
    "JUMLAH BERSIH 70% (Rp)": 528532.5,
    "TANDA TANGAN": 501
  },
  {
    "NIP": "'199112192022032010",
    "STATUS SEKARANG": "Ijin Belajar",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Made Putri Ariasih, S.Si., M.M.",
    "JURUSAN": "Manajemen (S1)",
    "FAKULTAS": "Fakultas Ekonomi",
    "GOLONGAN": "IIIB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Asisten Ahli",
    "GRADE FUNGSIONAL": 8,
    "STRUKTURAL": "[REN126] Pengelola Gugus Kendali Mutu (Fakultas) sebagai Anggota",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Fakultas Ekonomi",
    "POINT POSITION": 200,
    "POINT PERFORMANCE": 1245,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 1445,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 2167500,
    "PPh 100%": 108375,
    "JUMLAH KOTOR 30% (Rp)": 746550,
    "JUMLAH KOTOR 70% (Rp)": 1420950,
    "PPh 21": 71047.5,
    "JUMLAH BERSIH 70% (Rp)": 1349902.5,
    "TANDA TANGAN": 502
  },
  {
    "NIP": "'198505042015042001",
    "STATUS SEKARANG": "Ijin Belajar",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Ni Made Dwi Ariani Mayasari, S.E., M.M.",
    "JURUSAN": "Manajemen (S1)",
    "FAKULTAS": "Fakultas Ekonomi",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "UNIT KERJA": "-",
    "POINT PERFORMANCE": 1312.5,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 1312.5,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 1968750,
    "PPh 100%": 98437.5,
    "JUMLAH KOTOR 30% (Rp)": 787050,
    "JUMLAH KOTOR 70% (Rp)": 1181700,
    "PPh 21": 59085,
    "JUMLAH BERSIH 70% (Rp)": 1122615,
    "TANDA TANGAN": 503
  },
  {
    "NIP": "'199905092024062001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Ni Putu Suciyawati, S.Pd., M.M.",
    "JURUSAN": "Manajemen (S1)",
    "FAKULTAS": "Fakultas Ekonomi",
    "GOLONGAN": "IIIB",
    "STATUS PENELITIAN": "TIDAK ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Tenaga Pengajar",
    "GRADE FUNGSIONAL": 7,
    "UNIT KERJA": "-",
    "POINT POSITION": 0,
    "POINT PERFORMANCE": 0,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 0,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 0,
    "PPh 100%": 0,
    "JUMLAH KOTOR 30% (Rp)": 545400,
    "JUMLAH KOTOR 70% (Rp)": 0,
    "PPh 21": 0,
    "JUMLAH BERSIH 70% (Rp)": 0,
    "TANDA TANGAN": 504
  },
  {
    "NIP": "'199402142024061001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Nyoman Teja Adiastra, S.Ds., M.M.",
    "JURUSAN": "Manajemen (S1)",
    "FAKULTAS": "Fakultas Ekonomi",
    "GOLONGAN": "IIIB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Tenaga Pengajar",
    "GRADE FUNGSIONAL": 7,
    "UNIT KERJA": "-",
    "POINT PERFORMANCE": 629.167,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 629.167,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 943750.5,
    "PPh 100%": 47187.525,
    "JUMLAH KOTOR 30% (Rp)": 545400,
    "JUMLAH KOTOR 70% (Rp)": 398350.5,
    "PPh 21": 19917.525,
    "JUMLAH BERSIH 70% (Rp)": 378432.975,
    "TANDA TANGAN": 505
  },
  {
    "NIP": "'198805032018031001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Rahutama Atidira, M.M.",
    "JURUSAN": "Manajemen (S1)",
    "FAKULTAS": "Fakultas Ekonomi",
    "GOLONGAN": "IIIB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Asisten Ahli",
    "GRADE FUNGSIONAL": 8,
    "STRUKTURAL": "[REN126] Pengelola Gugus Kendali Mutu (Fakultas) sebagai Anggota",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Fakultas Ekonomi",
    "POINT POSITION": 200,
    "POINT PERFORMANCE": 1162.67,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 1362.67,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 2044005,
    "PPh 100%": 102200.25,
    "JUMLAH KOTOR 30% (Rp)": 746550,
    "JUMLAH KOTOR 70% (Rp)": 1297455,
    "PPh 21": 64872.75,
    "JUMLAH BERSIH 70% (Rp)": 1232582.25,
    "TANDA TANGAN": 506
  },
  {
    "NIP": "'199512062024061002",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Rikky Rundu Padang, M.M.",
    "JURUSAN": "Manajemen (S1)",
    "FAKULTAS": "Fakultas Ekonomi",
    "GOLONGAN": "IIIB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Tenaga Pengajar",
    "GRADE FUNGSIONAL": 7,
    "UNIT KERJA": "-",
    "POINT PERFORMANCE": 814.667,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 814.667,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 1222000.5,
    "PPh 100%": 61100.025,
    "JUMLAH KOTOR 30% (Rp)": 545400,
    "JUMLAH KOTOR 70% (Rp)": 676600.5,
    "PPh 21": 33830.025,
    "JUMLAH BERSIH 70% (Rp)": 642770.475,
    "TANDA TANGAN": 507
  },
  {
    "NIP": "'198705292023212044",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PPPK",
    "NAMA DOSEN": "Diota Prameswari Vijaya, S.E., M.SA.Ak.",
    "JURUSAN": "Akuntansi (S1)",
    "FAKULTAS": "Fakultas Ekonomi",
    "GOLONGAN": "X",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Asisten Ahli",
    "GRADE FUNGSIONAL": 8,
    "UNIT KERJA": "-",
    "POINT PERFORMANCE": 1043.67,
    "POINT KELEBIHAN": 29.6562,
    "POINT TOTAL": 1073.32,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 1609980,
    "PPh 100%": 80499,
    "JUMLAH KOTOR 30% (Rp)": 656550,
    "JUMLAH KOTOR 70% (Rp)": 953430,
    "PPh 21": 47671.5,
    "JUMLAH BERSIH 70% (Rp)": 905758.5,
    "TANDA TANGAN": 508
  },
  {
    "NIP": "'198905272015042001",
    "STATUS SEKARANG": "Ijin Belajar",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. Gst. Ayu Ketut Rencana Sari Dewi, S.E., M.Si.",
    "JURUSAN": "Akuntansi (S1)",
    "FAKULTAS": "Fakultas Ekonomi",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "UNIT KERJA": "-",
    "POINT PERFORMANCE": 1299.83,
    "POINT KELEBIHAN": 43.75,
    "POINT TOTAL": 1343.58,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 2015370,
    "PPh 100%": 100768.5,
    "JUMLAH KOTOR 30% (Rp)": 787050,
    "JUMLAH KOTOR 70% (Rp)": 1228320,
    "PPh 21": 61416,
    "JUMLAH BERSIH 70% (Rp)": 1166904,
    "TANDA TANGAN": 509
  },
  {
    "NIP": "'197311092010121001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. I Made Pradana Adiputra, S.E., S.H., M.Si.",
    "JURUSAN": "Akuntansi (S1)",
    "FAKULTAS": "Fakultas Ekonomi",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor Kepala",
    "GRADE FUNGSIONAL": 11,
    "STRUKTURAL": "[REN126] Pengelola Gugus Kendali Mutu (Fakultas) sebagai Anggota",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Akuntansi (S2)",
    "POINT POSITION": 200,
    "POINT PERFORMANCE": 2019.33,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 2219.33,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 3328995,
    "PPh 100%": 166449.75,
    "JUMLAH KOTOR 30% (Rp)": 1229400,
    "JUMLAH KOTOR 70% (Rp)": 2099595,
    "PPh 21": 104979.75,
    "JUMLAH BERSIH 70% (Rp)": 1994615.25,
    "TANDA TANGAN": 510
  },
  {
    "NIP": "'198809212015041002",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. Made Aristia Prayudi, S.A., M.Sc., Ak.",
    "JURUSAN": "Akuntansi (S1)",
    "FAKULTAS": "Fakultas Ekonomi",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor Kepala",
    "GRADE FUNGSIONAL": 11,
    "STRUKTURAL": "Sekretaris Dewan Pengawas",
    "GRADE STRUKTURAL": 9,
    "UNIT KERJA": "-",
    "POINT POSITION": 1749,
    "POINT PERFORMANCE": 2009.33,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 3758.33,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 5637495,
    "PPh 100%": 281874.75,
    "JUMLAH KOTOR 30% (Rp)": 1926450,
    "JUMLAH KOTOR 70% (Rp)": 3711045,
    "PPh 21": 185552.25,
    "JUMLAH BERSIH 70% (Rp)": 3525492.75,
    "TANDA TANGAN": 511
  },
  {
    "NIP": "'197210202010122002",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. Ni Kadek Sinarwati, S.E., M.Si., Ak.",
    "JURUSAN": "Akuntansi (S1)",
    "FAKULTAS": "Fakultas Ekonomi",
    "GOLONGAN": "IVA",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor Kepala",
    "GRADE FUNGSIONAL": 11,
    "UNIT KERJA": "-",
    "POINT PERFORMANCE": 2051.67,
    "POINT KELEBIHAN": 63.3333,
    "POINT TOTAL": 2115,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 3172500,
    "PPh 100%": 475875,
    "JUMLAH KOTOR 30% (Rp)": 1139400,
    "JUMLAH KOTOR 70% (Rp)": 2033100,
    "PPh 21": 304965,
    "JUMLAH BERSIH 70% (Rp)": 1728135,
    "TANDA TANGAN": 512
  },
  {
    "NIP": "'197703152002122003",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. Nyoman Trisna Herawati, S.E., Ak., M.Pd.",
    "JURUSAN": "Akuntansi (S1)",
    "FAKULTAS": "Fakultas Ekonomi",
    "GOLONGAN": "IVC",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor Kepala",
    "GRADE FUNGSIONAL": 11,
    "STRUKTURAL": "[REN126] Pengelola Gugus Kendali Mutu (Fakultas) sebagai Anggota",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Ilmu Pendidikan (S3)",
    "POINT POSITION": 200,
    "POINT PERFORMANCE": 2109.33,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 2309.33,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 3463995,
    "PPh 100%": 519599.25,
    "JUMLAH KOTOR 30% (Rp)": 1229400,
    "JUMLAH KOTOR 70% (Rp)": 2234595,
    "PPh 21": 335189.25,
    "JUMLAH BERSIH 70% (Rp)": 1899405.75,
    "TANDA TANGAN": 513
  },
  {
    "NIP": "'198911202015041001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. Putu Sukma Kurniawan, S.T., M.A.",
    "JURUSAN": "Akuntansi (S1)",
    "FAKULTAS": "Fakultas Ekonomi",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor Kepala",
    "GRADE FUNGSIONAL": 11,
    "STRUKTURAL": "Sekretaris Pusat Penelitian",
    "GRADE STRUKTURAL": 11,
    "UNIT KERJA": "-",
    "POINT POSITION": 1645.8,
    "POINT PERFORMANCE": 1990.33,
    "POINT KELEBIHAN": 63.3333,
    "POINT TOTAL": 3699.47,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 5549205,
    "PPh 100%": 277460.25,
    "JUMLAH KOTOR 30% (Rp)": 1880010,
    "JUMLAH KOTOR 70% (Rp)": 3669195,
    "PPh 21": 183459.75,
    "JUMLAH BERSIH 70% (Rp)": 3485735.25,
    "TANDA TANGAN": 514
  },
  {
    "NIP": "'198902272018032001",
    "STATUS SEKARANG": "Ijin Belajar",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. Sunitha Devi, S.E., M.Si., Ak.",
    "JURUSAN": "Akuntansi (S1)",
    "FAKULTAS": "Fakultas Ekonomi",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor Kepala",
    "GRADE FUNGSIONAL": 11,
    "STRUKTURAL": "Koordinator Program Studi S1/D3",
    "GRADE STRUKTURAL": 11,
    "UNIT KERJA": "Akuntansi (S1)",
    "POINT POSITION": 2152.2,
    "POINT PERFORMANCE": 2085.67,
    "POINT KELEBIHAN": 63.3333,
    "POINT TOTAL": 4301.2,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 6451800,
    "PPh 100%": 322590,
    "JUMLAH KOTOR 30% (Rp)": 2107890,
    "JUMLAH KOTOR 70% (Rp)": 4343910,
    "PPh 21": 217195.5,
    "JUMLAH BERSIH 70% (Rp)": 4126714.5,
    "TANDA TANGAN": 515
  },
  {
    "NIP": "'199610052024061001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Gede Teguh Prasetya Muttiwijaya, M.Ak.",
    "JURUSAN": "Akuntansi (S1)",
    "FAKULTAS": "Fakultas Ekonomi",
    "GOLONGAN": "IIIB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Tenaga Pengajar",
    "GRADE FUNGSIONAL": 7,
    "UNIT KERJA": "-",
    "POINT PERFORMANCE": 571.354,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 571.354,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 857031,
    "PPh 100%": 42851.55,
    "JUMLAH KOTOR 30% (Rp)": 545400,
    "JUMLAH KOTOR 70% (Rp)": 311631,
    "PPh 21": 15581.55,
    "JUMLAH BERSIH 70% (Rp)": 296049.45,
    "TANDA TANGAN": 516
  },
  {
    "NIP": "'199503132024061001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "I Dewa Gede Anom Jambe Adnyana, S.E., M.Ak.",
    "JURUSAN": "Akuntansi (S1)",
    "FAKULTAS": "Fakultas Ekonomi",
    "GOLONGAN": "IIIB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Tenaga Pengajar",
    "GRADE FUNGSIONAL": 7,
    "UNIT KERJA": "-",
    "POINT PERFORMANCE": 585.312,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 585.312,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 877968,
    "PPh 100%": 43898.4,
    "JUMLAH KOTOR 30% (Rp)": 545400,
    "JUMLAH KOTOR 70% (Rp)": 332568,
    "PPh 21": 16628.4,
    "JUMLAH BERSIH 70% (Rp)": 315939.6,
    "TANDA TANGAN": 517
  },
  {
    "NIP": "'198902192024211001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PPPK",
    "NAMA DOSEN": "I Gd Nandra Hary Wiguna, S.E., M.Si",
    "JURUSAN": "Akuntansi (S1)",
    "FAKULTAS": "Fakultas Ekonomi",
    "GOLONGAN": "X",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Asisten Ahli",
    "GRADE FUNGSIONAL": 8,
    "UNIT KERJA": "-",
    "POINT PERFORMANCE": 1081,
    "POINT KELEBIHAN": 36.5,
    "POINT TOTAL": 1117.5,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 1676250,
    "PPh 100%": 83812.5,
    "JUMLAH KOTOR 30% (Rp)": 656550,
    "JUMLAH KOTOR 70% (Rp)": 1019700,
    "PPh 21": 50985,
    "JUMLAH BERSIH 70% (Rp)": 968715,
    "TANDA TANGAN": 518
  },
  {
    "NIP": "'197602182005011004",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "I Gede Putu Banu Astawa, S.T., M.Ak.",
    "JURUSAN": "Akuntansi (S1)",
    "FAKULTAS": "Fakultas Ekonomi",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "STRUKTURAL": "Sekretaris Satuan Pengawas Internal",
    "GRADE STRUKTURAL": 13,
    "UNIT KERJA": "-",
    "POINT POSITION": 5400,
    "POINT PERFORMANCE": 1292.33,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 6692.33,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 10038495,
    "PPh 100%": 501924.75,
    "JUMLAH KOTOR 30% (Rp)": 3217050,
    "JUMLAH KOTOR 70% (Rp)": 6821445,
    "PPh 21": 341072.25,
    "JUMLAH BERSIH 70% (Rp)": 6480372.75,
    "TANDA TANGAN": 519
  },
  {
    "NIP": "'199905012024061001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "I Gusti Ngurah Agung Dananjaya, S.E., M.Ak.",
    "JURUSAN": "Akuntansi (S1)",
    "FAKULTAS": "Fakultas Ekonomi",
    "GOLONGAN": "IIIB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Tenaga Pengajar",
    "GRADE FUNGSIONAL": 7,
    "UNIT KERJA": "-",
    "POINT PERFORMANCE": 451.208,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 451.208,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 676812,
    "PPh 100%": 33840.6,
    "JUMLAH KOTOR 30% (Rp)": 545400,
    "JUMLAH KOTOR 70% (Rp)": 131412,
    "PPh 21": 6570.6,
    "JUMLAH BERSIH 70% (Rp)": 124841.4,
    "TANDA TANGAN": 520
  },
  {
    "NIP": "'199309092024061001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "I Made Widi Hartawan, S.E., M.Ak.",
    "JURUSAN": "Akuntansi (S1)",
    "FAKULTAS": "Fakultas Ekonomi",
    "GOLONGAN": "IIIB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Tenaga Pengajar",
    "GRADE FUNGSIONAL": 7,
    "UNIT KERJA": "-",
    "POINT PERFORMANCE": 417.969,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 417.969,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 626953.5,
    "PPh 100%": 31347.675,
    "JUMLAH KOTOR 30% (Rp)": 545400,
    "JUMLAH KOTOR 70% (Rp)": 81553.5,
    "PPh 21": 4077.675,
    "JUMLAH BERSIH 70% (Rp)": 77475.825,
    "TANDA TANGAN": 521
  },
  {
    "NIP": "'198401202015041001",
    "STATUS SEKARANG": "Ijin Belajar",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "I Nyoman Putra Yasa, S.E., M.Si.",
    "JURUSAN": "Akuntansi (S1)",
    "FAKULTAS": "Fakultas Ekonomi",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "UNIT KERJA": "-",
    "POINT PERFORMANCE": 1301.67,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 1301.67,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 1952505,
    "PPh 100%": 97625.25,
    "JUMLAH KOTOR 30% (Rp)": 787050,
    "JUMLAH KOTOR 70% (Rp)": 1165455,
    "PPh 21": 58272.75,
    "JUMLAH BERSIH 70% (Rp)": 1107182.25,
    "TANDA TANGAN": 522
  },
  {
    "NIP": "'199303282020121007",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "I Putu Hendra Martadinata, S.E.,M.Sc",
    "JURUSAN": "Akuntansi (S1)",
    "FAKULTAS": "Fakultas Ekonomi",
    "GOLONGAN": "IIIC",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "STRUKTURAL": "[REN126] Pengelola Gugus Kendali Mutu (Fakultas) sebagai Anggota",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Fakultas Ekonomi",
    "POINT POSITION": 200,
    "POINT PERFORMANCE": 1405.67,
    "POINT KELEBIHAN": 174.667,
    "POINT TOTAL": 1780.33,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 2670495,
    "PPh 100%": 133524.75,
    "JUMLAH KOTOR 30% (Rp)": 877050,
    "JUMLAH KOTOR 70% (Rp)": 1793445,
    "PPh 21": 89672.25,
    "JUMLAH BERSIH 70% (Rp)": 1703772.75,
    "TANDA TANGAN": 523
  },
  {
    "NIP": "'198207062014041001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "I Putu Julianto, SE., M.Si., Ak.",
    "JURUSAN": "Akuntansi (S1)",
    "FAKULTAS": "Fakultas Ekonomi",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "STRUKTURAL": "Anggota Satuan Pengawas Internal",
    "GRADE STRUKTURAL": 11,
    "UNIT KERJA": "-",
    "POINT POSITION": 2532,
    "POINT PERFORMANCE": 1376.5,
    "POINT KELEBIHAN": 43.6667,
    "POINT TOTAL": 3952.17,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 5928255,
    "PPh 100%": 296412.75,
    "JUMLAH KOTOR 30% (Rp)": 1926450,
    "JUMLAH KOTOR 70% (Rp)": 4001805,
    "PPh 21": 200090.25,
    "JUMLAH BERSIH 70% (Rp)": 3801714.75,
    "TANDA TANGAN": 524
  },
  {
    "NIP": "'199212202024062004",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Kadek Marlina Nalarreason, S.E., M.S.A.",
    "JURUSAN": "Akuntansi (S1)",
    "FAKULTAS": "Fakultas Ekonomi",
    "GOLONGAN": "IIIB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Tenaga Pengajar",
    "GRADE FUNGSIONAL": 7,
    "UNIT KERJA": "-",
    "POINT PERFORMANCE": 493,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 493,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 739500,
    "PPh 100%": 36975,
    "JUMLAH KOTOR 30% (Rp)": 545400,
    "JUMLAH KOTOR 70% (Rp)": 194100,
    "PPh 21": 9705,
    "JUMLAH BERSIH 70% (Rp)": 184395,
    "TANDA TANGAN": 525
  },
  {
    "NIP": "'199806142024061002",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Komang Dandy Andriadi, M.Ak.",
    "JURUSAN": "Akuntansi (S1)",
    "FAKULTAS": "Fakultas Ekonomi",
    "GOLONGAN": "IIIB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Tenaga Pengajar",
    "GRADE FUNGSIONAL": 7,
    "UNIT KERJA": "-",
    "POINT PERFORMANCE": 498.167,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 498.167,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 747250.5,
    "PPh 100%": 37362.525,
    "JUMLAH KOTOR 30% (Rp)": 545400,
    "JUMLAH KOTOR 70% (Rp)": 201850.5,
    "PPh 21": 10092.525,
    "JUMLAH BERSIH 70% (Rp)": 191757.975,
    "TANDA TANGAN": 526
  },
  {
    "NIP": "'199503072022032012",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Lidwina Mersilian Manoe, M.Ak.",
    "JURUSAN": "Akuntansi (S1)",
    "FAKULTAS": "Fakultas Ekonomi",
    "GOLONGAN": "IIIB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Tenaga Pengajar",
    "GRADE FUNGSIONAL": 7,
    "UNIT KERJA": "-",
    "POINT PERFORMANCE": 330.167,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 330.167,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 495250.5,
    "PPh 100%": 24762.525,
    "JUMLAH KOTOR 30% (Rp)": 545400,
    "JUMLAH KOTOR 70% (Rp)": 0,
    "PPh 21": 0,
    "JUMLAH BERSIH 70% (Rp)": 0,
    "TANDA TANGAN": 527
  },
  {
    "NIP": "'198804012018032001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Luh Gede Kusuma Dewi, S.E.,M.Si",
    "JURUSAN": "Akuntansi (S1)",
    "FAKULTAS": "Fakultas Ekonomi",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "UNIT KERJA": "-",
    "POINT PERFORMANCE": 1363.17,
    "POINT KELEBIHAN": 276.41,
    "POINT TOTAL": 1639.58,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 2459370,
    "PPh 100%": 122968.5,
    "JUMLAH KOTOR 30% (Rp)": 787050,
    "JUMLAH KOTOR 70% (Rp)": 1672320,
    "PPh 21": 83616,
    "JUMLAH BERSIH 70% (Rp)": 1588704,
    "TANDA TANGAN": 528
  },
  {
    "NIP": "'198301052008122002",
    "STATUS SEKARANG": "Ijin Belajar",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Made Arie Wahyuni, S.E., M.Si.",
    "JURUSAN": "Akuntansi (S1)",
    "FAKULTAS": "Fakultas Ekonomi",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "UNIT KERJA": "-",
    "POINT PERFORMANCE": 1144.5,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 1144.5,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 1716750,
    "PPh 100%": 85837.5,
    "JUMLAH KOTOR 30% (Rp)": 787050,
    "JUMLAH KOTOR 70% (Rp)": 929700,
    "PPh 21": 46485,
    "JUMLAH BERSIH 70% (Rp)": 883215,
    "TANDA TANGAN": 529
  },
  {
    "NIP": "'199712062024062002",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Ni Putu Anindya Sarasija Prameswari, S.Ak., M.Ak.",
    "JURUSAN": "Akuntansi (S1)",
    "FAKULTAS": "Fakultas Ekonomi",
    "GOLONGAN": "IIIB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Tenaga Pengajar",
    "GRADE FUNGSIONAL": 7,
    "UNIT KERJA": "-",
    "POINT PERFORMANCE": 461,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 461,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 691500,
    "PPh 100%": 34575,
    "JUMLAH KOTOR 30% (Rp)": 545400,
    "JUMLAH KOTOR 70% (Rp)": 146100,
    "PPh 21": 7305,
    "JUMLAH BERSIH 70% (Rp)": 138795,
    "TANDA TANGAN": 530
  },
  {
    "NIP": "'198007262005012002",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Ni Wayan Yulianita Dewi, S.E., M.S.A., Ak.",
    "JURUSAN": "Akuntansi (S1)",
    "FAKULTAS": "Fakultas Ekonomi",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "UNIT KERJA": "-",
    "POINT PERFORMANCE": 1068.17,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 1068.17,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 1602255,
    "PPh 100%": 80112.75,
    "JUMLAH KOTOR 30% (Rp)": 787050,
    "JUMLAH KOTOR 70% (Rp)": 815205,
    "PPh 21": 40760.25,
    "JUMLAH BERSIH 70% (Rp)": 774444.75,
    "TANDA TANGAN": 531
  },
  {
    "NIP": "'199212172019032025",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Nyoman Ayu Wulan Trisna Dewi, S.E.,M.Sc.",
    "JURUSAN": "Akuntansi (S1)",
    "FAKULTAS": "Fakultas Ekonomi",
    "GOLONGAN": "IIIC",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "STRUKTURAL": "[REN223] Sekretaris Pusat/ Ketua Divisi/ Asrama/ Koordinator Lab. Jurusan Kepala Unit BPU/ Sekretaris Gugus Kendali Mutu Fakultas/ Sekretaris Tim Pengelolaan dan Penerimaan Mahasiswa Asing/ Sekretaris Unit Pengembangan dan Peningkatan Kapasitas Kelembagaan",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Fakultas Ekonomi",
    "POINT POSITION": 800,
    "POINT PERFORMANCE": 1377.17,
    "POINT KELEBIHAN": 401.733,
    "POINT TOTAL": 2578.9,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 3868350,
    "PPh 100%": 193417.5,
    "JUMLAH KOTOR 30% (Rp)": 1147050,
    "JUMLAH KOTOR 70% (Rp)": 2721300,
    "PPh 21": 136065,
    "JUMLAH BERSIH 70% (Rp)": 2585235,
    "TANDA TANGAN": 532
  },
  {
    "NIP": "'198306082023211012",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PPPK",
    "NAMA DOSEN": "Nyoman Suadnyana Pasek, SE.,M.Si",
    "JURUSAN": "Akuntansi (S1)",
    "FAKULTAS": "Fakultas Ekonomi",
    "GOLONGAN": "X",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Asisten Ahli",
    "GRADE FUNGSIONAL": 8,
    "STRUKTURAL": "[REN126] Pengelola Gugus Kendali Mutu (Fakultas) sebagai Anggota",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Fakultas Ekonomi",
    "POINT POSITION": 200,
    "POINT PERFORMANCE": 1130.5,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 1330.5,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 1995750,
    "PPh 100%": 99787.5,
    "JUMLAH KOTOR 30% (Rp)": 746550,
    "JUMLAH KOTOR 70% (Rp)": 1249200,
    "PPh 21": 62460,
    "JUMLAH BERSIH 70% (Rp)": 1186740,
    "TANDA TANGAN": 533
  },
  {
    "NIP": "'197702012001121001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Prof. Dr. Anantawikrama Tungga Atmadja, S.E., Ak., M.Si.",
    "JURUSAN": "Akuntansi (S1)",
    "FAKULTAS": "Fakultas Ekonomi",
    "GOLONGAN": "IVC",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Guru Besar",
    "GRADE FUNGSIONAL": 12,
    "STRUKTURAL": "Koordinator Program Studi S2",
    "GRADE STRUKTURAL": 12,
    "UNIT KERJA": "Akuntansi (S2)",
    "POINT POSITION": 2559.35,
    "POINT PERFORMANCE": 2508.17,
    "POINT KELEBIHAN": 77.5083,
    "POINT TOTAL": 5145.02,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 7717530,
    "PPh 100%": 1157629.5,
    "JUMLAH KOTOR 30% (Rp)": 2506657.5,
    "JUMLAH KOTOR 70% (Rp)": 5210872.5,
    "PPh 21": 781630.875,
    "JUMLAH BERSIH 70% (Rp)": 4429241.625,
    "TANDA TANGAN": 534
  },
  {
    "NIP": "'197307271999031001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Prof. Dr. Edy Sujana, S.E., M.Si., Ak.",
    "JURUSAN": "Akuntansi (S1)",
    "FAKULTAS": "Fakultas Ekonomi",
    "GOLONGAN": "IVB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Guru Besar",
    "GRADE FUNGSIONAL": 12,
    "STRUKTURAL": "[REN126] Pengelola Gugus Kendali Mutu (Fakultas) sebagai Anggota",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Pascasarjana",
    "POINT POSITION": 200,
    "POINT PERFORMANCE": 2126.09,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 2326.09,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 3489135,
    "PPh 100%": 523370.25,
    "JUMLAH KOTOR 30% (Rp)": 1444950,
    "JUMLAH KOTOR 70% (Rp)": 2044185,
    "PPh 21": 306627.75,
    "JUMLAH BERSIH 70% (Rp)": 1737557.25,
    "TANDA TANGAN": 535
  },
  {
    "NIP": "'198703212015042001",
    "STATUS SEKARANG": "Ijin Belajar",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Putu Eka Dianita Marvilianti Dewi, S.S.T.Ak., M.Si.",
    "JURUSAN": "Akuntansi (S1)",
    "FAKULTAS": "Fakultas Ekonomi",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "UNIT KERJA": "-",
    "POINT PERFORMANCE": 1262.83,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 1262.83,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 1894245,
    "PPh 100%": 94712.25,
    "JUMLAH KOTOR 30% (Rp)": 787050,
    "JUMLAH KOTOR 70% (Rp)": 1107195,
    "PPh 21": 55359.75,
    "JUMLAH BERSIH 70% (Rp)": 1051835.25,
    "TANDA TANGAN": 536
  },
  {
    "NIP": "'199103302019032015",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Putu Riesty Masdiantini, S.E.,M.Si.",
    "JURUSAN": "Akuntansi (S1)",
    "FAKULTAS": "Fakultas Ekonomi",
    "GOLONGAN": "IIIC",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "UNIT KERJA": "-",
    "POINT PERFORMANCE": 1364.83,
    "POINT KELEBIHAN": 87.3333,
    "POINT TOTAL": 1452.17,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 2178255,
    "PPh 100%": 108912.75,
    "JUMLAH KOTOR 30% (Rp)": 787050,
    "JUMLAH KOTOR 70% (Rp)": 1391205,
    "PPh 21": 69560.25,
    "JUMLAH BERSIH 70% (Rp)": 1321644.75,
    "TANDA TANGAN": 537
  },
  {
    "NIP": "'199311282020121002",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Putu Yunartha Pradnyana Putra, S.E., M.Sc.",
    "JURUSAN": "Akuntansi (S1)",
    "FAKULTAS": "Fakultas Ekonomi",
    "GOLONGAN": "IIIB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "TIDAK ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Asisten Ahli",
    "GRADE FUNGSIONAL": 8,
    "UNIT KERJA": "-",
    "POINT POSITION": 0,
    "POINT PERFORMANCE": 0,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 0,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 0,
    "PPh 100%": 0,
    "JUMLAH KOTOR 30% (Rp)": 656550,
    "JUMLAH KOTOR 70% (Rp)": 0,
    "PPh 21": 0,
    "JUMLAH BERSIH 70% (Rp)": 0,
    "TANDA TANGAN": 538
  },
  {
    "NIP": "'199303112024062002",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Rindhi Marverissa, M.Acc.",
    "JURUSAN": "Akuntansi (S1)",
    "FAKULTAS": "Fakultas Ekonomi",
    "GOLONGAN": "IIIB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Tenaga Pengajar",
    "GRADE FUNGSIONAL": 7,
    "UNIT KERJA": "-",
    "POINT PERFORMANCE": 521.083,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 521.083,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 781624.5,
    "PPh 100%": 39081.225,
    "JUMLAH KOTOR 30% (Rp)": 545400,
    "JUMLAH KOTOR 70% (Rp)": 236224.5,
    "PPh 21": 11811.225,
    "JUMLAH BERSIH 70% (Rp)": 224413.275,
    "TANDA TANGAN": 539
  },
  {
    "NIP": "'198308202009121006",
    "STATUS SEKARANG": "Tugas Belajar",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "dr. Adnyana Putra, S.Ked., M.Kes.",
    "JURUSAN": "Program Studi Kedokteran",
    "FAKULTAS": "Fakultas Kedokteran",
    "GOLONGAN": "IIIC",
    "STATUS PENELITIAN": "TIDAK ADA",
    "STATUS PENGABDIAN": "TIDAK ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "UNIT KERJA": "-",
    "POINT POSITION": 0,
    "POINT PERFORMANCE": 0,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 0,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 0,
    "PPh 100%": 0,
    "JUMLAH KOTOR 70% (Rp)": 0,
    "PPh 21": 0,
    "JUMLAH BERSIH 70% (Rp)": 0,
    "TANDA TANGAN": 540
  },
  {
    "NIP": "'197512152008121001",
    "STATUS SEKARANG": "Ijin Belajar",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. dr. I Made Kusuma Wijaya, S.Ked., M.Kes.",
    "JURUSAN": "Program Studi Kedokteran",
    "FAKULTAS": "Fakultas Kedokteran",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "STRUKTURAL": "Ketua Laboratorium Fakultas",
    "GRADE STRUKTURAL": 12,
    "UNIT KERJA": "Fakultas Kedokteran",
    "POINT POSITION": 2408.8,
    "POINT PERFORMANCE": 1040.17,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 3448.97,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 5173455,
    "PPh 100%": 258672.75,
    "JUMLAH KOTOR 30% (Rp)": 1871010,
    "JUMLAH KOTOR 70% (Rp)": 3302445,
    "PPh 21": 165122.25,
    "JUMLAH BERSIH 70% (Rp)": 3137322.75,
    "TANDA TANGAN": 541
  },
  {
    "NIP": "'198103212008121003",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. dr. Ketut Indra Purnomo, S.Ked., M.Kes.",
    "JURUSAN": "Program Studi Kedokteran",
    "FAKULTAS": "Fakultas Kedokteran",
    "GOLONGAN": "IIIC",
    "STATUS PENELITIAN": "TIDAK ADA",
    "STATUS PENGABDIAN": "TIDAK ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "STRUKTURAL": "[REN223] Sekretaris Pusat/ Ketua Divisi/ Asrama/ Koordinator Lab. Jurusan Kepala Unit BPU/ Sekretaris Gugus Kendali Mutu Fakultas/ Sekretaris Tim Pengelolaan dan Penerimaan Mahasiswa Asing/ Sekretaris Unit Pengembangan dan Peningkatan Kapasitas Kelembagaan",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Fakultas Kedokteran",
    "POINT POSITION": 0,
    "POINT PERFORMANCE": 0,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 0,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 0,
    "PPh 100%": 0,
    "JUMLAH KOTOR 30% (Rp)": 1147050,
    "JUMLAH KOTOR 70% (Rp)": 0,
    "PPh 21": 0,
    "JUMLAH BERSIH 70% (Rp)": 0,
    "TANDA TANGAN": 542
  },
  {
    "NIP": "'198209302009121003",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. dr. Komang Hendra Setiawan, S.Ked., M.Kes.",
    "JURUSAN": "Program Studi Kedokteran",
    "FAKULTAS": "Fakultas Kedokteran",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor Kepala",
    "GRADE FUNGSIONAL": 11,
    "STRUKTURAL": "[REN222] Kepala Pusat /Kantor/Kepala Gugus Kendali Mutu Fakultas/Ketua Unit Pengelolaan dan Penerimaan Mahasiswa Asing/ Ketua Unit Pengembangan dan Peningkatan Kapasitas Kelembagaan",
    "UNIT KERJA": "-",
    "POINT POSITION": 1150,
    "POINT PERFORMANCE": 1476.75,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 2626.75,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 3940125,
    "PPh 100%": 197006.25,
    "JUMLAH KOTOR 30% (Rp)": 1656900,
    "JUMLAH KOTOR 70% (Rp)": 2283225,
    "PPh 21": 114161.25,
    "JUMLAH BERSIH 70% (Rp)": 2169063.75,
    "TANDA TANGAN": 543
  },
  {
    "NIP": "'197705122005011002",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. dr. Made Budiawan, S.Ked., M.Kes.",
    "JURUSAN": "Program Studi Kedokteran",
    "FAKULTAS": "Fakultas Kedokteran",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "STRUKTURAL": "Wakil Dekan III",
    "GRADE STRUKTURAL": 14,
    "UNIT KERJA": "Fakultas Kedokteran",
    "POINT POSITION": 8640,
    "POINT PERFORMANCE": 1281.33,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 9921.33,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 14881995,
    "PPh 100%": 744099.75,
    "JUMLAH KOTOR 30% (Rp)": 4675050,
    "JUMLAH KOTOR 70% (Rp)": 10206945,
    "PPh 21": 510347.25,
    "JUMLAH BERSIH 70% (Rp)": 9696597.75,
    "TANDA TANGAN": 544
  },
  {
    "NIP": "'198202172008122001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. dr. Made Kurnia Widiastuti Giri, S.Ked., M.Kes.",
    "JURUSAN": "Program Studi Kedokteran",
    "FAKULTAS": "Fakultas Kedokteran",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor Kepala",
    "GRADE FUNGSIONAL": 11,
    "STRUKTURAL": "Ketua Senat Fakultas",
    "GRADE STRUKTURAL": 11,
    "UNIT KERJA": "Fakultas Kedokteran",
    "POINT POSITION": 2025.6,
    "POINT PERFORMANCE": 1975.04,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 4000.64,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 6000960,
    "PPh 100%": 300048,
    "JUMLAH KOTOR 30% (Rp)": 2050920,
    "JUMLAH KOTOR 70% (Rp)": 3950040,
    "PPh 21": 197502,
    "JUMLAH BERSIH 70% (Rp)": 3752538,
    "TANDA TANGAN": 545
  },
  {
    "NIP": "'197502252005012001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. dr. Ni Luh Kadek Alit Arsani, S.Ked., M.Biomed.",
    "JURUSAN": "Program Studi Kedokteran",
    "FAKULTAS": "Fakultas Kedokteran",
    "GOLONGAN": "IVA",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor Kepala",
    "GRADE FUNGSIONAL": 11,
    "STRUKTURAL": "Wakil Dekan II",
    "GRADE STRUKTURAL": 14,
    "UNIT KERJA": "Fakultas Kedokteran",
    "POINT POSITION": 8640,
    "POINT PERFORMANCE": 1319.67,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 9959.67,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 14939505,
    "PPh 100%": 2240925.75,
    "JUMLAH KOTOR 30% (Rp)": 5027400,
    "JUMLAH KOTOR 70% (Rp)": 9912105,
    "PPh 21": 1486815.75,
    "JUMLAH BERSIH 70% (Rp)": 8425289.25,
    "TANDA TANGAN": 546
  },
  {
    "NIP": "'198207022008122002",
    "STATUS SEKARANG": "Tugas Belajar",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. dr. Ni Made Sri Dewi Lestari, S.Ked., M.Kes.",
    "JURUSAN": "Program Studi Kedokteran",
    "FAKULTAS": "Fakultas Kedokteran",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "STRUKTURAL": "[REN223] Sekretaris Pusat/ Ketua Divisi/ Asrama/ Koordinator Lab. Jurusan Kepala Unit BPU/ Sekretaris Gugus Kendali Mutu Fakultas/ Sekretaris Tim Pengelolaan dan Penerimaan Mahasiswa Asing/ Sekretaris Unit Pengembangan dan Peningkatan Kapasitas Kelembagaan",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Fakultas Kedokteran",
    "POINT POSITION": 800,
    "POINT PERFORMANCE": 0,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 800,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 1200000,
    "PPh 100%": 60000,
    "JUMLAH KOTOR 70% (Rp)": 1200000,
    "PPh 21": 60000,
    "JUMLAH BERSIH 70% (Rp)": 1140000,
    "TANDA TANGAN": 547
  },
  {
    "NIP": "'198410152009121005",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. dr. Putu Adi Suputra, S.Ked., M.Kes.",
    "JURUSAN": "Program Studi Kedokteran",
    "FAKULTAS": "Fakultas Kedokteran",
    "GOLONGAN": "IVA",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor Kepala",
    "GRADE FUNGSIONAL": 11,
    "UNIT KERJA": "-",
    "POINT PERFORMANCE": 1657.42,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 1657.42,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 2486130,
    "PPh 100%": 372919.5,
    "JUMLAH KOTOR 30% (Rp)": 1139400,
    "JUMLAH KOTOR 70% (Rp)": 1346730,
    "PPh 21": 202009.5,
    "JUMLAH BERSIH 70% (Rp)": 1144720.5,
    "TANDA TANGAN": 548
  },
  {
    "NIP": "'198401292019031002",
    "STATUS SEKARANG": "Tugas Belajar",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "dr. I Gede Surya Dinata, M.Biomed.,Sp.B.",
    "JURUSAN": "Program Studi Kedokteran",
    "FAKULTAS": "Fakultas Kedokteran",
    "GOLONGAN": "IIIC",
    "STATUS PENELITIAN": "TIDAK ADA",
    "STATUS PENGABDIAN": "TIDAK ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "UNIT KERJA": "-",
    "POINT POSITION": 0,
    "POINT PERFORMANCE": 0,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 0,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 0,
    "PPh 100%": 0,
    "JUMLAH KOTOR 70% (Rp)": 0,
    "PPh 21": 0,
    "JUMLAH BERSIH 70% (Rp)": 0,
    "TANDA TANGAN": 549
  },
  {
    "NIP": "'198208112008121005",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "dr. I.P. Adi Wibowo, S.Ked., M.Kes.",
    "JURUSAN": "Program Studi Kedokteran",
    "FAKULTAS": "Fakultas Kedokteran",
    "GOLONGAN": "IIIC",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "STRUKTURAL": "[REN126] Pengelola Gugus Kendali Mutu (Fakultas) sebagai Anggota",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Fakultas Kedokteran",
    "POINT POSITION": 200,
    "POINT PERFORMANCE": 1004.5,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 1204.5,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 1806750,
    "PPh 100%": 90337.5,
    "JUMLAH KOTOR 30% (Rp)": 877050,
    "JUMLAH KOTOR 70% (Rp)": 929700,
    "PPh 21": 46485,
    "JUMLAH BERSIH 70% (Rp)": 883215,
    "TANDA TANGAN": 550
  },
  {
    "NIP": "'198904232022032010",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "dr. Ida Ayu Diah Purnama Sari, Sp.KK",
    "JURUSAN": "Program Studi Kedokteran",
    "FAKULTAS": "Fakultas Kedokteran",
    "GOLONGAN": "IIIB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Asisten Ahli",
    "GRADE FUNGSIONAL": 8,
    "STRUKTURAL": "[REN224] Sekretaris Unit BPU",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "-",
    "POINT POSITION": 500,
    "POINT PERFORMANCE": 854,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 1354,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 2031000,
    "PPh 100%": 101550,
    "JUMLAH KOTOR 30% (Rp)": 881550,
    "JUMLAH KOTOR 70% (Rp)": 1149450,
    "PPh 21": 57472.5,
    "JUMLAH BERSIH 70% (Rp)": 1091977.5,
    "TANDA TANGAN": 551
  },
  {
    "NIP": "'199304262019031008",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "dr. Made Bayu Permasutha, S.Ked., M.Biomed.",
    "JURUSAN": "Program Studi Kedokteran",
    "FAKULTAS": "Fakultas Kedokteran",
    "GOLONGAN": "IIIB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Asisten Ahli",
    "GRADE FUNGSIONAL": 8,
    "STRUKTURAL": "[REN223] Sekretaris Pusat/ Ketua Divisi/ Asrama/ Koordinator Lab. Jurusan Kepala Unit BPU/ Sekretaris Gugus Kendali Mutu Fakultas/ Sekretaris Tim Pengelolaan dan Penerimaan Mahasiswa Asing/ Sekretaris Unit Pengembangan dan Peningkatan Kapasitas Kelembagaan",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Fakultas Kedokteran",
    "POINT POSITION": 800,
    "POINT PERFORMANCE": 1095.83,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 1895.83,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 2843745,
    "PPh 100%": 142187.25,
    "JUMLAH KOTOR 30% (Rp)": 1016550,
    "JUMLAH KOTOR 70% (Rp)": 1827195,
    "PPh 21": 91359.75,
    "JUMLAH BERSIH 70% (Rp)": 1735835.25,
    "TANDA TANGAN": 552
  },
  {
    "NIP": "'199602132024062002",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "dr. Made Dinda Pratiwi, S.Ked., M.Biomed.",
    "JURUSAN": "Program Studi Kedokteran",
    "FAKULTAS": "Fakultas Kedokteran",
    "GOLONGAN": "IIIB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Tenaga Pengajar",
    "GRADE FUNGSIONAL": 7,
    "STRUKTURAL": "[REN126] Pengelola Gugus Kendali Mutu (Fakultas) sebagai Anggota",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Fakultas Kedokteran",
    "POINT POSITION": 200,
    "POINT PERFORMANCE": 793.333,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 993.333,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 1489999.5,
    "PPh 100%": 74499.975,
    "JUMLAH KOTOR 30% (Rp)": 635400,
    "JUMLAH KOTOR 70% (Rp)": 854599.5,
    "PPh 21": 42729.975,
    "JUMLAH BERSIH 70% (Rp)": 811869.525,
    "TANDA TANGAN": 553
  },
  {
    "NIP": "'198108212009122002",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "dr. Made Suadnyani Pasek, S.Ked., M.Kes.",
    "JURUSAN": "Program Studi Kedokteran",
    "FAKULTAS": "Fakultas Kedokteran",
    "GOLONGAN": "IIIC",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "STRUKTURAL": "[REN126] Pengelola Gugus Kendali Mutu (Fakultas) sebagai Anggota",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Fakultas Kedokteran",
    "POINT POSITION": 200,
    "POINT PERFORMANCE": 995.667,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 1195.67,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 1793505,
    "PPh 100%": 89675.25,
    "JUMLAH KOTOR 30% (Rp)": 877050,
    "JUMLAH KOTOR 70% (Rp)": 916455,
    "PPh 21": 45822.75,
    "JUMLAH BERSIH 70% (Rp)": 870632.25,
    "TANDA TANGAN": 554
  },
  {
    "NIP": "'199210172019032018",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "dr. Ni Luh Putu Pranena Sastri, S.Ked., MHPE",
    "JURUSAN": "Program Studi Kedokteran",
    "FAKULTAS": "Fakultas Kedokteran",
    "GOLONGAN": "IIIB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Asisten Ahli",
    "GRADE FUNGSIONAL": 8,
    "STRUKTURAL": "[REN223] Sekretaris Pusat/ Ketua Divisi/ Asrama/ Koordinator Lab. Jurusan Kepala Unit BPU/ Sekretaris Gugus Kendali Mutu Fakultas/ Sekretaris Tim Pengelolaan dan Penerimaan Mahasiswa Asing/ Sekretaris Unit Pengembangan dan Peningkatan Kapasitas Kelembagaan",
    "UNIT KERJA": "-",
    "POINT POSITION": 800,
    "POINT PERFORMANCE": 1009.5,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 1809.5,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 2714250,
    "PPh 100%": 135712.5,
    "JUMLAH KOTOR 30% (Rp)": 1016550,
    "JUMLAH KOTOR 70% (Rp)": 1697700,
    "PPh 21": 84885,
    "JUMLAH BERSIH 70% (Rp)": 1612815,
    "TANDA TANGAN": 555
  },
  {
    "NIP": "'199003182024062001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "dr. Ni Made Dwi Rosmiati, Sp.PK.",
    "JURUSAN": "Program Studi Kedokteran",
    "FAKULTAS": "Fakultas Kedokteran",
    "GOLONGAN": "IIIB",
    "STATUS PENELITIAN": "TIDAK ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Tenaga Pengajar",
    "GRADE FUNGSIONAL": 7,
    "UNIT KERJA": "-",
    "POINT POSITION": 0,
    "POINT PERFORMANCE": 0,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 0,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 0,
    "PPh 100%": 0,
    "JUMLAH KOTOR 30% (Rp)": 545400,
    "JUMLAH KOTOR 70% (Rp)": 0,
    "PPh 21": 0,
    "JUMLAH BERSIH 70% (Rp)": 0,
    "TANDA TANGAN": 556
  },
  {
    "NIP": "'198508252009122007",
    "STATUS SEKARANG": "Ijin Belajar",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "dr. Ni Nyoman Mestri Agustini, S.Ked., M.Kes., M.Biomed., Sp.",
    "JURUSAN": "Program Studi Kedokteran",
    "FAKULTAS": "Fakultas Kedokteran",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "STRUKTURAL": "Sekretaris Senat Fakultas",
    "GRADE STRUKTURAL": 10,
    "UNIT KERJA": "Fakultas Kedokteran",
    "POINT POSITION": 1684.8,
    "POINT PERFORMANCE": 1162.17,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 2846.97,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 4270455,
    "PPh 100%": 213522.75,
    "JUMLAH KOTOR 30% (Rp)": 1545210,
    "JUMLAH KOTOR 70% (Rp)": 2725245,
    "PPh 21": 136262.25,
    "JUMLAH BERSIH 70% (Rp)": 2588982.75,
    "TANDA TANGAN": 557
  },
  {
    "NIP": "'197906212008122002",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "dr. Ni Putu Dewi Sri Wahyuni, S.Ked., M.Kes.",
    "JURUSAN": "Program Studi Kedokteran",
    "FAKULTAS": "Fakultas Kedokteran",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "STRUKTURAL": "[REN223] Sekretaris Pusat/ Ketua Divisi/ Asrama/ Koordinator Lab. Jurusan Kepala Unit BPU/ Sekretaris Gugus Kendali Mutu Fakultas/ Sekretaris Tim Pengelolaan dan Penerimaan Mahasiswa Asing/ Sekretaris Unit Pengembangan dan Peningkatan Kapasitas Kelembagaan",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "-",
    "POINT POSITION": 800,
    "POINT PERFORMANCE": 936.333,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 1736.33,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 2604495,
    "PPh 100%": 130224.75,
    "JUMLAH KOTOR 30% (Rp)": 1147050,
    "JUMLAH KOTOR 70% (Rp)": 1457445,
    "PPh 21": 72872.25,
    "JUMLAH BERSIH 70% (Rp)": 1384572.75,
    "TANDA TANGAN": 558
  },
  {
    "NIP": "'199207072019032031",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "dr. Nyoman Intan Permatahati Wiguna, S.Ked., M.Biomed.",
    "JURUSAN": "Program Studi Kedokteran",
    "FAKULTAS": "Fakultas Kedokteran",
    "GOLONGAN": "IIIB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Asisten Ahli",
    "GRADE FUNGSIONAL": 8,
    "STRUKTURAL": "[REN126] Pengelola Gugus Kendali Mutu (Fakultas) sebagai Anggota",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Fakultas Kedokteran",
    "POINT POSITION": 200,
    "POINT PERFORMANCE": 1025.83,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 1225.83,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 1838745,
    "PPh 100%": 91937.25,
    "JUMLAH KOTOR 30% (Rp)": 746550,
    "JUMLAH KOTOR 70% (Rp)": 1092195,
    "PPh 21": 54609.75,
    "JUMLAH BERSIH 70% (Rp)": 1037585.25,
    "TANDA TANGAN": 559
  },
  {
    "NIP": "'198904022024062001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "dr. Putri Krishna Kumara Dewi, M.Biomed",
    "JURUSAN": "Program Studi Kedokteran",
    "FAKULTAS": "Fakultas Kedokteran",
    "GOLONGAN": "IIIB",
    "STATUS PENELITIAN": "TIDAK ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Tenaga Pengajar",
    "GRADE FUNGSIONAL": 7,
    "STRUKTURAL": "[REN126] Pengelola Gugus Kendali Mutu (Fakultas) sebagai Anggota",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Fakultas Kedokteran",
    "POINT POSITION": 0,
    "POINT PERFORMANCE": 0,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 0,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 0,
    "PPh 100%": 0,
    "JUMLAH KOTOR 30% (Rp)": 635400,
    "JUMLAH KOTOR 70% (Rp)": 0,
    "PPh 21": 0,
    "JUMLAH BERSIH 70% (Rp)": 0,
    "TANDA TANGAN": 560
  },
  {
    "NIP": "'198709042022032007",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Irma Rahmayani, S.Pd., M.Si.",
    "JURUSAN": "Program Studi Kedokteran",
    "FAKULTAS": "Fakultas Kedokteran",
    "GOLONGAN": "IIIB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Asisten Ahli",
    "GRADE FUNGSIONAL": 8,
    "STRUKTURAL": "[REN126] Pengelola Gugus Kendali Mutu (Fakultas) sebagai Anggota",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Fakultas Kedokteran",
    "POINT POSITION": 200,
    "POINT PERFORMANCE": 949.833,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 1149.83,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 1724745,
    "PPh 100%": 86237.25,
    "JUMLAH KOTOR 30% (Rp)": 746550,
    "JUMLAH KOTOR 70% (Rp)": 978195,
    "PPh 21": 48909.75,
    "JUMLAH BERSIH 70% (Rp)": 929285.25,
    "TANDA TANGAN": 561
  },
  {
    "NIP": "'198810032020121004",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "dr. Aditya Prabawa, M.Biomed., Sp.OG.",
    "JURUSAN": "Pendidikan Profesi Dokter",
    "FAKULTAS": "Fakultas Kedokteran",
    "GOLONGAN": "IIIC",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "STRUKTURAL": "Koordinator Program Studi S1/D3",
    "GRADE STRUKTURAL": 11,
    "UNIT KERJA": "Pendidikan Profesi Dokter",
    "POINT POSITION": 1645.8,
    "POINT PERFORMANCE": 685.625,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 2331.43,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 3497145,
    "PPh 100%": 174857.25,
    "JUMLAH KOTOR 30% (Rp)": 1527660,
    "JUMLAH KOTOR 70% (Rp)": 1969485,
    "PPh 21": 98474.25,
    "JUMLAH BERSIH 70% (Rp)": 1871010.75,
    "TANDA TANGAN": 562
  },
  {
    "NIP": "'198909232024061002",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Dr. dr. Putu Kermawan, Sp.OT., M.Biomed",
    "JURUSAN": "Pendidikan Profesi Dokter",
    "FAKULTAS": "Fakultas Kedokteran",
    "GOLONGAN": "IIIB",
    "STATUS PENELITIAN": "TIDAK ADA",
    "STATUS PENGABDIAN": "TIDAK ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Tenaga Pengajar",
    "GRADE FUNGSIONAL": 7,
    "STRUKTURAL": "[REN126] Pengelola Gugus Kendali Mutu (Fakultas) sebagai Anggota",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Fakultas Kedokteran",
    "POINT POSITION": 0,
    "POINT PERFORMANCE": 0,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 0,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 0,
    "PPh 100%": 0,
    "JUMLAH KOTOR 30% (Rp)": 635400,
    "JUMLAH KOTOR 70% (Rp)": 0,
    "PPh 21": 0,
    "JUMLAH BERSIH 70% (Rp)": 0,
    "TANDA TANGAN": 563
  },
  {
    "NIP": "'197707011999032002",
    "STATUS SEKARANG": "Ijin Belajar",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Made Juliani, S.ST., S.Kep., Ns., M.Pd.",
    "JURUSAN": "Keperawatan (S1)",
    "FAKULTAS": "Fakultas Kedokteran",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "UNIT KERJA": "-",
    "POINT PERFORMANCE": 275.667,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 275.667,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 413500.5,
    "PPh 100%": 20675.025,
    "JUMLAH KOTOR 30% (Rp)": 787050,
    "JUMLAH KOTOR 70% (Rp)": 0,
    "PPh 21": 0,
    "JUMLAH BERSIH 70% (Rp)": 0,
    "TANDA TANGAN": 564
  },
  {
    "NIP": "'199611092024061001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Made Satya Nugraha Gautama, M.Sc.",
    "JURUSAN": "Keperawatan (S1)",
    "FAKULTAS": "Fakultas Kedokteran",
    "GOLONGAN": "IIIB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Tenaga Pengajar",
    "GRADE FUNGSIONAL": 7,
    "STRUKTURAL": "[REN126] Pengelola Gugus Kendali Mutu (Fakultas) sebagai Anggota",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Fakultas Kedokteran",
    "POINT POSITION": 200,
    "POINT PERFORMANCE": 438.583,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 638.583,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 957874.5,
    "PPh 100%": 47893.725,
    "JUMLAH KOTOR 30% (Rp)": 635400,
    "JUMLAH KOTOR 70% (Rp)": 322474.5,
    "PPh 21": 16123.725,
    "JUMLAH BERSIH 70% (Rp)": 306350.775,
    "TANDA TANGAN": 565
  },
  {
    "NIP": "'197512081998032008",
    "STATUS SEKARANG": "Tugas Belajar",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Ni Wayan Dewi Tarini, S.KepNs., M.Kes.",
    "JURUSAN": "Keperawatan (S1)",
    "FAKULTAS": "Fakultas Kedokteran",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "UNIT KERJA": "-",
    "POINT PERFORMANCE": 0,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 0,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 0,
    "PPh 100%": 0,
    "JUMLAH KOTOR 70% (Rp)": 0,
    "PPh 21": 0,
    "JUMLAH BERSIH 70% (Rp)": 0,
    "TANDA TANGAN": 566
  },
  {
    "NIP": "'199305052022031009",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Ns. I Dewa Agung Gde Fanji Pradiptha, M.Kep.",
    "JURUSAN": "Keperawatan (S1)",
    "FAKULTAS": "Fakultas Kedokteran",
    "GOLONGAN": "IIIB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Asisten Ahli",
    "GRADE FUNGSIONAL": 8,
    "STRUKTURAL": "[REN222] Kepala Pusat /Kantor/Kepala Gugus Kendali Mutu Fakultas/Ketua Unit Pengelolaan dan Penerimaan Mahasiswa Asing/ Ketua Unit Pengembangan dan Peningkatan Kapasitas Kelembagaan",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Fakultas Kedokteran",
    "POINT POSITION": 1150,
    "POINT PERFORMANCE": 568.25,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 1718.25,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 2577375,
    "PPh 100%": 128868.75,
    "JUMLAH KOTOR 30% (Rp)": 1174050,
    "JUMLAH KOTOR 70% (Rp)": 1403325,
    "PPh 21": 70166.25,
    "JUMLAH BERSIH 70% (Rp)": 1333158.75,
    "TANDA TANGAN": 567
  },
  {
    "NIP": "'198911072024061002",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Ns. I Kadek Artawan, M.Kep.",
    "JURUSAN": "Keperawatan (S1)",
    "FAKULTAS": "Fakultas Kedokteran",
    "GOLONGAN": "IIIB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Tenaga Pengajar",
    "GRADE FUNGSIONAL": 7,
    "STRUKTURAL": "[REN126] Pengelola Gugus Kendali Mutu (Fakultas) sebagai Anggota",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Fakultas Kedokteran",
    "POINT POSITION": 200,
    "POINT PERFORMANCE": 358.708,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 558.708,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 838062,
    "PPh 100%": 41903.1,
    "JUMLAH KOTOR 30% (Rp)": 635400,
    "JUMLAH KOTOR 70% (Rp)": 202662,
    "PPh 21": 10133.1,
    "JUMLAH BERSIH 70% (Rp)": 192528.9,
    "TANDA TANGAN": 568
  },
  {
    "NIP": "'199010192020121011",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Ns. Made Bayu Oka Widiarta, S.Kep., M.Kep.",
    "JURUSAN": "Keperawatan (S1)",
    "FAKULTAS": "Fakultas Kedokteran",
    "GOLONGAN": "IIIC",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "STRUKTURAL": "Koordinator Program Studi S1/D3",
    "GRADE STRUKTURAL": 11,
    "UNIT KERJA": "Keperawatan (S1)",
    "POINT POSITION": 1645.8,
    "POINT PERFORMANCE": 190.875,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 1836.68,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 2755020,
    "PPh 100%": 137751,
    "JUMLAH KOTOR 30% (Rp)": 1527660,
    "JUMLAH KOTOR 70% (Rp)": 1227360,
    "PPh 21": 61368,
    "JUMLAH BERSIH 70% (Rp)": 1165992,
    "TANDA TANGAN": 569
  },
  {
    "NIP": "'199011092022032015",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Ns. Made Ririn Sri Wulandari, S.Kep., M.Kep.",
    "JURUSAN": "Keperawatan (S1)",
    "FAKULTAS": "Fakultas Kedokteran",
    "GOLONGAN": "IIIB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Asisten Ahli",
    "GRADE FUNGSIONAL": 8,
    "STRUKTURAL": "[REN126] Pengelola Gugus Kendali Mutu (Fakultas) sebagai Anggota",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Fakultas Kedokteran",
    "POINT POSITION": 200,
    "POINT PERFORMANCE": 680.146,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 880.146,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 1320219,
    "PPh 100%": 66010.95,
    "JUMLAH KOTOR 30% (Rp)": 746550,
    "JUMLAH KOTOR 70% (Rp)": 573669,
    "PPh 21": 28683.45,
    "JUMLAH BERSIH 70% (Rp)": 544985.55,
    "TANDA TANGAN": 570
  },
  {
    "NIP": "'199106272022032009",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Ns. Ni Kadek Diah Purnamayanti, S.Kep., M.Kep.",
    "JURUSAN": "Keperawatan (S1)",
    "FAKULTAS": "Fakultas Kedokteran",
    "GOLONGAN": "IIIB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Asisten Ahli",
    "GRADE FUNGSIONAL": 8,
    "STRUKTURAL": "[REN223] Sekretaris Pusat/ Ketua Divisi/ Asrama/ Koordinator Lab. Jurusan Kepala Unit BPU/ Sekretaris Gugus Kendali Mutu Fakultas/ Sekretaris Tim Pengelolaan dan Penerimaan Mahasiswa Asing/ Sekretaris Unit Pengembangan dan Peningkatan Kapasitas Kelembagaan",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Fakultas Kedokteran",
    "POINT POSITION": 800,
    "POINT PERFORMANCE": 901.833,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 1701.83,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 2552745,
    "PPh 100%": 127637.25,
    "JUMLAH KOTOR 30% (Rp)": 1016550,
    "JUMLAH KOTOR 70% (Rp)": 1536195,
    "PPh 21": 76809.75,
    "JUMLAH BERSIH 70% (Rp)": 1459385.25,
    "TANDA TANGAN": 571
  },
  {
    "NIP": "'199203182022031003",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Ns. Shofi Khaqul Ilmy, S.Kep., M.Kep.",
    "JURUSAN": "Keperawatan (S1)",
    "FAKULTAS": "Fakultas Kedokteran",
    "GOLONGAN": "IIIB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Asisten Ahli",
    "GRADE FUNGSIONAL": 8,
    "STRUKTURAL": "Koordinator Program Studi S1/D3",
    "GRADE STRUKTURAL": 11,
    "UNIT KERJA": "Pendidikan Profesi Ners",
    "POINT POSITION": 800,
    "POINT PERFORMANCE": 333.917,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 1133.92,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 1700880,
    "PPh 100%": 85044,
    "JUMLAH KOTOR 30% (Rp)": 1016550,
    "JUMLAH KOTOR 70% (Rp)": 684330,
    "PPh 21": 34216.5,
    "JUMLAH BERSIH 70% (Rp)": 650113.5,
    "TANDA TANGAN": 572
  },
  {
    "NIP": "'198511062010122002",
    "STATUS SEKARANG": "Ijin Belajar",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Putu Handi Partiwi, S.Kep.,Ns., M. Pd.",
    "JURUSAN": "Keperawatan (S1)",
    "FAKULTAS": "Fakultas Kedokteran",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Asisten Ahli",
    "GRADE FUNGSIONAL": 8,
    "UNIT KERJA": "-",
    "POINT PERFORMANCE": 224.438,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 224.438,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 336657,
    "PPh 100%": 16832.85,
    "JUMLAH KOTOR 30% (Rp)": 656550,
    "JUMLAH KOTOR 70% (Rp)": 0,
    "PPh 21": 0,
    "JUMLAH BERSIH 70% (Rp)": 0,
    "TANDA TANGAN": 573
  },
  {
    "NIP": "'199303122024062002",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Bd. Titin Novayanti Dey, M.Keb.",
    "JURUSAN": "Kebidanan (S1)",
    "FAKULTAS": "Fakultas Kedokteran",
    "GOLONGAN": "IIIB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Tenaga Pengajar",
    "GRADE FUNGSIONAL": 7,
    "STRUKTURAL": "[REN126] Pengelola Gugus Kendali Mutu (Fakultas) sebagai Anggota",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Fakultas Kedokteran",
    "POINT POSITION": 200,
    "POINT PERFORMANCE": 242.667,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 442.667,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 664000.5,
    "PPh 100%": 33200.025,
    "JUMLAH KOTOR 30% (Rp)": 635400,
    "JUMLAH KOTOR 70% (Rp)": 28600.5,
    "PPh 21": 1430.025,
    "JUMLAH BERSIH 70% (Rp)": 27170.475,
    "TANDA TANGAN": 574
  },
  {
    "NIP": "'199503102024062001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Sumiati, S.Tr.Keb., M.Keb.",
    "JURUSAN": "Kebidanan (S1)",
    "FAKULTAS": "Fakultas Kedokteran",
    "GOLONGAN": "IIIB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Tenaga Pengajar",
    "GRADE FUNGSIONAL": 7,
    "STRUKTURAL": "[REN126] Pengelola Gugus Kendali Mutu (Fakultas) sebagai Anggota",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Fakultas Kedokteran",
    "POINT POSITION": 200,
    "POINT PERFORMANCE": 337.75,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 537.75,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 806625,
    "PPh 100%": 40331.25,
    "JUMLAH KOTOR 30% (Rp)": 635400,
    "JUMLAH KOTOR 70% (Rp)": 171225,
    "PPh 21": 8561.25,
    "JUMLAH BERSIH 70% (Rp)": 162663.75,
    "TANDA TANGAN": 575
  },
  {
    "NIP": "'196312311987031260",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "I Ketut Wijana, S.ST., M.Pd.",
    "JURUSAN": "Pendidikan Profesi Ners",
    "FAKULTAS": "Fakultas Kedokteran",
    "GOLONGAN": "IVA",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "UNIT KERJA": "-",
    "POINT PERFORMANCE": 214.917,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 214.917,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 322375.5,
    "PPh 100%": 48356.325,
    "JUMLAH KOTOR 30% (Rp)": 787050,
    "JUMLAH KOTOR 70% (Rp)": 0,
    "PPh 21": 0,
    "JUMLAH BERSIH 70% (Rp)": 0,
    "TANDA TANGAN": 576
  },
  {
    "NIP": "'197706011999032003",
    "STATUS SEKARANG": "Ijin Belajar",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Ni Ketut Erawati, S.Kep., Ns., M.Pd.",
    "JURUSAN": "Pendidikan Profesi Ners",
    "FAKULTAS": "Fakultas Kedokteran",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "STRUKTURAL": "[REN126] Pengelola Gugus Kendali Mutu (Fakultas) sebagai Anggota",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Fakultas Kedokteran",
    "POINT POSITION": 200,
    "POINT PERFORMANCE": 461.979,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 661.979,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 992968.5,
    "PPh 100%": 49648.425,
    "JUMLAH KOTOR 30% (Rp)": 877050,
    "JUMLAH KOTOR 70% (Rp)": 115918.5,
    "PPh 21": 5795.925,
    "JUMLAH BERSIH 70% (Rp)": 110122.575,
    "TANDA TANGAN": 577
  },
  {
    "NIP": "'199001062024061001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Ns. Komang Agus Jerry Widyanata, M.Kep.",
    "JURUSAN": "Pendidikan Profesi Ners",
    "FAKULTAS": "Fakultas Kedokteran",
    "GOLONGAN": "IIIB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Tenaga Pengajar",
    "GRADE FUNGSIONAL": 7,
    "STRUKTURAL": "[REN126] Pengelola Gugus Kendali Mutu (Fakultas) sebagai Anggota",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Fakultas Kedokteran",
    "POINT POSITION": 200,
    "POINT PERFORMANCE": 290.938,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 490.938,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 736407,
    "PPh 100%": 36820.35,
    "JUMLAH KOTOR 30% (Rp)": 635400,
    "JUMLAH KOTOR 70% (Rp)": 101007,
    "PPh 21": 5050.35,
    "JUMLAH BERSIH 70% (Rp)": 95956.65,
    "TANDA TANGAN": 578
  },
  {
    "NIP": "'199511152024062002",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Ns. Komang Noviantari, M.Kep.",
    "JURUSAN": "Pendidikan Profesi Ners",
    "FAKULTAS": "Fakultas Kedokteran",
    "GOLONGAN": "IIIB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Tenaga Pengajar",
    "GRADE FUNGSIONAL": 7,
    "UNIT KERJA": "-",
    "POINT PERFORMANCE": 197.625,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 197.625,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 296437.5,
    "PPh 100%": 14821.875,
    "JUMLAH KOTOR 30% (Rp)": 545400,
    "JUMLAH KOTOR 70% (Rp)": 0,
    "PPh 21": 0,
    "JUMLAH BERSIH 70% (Rp)": 0,
    "TANDA TANGAN": 579
  },
  {
    "NIP": "'198811112024062002",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Ns. Theresia, S.Kep., MSN.",
    "JURUSAN": "Pendidikan Profesi Ners",
    "FAKULTAS": "Fakultas Kedokteran",
    "GOLONGAN": "IIIB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Tenaga Pengajar",
    "GRADE FUNGSIONAL": 7,
    "STRUKTURAL": "[REN126] Pengelola Gugus Kendali Mutu (Fakultas) sebagai Anggota",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Fakultas Kedokteran",
    "POINT POSITION": 200,
    "POINT PERFORMANCE": 574.333,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 774.333,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 1161499.5,
    "PPh 100%": 58074.975,
    "JUMLAH KOTOR 30% (Rp)": 635400,
    "JUMLAH KOTOR 70% (Rp)": 526099.5,
    "PPh 21": 26304.975,
    "JUMLAH BERSIH 70% (Rp)": 499794.525,
    "TANDA TANGAN": 580
  },
  {
    "NIP": "'196802251991032011",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Ria Tri Harini Dwi Rusiawati, S.ST., M.Pd.",
    "JURUSAN": "Pendidikan Profesi Ners",
    "FAKULTAS": "Fakultas Kedokteran",
    "GOLONGAN": "IIID",
    "STATUS PENELITIAN": "TIDAK ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "UNIT KERJA": "-",
    "POINT POSITION": 0,
    "POINT PERFORMANCE": 0,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 0,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 0,
    "PPh 100%": 0,
    "JUMLAH KOTOR 30% (Rp)": 787050,
    "JUMLAH KOTOR 70% (Rp)": 0,
    "PPh 21": 0,
    "JUMLAH BERSIH 70% (Rp)": 0,
    "TANDA TANGAN": 581
  },
  {
    "NIP": "'196303031983072002",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Wayan Sugandini, S.ST., M.Pd.",
    "JURUSAN": "Pendidikan Profesi Ners",
    "FAKULTAS": "Fakultas Kedokteran",
    "GOLONGAN": "IVA",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "STRUKTURAL": "[REN126] Pengelola Gugus Kendali Mutu (Fakultas) sebagai Anggota",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Fakultas Kedokteran",
    "POINT POSITION": 200,
    "POINT PERFORMANCE": 737.25,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 937.25,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 1405875,
    "PPh 100%": 210881.25,
    "JUMLAH KOTOR 30% (Rp)": 877050,
    "JUMLAH KOTOR 70% (Rp)": 528825,
    "PPh 21": 79323.75,
    "JUMLAH BERSIH 70% (Rp)": 449501.25,
    "TANDA TANGAN": 582
  },
  {
    "NIP": "'196312131983101001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Wigutomo Gozali, S.Pd., M.Kes.",
    "JURUSAN": "Pendidikan Profesi Ners",
    "FAKULTAS": "Fakultas Kedokteran",
    "GOLONGAN": "IVA",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Ya",
    "FUNGSIONAL": "Lektor",
    "GRADE FUNGSIONAL": 9,
    "UNIT KERJA": "-",
    "POINT PERFORMANCE": 380.896,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 380.896,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 571344,
    "PPh 100%": 85701.6,
    "JUMLAH KOTOR 30% (Rp)": 787050,
    "JUMLAH KOTOR 70% (Rp)": 0,
    "PPh 21": 0,
    "JUMLAH BERSIH 70% (Rp)": 0,
    "TANDA TANGAN": 583
  },
  {
    "NIP": "'199712152024062001",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Bd Ni Putu Citra Laksmi, S.Tr.Keb., M.Keb.",
    "JURUSAN": "Pendidikan Profesi Bidan",
    "FAKULTAS": "Fakultas Kedokteran",
    "GOLONGAN": "IIIB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Tenaga Pengajar",
    "GRADE FUNGSIONAL": 7,
    "STRUKTURAL": "[REN126] Pengelola Gugus Kendali Mutu (Fakultas) sebagai Anggota",
    "GRADE STRUKTURAL": 0,
    "UNIT KERJA": "Fakultas Kedokteran",
    "POINT POSITION": 200,
    "POINT PERFORMANCE": 334.188,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 534.188,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 801282,
    "PPh 100%": 40064.1,
    "JUMLAH KOTOR 30% (Rp)": 635400,
    "JUMLAH KOTOR 70% (Rp)": 165882,
    "PPh 21": 8294.1,
    "JUMLAH BERSIH 70% (Rp)": 157587.9,
    "TANDA TANGAN": 584
  },
  {
    "NIP": "'199801072024062003",
    "STATUS SEKARANG": "Aktif",
    "STATUS PEGAWAI": "PNS",
    "NAMA DOSEN": "Bd. Luh Citrarasmi Dara Mestika, S.Tr.Keb., M.Keb.",
    "JURUSAN": "Pendidikan Profesi Bidan",
    "FAKULTAS": "Fakultas Kedokteran",
    "GOLONGAN": "IIIB",
    "STATUS PENELITIAN": "ADA",
    "STATUS PENGABDIAN": "ADA",
    "STATUS SERDOS": "Tidak",
    "FUNGSIONAL": "Tenaga Pengajar",
    "GRADE FUNGSIONAL": 7,
    "UNIT KERJA": "-",
    "POINT PERFORMANCE": 316.542,
    "POINT KELEBIHAN": 0,
    "POINT TOTAL": 316.542,
    "PIR": 1500,
    "JUMLAH KOTOR 100% (Rp)": 474813,
    "PPh 100%": 23740.65,
    "JUMLAH KOTOR 30% (Rp)": 545400,
    "JUMLAH KOTOR 70% (Rp)": 0,
    "PPh 21": 0,
    "JUMLAH BERSIH 70% (Rp)": 0,
    "TANDA TANGAN": 585
  }
]
